webpackJsonp([1],{

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return designs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pdf; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var api = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: '/api/designs'
});

var designs = {
  create: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(design) {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api.post('/', design);

            case 2:
              resp = _context.sent;
              return _context.abrupt('return', resp.data);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _ref.apply(this, arguments);
    }

    return create;
  }(),
  update: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(id, design) {
      return __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return api.put('/' + id, design);

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function update(_x2, _x3) {
      return _ref2.apply(this, arguments);
    }

    return update;
  }(),
  get: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return api.get('/' + id);

            case 2:
              resp = _context3.sent;
              return _context3.abrupt('return', resp.data);

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function get(_x4) {
      return _ref3.apply(this, arguments);
    }

    return get;
  }()
};

var pdf = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(design) {
    var resp;
    return __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/pdf', design, { responseType: 'arraybuffer' });

          case 2:
            resp = _context4.sent;
            return _context4.abrupt('return', resp.data);

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function pdf(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__universal_filzfelt_patterns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__universal_filzfelt_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__universal_filzfelt_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generate_preview__ = __webpack_require__(256);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_2__universal_filzfelt_patterns___default.a).map(function (_ref) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      id = _ref2[0],
      _ref2$ = _ref2[1],
      name = _ref2$.name,
      _ref2$$preview = _ref2$.preview;

  _ref2$$preview = _ref2$$preview === undefined ? {} : _ref2$$preview;
  var _ref2$$preview$width = _ref2$$preview.width,
      width = _ref2$$preview$width === undefined ? 72 : _ref2$$preview$width,
      _ref2$$preview$height = _ref2$$preview.height,
      height = _ref2$$preview$height === undefined ? 48 : _ref2$$preview$height;
  return {
    id: id,
    name: name,
    preview: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__generate_preview__["a" /* default */])(id, width, height)
  };
}));

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__);

/* harmony default export */ __webpack_exports__["a"] = (function (data, key) {
  var _key$split$map = key.split(',').map(function (n) {
    return Number(n);
  }),
      _key$split$map2 = __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_key$split$map, 3),
      i = _key$split$map2[0],
      j = _key$split$map2[1],
      k = _key$split$map2[2];

  var g = (Math.abs(i) + Math.abs(j)) % 2 === 0 ? '0' : '1';
  if (k === 0) return '' + g + k + '0';

  var variant = function variant(v) {
    return '' + g + k + v;
  };

  switch (k) {
    case 1:
      // NE
      if (data[i + 1 + ',' + (j - 1) + ',0']) return variant('3'); // full if has NE neighbor
      if (data[i + ',' + (j - 1) + ',0']) return variant('2'); // 1/2v if has N neighbor
      if (data[i + 1 + ',' + j + ',0']) return variant('1'); // 1/2h if has E neighbor
      return variant('0'); // 1/4 if has no neighbors
    case 2:
      // SE
      if (!data[i + 1 + ',' + j + ',0'] && !data[i + ',' + (j + 1) + ',0']) {
        return variant('0'); // 1/4 if has no E and S neighbors
      }
      return null; // no block otherwise
    case 3:
      // SW
      if (data[i - 1 + ',' + (j + 1) + ',0']) return null; // no block if has SW neighbor
      if (data[i + ',' + (j + 1) + ',0']) return variant('2'); // 1/2v if has S neighbor
      if (data[i - 1 + ',' + j + ',0']) return variant('1'); // 1/2h if has W neighbor
      return variant('0'); // 1/4 if has no neighbors
    case 4:
      // NW
      if (!data[i - 1 + ',' + j + ',0'] && !data[i + ',' + (j - 1) + ',0']) {
        return variant('0'); // 1/4 if has no W and N neighbors
      }
      return null; // no block otherwise
  }
});

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generate_preview__ = __webpack_require__(257);


/* harmony default export */ __webpack_exports__["a"] = ([
// Design 402
// 'aff5ea63-34c8-40f0-8c65-a510460ba076', // 402 Large
// '281d02c2-e7e5-4252-9e7b-2068a366fc01', // 402 Medium
// 'cd9ca5e5-ed19-4729-812c-8182ab8fc5c7', // 402 Small

// lisboa
'23d97e24-99c2-4520-b1c8-09e182fdf9d0', // 1-001
'29ad7b4d-25cd-44bb-9e06-d3fcc3eed182', // 2-001
'03cecbb5-aafe-4c7e-ba6a-f7c331a24eea', // 2-002
'332eb4b9-c33c-4aaa-967d-58bae5309545', // 3-001
'd0acfa61-0063-4424-8df2-da4f98254fb8', // 4-001
'3fbad118-6526-40db-864a-38807f4a7390', // 4-002
'244c939e-eed5-428c-846f-9e4737ce53c3', // 5-001
'48cc25cb-55f7-47f3-9fef-ddc5a450d85d', // 5-002
'c7004e30-d53a-42dc-b64f-7676f788b818', // All-001
'93beb7dd-edeb-4447-a264-ade07b1b2746', // All-002

// Porto
'97210965-f0e7-4142-bc58-c0eef97f07b8', // 1-001
'fc41f36d-beb7-4920-a650-c2b13beb6bd2', // 1-002
'515c1b94-da9d-466b-b354-571968374992', // 1-003

'2ee4d11e-c94e-49dd-93b3-2f2fb6b3ebca', // 2-001
'd3fb820a-cc5d-40ad-9efd-78c524c9b7b3', // 2-002
'b2eb9482-17b3-4dae-80a1-85a58de9012a', // 2-003

'81bb8afa-9574-45aa-b9be-2f42ccfa3ee8', // 3-001
'274bee68-74bd-4776-804e-566b99927346', // 3-002
'1d12c8b3-1016-4340-b439-70b640f1e367', // 3-003
'2f096dee-b4c7-4e1e-94fa-a43531ce71e5', // 3-004
'12c38751-6815-43ff-8421-75b9c5eed2eb'].map(__WEBPACK_IMPORTED_MODULE_0__generate_preview__["a" /* default */]));

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

module.exports = {
    DEFAULT_WALL_WIDTH: 144,
    DEFAULT_WALL_HEIGHT: 96
};

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = convertInchesToCm;
/* harmony export (immutable) */ __webpack_exports__["a"] = convertInchesToFeet;
/* unused harmony export convertCmToInches */
function convertInchesToCm(v) {
    return Math.round(v / 2.54);
};

function convertInchesToFeet(inches) {
    var feet = Math.floor(inches / 12);
    inches %= 12;
    return {
        feet: feet,
        inches: inches
    };
};

function convertCmToInches(v) {
    return Math.round(v / INCHES_IN_METER * 100);
};

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__universal_spinneybeck_patterns__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__universal_spinneybeck_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__universal_spinneybeck_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filzfelt_generate_pattern__ = __webpack_require__(80);



/* harmony default export */ __webpack_exports__["a"] = (function (pattern, width, height, old) {
  var name = __WEBPACK_IMPORTED_MODULE_0__universal_spinneybeck_patterns___default.a[pattern].name;


  return (/402/.test(name) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__filzfelt_generate_pattern__["a" /* default */])(pattern, width, height, old) : dnd(pattern, width, height, old)
  );
});

function dnd(pattern, width, height, old) {
  pattern = __WEBPACK_IMPORTED_MODULE_0__universal_spinneybeck_patterns___default.a[pattern];
  var mod = pattern.module;

  var result = {};

  var rem = width % 16;

  var x0 = rem ? 0 - (16 - rem / 2) : 0;
  var y0 = 0;

  var row = 0;
  for (var y = y0; y < height; y += 16) {
    var col = 0;
    for (var x = x0; x < width; x += 16) {
      var key = col + ',' + row;
      var rowIdx = row % mod.length;
      var colIdx = col % mod[rowIdx].length;
      var id = pattern.module[rowIdx][colIdx].id;
      var name = pattern.module[rowIdx][colIdx].name;
      var r = pattern.module[rowIdx][colIdx].r;
      if (old && key in old) {
        id = old[key].id;
        name = old[key].name;
        r = old[key].r;
      }
      var partial = x < 0 || x > width - 16 || y < 0 || y > height - 16;
      result[key] = { id: id, name: name, r: r, x: x, y: y, partial: partial };
      col += 1;
    }
    row += 1;
  }

  return result;
}

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global CustomEvent */

var getPosition = function getPosition(event) {
  return {
    x: event.touches && event.touches[0].pageX || event.pageX,
    y: event.touches && event.touches[0].pageY || event.pageY
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, _ref) {
    var value = _ref.value;

    var grabFlag = false;
    var x = null;
    var y = null;
    var dragInProcess = false;
    var detail = null;

    var start = function start(event) {
      grabFlag = true;
      var pos = getPosition(event);
      x = pos.x;
      y = pos.y;
    };

    var click = function click(event) {
      if (dragInProcess) {
        event.stopPropagation();
        event.preventDefault();
      }
    };

    var cancel = function cancel() {
      grabFlag = false;
      x = null;
      y = null;
    };

    var dragStart = function dragStart(event) {
      if (value === false || value === null) {
        return;
      }
      if (!grabFlag) return;
      var pos = getPosition(event);
      var d2 = Math.pow(pos.x - x, 2) + Math.pow(pos.y - y, 2);
      if (d2 <= Math.pow(5, 2)) return;

      cancel();
      dragInProcess = true;
      detail = el.dataset.drag;
      el.dispatchEvent(new CustomEvent('drag-start', {
        bubbles: true,
        detail: detail
      }));

      document.addEventListener('mousemove', dragOver);
      document.addEventListener('touchmove', dragOver);
      document.addEventListener('mouseup', dragEnd);
      document.addEventListener('touchend', dragEnd);
    };

    var dragOver = function dragOver(event) {
      if (value === false || value === null) {
        return;
      }
      event.preventDefault();
      event.target.dispatchEvent(new CustomEvent('drag-over', {
        bubbles: true,
        detail: detail
      }));
    };

    var dragEnd = function dragEnd(event) {
      if (value === false || value === null) {
        return;
      }
      event.target.dispatchEvent(new CustomEvent('drag-end', {
        bubbles: true,
        detail: detail
      }));

      detail = null;
      setTimeout(function () {
        dragInProcess = false;
      }, 0);

      document.removeEventListener('mouseup', dragEnd);
      document.removeEventListener('touchend', dragEnd);

      document.removeEventListener('mousemove', dragOver);
      document.removeEventListener('mousemove', dragOver);
      document.removeEventListener('touchmove', dragOver);
    };

    el.addEventListener('mousedown', start);
    el.addEventListener('touchstart', start);

    el.addEventListener('mouseup', cancel);
    el.addEventListener('touchend', cancel);

    el.addEventListener('mousemove', dragStart);
    el.addEventListener('touchmove', dragStart);

    el.addEventListener('click', click);
  }
});

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Intro_vue__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Edit_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_View_vue__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_View_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_View_vue__);






var redirectPath = window && window.location && window.location.href && window.location.href.includes('spinneybeck') ? '/spinneybeck' : '/filzfelt';

var routes = [{ path: '/', redirect: redirectPath }, { name: 'intro', path: '/:brand(filzfelt|spinneybeck)', component: __WEBPACK_IMPORTED_MODULE_2__pages_Intro_vue___default.a, props: true }, { name: 'edit', path: '/:id?/:slug?/edit', component: __WEBPACK_IMPORTED_MODULE_3__pages_Edit_vue___default.a, props: true }, { name: 'view', path: '/:id?/:slug?/view', component: __WEBPACK_IMPORTED_MODULE_4__pages_View_vue___default.a, props: true }, { path: '*', redirect: '/' }];

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: __webpack_require__.i({"NODE_ENV":"production"}).VUE_ROUTER_MODE || 'history',
  routes: routes
}));

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(574),
  /* scopeId */
  "data-v-cb5cdc42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(572),
  /* scopeId */
  "data-v-9ee1e386",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);









var GoogleAnalyticsId = window && window.location && window.location.href && window.location.href.includes('spinneybeck') ? 'UA-106859560-1' // spinneybeck
: 'UA-106860522-1'; // filzfelt

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_analytics___default.a, {
  id: GoogleAnalyticsId,
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  },
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
}));

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_api__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_wrappers_HeaderFilzfelt_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_wrappers_HeaderFilzfelt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_wrappers_HeaderFilzfelt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_wrappers_FooterFilzfelt_vue__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_wrappers_FooterFilzfelt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_wrappers_FooterFilzfelt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_wrappers_HeaderSpinneybeck_vue__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_wrappers_HeaderSpinneybeck_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_wrappers_HeaderSpinneybeck_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_wrappers_FooterSpinneybeck_vue__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_wrappers_FooterSpinneybeck_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_wrappers_FooterSpinneybeck_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FooterFilzfelt: __WEBPACK_IMPORTED_MODULE_4__pages_wrappers_FooterFilzfelt_vue___default.a,
    FooterSpinneybeck: __WEBPACK_IMPORTED_MODULE_6__pages_wrappers_FooterSpinneybeck_vue___default.a,
    HeaderFilzfelt: __WEBPACK_IMPORTED_MODULE_3__pages_wrappers_HeaderFilzfelt_vue___default.a,
    HeaderSpinneybeck: __WEBPACK_IMPORTED_MODULE_5__pages_wrappers_HeaderSpinneybeck_vue___default.a
  },

  computed: {
    classes: function classes() {
      return {
        filzfelt: this.$store.getters.brand === 'filzfelt',
        spinneybeck: this.$store.getters.brand === 'spinneybeck'
      };
    },
    brand: function brand() {
      return this.$store.getters.brand;
    },
    design: function design() {
      return this.$store.state.design;
    }
  },

  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {
    // concierge widget
    if (this.brand === 'spinneybeck') {
      // spinneybeck
      (function (w, i, d, g, e, t, s) {
        w[d] = w[d] || [];t = i.createElement(g);
        t.async = 1;t.src = e;s = i.getElementsByTagName(g)[0];s.parentNode.insertBefore(t, s);
      })(window, document, '_gscq', 'script', '//widgets.getsitecontrol.com/79502/script.js');
    } else {
      // filzfelt
      (function (w, i, d, g, e, t, s) {
        w[d] = w[d] || [];t = i.createElement(g);
        t.async = 1;t.src = e;s = i.getElementsByTagName(g)[0];s.parentNode.insertBefore(t, s);
      })(window, document, '_gscq', 'script', '//widgets.getsitecontrol.com/78480/script.js');
    }
  },


  watch: {
    '$route': 'fetchData'
  },

  methods: {
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _$route$params, id, slug, brand, _ref2, design;

        return __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _$route$params = this.$route.params, id = _$route$params.id, slug = _$route$params.slug, brand = _$route$params.brand;

                if (!(id && !slug)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__lib_api__["a" /* designs */].get(id);

              case 4:
                _ref2 = _context.sent;
                design = _ref2.design;

                this.$store.commit('setDesignData', design);
                _context.next = 10;
                break;

              case 9:
                if (slug) {
                  // otherwise, assume user is starting from a pattern
                  this.$store.commit('setPattern', id);
                }

              case 10:
                if (brand) {
                  this.$store.commit('setBrand', brand);
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData() {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }()
  }

});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_json_stringify__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_v_draggable__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__universal_filzfelt_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__universal_filzfelt_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__universal_filzfelt_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__universal_filzfelt_blocks__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__universal_filzfelt_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__universal_filzfelt_blocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__universal_spinneybeck_blocks__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__universal_spinneybeck_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__universal_spinneybeck_blocks__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    draggable: __WEBPACK_IMPORTED_MODULE_6__lib_v_draggable__["a" /* default */]
  },
  props: {
    design: {
      pattern: String,
      width: Number,
      height: Number,
      data: Object
    },
    readonly: Boolean
  },
  computed: __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default()({
    brand: function brand() {
      return this.$store.getters.brand;
    },
    scaleBlockInUse: function scaleBlockInUse() {
      var blockId = {
        'be3ee6b5-32fc-43ca-aa1d-d9a6919cfc70': '717fae39-bca4-4637-8e18-b203024ff3f2',
        'ce3a0a56-e73f-4f8c-bc6c-3c98453ce58f': 'c52c3cb4-390b-4cac-9ff3-f601c7439369'
      }[this.design.pattern];
      return __WEBPACK_IMPORTED_MODULE_8__universal_filzfelt_blocks___default.a[blockId];
    },
    scalePattern: function scalePattern() {
      var BLOCK = this.scaleBlockInUse;
      if (!BLOCK) return;

      var bg = [];
      var fg = [];
      var data = this.design.data;

      var _loop = function _loop(key) {
        var _key$split$map = key.split(',').map(function (n) {
          return Number(n);
        }),
            _key$split$map2 = __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_key$split$map, 3),
            i = _key$split$map2[0],
            j = _key$split$map2[1],
            k = _key$split$map2[2];

        var mask = (k === 0 ? [data[i - 1 + ',' + (j - 1) + ',1'], // top-left
        data[i + ',' + (j - 1) + ',1'], // top-right
        data[i + ',' + j + ',1'], // bottom-right
        data[i - 1 + ',' + j + ',1'] // bottom-left
        ] : [data[i + ',' + j + ',0'], // top-left
        data[i + 1 + ',' + j + ',0'], // top-right
        data[i + 1 + ',' + (j + 1) + ',0'], // bottom-right
        data[i + ',' + (j + 1) + ',0'] // bottom-left
        ]).map(function (a) {
          if (data[key].color) {
            return a && a.color ? 1 : 0;
          } else {
            return a ? 1 : 0;
          }
        }).join('');
        var path = BLOCK.variants[mask];
        var layer = data[key].color ? fg : bg;
        layer.push(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default()({}, data[key], { key: key, path: path }));
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys___default()(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          _loop(key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return [bg, fg];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['sp402Pattern'])),
  methods: {
    getBlockPoints: function getBlockPoints(_ref) {
      var points = _ref.points;

      if (points) return points.join(' ');
    },
    getFFBlockPath: function getFFBlockPath(_ref2) {
      var id = _ref2.id;

      return __WEBPACK_IMPORTED_MODULE_8__universal_filzfelt_blocks___default.a[id].path;
    },
    getBlockTransform: function getBlockTransform(_ref3) {
      var x = _ref3.x,
          y = _ref3.y,
          r = _ref3.r;

      return 'translate(' + x + ', ' + y + ')' + (r ? ' rotate(' + r[0] + ', ' + r[1] + ', ' + r[2] + ')' : '');
    },
    getBlockFill: function getBlockFill(block) {
      var color = block.color;

      var placeholderColor = __WEBPACK_IMPORTED_MODULE_8__universal_filzfelt_blocks___default.a[block.id].placeholderColor ? __WEBPACK_IMPORTED_MODULE_8__universal_filzfelt_blocks___default.a[block.id].placeholderColor : '#fff';
      var fill = __WEBPACK_IMPORTED_MODULE_7__universal_filzfelt_colors___default.a[color];
      return fill && fill.value || placeholderColor;
    },
    getBlockPath: function getBlockPath(_ref4) {
      var id = _ref4.id;

      return __WEBPACK_IMPORTED_MODULE_9__universal_spinneybeck_blocks___default.a[id].d;
    },
    getBlockDropData: function getBlockDropData(_ref5) {
      var id = _ref5.id,
          name = _ref5.name,
          r = _ref5.r;

      return __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_json_stringify___default()({ id: id, name: name, r: r });
    },
    blockDrop: function blockDrop(key, event) {
      var _JSON$parse = JSON.parse(event.detail),
          id = _JSON$parse.id,
          name = _JSON$parse.name,
          r = _JSON$parse.r;

      this.$emit('block-drop', { key: key, id: id, name: name, r: r });
    },
    blockDrag: function blockDrag(key, event) {
      var _this = this;

      var _JSON$parse2 = JSON.parse(event.detail),
          id = _JSON$parse2.id,
          name = _JSON$parse2.name,
          r = _JSON$parse2.r;

      this.$emit('block-drag', { key: key, id: id, name: name, r: r });
      this.$nextTick(function () {
        // default/blank Lisboa tile
        var block = {
          id: '7d139b52-372d-4f39-93fc-40f3c0a37955',
          name: 'Lisboa 1'
        };
        _this.$store.commit('setCustomBlock', __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default()({ key: key }, block));
      });
    }
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnitInput__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnitInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UnitInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UnitInput: __WEBPACK_IMPORTED_MODULE_0__UnitInput___default.a
  },
  data: function data() {
    return {
      centimeters: Math.round(this.value * 2.54) // convert to cm
    };
  },

  props: {
    value: {
      type: [Number, String],
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100 * 12
    },
    showInches: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    metric: function metric() {
      return this.$store.getters.metric;
    },
    design: function design() {
      return this.$store.getters.design;
    },

    feet: {
      get: function get() {
        return this.value / 12 | 0;
      },
      set: function set(v) {
        this.outputImperial(v * 12 + this.inches);
      }
    },
    inches: {
      get: function get() {
        return this.value % 12;
      },
      set: function set(v) {
        this.outputImperial(this.feet * 12 + v);
      }
    }
  },
  watch: {
    centimeters: function centimeters(newValue) {
      this.outputMetric(newValue);
    }
  },
  methods: {
    outputImperial: function outputImperial(v) {
      if (isNaN(v)) v = 0;
      if (v < this.min) v = this.min;
      if (v > this.max) v = this.max;
      this.$emit('input', Number(v));
    },
    outputMetric: function outputMetric(v) {
      if (isNaN(v)) v = 0;
      if (v < this.min) v = this.min;
      this.$emit('input', Number(this.centimeters));
    }
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_api__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_patterns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns__);


//
//
//
//





var INCHES_IN_METER = 39.3700787;

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    design: function design() {
      return this.$store.state.design;
    },
    width: function width() {
      return this.$store.getters.width;
    },
    height: function height() {
      return this.$store.getters.height;
    },
    brand: function brand() {
      return this.$store.getters.brand;
    },
    metric: function metric() {
      return this.$store.getters.metric;
    },
    tileDimensions: function tileDimensions() {
      var pattern = this.brand === "filzfelt" ? __WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_patterns___default.a[this.design.pattern] : __WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns___default.a[this.design.pattern];

      return this.metric ? pattern && pattern.dimensions && pattern.dimensions.m : pattern && pattern.dimensions && pattern.dimensions.i;
    }
  },
  methods: {
    downloadPdf: function downloadPdf() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default()({
        dimensions: "W " + this.width + " x H " + this.height
      }, this.tileDimensions && { tileDimensions: this.tileDimensions }), this.design);

      __WEBPACK_IMPORTED_MODULE_2__lib_api__["b" /* pdf */](data).then(function (pdf) {
        var ie = navigator.userAgent.match(/MSIE\s([\d.]+)/);
        var ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/);
        var ieEDGE = navigator.userAgent.match(/Edge/g);
        var ieVer = ie ? ie[1] : ie11 ? 11 : ieEDGE ? 12 : -1;

        if (ie && ieVer < 10) {
          console.log("No blobs on IE ver<10");
          return;
        }

        var blob = new Blob([pdf], { type: "application/pdf" });
        var timestamp = new Date().getTime().toString();
        var fileName = _this.brand + "-design-spec_" + timestamp + ".pdf";

        if (ieVer > -1) {
          window.navigator.msSaveBlob(blob, fileName);
        } else {
          var downloadLink = document.createElement("a");
          downloadLink.download = fileName;
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.onclick = function (e) {
            document.body.removeChild(e.target);
          };
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.click();
        }

        // GA: track PDF download
        if (ga) {
          ga("send", {
            hitType: "event",
            eventCategory: "PDF",
            eventAction: "download",
            eventLabel: fileName
          });
        }
      }).catch(function (err) {
        return console.error(err);
      });
    }
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_filzfelt_patterns__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_spinneybeck_patterns__ = __webpack_require__(107);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    patterns: function patterns() {
      if (this.$store.getters.brand === 'filzfelt') {
        return __WEBPACK_IMPORTED_MODULE_0__lib_filzfelt_patterns__["a" /* default */].sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1__lib_spinneybeck_patterns__["a" /* default */];
    }
  },
  methods: {
    getPatternLink: function getPatternLink(_ref) {
      var id = _ref.id,
          name = _ref.name;

      var slug = name.replace(/\s+/g, '-').toLowerCase();
      return { name: 'edit', params: { id: id, slug: slug } };
    }
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    email: function email() {
      return this.$store.state.email;
    },
    authorized: function authorized() {
      return this.$route.params.id && this.$store.state.authorized;
    },
    isNewDesign: function isNewDesign() {
      return this.$route.params.slug;
    },
    saveError: function saveError() {
      return this.$store.state.saveError;
    },
    saveSuccess: function saveSuccess() {
      return this.$store.state.saveSuccess;
    },
    secret: function secret() {
      return this.$store.state.secret;
    }
  },
  created: function created() {
    var localSecret = this.isNewDesign ? this.generateNewSecret() : '';

    this.$store.commit('setSecret', localSecret);
  },

  methods: {
    save: function save() {
      this.$store.dispatch('save');
    },
    setEmail: function setEmail(event) {
      this.$store.commit('setEmail', event.target.value);
    },
    setSecret: function setSecret(event) {
      this.$store.commit('setSecret', event.target.value);
    },
    generateNewSecret: function generateNewSecret() {
      var text = '';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }return text;
    }
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    mark: String,
    value: Number,
    placeholder: String
  },
  data: function data() {
    return {
      keepClean: false,
      valueCopy: String(this.value)
    };
  },

  computed: {
    displayValue: function displayValue() {
      if (!this.keepClean) {
        this.valueCopy = String(this.value);
      }
      return this.valueCopy;
    }
  },
  methods: {
    onInput: function onInput(event) {
      this.valueCopy = event.target.value;
      if (/^0+/.test(this.valueCopy) || /\./.test(this.valueCopy)) {
        this.valueCopy = Math.round(this.valueCopy);
        event.target.value = this.valueCopy;
      }
      this.keepClean = this.valueCopy === '';
      this.$emit('input', Number(this.valueCopy));
    },
    onChange: function onChange(event) {
      this.keepClean = false;
      this.valueCopy = event.target.value;
      if (this.valueCopy === '') {
        this.valueCopy = '0';
        event.target.value = '0';
      }
      this.$emit('change', Number(this.valueCopy));
    }
  }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_json_stringify__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DesignView__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DesignView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DesignView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DimensionInput__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DimensionInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DimensionInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadPdf__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadPdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DownloadPdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SaveForm__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SaveForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_SaveForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_v_draggable__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__universal_filzfelt_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__universal_filzfelt_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__universal_filzfelt_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_filzfelt_patterns__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__universal_filzfelt_patterns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__universal_filzfelt_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__universal_filzfelt_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_spinneybeck_patterns__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__universal_spinneybeck_patterns__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__universal_spinneybeck_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__universal_spinneybeck_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__universal_filzfelt_blocks__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__universal_filzfelt_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__universal_filzfelt_blocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__lib_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_conversions__ = __webpack_require__(162);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DesignView: __WEBPACK_IMPORTED_MODULE_2__components_DesignView___default.a,
    DimensionInput: __WEBPACK_IMPORTED_MODULE_3__components_DimensionInput___default.a,
    DownloadPdf: __WEBPACK_IMPORTED_MODULE_4__components_DownloadPdf___default.a,
    SaveForm: __WEBPACK_IMPORTED_MODULE_5__components_SaveForm___default.a
  },
  directives: {
    draggable: __WEBPACK_IMPORTED_MODULE_6__lib_v_draggable__["a" /* default */]
  },
  data: function data() {
    return {
      colors: __WEBPACK_IMPORTED_MODULE_7__universal_filzfelt_colors___default.a,
      activeColor: false,
      activeCustomBlock: false,
      activeRotate: false,
      draggedBlock: null,
      cursorX: 0,
      cursorY: 0
    };
  },

  computed: {
    design: function design() {
      return this.$store.getters.design;
    },
    brand: function brand() {
      return this.$store.getters.brand;
    },
    metric: function metric() {
      return this.$store.getters.metric;
    },
    patterns: function patterns() {
      return this.brand === 'filzfelt' ? __WEBPACK_IMPORTED_MODULE_8__lib_filzfelt_patterns__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_10__lib_spinneybeck_patterns__["a" /* default */];
    },
    patternDefs: function patternDefs() {
      return this.brand === 'filzfelt' ? __WEBPACK_IMPORTED_MODULE_9__universal_filzfelt_patterns___default.a : __WEBPACK_IMPORTED_MODULE_11__universal_spinneybeck_patterns___default.a;
    },
    patternDef: function patternDef() {
      return this.patternDefs[this.design.pattern];
    },
    helpNote: function helpNote() {
      if (!this.patternDef) return false;
      return this.patternDef.customHelpNote ? this.patternDef.customHelpNote : '';
    },
    showHelpNote: function showHelpNote() {
      if (!this.patternDef) return false;
      return this.patternDef.customHelpNote ? true : false;
    },
    showMetric: function showMetric() {
      if (!this.patternDef) return true;
      return this.patternDef.showMetric === false ? this.patternDef.showMetric : true;
    },
    showInches: function showInches() {
      if (!this.patternDef) return true;
      return this.patternDef.showInches === false ? this.patternDef.showInches : true;
    },
    showFill: function showFill() {
      if (!this.patternDef) return true;
      return this.patternDef.showFill === false ? this.patternDef.showFill : true;
    },
    showPatternRepeatHeight: function showPatternRepeatHeight() {
      if (!this.patternDef || !this.patternDef.patternRepeatHeight) return false;
      if (this.metric) {
        return this.design.height < __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_conversions__["b" /* convertInchesToCm */])(this.patternDef.patternRepeatHeight);
      }
      return this.design.height < this.patternDef.patternRepeatHeight;
    },
    patternRepeatHeight: function patternRepeatHeight() {
      if (!this.patternDef || !this.patternDef.patternRepeatHeight) return;
      if (this.metric) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_conversions__["b" /* convertInchesToCm */])(this.patternDef.patternRepeatHeight) + 'cm';
      }
      var feetInches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_conversions__["a" /* convertInchesToFeet */])(this.patternDef.patternRepeatHeight);
      return feetInches.feet + ' \'' + (feetInches.inches !== 0 ? ' ' + feetInches.inches + ' "' : '');
    },
    isSp402: function isSp402() {
      var pattern = __WEBPACK_IMPORTED_MODULE_11__universal_spinneybeck_patterns___default.a[this.design.pattern];
      return (/402/.test(pattern && pattern.name)
      );
    },
    customBlocks: function customBlocks() {
      var pattern = __WEBPACK_IMPORTED_MODULE_11__universal_spinneybeck_patterns___default.a[this.design.pattern];
      if (!pattern || !pattern.customBlocks) return [];
      return pattern.customBlocks.map(function (id) {
        return __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default()({ id: id }, __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks___default.a[id]);
      });
    },
    ghostBlock: function ghostBlock() {
      if (!this.draggedBlock) return;
      var _draggedBlock = this.draggedBlock,
          id = _draggedBlock.id,
          r = _draggedBlock.r;

      var d = __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks___default.a[id].d;
      return { id: id, r: r, d: d };
    },
    classes: function classes() {
      return {
        'active-color': this.activeColor,
        'active-custom-block': this.activeCustomBlock,
        'active-rotate': this.activeRotate,
        'drag-over': this.draggedBlock
      };
    },
    galleryLink: function galleryLink() {
      var brand = this.brand;
      return { name: 'intro', params: { brand: brand } };
    },
    howToText: function howToText() {
      if (this.isSp402) {
        return ['Enter the width and height of your wall.', 'To see the tile counts, click on ‘View Specs’.', 'To save or share your work, enter your email address in the lower left corner. You’ll receive an email with a link to pick up where you left off.', 'To download a PDF of your design, click on ‘Download PDF’.'];
      }

      if (this.brand === 'filzfelt') {
        return ['Enter the width and height of your wall.', 'To add color to individual tiles, select a color and click on tiles. To remove color, click again on that tile. Click ‘Fill’ to fill entire wall with selected color.', 'Continue adding color by selecting colors and clicking on tiles until your design is complete.', 'Want a blank slate? Click ‘Clear’.', 'To create a floating installation (instead of wall-to- wall), leave tiles blank.', 'To see the tile counts, click on ‘View Specs’.', 'To save or share your work, enter your email address in the lower left corner. You’ll receive an email with a link to pick up where you left off.', 'To download a PDF of your design, click on ‘Download PDF’.'];
      }
      // Spinneybeck
      return ['Enter the width and height of your wall.', 'To customize, select a tile style under ‘Customize’ and drag to the location on your wall.', 'To rotate, select ‘Rotate’ and then click on a tile to rotate.', 'To see the tile counts, click on ‘View Specs’.', 'To save or share your work, enter your email address in the lower left corner. You’ll receive an email with a link to pick up where you left off.', 'To download a PDF of your design, click on ‘Download PDF’.'];
    }
  },

  methods: {
    onBlockClick: function onBlockClick(_ref) {
      var block = _ref.block,
          key = _ref.key;

      if (this.brand === 'filzfelt' && this.activeColor) {
        // if fill all is true, set color for all blocks of same type
        if (__WEBPACK_IMPORTED_MODULE_13__universal_filzfelt_blocks___default.a[block.id].fillAll) {
          this.setColorForSameBlockType({ key: key, color: this.activeColor });
          return;
        }
        this.setColor({ key: key, color: this.activeColor });
      }
      if (this.brand === 'spinneybeck' && this.activeCustomBlock) {
        var id = this.activeCustomBlock;
        var name = __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks___default.a[id].name || '';
        var r = 0;
        this.setCustomBlock({ key: key, id: id, name: name, r: r });
      }
      if (this.brand === 'spinneybeck' && this.activeRotate) {
        var _r = this.design.data[key].r || 0;
        _r = (_r + 90) % 360;
        this.setBlockRotate({ key: key, r: _r });
      }
    },
    onBlockDrop: function onBlockDrop(_ref2) {
      var key = _ref2.key,
          id = _ref2.id,
          name = _ref2.name,
          r = _ref2.r;

      this.draggedBlock = null;
      this.setCustomBlock({ key: key, id: id, name: name, r: r });
    },
    onBlockDrag: function onBlockDrag(_ref3) {
      var id = _ref3.id,
          name = _ref3.name,
          r = _ref3.r;

      this.draggedBlock = { id: id, name: name, r: r };
    },
    grabCustomBlock: function grabCustomBlock(cb) {
      var id = cb.id;

      this.draggedBlock = { id: id };
      this.setActiveCustomBlock(id);
    },
    getCustomBlockData: function getCustomBlockData(_ref4) {
      var id = _ref4.id,
          name = _ref4.name;

      return __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_json_stringify___default()({ id: id, name: name });
    },
    setActiveColor: function setActiveColor(key) {
      this.activeCustomBlock = false;
      this.activeRotate = false;
      this.activeColor = key;
    },
    setActiveCustomBlock: function setActiveCustomBlock(cb) {
      var id = cb.id;

      this.activeColor = false;
      this.activeRotate = false;
      this.activeCustomBlock = id;
    },
    setActiveRotate: function setActiveRotate() {
      this.activeCustomBlock = false;
      this.activeColor = false;
      this.activeRotate = true;
    },
    setWidth: function setWidth(value) {
      if (this.design.width === value || isNaN(value) || !value) {
        return;
      }

      if (this.metric) {
        // convert cm to inches
        this.$store.commit('setWidth', Math.round(value / 2.54));
      } else {
        this.$store.commit('setWidth', value);
      }
    },
    setHeight: function setHeight(value) {
      if (this.design.height === value || isNaN(value) || !value) {
        return;
      }

      if (this.metric) {
        // convert cm to inches
        this.$store.commit('setHeight', Math.round(value / 2.54));
      } else {
        this.$store.commit('setHeight', value);
      }
    },
    setInitialHeight: function setInitialHeight() {
      var patternHeight = this.patternDef.wallHeight;
      if (patternHeight) {
        this.$store.commit('setHeight', patternHeight);
      } else {
        this.$store.commit('setHeight', __WEBPACK_IMPORTED_MODULE_14__lib_constants___default.a.DEFAULT_WALL_HEIGHT);
      }
    },
    setInitialWidth: function setInitialWidth() {
      var patternWidth = this.patternDef.wallWidth;
      if (patternWidth) {
        this.$store.commit('setWidth', patternWidth);
      } else {
        this.$store.commit('setWidth', __WEBPACK_IMPORTED_MODULE_14__lib_constants___default.a.DEFAULT_WALL_WIDTH);
      }
    },
    setPattern: function setPattern(id) {
      this.$store.dispatch('setPatternById', id);
    },
    setColor: function setColor(payload) {
      this.$store.commit('setColor', payload);
    },
    setColorForSameBlockType: function setColorForSameBlockType(payload) {
      this.$store.commit('setColorForSameBlockType', payload);
    },
    setColorForAll: function setColorForAll(payload) {
      this.$store.commit('setColorForAll', payload);
    },
    clearColorForAll: function clearColorForAll(payload) {
      this.$store.commit('clearColorForAll', payload);
    },
    setCustomBlock: function setCustomBlock(payload) {
      this.$store.commit('setCustomBlock', payload);
    },
    setBlockRotate: function setBlockRotate(payload) {
      this.$store.commit('setBlockRotate', payload);
    },
    switchUnits: function switchUnits() {
      this.$store.commit('setMetric', !this.metric);
    }
  },

  created: function created() {
    if (!this.design.pattern) {
      this.setPattern(this.brand === 'filzfelt' ? __WEBPACK_IMPORTED_MODULE_8__lib_filzfelt_patterns__["a" /* default */][0].id : __WEBPACK_IMPORTED_MODULE_10__lib_spinneybeck_patterns__["a" /* default */][0].id);
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.scrollTo(0, 0);
    window.addEventListener('mousemove', function (event) {
      _this.cursorX = event.pageX;
      _this.cursorY = event.pageY;
    });
    window.addEventListener('mouseup', function (event) {
      _this.draggedBlock = null;
    });

    this.setInitialWidth();
    this.setInitialHeight();
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PatternGallery__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PatternGallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PatternGallery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PatternGallery: __WEBPACK_IMPORTED_MODULE_0__components_PatternGallery___default.a
  },
  computed: {
    brand: function brand() {
      return this.$route.params.brand === 'filzfelt' ? 'FilzFelt' : 'Spinneybeck';
    }
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DesignView__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DesignView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_DesignView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DownloadPdf__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DownloadPdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_DownloadPdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SaveForm__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SaveForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SaveForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__universal_filzfelt_blocks__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__universal_filzfelt_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__universal_filzfelt_blocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__universal_filzfelt_patterns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__universal_filzfelt_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__universal_filzfelt_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__universal_spinneybeck_patterns__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__universal_spinneybeck_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__universal_spinneybeck_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__universal_filzfelt_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__universal_filzfelt_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__universal_filzfelt_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_filzfelt_patterns__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_spinneybeck_patterns__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_spinneybeck_get_sp402_variant__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_conversions__ = __webpack_require__(162);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// import { getColorsUsedAndPlaceholders } from '../lib/utils/get-colors-used-and-placeholders';

var _require = __webpack_require__(258),
    getColorsUsedAndPlaceholders = _require.getColorsUsedAndPlaceholders;

var INCHES_IN_METER = 39.3700787;

// START duplicate code for processing pattern 402 (SP)
// NOTE: should refactor code inside src/server/process402Pattern.js to share universally
var sp402VariantNames = __webpack_require__(266);

var blockByPattern = {};
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_15__universal_spinneybeck_patterns___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var id = _step.value;

    var p = __WEBPACK_IMPORTED_MODULE_15__universal_spinneybeck_patterns___default.a[id];
    if (!p.blocks) continue;
    blockByPattern[id] = p.blocks[0].id;
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

var getBlock = function getBlock(patternId) {
  return __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks___default.a[blockByPattern[patternId]];
};

var getBlockName = function getBlockName(brand, id) {
  var block = brand === "filzfelt" ? __WEBPACK_IMPORTED_MODULE_13__universal_filzfelt_blocks___default.a[id] : __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks___default.a[id];
  return block && block.name;
};

function get402variant(data, key) {
  var _key$split$map = key.split(",").map(function (n) {
    return Number(n);
  }),
      _key$split$map2 = __WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_key$split$map, 3),
      i = _key$split$map2[0],
      j = _key$split$map2[1],
      k = _key$split$map2[2];

  var g = (Math.abs(i) + Math.abs(j)) % 2 === 0 ? "0" : "1";
  if (k === 0) return "" + g + k + "0";

  var variant = function variant(v) {
    return "" + g + k + v;
  };

  switch (k) {
    case 1:
      // NE
      if (data[i + 1 + "," + (j - 1) + ",0"]) return variant("3"); // full if has NE neighbor
      if (data[i + "," + (j - 1) + ",0"]) return variant("2"); // 1/2v if has N neighbor
      if (data[i + 1 + "," + j + ",0"]) return variant("1"); // 1/2h if has E neighbor
      return variant("0"); // 1/4 if has no neighbors
    case 2:
      // SE
      if (!data[i + 1 + "," + j + ",0"] && !data[i + "," + (j + 1) + ",0"]) {
        return variant("0"); // 1/4 if has no E and S neighbors
      }
      return null; // no block otherwise
    case 3:
      // SW
      if (data[i - 1 + "," + (j + 1) + ",0"]) return null; // no block if has SW neighbor
      if (data[i + "," + (j + 1) + ",0"]) return variant("2"); // 1/2v if has S neighbor
      if (data[i - 1 + "," + j + ",0"]) return variant("1"); // 1/2h if has W neighbor
      return variant("0"); // 1/4 if has no neighbors
    case 4:
      // NW
      if (!data[i - 1 + "," + j + ",0"] && !data[i + "," + (j - 1) + ",0"]) {
        return variant("0"); // 1/4 if has no W and N neighbors
      }
      return null; // no block otherwise
  }
}

var process402Pattern = function process402Pattern(patternId, designData) {
  var BLOCK = getBlock(patternId);
  if (!BLOCK) return;
  var data = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys___default()(designData)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      var block = designData[key];
      var variant = get402variant(designData, key);
      if (variant) {
        var path = BLOCK.variants[variant];
        data.push(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default()({}, block, { key: key, path: path, variant: variant }));
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return data;
};
// END duplicate code for processing pattern 402 (SP)

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DesignView: __WEBPACK_IMPORTED_MODULE_9__components_DesignView___default.a,
    DownloadPdf: __WEBPACK_IMPORTED_MODULE_10__components_DownloadPdf___default.a,
    SaveForm: __WEBPACK_IMPORTED_MODULE_11__components_SaveForm___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(["sp402Pattern"]), {
    design: function design() {
      return this.$store.state.design;
    },
    brand: function brand() {
      return this.$store.getters.brand;
    },
    metric: function metric() {
      return this.$store.getters.metric;
    },
    galleryLink: function galleryLink() {
      var brand = this.brand;
      return { name: "intro", params: { brand: brand } };
    },
    pattern: function pattern() {
      var pattern = this.brand === "filzfelt" ? __WEBPACK_IMPORTED_MODULE_14__universal_filzfelt_patterns___default.a[this.design.pattern] : __WEBPACK_IMPORTED_MODULE_15__universal_spinneybeck_patterns___default.a[this.design.pattern];
      return pattern;
    },
    patternName: function patternName() {
      var pattern = this.pattern;
      return pattern && pattern.name;
    },
    tileDimensions: function tileDimensions() {
      var pattern = this.brand === "filzfelt" ? __WEBPACK_IMPORTED_MODULE_14__universal_filzfelt_patterns___default.a[this.design.pattern] : __WEBPACK_IMPORTED_MODULE_15__universal_spinneybeck_patterns___default.a[this.design.pattern];

      return this.metric ? pattern && pattern.dimensions && pattern.dimensions.m : pattern && pattern.dimensions && pattern.dimensions.i;
    },
    isSp402: function isSp402() {
      return (/402/.test(this.patternName)
      );
    },
    sb402Pattern: function sb402Pattern() {
      return process402Pattern(this.design.pattern, this.design.data);
    },
    totalTileCountByDimension: function totalTileCountByDimension() {
      var wallWidthInFeet = parseInt(this.width.split("'")[0], 10);
      var wallHeightInFeet = parseInt(this.height.split("'")[0], 10);
      return wallWidthInFeet * wallHeightInFeet;
    },
    totalTilesCount: function totalTilesCount() {
      // execption made for Mosaik patterns
      // tiles are 1' x 1' - tile count is the whole wall, not just what has colors
      if (this.pattern.calcTileCountWithDimensions === true) {
        return this.totalTileCountByDimension;
      }
      return __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys___default()(this.sp402Pattern || this.design.data).length;
    },
    coloredTilesCount: function coloredTilesCount() {
      var _this = this;

      if (this.pattern.calcTileCountWithDimensions === true) {
        return this.totalTileCountByDimension;
      }
      var colored = __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(this.design.data).filter(function (block) {
        return block.color;
      });
      if (this.patternName.startsWith("402")) {
        return __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries___default()(this.design.data).filter(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              block = _ref2[1];

          return block.color;
        }).filter(function (_ref3) {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
              key = _ref4[0];

          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_spinneybeck_get_sp402_variant__["a" /* default */])(_this.design.data, key);
        }).length;
      }

      return __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(this.design.data).filter(function (block) {
        return block.color;
      }).length;
    },
    coloredTilesDimensions: function coloredTilesDimensions() {
      var _design = this.design,
          data = _design.data,
          width = _design.width,
          height = _design.height;

      var x1 = width;
      var x2 = 0;
      var y1 = height;
      var y2 = 0;
      var extend = function extend(x, y) {
        if (x < x1) x1 = x;
        if (x > x2) x2 = x;
        if (y < y1) y1 = y;
        if (y > y2) y2 = y;
      };
      var transform = function transform(_ref5, x, y, r) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            px = _ref6[0],
            py = _ref6[1];

        px += x;
        py += y;
        if (r == null) {
          return [px, py];
        }

        var _r = __WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(r, 3),
            a = _r[0],
            cx = _r[1],
            cy = _r[2];

        cx += x;
        cy += y;
        a *= Math.PI / 180;
        return [cx + Math.cos(a) * (px - cx) - Math.sin(a) * (py - cy), cy + Math.sin(a) * (px - cx) + Math.cos(a) * (py - cy)];
      };
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(data)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref7 = _step3.value;
          var _id = _ref7.id,
              x = _ref7.x,
              y = _ref7.y,
              r = _ref7.r,
              color = _ref7.color,
              points = _ref7.points;

          if (!color) continue;
          if (points) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(points), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _ref8 = _step4.value;

                var _ref9 = __WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref8, 2);

                var _x = _ref9[0];
                var _y = _ref9[1];

                extend(_x, _y);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          } else {
            var bounds = __WEBPACK_IMPORTED_MODULE_13__universal_filzfelt_blocks___default.a[_id].bounds;

            var _bounds = __WEBPACK_IMPORTED_MODULE_7__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(bounds, 4),
                _x2 = _bounds[0],
                _y2 = _bounds[1],
                _bounds$ = _bounds[2],
                x0 = _bounds$ === undefined ? 0 : _bounds$,
                _bounds$2 = _bounds[3],
                y0 = _bounds$2 === undefined ? 0 : _bounds$2;

            var box = [[x0, y0], [_x2, y0], [_x2, _y2], [x0, _y2]];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(box), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var p = _step5.value;

                extend.apply(undefined, __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_toConsumableArray___default()(transform(p, x, y, r)));
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (x1 < 0) x1 = 0;
      if (x2 > width) x2 = width;
      if (y1 < 0) y1 = 0;
      if (y2 > height) y2 = height;
      return {
        width: Math.round(Math.max(x2 - x1, 0)),
        height: Math.round(Math.max(y2 - y1, 0))
      };
    },


    // for mosaik
    colorsUsedAndPlaceholders: function colorsUsedAndPlaceholders() {
      return getColorsUsedAndPlaceholders({ design: this.design, brand: this.brand });
    },
    usedColors: function usedColors() {
      var usedSet = new __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set___default.a();
      var colorUsed = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(this.design.data)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _ref10 = _step6.value;
          var color = _ref10.color;

          if (color) {
            usedSet.add(color);
            colorUsed.push(color);
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var colors = [].concat(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_toConsumableArray___default()(usedSet)).sort().map(function (color) {
        return [color, colorUsed.filter(function (c) {
          return c === color;
        }).length, __WEBPACK_IMPORTED_MODULE_16__universal_filzfelt_colors___default.a[color]];
      });
      return colors;
    },
    usedBlocks: function usedBlocks() {
      var tilesUsed = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(this.design.data)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _ref11 = _step7.value;
          var name = _ref11.name;

          if (name) {
            tilesUsed.push(name);
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return tilesUsed.sort().reduce(function (a, b) {
        return (a[b] = a[b] + 1 || 1) && a;
      }, {});
    },
    sp402Breakdown: function sp402Breakdown() {
      var breakdown = [];
      var qty = {};
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_6__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(_.values(this.sb402Pattern)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _ref12 = _step8.value;
          var _id2 = _ref12.id,
              color = _ref12.color,
              variant = _ref12.variant;

          // let key = getBlockName(this.brand, id);
          // NOTE: replace pattern name with generic "Pattern Element" label for 402
          var key = "Pattern Element";
          if (variant) {
            // 402 quantities
            if (sp402VariantNames[variant]) {
              var sp402key = key + " " + sp402VariantNames[variant];
              qty[sp402key] = qty[sp402key] + 1 || 1;
            }
          } else {
            qty[key] = qty[key] + 1 || 1;
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys___default()(qty).sort().forEach(function (v, i) {
        breakdown.push({ tile: v, count: qty[v] });
      });

      return breakdown;
    },
    width: function width() {
      return this.$store.getters.width;
    },
    height: function height() {
      return this.$store.getters.height;
    }
  }),

  methods: {
    setPattern: function setPattern(payload) {
      this.$store.commit("setPattern", payload);
    },
    inchesToFeetString: function inchesToFeetString(inches) {
      var feetInches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_conversions__["a" /* convertInchesToFeet */])(inches);
      return feetInches.feet + "'-" + feetInches.inches + "\"";
    }
  },

  created: function created() {
    if (!this.design.pattern) {
      this.setPattern(this.brand === "filzfelt" ? __WEBPACK_IMPORTED_MODULE_17__lib_filzfelt_patterns__["a" /* default */][0].id : __WEBPACK_IMPORTED_MODULE_18__lib_spinneybeck_patterns__["a" /* default */][0].id);
    }
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      navItems: [{
        text: 'Color Book',
        url: 'https://www.spinneybeck.com/colorbook/categories/'
      }, {
        text: 'Upholstery Leather',
        url: 'https://www.spinneybeck.com/upholstery-leather/categories/'
      }, {
        text: 'Architectural Products',
        url: 'https://www.spinneybeck.com/architectural-products/'
      }, {
        text: 'Design Tool',
        url: 'http://dt.spinneybeck.com/',
        active: true
      }, {
        text: 'Portfolio',
        url: 'https://www.spinneybeck.com/portfolio/categories/'
      }, { text: 'About', url: 'https://www.spinneybeck.com/about' }, {
        text: 'Shop',
        url: 'https://www.spinneybeck.com/shop/categories/'
      }]
    };
  },

  methods: {
    getClasses: function getClasses(active) {
      console.log('active', active);
      return {
        'c-nav__item': true,
        'c-nav__item--test': true,
        'c-nav__item--active': active
      };
    }
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generate_pattern__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_blocks__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_blocks__);





/* harmony default export */ __webpack_exports__["a"] = (function (id, width, height) {
  var svg = '<svg viewBox="0 0 ' + width + ' ' + height + '">';
  var blocks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__generate_pattern__["a" /* default */])(id, width, height);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(blocks)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;
      var _id = _ref.id,
          points = _ref.points,
          x = _ref.x,
          y = _ref.y,
          r = _ref.r;

      if (points) {
        var fill = __WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_blocks___default.a[_id].placeholderColor || 'transparent';
        svg += '<g><polygon points="' + points.join(' ') + '" fill="' + fill + '" /></g>';
      } else {
        var t = 'translate(' + x + ', ' + y + ')' + (r ? ' rotate(' + r[0] + ', ' + r[1] + ', ' + r[2] + ')' : '');
        if (__WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_blocks___default.a[_id].path) {
          svg += '<path transform="' + t + '" d="' + __WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_blocks___default.a[_id].path + '" />';
        }
        if (__WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_blocks___default.a[_id].variants && __WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_blocks___default.a[_id].variants['1111']) {
          svg += '<path transform="' + t + '" d="' + __WEBPACK_IMPORTED_MODULE_3__universal_filzfelt_blocks___default.a[_id].variants['1111'] + '" />';
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  svg += '<rect width="' + width + '" height="' + height + '" />';
  svg += '</svg>';
  return svg;
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__universal_spinneybeck_blocks__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__universal_spinneybeck_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__universal_spinneybeck_blocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__generate_pattern__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filzfelt_generate_pattern__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__get_sp402_variant__ = __webpack_require__(106);










/* harmony default export */ __webpack_exports__["a"] = (function (id) {
  var _patterns$id = __WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns___default.a[id],
      name = _patterns$id.name,
      _patterns$id$preview = _patterns$id.preview;
  _patterns$id$preview = _patterns$id$preview === undefined ? {} : _patterns$id$preview;
  var _patterns$id$preview$ = _patterns$id$preview.width,
      width = _patterns$id$preview$ === undefined ? 144 : _patterns$id$preview$,
      _patterns$id$preview$2 = _patterns$id$preview.height,
      height = _patterns$id$preview$2 === undefined ? 96 : _patterns$id$preview$2;


  return (/402/.test(name) ? sp402(id, width, height) : dnd(id, width, height)
  );
});

function dnd(id, width, height) {
  var b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__generate_pattern__["a" /* default */])(id, width, height);
  var preview = '<svg viewBox="0 0 ' + width + ' ' + height + '">';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(b)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;
      var _id = _ref.id,
          x = _ref.x,
          y = _ref.y,
          r = _ref.r;

      var d = __WEBPACK_IMPORTED_MODULE_5__universal_spinneybeck_blocks___default.a[_id].d;
      preview += '<g transform="translate(' + x + ' ' + y + ')">';
      preview += '<polygon points="0,0 16,0 16,16 0,16" fill="transparent" />';
      if (d) preview += '<path d="' + d + '" transform="rotate(' + (r || 0) + ' 8 8)" />';
      preview += '</g>';
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  preview += '<rect width="' + width + '" height="' + height + '" />';
  preview += '</svg>';
  return {
    id: id,
    preview: preview,
    name: __WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns___default.a[id].name
  };
}

function sp402(id, width, height) {
  var preview = '<svg viewBox="0 0 ' + width + ' ' + height + '" fill="transparent">';

  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filzfelt_generate_pattern__["a" /* default */])(id, width, height);

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_entries___default()(data)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref2 = _step2.value;

      var _ref3 = __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

      var key = _ref3[0];
      var block = _ref3[1];

      var variant = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__get_sp402_variant__["a" /* default */])(data, key);
      if (variant) {
        preview += '<path transform="translate(' + block.x + ', ' + block.y + ')" d="' + __WEBPACK_IMPORTED_MODULE_5__universal_spinneybeck_blocks___default.a[block.id].variants[variant] + '" />';
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  preview += '<rect width="' + width + '" height="' + height + '" />';
  preview += '</svg>';

  return {
    id: id,
    preview: preview,
    name: __WEBPACK_IMPORTED_MODULE_4__universal_spinneybeck_patterns___default.a[id].name
  };
}

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getColorsUsedAndPlaceholders"] = getColorsUsedAndPlaceholders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__);





var SP_BLOCKS = __webpack_require__(36);
var FF_BLOCKS = __webpack_require__(59);
var COLORS = __webpack_require__(81);

// same as /universal/utils/get-colors-used-and-placeholders.js
// one exported for client, one for server - trying to use it in both places wouldn't work
function getColorsUsedAndPlaceholders(_ref) {
    var design = _ref.design,
        brand = _ref.brand;

    var usedBlocks = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(design.data).map(function (block) {
        return block.id;
    });
    var blockIds = [].concat(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set___default.a(usedBlocks)));
    var blocks = blockIds.map(function (id) {
        var block = brand === "filzfelt" ? FF_BLOCKS[id] : SP_BLOCKS[id];
        return {
            id: id,
            name: block.name,
            placeholderColor: block.placeholderColor
        };
    });

    // if there are no placeholder colors, return empty array and show usedColors
    var blocksWithPlaceholderColors = blocks.filter(function (block) {
        return block.placeholderColor;
    });
    if (blocksWithPlaceholderColors.length === 0) {
        return [];
    }

    var usedSet = new __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set___default.a();
    var colorUsed = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(design.data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;
            var color = _ref2.color;

            if (color) {
                usedSet.add(color);
                colorUsed.push(color);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var usedColors = {};
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(design.data)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref3 = _step2.value;
            var _color = _ref3.color,
                id = _ref3.id;

            if (_color) {
                usedColors[id] = _color;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var blocksWithUsedColors = blocks.map(function (block) {
        var usedColor = usedColors[block.id] ? COLORS[usedColors[block.id]] : null;
        return __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default()({}, block, {
            usedColor: usedColor
        });
    });
    return blocksWithUsedColors;
};

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_filzfelt_generate_pattern__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_spinneybeck_generate_pattern__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__universal_spinneybeck_patterns__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__universal_spinneybeck_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__universal_spinneybeck_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__universal_filzfelt_patterns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__universal_filzfelt_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__universal_filzfelt_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__universal_spinneybeck_blocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_spinneybeck_get_sp402_variant__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_api__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__lib_constants__);


















var generate = function generate(id) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (id in __WEBPACK_IMPORTED_MODULE_11__universal_filzfelt_patterns___default.a) return __WEBPACK_IMPORTED_MODULE_8__lib_filzfelt_generate_pattern__["a" /* default */].apply(undefined, [id].concat(args));
  if (id in __WEBPACK_IMPORTED_MODULE_10__universal_spinneybeck_patterns___default.a) return __WEBPACK_IMPORTED_MODULE_9__lib_spinneybeck_generate_pattern__["a" /* default */].apply(undefined, [id].concat(args));
};

var toCentimeters = function toCentimeters(value) {
  return Math.round(value * 2.54);
};

__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */].Store({
  state: {
    brand: 'filzfelt',
    design: {
      pattern: null,
      width: __WEBPACK_IMPORTED_MODULE_16__lib_constants__["DEFAULT_WALL_WIDTH"],
      height: __WEBPACK_IMPORTED_MODULE_16__lib_constants__["DEFAULT_WALL_HEIGHT"],
      data: []
    },
    metric: false,
    email: null,
    authorized: false,
    secret: null,
    saveError: null,
    saveSuccess: null
  },

  getters: {
    brand: function brand(state) {
      if (state.route.params.brand) return state.route.params.brand;
      var p = state.design.pattern;
      if (p in __WEBPACK_IMPORTED_MODULE_11__universal_filzfelt_patterns___default.a) return 'filzfelt';
      if (p in __WEBPACK_IMPORTED_MODULE_10__universal_spinneybeck_patterns___default.a) return 'spinneybeck';
      return 'filzfelt';
    },
    metric: function metric(state) {
      return state.metric;
    },
    design: function design(state) {
      return state.design;
    },
    width: function width(state) {
      if (state.metric) {
        return toCentimeters(state.design.width) + ' cm';
      }
      var inches = state.design.width.toFixed(0);
      var feet = Math.floor(inches / 12);
      return inches && inches > 0 ? feet + '\'-' + inches % 12 + '"' : feet + '\'';
    },
    height: function height(state) {
      if (state.metric) {
        return toCentimeters(state.design.height) + ' cm';
      }
      var inches = state.design.height.toFixed(0);
      var feet = Math.floor(inches / 12);
      return inches && inches > 0 ? feet + '\'-' + inches % 12 + '"' : feet + '\'';
    },


    // sp402BlockInUse (state) {
    //   const blockId = {
    //     'aff5ea63-34c8-40f0-8c65-a510460ba076': 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9',
    //     '281d02c2-e7e5-4252-9e7b-2068a366fc01': '4a64a548-bcbb-48d6-8c60-86af1371d164',
    //     'cd9ca5e5-ed19-4729-812c-8182ab8fc5c7': '3eadae5c-c35d-4f74-a516-a9e0795ac76f'
    //   }[state.design.pattern]
    //   return SP_BLOCKS[blockId]
    // },

    sp402Pattern: function sp402Pattern(state, getters) {
      var BLOCK = getters.sp402BlockInUse;
      if (!BLOCK) return;
      var data = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_keys___default()(state.design.data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var block = state.design.data[key];
          var variant = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_spinneybeck_get_sp402_variant__["a" /* default */])(state.design.data, key);
          if (variant) {
            var path = BLOCK.variants[variant];
            data.push(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_helpers_extends___default()({}, block, { key: key, path: path }));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return data;
    }
  },

  mutations: {
    setBrand: function setBrand(state, brand) {
      state.brand = brand;
    },
    setDesignData: function setDesignData(state, design) {
      var _arr = ['data', 'pattern', 'width', 'height'];

      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];
        state.design[key] = design[key];
      }
    },
    setPattern: function setPattern(state, pattern) {
      var _state$design = state.design,
          oldPattern = _state$design.pattern,
          width = _state$design.width,
          height = _state$design.height,
          data = _state$design.data;

      state.design.data = generate(pattern, width, height, pattern === oldPattern ? data : undefined);
      state.design.pattern = pattern;
    },
    setWidth: function setWidth(state, width) {
      var _state$design2 = state.design,
          pattern = _state$design2.pattern,
          height = _state$design2.height,
          data = _state$design2.data;

      state.design.width = width || 0;
      state.design.data = generate(pattern, width, height, data);
    },
    setHeight: function setHeight(state, height) {
      var _state$design3 = state.design,
          pattern = _state$design3.pattern,
          width = _state$design3.width,
          data = _state$design3.data;

      state.design.height = height || 0;
      state.design.data = generate(pattern, width, height, data);
    },
    setColor: function setColor(state, _ref) {
      var key = _ref.key,
          color = _ref.color;

      var block = state.design.data[key];
      if (!block) return;
      if (block.color !== color) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(block, 'color', color);
      } else {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(block, 'color');
      }
    },
    setColorForSameBlockType: function setColorForSameBlockType(state, _ref2) {
      var key = _ref2.key,
          color = _ref2.color;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(state.design.data)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var block = _step2.value;

          if (block.id === state.design.data[key].id) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(block, 'color', color);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    setColorForAll: function setColorForAll(state, color) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(state.design.data)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var block = _step3.value;

          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(block, 'color', color);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    clearColorForAll: function clearColorForAll(state) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_object_values___default()(state.design.data)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var block = _step4.value;

          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(block, 'color');
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    setCustomBlock: function setCustomBlock(state, _ref3) {
      var key = _ref3.key,
          id = _ref3.id,
          name = _ref3.name,
          r = _ref3.r;

      var block = state.design.data[key];
      if (!block) return;
      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(block, 'id', id);
      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(block, 'name', name);
      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(block, 'r', r);
    },
    setBlockRotate: function setBlockRotate(state, _ref4) {
      var key = _ref4.key,
          r = _ref4.r;

      var block = state.design.data[key];
      if (!block) return;
      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(block, 'r', r);
    },
    setEmail: function setEmail(state, email) {
      state.email = email;
    },
    setSecret: function setSecret(state, secret) {
      state.secret = secret;
    },
    setAuthorized: function setAuthorized(state, authorized) {
      state.authorized = authorized;
    },
    setSaveError: function setSaveError(state, saveError) {
      state.saveError = saveError;
    },
    setSaveSuccess: function setSaveSuccess(state, saveSuccess) {
      state.saveSuccess = saveSuccess;
    },
    setMetric: function setMetric(state, metric) {
      state.metric = metric;
    }
  },

  actions: {
    save: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state;

        var design, email, secret, brand, _state$route$params, id, slug, _ref7, _id;

        return __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                design = state.design, email = state.email, secret = state.secret, brand = state.brand;
                _state$route$params = state.route.params, id = _state$route$params.id, slug = _state$route$params.slug;
                _context.prev = 2;

                if (!(id && !slug)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_15__lib_api__["a" /* designs */].update(id, { design: design, secret: secret });

              case 6:
                _context.next = 13;
                break;

              case 8:
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_15__lib_api__["a" /* designs */].create({ design: design, email: email, secret: secret, brand: brand });

              case 10:
                _ref7 = _context.sent;
                _id = _ref7.id;

                __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */].push({ params: { id: _id, slug: null } });

              case 13:
                commit('setAuthorized', true);
                commit('setSaveSuccess', 'Design updated.');
                setTimeout(function () {
                  return commit('setSaveSuccess', null);
                }, 3000);
                commit('setSaveError', null);
                _context.next = 26;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](2);

                if (!(_context.t0.response.status === 403)) {
                  _context.next = 25;
                  break;
                }

                commit('setSaveError', 'Incorrect secret.');
                _context.next = 26;
                break;

              case 25:
                throw _context.t0;

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 19]]);
      }));

      function save(_x) {
        return _ref6.apply(this, arguments);
      }

      return save;
    }(),
    setPatternById: function setPatternById(_ref8, id) {
      var commit = _ref8.commit,
          state = _ref8.state;

      var slug = null;
      if (state.brand === 'filzfelt') {
        slug = __WEBPACK_IMPORTED_MODULE_11__universal_filzfelt_patterns___default.a[id].name;
      } else if (state.brand === 'spinneybeck') {
        slug = __WEBPACK_IMPORTED_MODULE_10__universal_spinneybeck_patterns___default.a[id].name;
      }

      if (!id || !slug) return;

      commit('setPattern', id);
      // update path to current pattern
      __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */].push({ params: { id: id, slug: slug } });
    }
  }
}));

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports = {
      'color-1': {
            name: 'Color 1',
            fillAll: true,
            placeholderColor: 'rgb(225, 223, 220)',
            border: [[0, 0], [2, 0], [2, 2], [0, 2], [0, 0], [0, 2], [2, 2], [2, 4], [0, 4], [0, 2], [0, 4], [2, 4], [2, 6], [0, 6], [0, 4], [0, 12], [2, 12], [2, 14], [0, 14], [0, 12], [0, 14], [2, 14], [2, 16], [0, 16], [0, 14], [0, 16], [2, 16], [2, 18], [0, 18], [0, 24], [2, 24], [2, 26], [0, 26], [0, 24], [0, 26], [2, 26], [2, 28], [0, 28], [0, 26], [0, 28], [2, 28], [2, 30], [0, 30], [0, 28], [0, 24], [2, 24], [2, 30], [0, 30], [0, 24], [0, 30], [0, 36], [2, 36], [2, 38], [0, 38], [0, 36], [0, 38], [2, 38], [2, 40], [0, 40], [0, 38], [0, 40], [2, 40], [2, 42], [0, 42], [0, 36], [2, 36], [2, 42], [0, 42], [0, 36], [0, 48], [2, 48], [2, 50], [0, 50], [0, 48], [0, 50], [2, 50], [2, 52], [0, 52], [0, 50], [0, 52], [2, 52], [2, 54], [0, 54], [0, 48], [2, 48], [2, 54], [0, 54], [0, 48], [0, 60], [2, 60], [2, 62], [0, 62], [0, 60], [0, 62], [2, 62], [2, 64], [0, 64], [0, 62], [0, 64], [2, 64], [2, 66], [0, 66], [0, 60], [0, 72], [2, 72], [2, 74], [0, 74], [0, 72], [0, 74], [2, 74], [2, 76], [0, 76], [0, 74], [0, 76], [2, 76], [2, 78], [0, 78], [0, 72], [2, 72], [2, 78], [0, 78], [0, 84], [2, 84], [2, 86], [0, 86], [0, 84], [0, 86], [2, 86], [2, 88], [0, 88], [0, 86], [0, 88], [2, 88], [2, 90], [0, 90], [0, 84], [0, 0], [2, 0], [2, 6], [4, 6], [4, 6], [4, 8], [2, 8], [2, 6], [2, 8], [4, 8], [4, 10], [2, 10], [2, 8], [2, 10], [4, 10], [4, 12], [2, 12], [2, 18], [4, 18], [4, 20], [2, 20], [2, 18], [2, 20], [4, 20], [4, 22], [2, 22], [2, 20], [2, 22], [4, 22], [4, 24], [2, 24], [2, 18], [2, 24], [4, 24], [4, 26], [2, 26], [2, 24], [2, 30], [4, 30], [4, 32], [2, 32], [2, 30], [2, 32], [4, 32], [4, 34], [2, 34], [2, 32], [2, 34], [4, 34], [4, 36], [2, 36], [2, 30], [2, 36], [4, 36], [4, 38], [2, 38], [2, 36], [2, 30], [2, 42], [4, 42], [4, 44], [2, 44], [2, 42], [2, 44], [4, 44], [4, 46], [2, 46], [2, 44], [2, 46], [4, 46], [4, 48], [2, 48], [2, 42], [2, 48], [4, 48], [4, 50], [2, 50], [2, 48], [2, 42], [2, 54], [4, 54], [4, 56], [2, 56], [2, 54], [2, 56], [4, 56], [4, 58], [2, 58], [2, 56], [2, 58], [4, 58], [4, 60], [2, 60], [2, 54], [2, 60], [2, 66], [4, 66], [4, 68], [2, 68], [2, 66], [2, 68], [4, 68], [4, 70], [2, 70], [2, 68], [2, 70], [4, 70], [4, 72], [2, 72], [2, 66], [2, 72], [4, 72], [4, 74], [2, 74], [2, 78], [4, 78], [4, 80], [2, 80], [2, 78], [2, 80], [4, 80], [4, 82], [2, 82], [2, 80], [2, 82], [4, 82], [4, 84], [2, 84], [2, 78], [2, 84], [4, 84], [4, 86], [2, 86], [2, 84], [2, 90], [4, 90], [4, 92], [2, 92], [2, 90], [2, 92], [4, 92], [4, 94], [2, 94], [2, 92], [2, 94], [4, 94], [4, 96], [2, 96], [2, 90], [2, 0], [6, 0], [6, 2], [4, 2], [4, 0], [4, 2], [6, 2], [6, 4], [4, 4], [4, 2], [4, 4], [6, 4], [6, 6], [4, 6], [4, 4], [4, 0], [4, 12], [6, 12], [6, 14], [4, 14], [4, 12], [4, 14], [6, 14], [6, 16], [4, 16], [4, 14], [4, 16], [6, 16], [6, 18], [4, 18], [4, 12], [4, 18], [6, 18], [6, 20], [4, 20], [4, 18], [4, 24], [6, 24], [6, 26], [4, 26], [4, 24], [4, 26], [6, 26], [6, 28], [4, 28], [4, 26], [4, 28], [6, 28], [6, 30], [4, 30], [4, 24], [4, 30], [4, 36], [6, 36], [6, 38], [4, 38], [4, 36], [4, 38], [6, 38], [6, 40], [4, 40], [4, 38], [4, 40], [6, 40], [6, 42], [4, 42], [4, 36], [4, 42], [6, 42], [6, 44], [4, 44], [4, 48], [6, 48], [6, 50], [4, 50], [4, 48], [4, 50], [6, 50], [6, 52], [4, 52], [4, 50], [4, 52], [6, 52], [6, 54], [4, 54], [4, 48], [4, 54], [6, 54], [6, 56], [4, 56], [4, 54], [4, 60], [6, 60], [6, 62], [4, 62], [4, 60], [4, 62], [6, 62], [6, 64], [4, 64], [4, 62], [4, 64], [6, 64], [6, 66], [4, 66], [4, 60], [4, 66], [6, 66], [6, 68], [4, 68], [4, 66], [4, 72], [6, 72], [6, 74], [4, 74], [4, 72], [4, 74], [6, 74], [6, 76], [4, 76], [4, 74], [4, 76], [6, 76], [6, 78], [4, 78], [4, 72], [4, 84], [6, 84], [6, 86], [4, 86], [4, 84], [4, 86], [6, 86], [6, 88], [4, 88], [4, 86], [4, 88], [6, 88], [6, 90], [4, 90], [4, 84], [4, 0], [6, 0], [6, 6], [8, 6], [8, 6], [8, 8], [6, 8], [6, 6], [6, 8], [8, 8], [8, 10], [6, 10], [6, 8], [6, 10], [8, 10], [8, 12], [6, 12], [6, 18], [8, 18], [8, 20], [6, 20], [6, 18], [6, 20], [8, 20], [8, 22], [6, 22], [6, 20], [6, 22], [8, 22], [8, 24], [6, 24], [6, 18], [6, 24], [8, 24], [8, 26], [6, 26], [6, 30], [8, 30], [8, 32], [6, 32], [6, 30], [6, 32], [8, 32], [8, 34], [6, 34], [6, 32], [6, 34], [8, 34], [8, 36], [6, 36], [6, 30], [6, 42], [8, 42], [8, 44], [6, 44], [6, 42], [6, 44], [8, 44], [8, 46], [6, 46], [6, 44], [6, 46], [8, 46], [8, 48], [6, 48], [6, 42], [6, 48], [8, 48], [8, 50], [6, 50], [6, 48], [6, 42], [6, 54], [8, 54], [8, 56], [6, 56], [6, 54], [6, 56], [8, 56], [8, 58], [6, 58], [6, 56], [6, 58], [8, 58], [8, 60], [6, 60], [6, 54], [6, 60], [8, 60], [8, 62], [6, 62], [6, 60], [6, 54], [6, 66], [8, 66], [8, 68], [6, 68], [6, 66], [6, 68], [8, 68], [8, 70], [6, 70], [6, 68], [6, 70], [8, 70], [8, 72], [6, 72], [6, 66], [6, 78], [8, 78], [8, 80], [6, 80], [6, 78], [6, 80], [8, 80], [8, 82], [6, 82], [6, 80], [6, 82], [8, 82], [8, 84], [6, 84], [6, 78], [6, 90], [8, 90], [8, 92], [6, 92], [6, 90], [6, 92], [8, 92], [8, 94], [6, 94], [6, 92], [6, 94], [8, 94], [8, 96], [6, 96], [6, 90], [6, 0], [10, 0], [10, 2], [8, 2], [8, 0], [8, 2], [10, 2], [10, 4], [8, 4], [8, 2], [8, 4], [10, 4], [10, 6], [8, 6], [8, 4], [8, 0], [8, 12], [10, 12], [10, 14], [8, 14], [8, 12], [8, 14], [10, 14], [10, 16], [8, 16], [8, 14], [8, 16], [10, 16], [10, 18], [8, 18], [8, 12], [8, 24], [10, 24], [10, 26], [8, 26], [8, 24], [8, 26], [10, 26], [10, 28], [8, 28], [8, 26], [8, 28], [10, 28], [10, 30], [8, 30], [8, 24], [8, 36], [10, 36], [10, 38], [8, 38], [8, 36], [8, 38], [10, 38], [10, 40], [8, 40], [8, 38], [8, 40], [10, 40], [10, 42], [8, 42], [8, 36], [8, 48], [10, 48], [10, 50], [8, 50], [8, 48], [8, 50], [10, 50], [10, 52], [8, 52], [8, 50], [8, 52], [10, 52], [10, 54], [8, 54], [8, 48], [8, 60], [10, 60], [10, 62], [8, 62], [8, 60], [8, 62], [10, 62], [10, 64], [8, 64], [8, 62], [8, 64], [10, 64], [10, 66], [8, 66], [8, 60], [8, 72], [10, 72], [10, 74], [8, 74], [8, 72], [8, 74], [10, 74], [10, 76], [8, 76], [8, 74], [8, 76], [10, 76], [10, 78], [8, 78], [8, 72], [8, 84], [10, 84], [10, 86], [8, 86], [8, 84], [8, 86], [10, 86], [10, 88], [8, 88], [8, 86], [8, 88], [10, 88], [10, 90], [8, 90], [8, 84], [8, 0], [10, 0], [10, 6], [12, 6], [12, 6], [12, 8], [10, 8], [10, 6], [10, 8], [12, 8], [12, 10], [10, 10], [10, 8], [10, 10], [12, 10], [12, 12], [10, 12], [10, 6], [10, 18], [12, 18], [12, 20], [10, 20], [10, 18], [10, 20], [12, 20], [12, 22], [10, 22], [10, 20], [10, 22], [12, 22], [12, 24], [10, 24], [10, 18], [10, 30], [12, 30], [12, 32], [10, 32], [10, 30], [10, 32], [12, 32], [12, 34], [10, 34], [10, 32], [10, 34], [12, 34], [12, 36], [10, 36], [10, 30], [10, 42], [12, 42], [12, 44], [10, 44], [10, 42], [10, 44], [12, 44], [12, 46], [10, 46], [10, 44], [10, 46], [12, 46], [12, 48], [10, 48], [10, 42], [10, 54], [12, 54], [12, 56], [10, 56], [10, 54], [10, 56], [12, 56], [12, 58], [10, 58], [10, 56], [10, 58], [12, 58], [12, 60], [10, 60], [10, 54], [10, 66], [12, 66], [12, 68], [10, 68], [10, 66], [10, 68], [12, 68], [12, 70], [10, 70], [10, 68], [10, 70], [12, 70], [12, 72], [10, 72], [10, 66], [10, 78], [12, 78], [12, 80], [10, 80], [10, 78], [10, 80], [12, 80], [12, 82], [10, 82], [10, 80], [10, 82], [12, 82], [12, 84], [10, 84], [10, 78], [10, 90], [12, 90], [12, 92], [10, 92], [10, 90], [10, 92], [12, 92], [12, 94], [10, 94], [10, 92], [10, 94], [12, 94], [12, 96], [10, 96], [10, 90], [10, 0]]
      },
      'color-2': {
            name: 'Color 2',
            fillAll: true,
            placeholderColor: 'rgb(159, 160, 162)',
            border: [[0, 0], [0, 54], [2, 54], [2, 56], [0, 56], [0, 54], [0, 56], [2, 56], [2, 58], [0, 58], [0, 56], [0, 58], [2, 58], [2, 60], [0, 60], [0, 54], [2, 54], [2, 48], [4, 48], [4, 48], [4, 50], [2, 50], [2, 48], [2, 50], [4, 50], [4, 52], [2, 52], [2, 50], [2, 52], [4, 52], [4, 54], [2, 54], [2, 48], [4, 48], [4, 54], [2, 54], [0, 54], [6, 54], [6, 56], [4, 56], [4, 54], [4, 56], [6, 56], [6, 58], [4, 58], [4, 56], [4, 58], [6, 58], [6, 60], [4, 60], [4, 58], [4, 54], [6, 54], [6, 48], [8, 48], [8, 50], [6, 50], [6, 48], [6, 50], [8, 50], [8, 52], [6, 52], [6, 50], [6, 52], [8, 52], [8, 54], [6, 54], [6, 48], [8, 48], [8, 54], [10, 54], [10, 56], [8, 56], [8, 54], [8, 56], [10, 56], [10, 58], [8, 58], [8, 56], [8, 58], [10, 58], [10, 60], [8, 60], [8, 58], [8, 54], [10, 54], [10, 48], [12, 48], [12, 50], [10, 50], [10, 48], [10, 50], [12, 50], [12, 52], [10, 52], [10, 50], [10, 52], [12, 52], [12, 54], [0, 54]]
      },
      'color-3': {
            name: 'Color 3',
            fillAll: true,
            placeholderColor: 'rgb(149, 148, 144)',
            border: [[0, 0], [0, 42], [2, 42], [2, 44], [0, 44], [0, 42], [0, 44], [2, 44], [2, 46], [0, 46], [0, 44], [0, 46], [2, 46], [2, 48], [0, 48], [0, 42], [2, 42], [2, 48], [0, 48], [0, 42], [2, 42], [2, 36], [4, 36], [4, 36], [4, 38], [2, 38], [2, 36], [2, 38], [4, 38], [4, 40], [2, 40], [2, 38], [2, 40], [4, 40], [4, 42], [2, 42], [2, 36], [4, 36], [4, 42], [2, 42], [0, 42], [6, 42], [6, 44], [4, 44], [4, 42], [4, 44], [6, 44], [6, 46], [4, 46], [4, 44], [4, 46], [6, 46], [6, 48], [4, 48], [4, 46], [4, 42], [6, 42], [6, 36], [8, 36], [8, 38], [6, 38], [6, 36], [6, 38], [8, 38], [8, 40], [6, 40], [6, 38], [6, 40], [8, 40], [8, 42], [6, 42], [10, 42], [10, 44], [8, 44], [8, 42], [8, 44], [10, 44], [10, 46], [8, 46], [8, 44], [8, 46], [10, 46], [10, 48], [8, 48], [8, 46], [8, 42], [10, 42], [10, 36], [12, 36], [12, 38], [10, 38], [10, 36], [10, 38], [12, 38], [12, 40], [10, 40], [10, 38], [10, 40], [12, 40], [12, 42], [0, 42], [0, 66], [2, 66], [2, 68], [0, 68], [0, 66], [0, 68], [2, 68], [2, 70], [0, 70], [0, 68], [0, 70], [2, 70], [2, 72], [0, 72], [0, 66], [2, 66], [2, 72], [0, 72], [0, 66], [2, 66], [2, 60], [4, 60], [4, 60], [4, 62], [2, 62], [2, 60], [2, 62], [4, 62], [4, 64], [2, 64], [2, 62], [2, 64], [4, 64], [4, 66], [2, 66], [0, 66], [6, 66], [6, 68], [4, 68], [4, 66], [4, 68], [6, 68], [6, 70], [4, 70], [4, 68], [4, 70], [6, 70], [6, 72], [4, 72], [4, 70], [4, 66], [6, 66], [6, 60], [8, 60], [8, 62], [6, 62], [6, 60], [6, 62], [8, 62], [8, 64], [6, 64], [6, 62], [6, 64], [8, 64], [8, 66], [6, 66], [10, 66], [10, 68], [8, 68], [8, 66], [8, 68], [10, 68], [10, 70], [8, 70], [8, 68], [8, 70], [10, 70], [10, 72], [8, 72], [8, 70], [8, 66], [10, 66], [10, 60], [12, 60], [12, 62], [10, 62], [10, 60], [10, 62], [12, 62], [12, 64], [10, 64], [10, 62], [10, 64], [12, 64], [12, 66], [0, 66]]
      },
      'color-4': {
            name: 'Color 4',
            fillAll: true,
            placeholderColor: 'rgb(152, 150, 156)',
            border: [[0, 0], [0, 30], [2, 30], [2, 32], [0, 32], [0, 30], [0, 32], [2, 32], [2, 34], [0, 34], [0, 32], [0, 34], [2, 34], [2, 36], [0, 36], [0, 30], [2, 30], [2, 24], [4, 24], [4, 24], [4, 26], [2, 26], [2, 24], [2, 26], [4, 26], [4, 28], [2, 28], [2, 26], [2, 28], [4, 28], [4, 30], [2, 30], [6, 30], [6, 32], [4, 32], [4, 30], [4, 32], [6, 32], [6, 34], [4, 34], [4, 32], [4, 34], [6, 34], [6, 36], [4, 36], [4, 34], [4, 30], [6, 30], [6, 24], [8, 24], [8, 26], [6, 26], [6, 24], [6, 26], [8, 26], [8, 28], [6, 28], [6, 26], [6, 28], [8, 28], [8, 30], [6, 30], [6, 24], [8, 24], [8, 30], [10, 30], [10, 32], [8, 32], [8, 30], [8, 32], [10, 32], [10, 34], [8, 34], [8, 32], [8, 34], [10, 34], [10, 36], [8, 36], [8, 34], [8, 30], [10, 30], [10, 24], [12, 24], [12, 26], [10, 26], [10, 24], [10, 26], [12, 26], [12, 28], [10, 28], [10, 26], [10, 28], [12, 28], [12, 30], [10, 30], [10, 24], [12, 24], [12, 30], [10, 30], [0, 30], [0, 78], [2, 78], [2, 80], [0, 80], [0, 78], [0, 80], [2, 80], [2, 82], [0, 82], [0, 80], [0, 82], [2, 82], [2, 84], [0, 84], [0, 78], [2, 78], [2, 72], [4, 72], [4, 72], [4, 74], [2, 74], [2, 72], [2, 74], [4, 74], [4, 76], [2, 76], [2, 74], [2, 76], [4, 76], [4, 78], [2, 78], [6, 78], [6, 80], [4, 80], [4, 78], [4, 80], [6, 80], [6, 82], [4, 82], [4, 80], [4, 82], [6, 82], [6, 84], [4, 84], [4, 82], [4, 78], [6, 78], [6, 78], [6, 72], [8, 72], [8, 74], [6, 74], [6, 72], [6, 74], [8, 74], [8, 76], [6, 76], [6, 74], [6, 76], [8, 76], [8, 78], [6, 78], [6, 72], [8, 72], [8, 78], [10, 78], [10, 80], [8, 80], [8, 78], [8, 80], [10, 80], [10, 82], [8, 82], [8, 80], [8, 82], [10, 82], [10, 84], [8, 84], [8, 82], [8, 78], [10, 78], [10, 84], [8, 84], [8, 78], [10, 78], [10, 72], [12, 72], [12, 74], [10, 74], [10, 72], [10, 74], [12, 74], [12, 76], [10, 76], [10, 74], [10, 76], [12, 76], [12, 78], [10, 78], [10, 72], [12, 72], [12, 78], [0, 78]]
      },
      'color-5': {
            name: 'Color 5',
            fillAll: true,
            placeholderColor: 'rgb(106, 105, 111)',
            border: [[0, 0], [0, 18], [2, 18], [2, 20], [0, 20], [0, 18], [0, 20], [2, 20], [2, 22], [0, 22], [0, 20], [0, 22], [2, 22], [2, 24], [0, 24], [0, 12], [4, 12], [4, 14], [2, 14], [2, 12], [2, 14], [4, 14], [4, 16], [2, 16], [2, 14], [2, 16], [4, 16], [4, 18], [2, 18], [2, 16], [2, 12], [4, 12], [4, 18], [6, 18], [6, 20], [4, 20], [4, 18], [4, 20], [6, 20], [6, 22], [4, 22], [4, 20], [4, 22], [6, 22], [6, 24], [4, 24], [4, 18], [6, 18], [4, 18], [4, 12], [8, 12], [8, 14], [6, 14], [6, 12], [6, 14], [8, 14], [8, 16], [6, 16], [6, 14], [6, 16], [8, 16], [8, 18], [6, 18], [6, 16], [6, 12], [8, 12], [8, 18], [10, 18], [10, 20], [8, 20], [8, 18], [8, 20], [10, 20], [10, 22], [8, 22], [8, 20], [8, 22], [10, 22], [10, 24], [8, 24], [8, 18], [10, 18], [8, 18], [8, 12], [12, 12], [12, 14], [10, 14], [10, 12], [10, 14], [12, 14], [12, 16], [10, 16], [10, 14], [10, 16], [12, 16], [12, 18], [10, 18], [10, 16], [10, 12], [0, 12], [0, 0], [0, 90], [2, 90], [2, 92], [0, 92], [0, 90], [0, 92], [2, 92], [2, 94], [0, 94], [0, 92], [0, 94], [2, 94], [2, 96], [0, 96], [0, 94], [0, 84], [4, 84], [4, 86], [2, 86], [2, 84], [2, 86], [4, 86], [4, 88], [2, 88], [2, 86], [2, 88], [4, 88], [4, 90], [2, 90], [2, 84], [0, 84], [4, 84], [4, 90], [6, 90], [6, 92], [4, 92], [4, 90], [4, 92], [6, 92], [6, 94], [4, 94], [4, 92], [4, 94], [6, 94], [6, 96], [4, 96], [4, 84], [8, 84], [8, 86], [6, 86], [6, 84], [6, 86], [8, 86], [8, 88], [6, 88], [6, 86], [6, 88], [8, 88], [8, 90], [6, 90], [6, 88], [6, 84], [8, 84], [8, 90], [10, 90], [10, 92], [8, 92], [8, 90], [8, 92], [10, 92], [10, 94], [8, 94], [8, 92], [8, 94], [10, 94], [10, 96], [8, 96], [8, 90], [8, 84], [12, 84], [12, 86], [10, 86], [10, 84], [10, 86], [12, 86], [12, 88], [10, 88], [10, 86], [10, 88], [12, 88], [12, 90], [10, 90], [10, 88], [10, 84], [12, 84], [12, 90], [10, 90], [10, 84], [0, 84]]
      },
      'color-6': {
            name: 'Color 6',
            fillAll: true,
            placeholderColor: 'rgb(60,64,70)',
            border: [[0, 0], [0, 6], [2, 6], [2, 8], [0, 8], [0, 6], [0, 8], [2, 8], [2, 10], [0, 10], [0, 8], [0, 10], [2, 10], [2, 12], [0, 12], [0, 10], [0, 0], [4, 0], [4, 2], [2, 2], [2, 0], [2, 2], [4, 2], [4, 4], [2, 4], [2, 2], [2, 4], [4, 4], [4, 6], [2, 6], [2, 4], [2, 6], [2, 0], [4, 0], [4, 6], [6, 6], [6, 8], [4, 8], [4, 6], [4, 8], [6, 8], [6, 10], [4, 10], [4, 8], [4, 10], [6, 10], [6, 12], [4, 12], [4, 10], [4, 0], [8, 0], [8, 2], [6, 2], [6, 0], [6, 2], [8, 2], [8, 4], [6, 4], [6, 2], [6, 4], [8, 4], [8, 6], [6, 6], [6, 4], [6, 0], [8, 0], [8, 6], [10, 6], [10, 8], [8, 8], [8, 6], [8, 8], [10, 8], [10, 10], [8, 10], [8, 8], [8, 10], [10, 10], [10, 12], [8, 12], [8, 10], [8, 0], [12, 0], [12, 2], [10, 2], [10, 0], [10, 2], [12, 2], [12, 4], [10, 4], [10, 2], [10, 4], [12, 4], [12, 6], [10, 6], [10, 4], [10, 0]]
      }
};

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports = {
      'color-1': {
            name: 'Color 1',
            fillAll: true,
            placeholderColor: 'rgb(211,208,201)',
            border: [[0, 0], [2, 0], [2, 2], [0, 2], [0, 0], [4, 0], [4, 2], [2, 2], [2, 0], [0, 0], [0, 2], [2, 2], [2, 4], [0, 4], [0, 2], [0, 4], [2, 4], [2, 2], [4, 2], [4, 4], [0, 4], [0, 8], [2, 8], [2, 10], [0, 10], [0, 8], [4, 8], [4, 10], [2, 10], [2, 8], [4, 8], [4, 12], [2, 12], [2, 10], [4, 10], [4, 12], [2, 12], [0, 12], [0, 10], [2, 10], [2, 12], [0, 12], [8, 12], [8, 10], [10, 10], [10, 12], [8, 12], [8, 8], [10, 8], [10, 10], [8, 10], [8, 8], [10, 8], [12, 8], [12, 10], [10, 10], [10, 8], [12, 8], [12, 10], [12, 12], [10, 12], [10, 10], [12, 10], [12, 12], [0, 12], [0, 0], [8, 0], [8, 2], [10, 2], [10, 0], [8, 0], [8, 4], [10, 4], [10, 2], [8, 2], [8, 0], [12, 0], [12, 2], [10, 2], [10, 0], [12, 0], [12, 2], [10, 2], [10, 4], [12, 4], [12, 0]]
      },
      'color-2': {
            name: 'Color 2',
            fillAll: true,
            placeholderColor: 'rgb(159,160,163)',
            border: [[0, 0], [0, 4], [2, 4], [2, 6], [0, 6], [0, 4], [4, 4], [4, 6], [2, 6], [2, 4], [0, 4], [0, 6], [2, 6], [2, 8], [0, 8], [0, 6], [4, 6], [4, 8], [2, 8], [2, 6], [0, 6], [0, 12], [4, 12], [4, 8], [6, 8], [6, 10], [4, 10], [4, 8], [8, 8], [8, 10], [6, 10], [6, 8], [4, 8], [4, 12], [4, 10], [6, 10], [6, 12], [4, 12], [6, 12], [6, 10], [8, 10], [8, 12], [6, 12], [8, 12], [4, 12], [12, 12], [0, 12], [0, 0], [6, 0], [6, 2], [4, 2], [4, 0], [6, 0], [6, 4], [4, 4], [4, 2], [6, 2], [6, 0], [8, 0], [8, 2], [6, 2], [6, 0], [6, 2], [8, 2], [8, 4], [6, 4], [6, 2], [6, 0], [12, 0], [12, 4], [10, 4], [10, 6], [12, 6], [12, 4], [10, 4], [10, 8], [12, 8], [12, 4], [8, 4], [8, 6], [10, 6], [10, 4], [8, 4], [8, 8], [10, 8], [10, 6], [8, 6], [8, 4], [12, 4], [12, 0]]
      },
      'color-3': {
            name: 'Color 3',
            fillAll: true,
            placeholderColor: 'rgb(106,106,110)',
            border: [[0, 0], [4, 0], [4, 4], [6, 4], [6, 6], [4, 6], [4, 4], [8, 4], [8, 6], [6, 6], [6, 4], [4, 4], [4, 6], [6, 6], [4, 6], [4, 8], [6, 8], [6, 6], [8, 6], [8, 8], [4, 8], [4, 6], [6, 6], [6, 8], [4, 8], [4, 0]]
      }
};

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

module.exports = {
    'color-1': {
        name: 'Color 1',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[0, 0], [2, 0], [2, 2], [0, 2], [0, 0]]
    },
    'color-2': {
        name: 'Color 2',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[2, 0], [4, 0], [4, 2], [2, 2], [2, 0]]
    },
    'color-3': {
        name: 'Color 3',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[4, 0], [6, 0], [6, 2], [4, 2], [4, 0]]
    },
    'color-4': {
        name: 'Color 4',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[6, 0], [8, 0], [8, 2], [6, 2], [6, 0]]
    },
    'color-5': {
        name: 'Color 5',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[8, 0], [10, 0], [10, 2], [8, 2], [8, 0]]
    },
    'color-6': {
        name: 'Color 6',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[10, 0], [12, 0], [12, 2], [10, 2], [10, 0]]
    },
    'color-7': {
        name: 'Color 7',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[0, 2], [2, 2], [2, 4], [0, 4], [0, 2]]
    },
    'color-8': {
        name: 'Color 8',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[2, 2], [4, 2], [4, 4], [2, 4], [2, 2]]
    },
    'color-9': {
        name: 'Color 9',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[4, 2], [6, 2], [6, 4], [4, 4], [4, 2]]
    },
    'color-10': {
        name: 'Color 10',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[6, 2], [8, 2], [8, 4], [6, 4], [6, 2]]
    },
    'color-11': {
        name: 'Color 11',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[8, 2], [10, 2], [10, 4], [8, 4], [8, 2]]
    },
    'color-12': {
        name: 'Color 12',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[10, 2], [12, 2], [12, 4], [10, 4], [10, 2]]
    },
    'color-13': {
        name: 'Color 13',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[0, 4], [2, 4], [2, 6], [0, 6], [0, 4]]
    },
    'color-14': {
        name: 'Color 14',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[2, 4], [4, 4], [4, 6], [2, 6], [2, 4]]
    },

    'color-15': {
        name: 'Color 15',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[4, 4], [6, 4], [6, 6], [4, 6], [4, 4]]
    },
    'color-16': {
        name: 'Color 16',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[6, 4], [8, 4], [8, 6], [6, 6], [6, 4]]
    },
    'color-17': {
        name: 'Color 17',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[8, 4], [10, 4], [10, 6], [8, 6], [8, 4]]
    },
    'color-18': {
        name: 'Color 18',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[10, 4], [12, 4], [12, 6], [10, 6], [10, 4]]
    },
    'color-19': {
        name: 'Color 19',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[0, 6], [2, 6], [2, 8], [0, 8], [0, 6], [0, 0]]
    },

    'color-20': {
        name: 'Color 20',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[2, 6], [4, 6], [4, 8], [2, 8], [2, 6]]
    },
    'color-21': {
        name: 'Color 21',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[4, 6], [6, 6], [6, 8], [4, 8], [4, 6]]
    },

    'color-22': {
        name: 'Color 22',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[6, 6], [8, 6], [8, 8], [6, 8], [6, 6]]
    },
    'color-23': {
        name: 'Color 23',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[8, 6], [10, 6], [10, 8], [8, 8], [8, 6]]
    },
    'color-24': {
        name: 'Color 24',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[10, 6], [12, 6], [12, 8], [10, 8], [10, 6]]
    },
    'color-25': {
        name: 'Color 25',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[0, 8], [2, 8], [2, 10], [0, 10], [0, 8]]
    },
    'color-26': {
        name: 'Color 26',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[2, 8], [4, 8], [4, 10], [2, 10], [2, 8]]
    },
    'color-27': {
        name: 'Color 27',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[4, 8], [6, 8], [6, 10], [4, 10], [4, 8]]
    },
    'color-28': {
        name: 'Color 28',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[6, 8], [8, 8], [8, 10], [6, 10], [6, 8]]
    },
    'color-29': {
        name: 'Color 29',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[8, 8], [10, 8], [10, 10], [8, 10], [8, 8]]
    },
    'color-30': {
        name: 'Color 30',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[10, 8], [12, 8], [12, 10], [10, 10], [10, 8]]
    },
    'color-31': {
        name: 'Color 31',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[0, 10], [2, 10], [2, 12], [0, 12], [0, 10]]
    },
    'color-32': {
        name: 'Color 32',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[2, 10], [4, 10], [4, 12], [2, 12], [2, 10]]
    },
    'color-33': {
        name: 'Color 33',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[4, 10], [6, 10], [6, 12], [4, 12], [4, 10]]
    },
    'color-34': {
        name: 'Color 34',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[6, 10], [8, 10], [8, 12], [6, 12], [6, 10]]
    },
    'color-35': {
        name: 'Color 35',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[8, 10], [10, 10], [10, 12], [8, 12], [8, 10]]
    },

    'color-36': {
        name: 'Color 36',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [[10, 10], [12, 10], [12, 12], [10, 12], [10, 10]]
    }

};

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

module.exports = {
      'color-1': {
            name: 'Color 1',
            fillAll: true,
            placeholderColor: 'rgb(211,207,201)',
            border: [[0, 0], [0, 2], [2, 2], [2, 0], [0, 0], [0, 2], [0, 4], [2, 4], [2, 2], [0, 2], [0, 8], [2, 8], [2, 6], [0, 6], [0, 8], [0, 10], [2, 10], [2, 8], [0, 8], [0, 14], [2, 14], [2, 12], [0, 12], [0, 14], [0, 16], [2, 16], [2, 14], [0, 14], [0, 20], [2, 20], [2, 18], [0, 18], [0, 20], [0, 22], [2, 22], [2, 20], [0, 20], [0, 26], [2, 26], [2, 24], [0, 24], [0, 28], [2, 28], [2, 26], [0, 26], [0, 32], [2, 32], [2, 30], [0, 30], [0, 32], [0, 34], [2, 34], [2, 32], [0, 32], [0, 0], [4, 0], [4, 2], [2, 2], [2, 0], [4, 0], [4, 2], [4, 4], [2, 4], [2, 2], [2, 6], [4, 6], [4, 8], [2, 8], [2, 6], [2, 8], [4, 8], [4, 10], [2, 10], [2, 12], [4, 12], [4, 14], [2, 14], [2, 12], [2, 14], [4, 14], [4, 16], [2, 16], [2, 14], [2, 18], [4, 18], [4, 20], [2, 20], [2, 18], [2, 20], [4, 20], [4, 22], [2, 22], [2, 20], [2, 24], [4, 24], [4, 26], [2, 26], [2, 24], [2, 26], [4, 26], [4, 28], [2, 28], [2, 26], [2, 24], [2, 30], [4, 30], [4, 32], [2, 32], [2, 30], [2, 32], [4, 32], [4, 34], [2, 34], [2, 32], [2, 0], [8, 0], [8, 2], [6, 2], [6, 0], [8, 0], [8, 2], [8, 4], [6, 4], [6, 2], [6, 6], [8, 6], [8, 8], [6, 8], [6, 6], [6, 8], [8, 8], [8, 10], [6, 10], [6, 8], [6, 12], [8, 12], [8, 14], [6, 14], [6, 12], [6, 14], [8, 14], [8, 16], [6, 16], [6, 14], [6, 18], [8, 18], [8, 20], [6, 20], [6, 18], [6, 20], [8, 20], [8, 22], [6, 22], [6, 20], [6, 24], [8, 24], [8, 26], [6, 26], [6, 24], [6, 26], [8, 26], [8, 28], [6, 28], [6, 26], [6, 24], [6, 30], [8, 30], [8, 32], [6, 32], [6, 30], [6, 32], [8, 32], [8, 34], [6, 34], [6, 32], [6, 0], [10, 0], [10, 2], [8, 2], [8, 0], [10, 0], [10, 2], [10, 4], [8, 4], [8, 2], [8, 4], [8, 6], [10, 6], [10, 8], [8, 8], [8, 6], [8, 8], [10, 8], [10, 10], [8, 10], [8, 8], [8, 6], [8, 12], [10, 12], [10, 14], [8, 14], [8, 12], [8, 14], [10, 14], [10, 16], [8, 16], [8, 14], [8, 12], [8, 18], [10, 18], [10, 20], [8, 20], [8, 18], [8, 20], [10, 20], [10, 22], [8, 22], [8, 24], [10, 24], [10, 26], [8, 26], [8, 24], [8, 26], [10, 26], [10, 28], [8, 28], [8, 26], [8, 30], [10, 30], [10, 32], [8, 32], [8, 30], [8, 32], [10, 32], [10, 34], [8, 34], [8, 32], [8, 30], [8, 0], [14, 0], [14, 2], [12, 2], [12, 0], [14, 0], [14, 2], [14, 4], [12, 4], [12, 2], [12, 4], [12, 6], [14, 6], [14, 8], [12, 8], [12, 6], [12, 8], [14, 8], [14, 10], [12, 10], [12, 8], [12, 6], [12, 12], [14, 12], [14, 14], [12, 14], [12, 12], [12, 14], [14, 14], [14, 16], [12, 16], [12, 14], [12, 18], [14, 18], [14, 20], [12, 20], [12, 18], [12, 20], [14, 20], [14, 22], [12, 22], [12, 24], [14, 24], [14, 26], [12, 26], [12, 24], [12, 26], [14, 26], [14, 28], [12, 28], [12, 26], [12, 30], [14, 30], [14, 32], [12, 32], [12, 30], [12, 32], [14, 32], [14, 34], [12, 34], [12, 0], [16, 0], [16, 2], [14, 2], [14, 0], [16, 0], [16, 2], [16, 4], [14, 4], [14, 6], [16, 6], [16, 8], [14, 8], [14, 6], [14, 8], [16, 8], [16, 10], [14, 10], [14, 8], [14, 12], [16, 12], [16, 14], [14, 14], [14, 12], [14, 14], [16, 14], [16, 16], [14, 16], [14, 14], [14, 18], [16, 18], [16, 20], [14, 20], [14, 18], [14, 20], [16, 20], [16, 22], [14, 22], [14, 24], [16, 24], [16, 26], [14, 26], [14, 24], [14, 26], [16, 26], [16, 28], [14, 28], [14, 26], [14, 30], [16, 30], [16, 32], [14, 32], [14, 30], [14, 32], [16, 32], [16, 34], [14, 34], [14, 0], [20, 0], [20, 2], [18, 2], [18, 0], [20, 0], [20, 2], [20, 4], [18, 4], [18, 2], [18, 4], [18, 6], [20, 6], [20, 8], [18, 8], [18, 6], [18, 8], [20, 8], [20, 10], [18, 10], [18, 8], [18, 12], [20, 12], [20, 14], [18, 14], [18, 12], [18, 14], [20, 14], [20, 16], [18, 16], [18, 14], [18, 12], [18, 10], [18, 18], [20, 18], [20, 20], [18, 20], [18, 18], [18, 20], [20, 20], [20, 22], [18, 22], [18, 20], [18, 18], [18, 24], [20, 24], [20, 26], [18, 26], [18, 24], [18, 26], [20, 26], [20, 28], [18, 28], [18, 26], [18, 30], [20, 30], [20, 32], [18, 32], [18, 30], [18, 32], [20, 32], [20, 34], [18, 34], [18, 32], [18, 30], [18, 0], [22, 0], [22, 2], [20, 2], [20, 0], [22, 0], [22, 2], [22, 4], [20, 4], [20, 2], [20, 4], [20, 6], [22, 6], [22, 8], [20, 8], [20, 6], [20, 8], [22, 8], [22, 10], [20, 10], [20, 8], [20, 12], [22, 12], [22, 14], [20, 14], [20, 12], [20, 14], [22, 14], [22, 16], [20, 16], [20, 14], [20, 18], [22, 18], [22, 20], [20, 20], [20, 18], [20, 20], [22, 20], [22, 22], [20, 22], [20, 20], [20, 18], [20, 24], [22, 24], [22, 26], [20, 26], [20, 24], [20, 26], [22, 26], [22, 28], [20, 28], [20, 26], [20, 24], [20, 22], [20, 30], [22, 30], [22, 32], [20, 32], [20, 30], [20, 32], [22, 32], [22, 34], [20, 34], [20, 32], [20, 30], [20, 0], [26, 0], [26, 2], [24, 2], [24, 0], [26, 0], [26, 2], [26, 4], [24, 4], [24, 2], [24, 4], [24, 6], [26, 6], [26, 8], [24, 8], [24, 6], [24, 8], [26, 8], [26, 10], [24, 10], [24, 8], [24, 12], [26, 12], [26, 14], [24, 14], [24, 12], [24, 14], [26, 14], [26, 16], [24, 16], [24, 14], [24, 18], [26, 18], [26, 20], [24, 20], [24, 18], [24, 20], [26, 20], [26, 22], [24, 22], [24, 20], [24, 24], [26, 24], [26, 26], [24, 26], [24, 24], [24, 26], [26, 26], [26, 28], [24, 28], [24, 26], [24, 30], [26, 30], [26, 32], [24, 32], [24, 30], [24, 32], [26, 32], [26, 34], [24, 34], [24, 32], [24, 30], [24, 0], [28, 0], [28, 2], [26, 2], [26, 0], [28, 0], [28, 2], [28, 4], [26, 4], [26, 2], [26, 4], [26, 6], [28, 6], [28, 8], [26, 8], [26, 6], [26, 8], [28, 8], [28, 10], [26, 10], [26, 8], [26, 6], [26, 12], [28, 12], [28, 14], [26, 14], [26, 12], [26, 14], [28, 14], [28, 16], [26, 16], [26, 14], [26, 12], [26, 18], [28, 18], [28, 20], [26, 20], [26, 18], [26, 20], [28, 20], [28, 22], [26, 22], [26, 20], [26, 18], [26, 24], [28, 24], [28, 26], [26, 26], [26, 24], [26, 26], [28, 26], [28, 28], [26, 28], [26, 26], [26, 24], [26, 30], [28, 30], [28, 32], [26, 32], [26, 30], [26, 32], [28, 32], [28, 34], [26, 34], [26, 32], [26, 30], [26, 0], [32, 0], [32, 2], [30, 2], [30, 0], [32, 0], [32, 2], [32, 4], [30, 4], [30, 2], [30, 4], [30, 6], [32, 6], [32, 8], [30, 8], [30, 6], [30, 8], [32, 8], [32, 10], [30, 10], [30, 8], [30, 6], [30, 4], [30, 12], [32, 12], [32, 14], [30, 14], [30, 12], [30, 14], [32, 14], [32, 16], [30, 16], [30, 14], [30, 18], [32, 18], [32, 20], [30, 20], [30, 18], [30, 20], [32, 20], [32, 22], [30, 22], [30, 20], [30, 24], [32, 24], [32, 26], [30, 26], [30, 24], [30, 26], [32, 26], [32, 28], [30, 28], [30, 26], [30, 30], [32, 30], [32, 32], [30, 32], [30, 30], [30, 32], [32, 32], [32, 34], [30, 34], [30, 32], [30, 30], [30, 0], [0, 0], [34, 0], [34, 2], [32, 2], [32, 0], [34, 0], [34, 2], [34, 4], [32, 4], [32, 2], [32, 6], [34, 6], [34, 8], [32, 8], [32, 6], [32, 8], [34, 8], [34, 10], [32, 10], [32, 8], [32, 12], [34, 12], [34, 14], [32, 14], [32, 12], [32, 14], [34, 14], [34, 16], [32, 16], [32, 14], [32, 12], [32, 18], [34, 18], [34, 20], [32, 20], [32, 18], [32, 20], [34, 20], [34, 22], [32, 22], [32, 20], [32, 18], [32, 16], [32, 24], [34, 24], [34, 26], [32, 26], [32, 24], [32, 26], [34, 26], [34, 28], [32, 28], [32, 26], [32, 24], [32, 22], [32, 30], [34, 30], [34, 32], [32, 32], [32, 30], [32, 32], [34, 32], [34, 34], [32, 34], [32, 32], [32, 30], [32, 0]]
      },
      'color-2': {
            name: 'Color 2',
            fillAll: true,
            placeholderColor: 'rgb(106,105,111)',
            border: [[0, 0], [0, 4], [2, 4], [2, 6], [0, 6], [0, 4], [2, 4], [4, 4], [4, 6], [2, 6], [2, 4], [0, 4], [0, 0], [6, 0], [6, 2], [4, 2], [4, 0], [6, 0], [6, 2], [6, 4], [4, 4], [4, 2], [4, 4], [6, 4], [6, 6], [4, 6], [4, 4], [4, 6], [6, 6], [6, 8], [4, 8], [4, 6], [4, 8], [6, 8], [6, 10], [4, 10], [4, 10], [4, 12], [6, 12], [6, 14], [4, 14], [4, 12], [4, 14], [6, 14], [6, 16], [4, 16], [4, 14], [4, 16], [6, 16], [6, 18], [4, 18], [4, 16], [4, 18], [6, 18], [6, 20], [4, 20], [4, 18], [4, 20], [6, 20], [6, 22], [4, 22], [4, 24], [6, 24], [6, 26], [4, 26], [4, 24], [4, 26], [6, 26], [6, 28], [4, 28], [4, 26], [4, 28], [6, 28], [6, 30], [4, 30], [4, 28], [4, 30], [6, 30], [6, 32], [4, 32], [4, 30], [4, 32], [6, 32], [6, 34], [4, 34], [4, 32], [4, 34], [4, 0], [8, 0], [8, 4], [8, 6], [6, 6], [6, 4], [8, 4], [10, 4], [10, 6], [8, 6], [8, 4], [12, 4], [12, 6], [10, 6], [10, 4], [14, 4], [14, 6], [12, 6], [12, 4], [16, 4], [16, 6], [14, 6], [14, 4], [20, 4], [20, 6], [18, 6], [18, 4], [22, 4], [22, 6], [20, 6], [20, 4], [24, 4], [24, 6], [22, 6], [22, 4], [26, 4], [26, 6], [24, 6], [24, 4], [28, 4], [28, 6], [26, 6], [26, 4], [32, 4], [32, 6], [30, 6], [30, 4], [34, 4], [34, 6], [32, 6], [32, 4], [36, 4], [36, 6], [34, 6], [34, 4], [8, 4], [8, 0]]
      },
      'color-3': {
            name: 'Color 3',
            fillAll: true,
            placeholderColor: 'rgb(152,150,156)',
            border: [[0, 0], [0, 10], [2, 10], [2, 12], [0, 12], [0, 10], [4, 10], [4, 12], [2, 12], [2, 10], [6, 10], [6, 12], [4, 12], [4, 10], [8, 10], [8, 12], [6, 12], [6, 10], [10, 10], [10, 12], [8, 12], [8, 10], [0, 10], [0, 0], [12, 0], [12, 2], [10, 2], [10, 0], [12, 0], [12, 2], [12, 4], [10, 4], [10, 2], [10, 4], [10, 6], [12, 6], [12, 8], [10, 8], [10, 6], [10, 8], [12, 8], [12, 10], [10, 10], [10, 8], [10, 10], [12, 10], [12, 12], [10, 12], [10, 10], [10, 12], [12, 12], [12, 14], [10, 14], [10, 12], [10, 14], [12, 14], [12, 16], [10, 16], [10, 18], [12, 18], [12, 20], [10, 20], [10, 18], [10, 20], [12, 20], [12, 22], [10, 22], [12, 22], [12, 24], [10, 24], [10, 22], [10, 24], [12, 24], [12, 26], [10, 26], [10, 24], [10, 26], [12, 26], [12, 28], [10, 28], [10, 26], [10, 30], [12, 30], [12, 32], [10, 32], [10, 30], [10, 32], [12, 32], [12, 34], [10, 34], [10, 32], [10, 34], [12, 34], [12, 36], [10, 36], [10, 34], [10, 0], [12, 0], [12, 10], [14, 10], [14, 12], [12, 12], [12, 10], [14, 10], [16, 10], [16, 12], [14, 12], [14, 10], [16, 10], [18, 10], [18, 12], [16, 12], [16, 10], [18, 10], [20, 10], [20, 12], [18, 12], [18, 10], [20, 10], [22, 10], [22, 12], [20, 12], [20, 10], [24, 10], [26, 10], [26, 12], [24, 12], [24, 10], [26, 10], [28, 10], [28, 12], [26, 12], [26, 10], [28, 10], [30, 10], [30, 12], [28, 12], [28, 10], [30, 10], [32, 10], [32, 12], [30, 12], [30, 10], [32, 10], [34, 10], [34, 12], [32, 12], [32, 10], [10, 10], [10, 0]]
      },
      'color-4': {
            name: 'Color 4',
            fillAll: true,
            placeholderColor: 'rgb(149,148,144)',
            border: [[0, 0], [0, 16], [2, 16], [2, 18], [0, 18], [0, 16], [4, 16], [4, 18], [2, 18], [2, 16], [8, 16], [8, 18], [6, 18], [6, 16], [8, 16], [10, 16], [10, 18], [8, 18], [8, 16], [10, 16], [12, 16], [12, 18], [10, 18], [10, 16], [12, 16], [14, 16], [14, 18], [12, 18], [12, 16], [14, 16], [16, 16], [16, 18], [14, 18], [14, 16], [16, 16], [0, 16], [0, 0], [18, 0], [18, 2], [16, 2], [16, 0], [18, 0], [18, 2], [18, 4], [16, 4], [16, 2], [16, 4], [18, 4], [18, 6], [16, 6], [16, 4], [16, 6], [18, 6], [18, 8], [16, 8], [16, 6], [16, 8], [18, 8], [18, 10], [16, 10], [16, 8], [16, 12], [18, 12], [18, 14], [16, 14], [16, 12], [16, 14], [18, 14], [18, 16], [16, 16], [16, 14], [16, 16], [18, 16], [18, 18], [16, 18], [16, 16], [16, 18], [18, 18], [18, 20], [16, 20], [16, 18], [16, 20], [18, 20], [18, 22], [16, 22], [16, 20], [16, 24], [18, 24], [18, 26], [16, 26], [16, 24], [16, 26], [18, 26], [18, 28], [16, 28], [16, 26], [16, 28], [18, 28], [18, 30], [16, 30], [16, 28], [16, 30], [18, 30], [18, 32], [16, 32], [16, 30], [16, 32], [18, 32], [18, 34], [16, 34], [16, 32], [16, 0], [18, 0], [18, 16], [20, 16], [20, 18], [18, 18], [18, 16], [20, 16], [22, 16], [22, 18], [20, 18], [20, 16], [22, 16], [24, 16], [24, 18], [22, 18], [22, 16], [24, 16], [26, 16], [26, 18], [24, 18], [24, 16], [26, 16], [28, 16], [28, 18], [26, 18], [26, 16], [30, 16], [32, 16], [32, 18], [30, 18], [30, 16], [32, 16], [34, 16], [34, 18], [32, 18], [32, 16], [34, 16], [36, 16], [36, 18], [34, 18], [34, 16], [16, 16], [16, 0]]
      },
      'color-5': {
            name: 'Color 5',
            fillAll: true,
            placeholderColor: 'rgb(63,67,72)',
            border: [[0, 0], [0, 22], [2, 22], [2, 24], [0, 24], [0, 22], [2, 22], [4, 22], [4, 24], [2, 24], [2, 22], [4, 22], [6, 22], [6, 24], [4, 24], [4, 22], [6, 22], [8, 22], [8, 24], [6, 24], [6, 22], [8, 22], [10, 22], [10, 24], [8, 24], [8, 22], [12, 22], [14, 22], [14, 24], [12, 24], [12, 22], [14, 22], [16, 22], [16, 24], [14, 24], [14, 22], [16, 22], [18, 22], [18, 24], [16, 24], [16, 22], [18, 22], [20, 22], [20, 24], [18, 24], [18, 22], [20, 22], [22, 22], [22, 24], [20, 24], [20, 22], [0, 22], [0, 0], [22, 0], [22, 2], [24, 2], [24, 0], [22, 0], [22, 2], [22, 4], [24, 4], [24, 2], [22, 2], [22, 6], [22, 8], [24, 8], [24, 6], [22, 6], [22, 8], [22, 10], [24, 10], [24, 8], [22, 8], [22, 10], [22, 12], [24, 12], [24, 10], [22, 10], [22, 12], [22, 14], [24, 14], [24, 12], [22, 12], [22, 14], [22, 16], [24, 16], [24, 14], [22, 14], [22, 18], [22, 20], [24, 20], [24, 18], [22, 18], [22, 20], [22, 22], [24, 22], [24, 20], [22, 20], [22, 22], [22, 24], [24, 24], [24, 22], [22, 22], [22, 24], [22, 26], [24, 26], [24, 24], [22, 24], [22, 26], [22, 28], [24, 28], [24, 26], [22, 26], [22, 30], [22, 32], [24, 32], [24, 30], [22, 30], [22, 32], [22, 34], [24, 34], [24, 32], [22, 32], [22, 34], [22, 36], [24, 36], [24, 34], [22, 34], [22, 0], [24, 0], [24, 22], [26, 22], [26, 24], [24, 24], [24, 22], [26, 22], [28, 22], [28, 24], [26, 24], [26, 22], [28, 22], [30, 22], [30, 24], [28, 24], [28, 22], [30, 22], [32, 22], [32, 24], [30, 24], [30, 22], [32, 22], [34, 22], [34, 24], [32, 24], [32, 22], [24, 22], [24, 0]]
      },
      'color-6': {
            name: 'Color 6',
            fillAll: true,
            placeholderColor: 'rgb(63,67,72)',
            border: [[0, 0], [0, 28], [2, 28], [2, 30], [0, 30], [0, 28], [2, 28], [4, 28], [4, 30], [2, 30], [2, 28], [6, 28], [8, 28], [8, 30], [6, 30], [6, 28], [8, 28], [10, 28], [10, 30], [8, 30], [8, 28], [10, 28], [12, 28], [12, 30], [10, 30], [10, 28], [12, 28], [14, 28], [14, 30], [12, 30], [12, 28], [14, 28], [16, 28], [16, 30], [14, 30], [14, 28], [18, 28], [20, 28], [20, 30], [18, 30], [18, 28], [20, 28], [22, 28], [22, 30], [20, 30], [20, 28], [22, 28], [24, 28], [24, 30], [22, 30], [22, 28], [24, 28], [26, 28], [26, 30], [24, 30], [24, 28], [26, 28], [28, 28], [28, 30], [26, 30], [26, 28], [0, 28], [0, 0], [28, 0], [28, 2], [30, 2], [30, 0], [28, 0], [28, 2], [28, 4], [30, 4], [30, 2], [28, 2], [28, 4], [28, 6], [30, 6], [30, 4], [28, 4], [28, 6], [28, 8], [30, 8], [30, 6], [28, 6], [28, 8], [28, 10], [30, 10], [30, 8], [28, 8], [28, 10], [28, 14], [30, 14], [30, 12], [28, 12], [28, 14], [28, 16], [30, 16], [30, 14], [28, 14], [28, 16], [28, 18], [30, 18], [30, 16], [28, 16], [28, 18], [28, 20], [30, 20], [30, 18], [28, 18], [28, 20], [28, 22], [30, 22], [30, 20], [28, 20], [28, 22], [28, 26], [30, 26], [30, 24], [28, 24], [28, 26], [28, 28], [30, 28], [30, 26], [28, 26], [28, 28], [28, 30], [30, 30], [30, 28], [28, 28], [28, 30], [28, 32], [30, 32], [30, 30], [28, 30], [28, 32], [28, 34], [30, 34], [30, 32], [28, 32], [28, 34], [28, 0], [30, 0], [30, 28], [32, 28], [32, 30], [30, 30], [30, 28], [32, 28], [34, 28], [34, 30], [32, 30], [32, 28], [34, 28], [36, 28], [36, 30], [34, 30], [34, 28], [30, 28], [30, 0]]
      },
      'color-7': {
            name: 'Color 7',
            fillAll: true,
            placeholderColor: 'rgb(60,64,70)',
            border: [[0, 0], [0, 34], [2, 34], [2, 36], [0, 36], [0, 34], [4, 34], [4, 36], [2, 36], [2, 34], [6, 34], [6, 36], [4, 36], [4, 34], [8, 34], [8, 36], [6, 36], [6, 34], [10, 34], [10, 36], [8, 36], [8, 34], [14, 34], [14, 36], [12, 36], [12, 34], [16, 34], [16, 36], [14, 36], [14, 34], [18, 34], [18, 36], [16, 36], [16, 34], [20, 34], [20, 36], [18, 36], [18, 34], [22, 34], [22, 36], [20, 36], [20, 34], [26, 34], [26, 36], [24, 36], [24, 34], [28, 34], [28, 36], [26, 36], [26, 34], [30, 34], [30, 36], [28, 36], [28, 34], [32, 34], [32, 36], [30, 36], [30, 34], [34, 34], [34, 36], [32, 36], [32, 34], [34, 34], [34, 0], [36, 0], [36, 2], [34, 2], [34, 0], [36, 0], [36, 2], [36, 4], [34, 4], [34, 2], [36, 2], [36, 4], [34, 4], [34, 8], [34, 6], [36, 6], [36, 8], [36, 10], [34, 10], [34, 8], [36, 8], [36, 10], [36, 12], [34, 12], [34, 10], [36, 10], [36, 12], [36, 14], [34, 14], [34, 12], [36, 12], [36, 14], [36, 16], [34, 16], [34, 14], [36, 14], [36, 16], [34, 16], [34, 20], [34, 18], [36, 18], [36, 20], [36, 22], [34, 22], [34, 20], [36, 20], [36, 22], [36, 24], [34, 24], [34, 22], [36, 22], [36, 24], [36, 26], [34, 26], [34, 24], [36, 24], [36, 26], [36, 28], [34, 28], [34, 26], [36, 26], [36, 28], [34, 28], [34, 30], [36, 30], [36, 32], [36, 34], [34, 34], [34, 32], [36, 32], [36, 34], [36, 36], [34, 36], [34, 34], [0, 34]]
      }
};

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

var tw = 2;
module.exports = {
      'color-1': {
            name: 'Color 1',
            placeholderColor: 'rgb(211,207,201)',
            // fill all the blocks of this type, the whole wall
            fillAll: true,
            border: [
            // col 2
            [0, 0], [tw * 2, 0], [tw, 0], [tw, tw * 1], [tw * 2, tw * 1], [tw, tw * 1], [tw, tw * 2], [tw * 2, tw * 2], [tw, tw * 2], [tw, tw * 7], [tw * 2, tw * 7], [tw, tw * 7], [tw, tw * 8], [tw * 2, tw * 8], [tw, tw * 8], [tw, tw * 9], [tw * 2, tw * 9], [tw, tw * 9], [tw, tw * 10], [tw * 2, tw * 10], [tw, tw * 10], [tw, tw * 11], [tw * 2, tw * 11], [tw, tw * 11], [tw, tw * 12], [tw * 2, tw * 12], [tw, tw * 12], [tw * 2, tw * 12], [tw * 2, 0],

            // col 4 
            [tw * 4, 0], [tw * 3, 0], [tw * 3, tw * 1], [tw * 4, tw * 1], [tw * 3, tw * 1], [tw * 3, tw * 2], [tw * 4, tw * 2], [tw * 3, tw * 2], [tw * 3, tw * 3], [tw * 4, tw * 3], [tw * 3, tw * 3], [tw * 3, tw * 4], [tw * 4, tw * 4], [tw * 3, tw * 4], [tw * 3, tw * 5], [tw * 4, tw * 5], [tw * 3, tw * 5], [tw * 3, tw * 6], [tw * 4, tw * 6], [tw * 3, tw * 6], [tw * 3, tw * 7], [tw * 4, tw * 7], [tw * 3, tw * 7], [tw * 3, tw * 8], [tw * 4, tw * 8], [tw * 4, 0],

            // col 6
            [tw * 6, 0], [tw * 5, 0], [tw * 5, tw * 1], [tw * 6, tw * 1], [tw * 5, tw * 1], [tw * 5, tw * 2], [tw * 6, tw * 2], [tw * 5, tw * 2], [tw * 5, tw * 3], [tw * 6, tw * 3], [tw * 5, tw * 3], [tw * 5, tw * 4], [tw * 6, tw * 4], [tw * 5, tw * 4], [tw * 5, tw * 5], [tw * 6, tw * 5], [tw * 5, tw * 5], [tw * 5, tw * 6], [tw * 6, tw * 6], [tw * 5, tw * 6], [tw * 5, tw * 7], [tw * 6, tw * 7], [tw * 5, tw * 7], [tw * 5, tw * 8], [tw * 6, tw * 8], [tw * 6, 0],

            // col 8
            [tw * 8, 0], [tw * 7, 0], [tw * 7, tw * 1], [tw * 8, tw * 1], [tw * 7, tw * 1], [tw * 7, tw * 2], [tw * 8, tw * 2], [tw * 7, tw * 2], [tw * 7, tw * 3], [tw * 8, tw * 3], [tw * 7, tw * 3], [tw * 7, tw * 4], [tw * 8, tw * 4], [tw * 7, tw * 4], [tw * 7, tw * 5], [tw * 8, tw * 5], [tw * 7, tw * 5], [tw * 7, tw * 6], [tw * 8, tw * 6], [tw * 7, tw * 6], [tw * 7, tw * 7], [tw * 8, tw * 7], [tw * 7, tw * 7], [tw * 7, tw * 8], [tw * 8, tw * 8], [tw * 8, 0],

            // col 10
            [tw * 10, 0], [tw * 9, 0], [tw * 9, tw * 1], [tw * 10, tw * 1], [tw * 9, tw * 1], [tw * 9, tw * 2], [tw * 10, tw * 2], [tw * 9, tw * 2], [tw * 9, tw * 7], [tw * 9, tw * 8], [tw * 9, tw * 7], [tw * 10, tw * 7], [tw * 9, tw * 7], [tw * 9, tw * 8], [tw * 10, tw * 8], [tw * 9, tw * 8], [tw * 9, tw * 9], [tw * 10, tw * 9], [tw * 9, tw * 9], [tw * 9, tw * 10], [tw * 10, tw * 10], [tw * 9, tw * 10], [tw * 9, tw * 11], [tw * 10, tw * 11], [tw * 9, tw * 11], [tw * 9, tw * 12], [tw * 10, tw * 12], [tw * 10, 0],

            // col 12
            [tw * 12, 0], [tw * 11, 0], [tw * 11, tw * 1], [tw * 12, tw * 1], [tw * 11, tw * 1], [tw * 11, tw * 2], [tw * 12, tw * 2], [tw * 11, tw * 2], [tw * 11, tw * 7], [tw * 11, tw * 8], [tw * 11, tw * 7], [tw * 12, tw * 7], [tw * 11, tw * 7], [tw * 11, tw * 8], [tw * 12, tw * 8], [tw * 11, tw * 8], [tw * 11, tw * 9], [tw * 12, tw * 9], [tw * 11, tw * 9], [tw * 11, tw * 10], [tw * 12, tw * 10], [tw * 11, tw * 10], [tw * 11, tw * 11], [tw * 12, tw * 11], [tw * 11, tw * 11], [tw * 11, tw * 12], [tw * 12, tw * 12], [tw * 12, 0]]
      },
      'color-2': {
            name: 'Color 2',
            placeholderColor: 'rgb(159,160,162)',
            // fill all the blocks of this type, the whole wall
            fillAll: true,
            border: [
            // col 1
            [0, 0], [0, tw * 8], [tw, tw * 8], [0, tw * 8], [0, tw * 9], [tw, tw * 9], [0, tw * 9], [0, tw * 10], [tw, tw * 10], [0, tw * 10], [0, tw * 11], [tw, tw * 11], [0, tw * 11], [0, tw * 12], [tw, tw * 12], [tw, tw * 8], [0, tw * 8], [0, 0],
            // col 5
            [tw * 4, 0], [tw * 4, tw * 2], [tw * 5, tw * 2], [tw * 4, tw * 2], [tw * 4, tw * 3], [tw * 5, tw * 3], [tw * 4, tw * 3], [tw * 4, tw * 4], [tw * 5, tw * 4], [tw * 4, tw * 4], [tw * 4, tw * 5], [tw * 5, tw * 5], [tw * 4, tw * 5], [tw * 4, tw * 6], [tw * 5, tw * 6], [tw * 5, tw * 2], [tw * 4, tw * 2], [tw * 4, 0],
            //col 7 same as 5
            [tw * 6, 0], [tw * 6, tw * 2], [tw * 7, tw * 2], [tw * 6, tw * 2], [tw * 6, tw * 3], [tw * 7, tw * 3], [tw * 6, tw * 3], [tw * 6, tw * 4], [tw * 7, tw * 4], [tw * 6, tw * 4], [tw * 6, tw * 5], [tw * 7, tw * 5], [tw * 6, tw * 5], [tw * 6, tw * 6], [tw * 7, tw * 6], [tw * 7, tw * 2], [tw * 6, tw * 2], [tw * 6, 0],

            // col 11 4 squares at bottom
            [tw * 10, 0], [tw * 10, tw * 8], [tw * 11, tw * 8], [tw * 10, tw * 8], [tw * 10, tw * 9], [tw * 11, tw * 9], [tw * 10, tw * 9], [tw * 10, tw * 10], [tw * 11, tw * 10], [tw * 10, tw * 10], [tw * 10, tw * 11], [tw * 11, tw * 11], [tw * 10, tw * 11], [tw * 10, tw * 12], [tw * 11, tw * 12], [tw * 11, tw * 8], [tw * 10, tw * 8], [tw * 10, 0]]
      },
      'color-3': {
            name: 'Color 3',
            placeholderColor: 'rgb(105,106,110)',
            // fill all the blocks of this type, the whole wall
            fillAll: true,
            border: [
            // col 2 - has to be enclosing because it will be a polygon
            [0, 0], [0, tw * 2], [tw, tw * 2], [tw, tw * 3], [tw, tw * 2], [tw * 2, tw * 2], [tw * 2, tw * 3], [tw, tw * 3], [tw * 2, tw * 3], [tw * 2, tw * 4], [tw, tw * 4], [tw, tw * 3], [tw, tw * 4], [tw * 2, tw * 4], [tw * 2, tw * 5], [tw, tw * 5], [tw, tw * 4], [tw, tw * 5], [tw * 2, tw * 5], [tw * 2, tw * 6], [tw, tw * 6], [tw, tw * 5], [tw, tw * 6], [tw * 2, tw * 6], [0, tw * 6], [0, tw * 5], [tw, tw * 5], [0, tw * 5], [0, tw * 4], [tw, tw * 4], [0, tw * 4], [0, tw * 3], [tw, tw * 3], [0, tw * 3], [0, tw * 2],

            // 3 col
            [0, tw * 6], [tw * 2, tw * 6], [tw * 2, tw * 12], [tw * 3, tw * 12], [tw * 3, tw * 11], [tw * 2, tw * 11], [tw * 3, tw * 11], [tw * 3, tw * 10], [tw * 2, tw * 10], [tw * 3, tw * 10], [tw * 3, tw * 9], [tw * 2, tw * 9], [tw * 3, tw * 9], [tw * 3, tw * 8], [tw * 2, tw * 8], [tw * 3, tw * 8], [tw * 2, tw * 8],

            // 5 col
            [tw * 4, tw * 8], [tw * 5, tw * 8], [tw * 4, tw * 8], [tw * 4, tw * 9], [tw * 5, tw * 9], [tw * 4, tw * 9], [tw * 4, tw * 10], [tw * 5, tw * 10], [tw * 4, tw * 10], [tw * 4, tw * 11], [tw * 5, tw * 11], [tw * 4, tw * 11], [tw * 4, tw * 12], [tw * 5, tw * 12], [tw * 5, tw * 8],

            // 7col 
            [tw * 6, tw * 8], [tw * 7, tw * 8], [tw * 6, tw * 8], [tw * 6, tw * 9], [tw * 7, tw * 9], [tw * 6, tw * 9], [tw * 6, tw * 10], [tw * 7, tw * 10], [tw * 6, tw * 10], [tw * 6, tw * 11], [tw * 7, tw * 11], [tw * 6, tw * 11], [tw * 6, tw * 12], [tw * 7, tw * 12], [tw * 7, tw * 8],

            // 8col 
            [tw * 7, tw * 12], [tw * 8, tw * 12], [tw * 8, tw * 11], [tw * 7, tw * 11], [tw * 8, tw * 11], [tw * 8, tw * 10], [tw * 7, tw * 10], [tw * 8, tw * 10], [tw * 8, tw * 9], [tw * 7, tw * 9], [tw * 8, tw * 9], [tw * 8, tw * 8], [tw * 7, tw * 8], [tw * 8, tw * 8],

            // 10col
            [tw * 8, tw * 6], [tw * 9, tw * 6], [tw * 8, tw * 6], [tw * 8, tw * 5], [tw * 9, tw * 5], [tw * 8, tw * 5], [tw * 8, tw * 4], [tw * 9, tw * 4], [tw * 8, tw * 4], [tw * 8, tw * 3], [tw * 9, tw * 3], [tw * 8, tw * 3], [tw * 8, tw * 2], [tw * 9, tw * 2], [tw * 9, tw * 6],

            // 11 col
            [tw * 10, tw * 6], [tw * 11, tw * 6], [tw * 10, tw * 6], [tw * 10, tw * 5], [tw * 11, tw * 5], [tw * 10, tw * 5], [tw * 10, tw * 4], [tw * 11, tw * 4], [tw * 10, tw * 4], [tw * 10, tw * 3], [tw * 11, tw * 3], [tw * 10, tw * 3], [tw * 10, tw * 2], [tw * 11, tw * 2], [tw * 11, tw * 6], [tw * 8, tw * 6], [tw * 8, tw * 8], [tw * 2, tw * 8], [tw * 2, tw * 6], [0, tw * 6]]
      },
      'color-4': {
            name: 'Color 4',
            // fill all the blocks of this type, the whole wall
            fillAll: true,
            placeholderColor: 'rgb(63,67,72)',
            border: [
            // darkest color
            // darkest - col 1
            [0, 0], [tw, 0], [tw, tw * 1], [0, tw * 1], [0, 0], [0, tw * 2], [tw, tw * 2], [tw, tw], [0, tw], [0, 0], [0, tw * 3], [tw, tw * 3], [tw, tw], [0, tw], [0, 0], [0, tw * 4], [tw, tw * 4], [tw, tw], [0, tw], [0, tw * 5], [tw, tw * 5], [tw, tw], [0, tw], [0, tw * 6], [tw, tw * 6], [tw, tw], [0, tw], [0, tw * 7], [tw, tw * 7], [tw, tw], [0, tw], [0, tw * 8], [tw, tw * 8], [tw, tw], [0, tw],

            // darkest col 3
            [0, 0], [tw * 2, 0], [tw * 3, 0], [tw * 3, tw * 1], [tw * 2, tw * 1], [tw * 2, 0], [tw * 2, 0], [tw * 2, tw], [tw * 3, tw], [tw * 3, tw * 2], [tw * 2, tw * 2], [tw * 2, 0], [tw * 2, tw * 6], [tw * 3, tw * 6], [tw * 2, tw * 6], [tw * 2, tw * 7], [tw * 3, tw * 7], [tw * 2, tw * 7], [tw * 2, tw * 8], [tw * 3, tw * 8], [tw * 2, tw * 8], [tw * 2, tw * 9], [tw * 3, tw * 9], [tw * 2, tw * 9], [tw * 2, tw * 10], [tw * 3, tw * 10], [tw * 2, tw * 10], [tw * 2, tw * 11], [tw * 3, tw * 11], [tw * 2, tw * 11], [tw * 2, tw * 12], [tw * 3, tw * 12], [tw * 3, tw * 6], [tw * 2, tw * 6], [tw * 2, 0],

            // col 5
            [tw * 5, 0], [tw * 4, 0], [tw * 4, tw * 1], [tw * 5, tw * 1], [tw * 4, tw * 1], [tw * 4, tw * 2], [tw * 5, tw * 2], [tw * 5, 0], [tw * 4, 0], [tw * 4, tw * 12], [tw * 5, tw * 12], [tw * 5, tw * 11], [tw * 4, tw * 11], [tw * 5, tw * 11], [tw * 5, tw * 10], [tw * 4, tw * 10], [tw * 5, tw * 10], [tw * 5, tw * 9], [tw * 4, tw * 9], [tw * 5, tw * 9], [tw * 5, tw * 8], [tw * 4, tw * 8], [tw * 5, tw * 8], [tw * 5, tw * 7], [tw * 4, tw * 7], [tw * 5, tw * 7], [tw * 5, tw * 6], [tw * 4, tw * 6], [tw * 4, 0], [tw * 5, 0],
            // col 7
            [tw * 7, 0], [tw * 6, 0], [tw * 6, tw * 1], [tw * 7, tw * 1], [tw * 6, tw * 1], [tw * 6, tw * 2], [tw * 7, tw * 2], [tw * 7, 0], [tw * 6, 0], [tw * 6, tw * 12], [tw * 7, tw * 12], [tw * 7, tw * 11], [tw * 6, tw * 11], [tw * 7, tw * 11], [tw * 7, tw * 10], [tw * 6, tw * 10], [tw * 7, tw * 10], [tw * 7, tw * 9], [tw * 6, tw * 9], [tw * 7, tw * 9], [tw * 7, tw * 8], [tw * 6, tw * 8], [tw * 7, tw * 8], [tw * 7, tw * 7], [tw * 6, tw * 7], [tw * 7, tw * 7], [tw * 7, tw * 6], [tw * 6, tw * 6], [tw * 6, 0], [tw * 7, 0],
            // col 9
            [tw * 9, 0], [tw * 8, 0], [tw * 8, tw * 1], [tw * 9, tw * 1], [tw * 8, tw * 1], [tw * 8, tw * 2], [tw * 9, tw * 2], [tw * 8, tw * 2], [tw * 8, tw * 3], [tw * 9, tw * 3], [tw * 8, tw * 3], [tw * 8, tw * 4], [tw * 9, tw * 4], [tw * 8, tw * 4], [tw * 8, tw * 5], [tw * 9, tw * 5], [tw * 8, tw * 5], [tw * 8, tw * 6], [tw * 9, tw * 6], [tw * 8, tw * 6], [tw * 8, tw * 7], [tw * 9, tw * 7], [tw * 8, tw * 7], [tw * 8, tw * 8], [tw * 9, tw * 8], [tw * 9, 0],

            // col 11 - same as 9
            [tw * 11, 0], [tw * 10, 0], [tw * 10, tw * 1], [tw * 11, tw * 1], [tw * 10, tw * 1], [tw * 10, tw * 2], [tw * 11, tw * 2], [tw * 10, tw * 2], [tw * 10, tw * 3], [tw * 11, tw * 3], [tw * 10, tw * 3], [tw * 10, tw * 4], [tw * 11, tw * 4], [tw * 10, tw * 4], [tw * 10, tw * 5], [tw * 11, tw * 5], [tw * 10, tw * 5], [tw * 10, tw * 6], [tw * 11, tw * 6], [tw * 10, tw * 6], [tw * 10, tw * 7], [tw * 11, tw * 7], [tw * 10, tw * 7], [tw * 10, tw * 8], [tw * 11, tw * 8], [tw * 11, 0]]
      }
};

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

module.exports = {
    'color-1': {
        name: 'Color 1',
        fillAll: true,
        placeholderColor: 'rgb(212,208,203)',
        border: [[0, 0], [2, 0], [2, 2], [0, 2], [0, 0], [0, 2], [2, 2], [2, 4], [0, 4], [0, 2], [0, 4], [2, 4], [2, 6], [0, 6], [0, 4], [0, 6], [2, 6], [2, 8], [0, 8], [0, 6], [0, 0], [4, 0], [4, 2], [2, 2], [2, 0], [2, 2], [4, 2], [4, 4], [2, 4], [2, 2], [2, 4], [4, 4], [4, 6], [2, 6], [2, 4], [2, 6], [4, 6], [4, 8], [2, 8], [2, 6], [2, 0], [6, 0], [6, 2], [4, 2], [4, 0], [4, 2], [6, 2], [6, 4], [4, 4], [4, 2], [4, 4], [6, 4], [6, 6], [4, 6], [4, 4], [4, 6], [6, 6], [6, 8], [4, 8], [4, 6], [4, 0], [6, 0], [8, 0], [8, 2], [6, 2], [6, 0], [6, 2], [8, 2], [8, 4], [6, 4], [6, 2], [6, 4], [8, 4], [8, 6], [6, 6], [6, 4], [6, 6], [8, 6], [8, 8], [6, 8], [6, 0], [12, 0], [12, 12], [14, 12], [14, 14], [12, 14], [12, 12], [12, 14], [14, 14], [14, 16], [12, 16], [12, 14], [12, 16], [14, 16], [14, 18], [12, 18], [12, 16], [12, 18], [14, 18], [14, 20], [12, 20], [12, 18], [12, 20], [14, 20], [14, 22], [12, 22], [12, 20], [12, 22], [14, 22], [14, 24], [12, 24], [12, 22], [12, 24], [12, 12], [16, 12], [16, 14], [14, 14], [14, 12], [14, 14], [16, 14], [16, 16], [14, 16], [14, 14], [14, 16], [16, 16], [16, 18], [14, 18], [14, 16], [14, 18], [16, 18], [16, 20], [14, 20], [14, 18], [14, 20], [16, 20], [16, 22], [14, 22], [14, 20], [14, 22], [16, 22], [16, 24], [14, 24], [14, 22], [14, 12], [18, 12], [18, 14], [16, 14], [16, 12], [16, 14], [18, 14], [18, 16], [16, 16], [16, 14], [16, 16], [16, 12], [20, 12], [20, 14], [18, 14], [18, 12], [18, 14], [20, 14], [20, 16], [18, 16], [18, 12], [22, 12], [22, 14], [20, 14], [20, 12], [20, 14], [22, 14], [22, 16], [20, 16], [20, 12], [24, 12], [24, 14], [22, 14], [22, 12], [22, 14], [24, 14], [24, 16], [22, 16], [22, 12], [22, 16], [22, 12], [12, 12], [12, 0]]
    },
    'color-2': {
        name: 'Color 2',
        fillAll: true,
        placeholderColor: 'rgb(159,160,162)',
        border: [[0, 0], [0, 12], [2, 12], [2, 14], [0, 14], [0, 12], [0, 14], [2, 14], [2, 16], [0, 16], [0, 14], [0, 12], [4, 12], [4, 14], [2, 14], [2, 12], [2, 14], [4, 14], [4, 16], [2, 16], [2, 14], [2, 12], [6, 12], [6, 14], [4, 14], [4, 12], [4, 14], [6, 14], [6, 16], [4, 16], [4, 14], [4, 12], [8, 12], [8, 14], [6, 14], [6, 12], [6, 14], [8, 14], [8, 16], [6, 16], [6, 14], [6, 12], [8, 12], [10, 12], [10, 14], [8, 14], [8, 12], [8, 14], [10, 14], [10, 16], [8, 16], [8, 14], [8, 16], [10, 16], [10, 18], [8, 18], [8, 16], [8, 18], [10, 18], [10, 20], [8, 20], [8, 18], [8, 20], [10, 20], [10, 22], [8, 22], [8, 20], [8, 22], [10, 22], [10, 24], [8, 24], [8, 22], [8, 24], [8, 12], [12, 12], [12, 14], [10, 14], [10, 12], [10, 14], [12, 14], [12, 16], [10, 16], [10, 14], [10, 16], [12, 16], [12, 18], [10, 18], [10, 16], [10, 18], [12, 18], [12, 20], [10, 20], [10, 18], [10, 20], [12, 20], [12, 22], [10, 22], [10, 20], [10, 22], [12, 22], [12, 24], [10, 24], [10, 22], [10, 24], [10, 12], [0, 12], [0, 0], [18, 0], [18, 2], [16, 2], [16, 0], [16, 2], [18, 2], [18, 4], [16, 4], [16, 2], [16, 4], [18, 4], [18, 6], [16, 6], [16, 4], [16, 6], [18, 6], [18, 8], [16, 8], [16, 6], [16, 8], [16, 0], [20, 0], [20, 2], [18, 2], [18, 0], [18, 2], [20, 2], [20, 4], [18, 4], [18, 2], [18, 4], [20, 4], [20, 6], [18, 6], [18, 4], [18, 6], [20, 6], [20, 8], [18, 8], [18, 6], [18, 0], [20, 0], [22, 0], [22, 2], [20, 2], [20, 0], [20, 2], [22, 2], [22, 4], [20, 4], [20, 2], [20, 4], [22, 4], [22, 6], [20, 6], [20, 4], [20, 6], [22, 6], [22, 8], [20, 8], [20, 6], [20, 0], [22, 0], [24, 0], [24, 2], [22, 2], [22, 0], [22, 2], [24, 2], [24, 4], [22, 4], [22, 2], [22, 4], [24, 4], [24, 6], [22, 6], [22, 4], [22, 6], [24, 6], [24, 8], [22, 8], [22, 6], [22, 8], [22, 0]]
    },
    'color-3': {
        name: 'Color 3',
        fillAll: true,
        placeholderColor: 'rgb(106,106,110)',
        border: [[0, 0], [0, 8], [2, 8], [2, 10], [0, 10], [0, 8], [0, 10], [2, 10], [2, 12], [0, 12], [0, 10], [0, 8], [4, 8], [4, 10], [2, 10], [2, 8], [2, 10], [4, 10], [4, 12], [2, 12], [2, 10], [2, 8], [2, 10], [4, 10], [4, 8], [6, 8], [6, 10], [4, 10], [4, 8], [4, 10], [6, 10], [6, 12], [4, 12], [4, 10], [4, 8], [2, 8], [2, 10], [4, 10], [4, 12], [4, 8], [6, 8], [8, 8], [8, 10], [6, 10], [6, 8], [6, 10], [8, 10], [8, 12], [6, 12], [6, 10], [6, 8], [0, 8], [0, 0], [10, 0], [10, 2], [8, 2], [8, 0], [8, 2], [10, 2], [10, 4], [8, 4], [8, 2], [8, 4], [10, 4], [10, 6], [8, 6], [8, 4], [8, 6], [10, 6], [10, 8], [8, 8], [8, 6], [8, 8], [10, 8], [10, 10], [8, 10], [8, 8], [8, 10], [10, 10], [10, 12], [8, 12], [8, 10], [8, 0], [12, 0], [12, 2], [10, 2], [10, 0], [10, 2], [12, 2], [12, 4], [10, 4], [10, 2], [10, 4], [12, 4], [12, 6], [10, 6], [10, 4], [10, 6], [12, 6], [12, 8], [10, 8], [10, 6], [10, 8], [12, 8], [12, 10], [10, 10], [10, 8], [10, 10], [12, 10], [12, 12], [10, 12], [10, 0], [16, 0], [16, 16], [18, 16], [18, 18], [16, 18], [16, 16], [16, 18], [18, 18], [18, 20], [16, 20], [16, 18], [16, 20], [18, 20], [18, 22], [16, 22], [16, 20], [16, 22], [18, 22], [18, 24], [16, 24], [16, 22], [16, 16], [20, 16], [20, 18], [18, 18], [18, 16], [18, 18], [20, 18], [20, 20], [18, 20], [18, 18], [18, 20], [20, 20], [20, 22], [18, 22], [18, 20], [18, 22], [20, 22], [20, 24], [18, 24], [18, 22], [18, 16], [22, 16], [22, 18], [20, 18], [20, 16], [20, 18], [22, 18], [22, 20], [20, 20], [20, 18], [20, 20], [22, 20], [22, 22], [20, 22], [20, 20], [20, 22], [22, 22], [22, 24], [20, 24], [20, 16], [24, 16], [24, 18], [22, 18], [22, 16], [22, 18], [24, 18], [24, 20], [22, 20], [22, 18], [22, 20], [24, 20], [24, 22], [22, 22], [22, 20], [22, 22], [24, 22], [24, 24], [22, 24], [22, 22], [22, 16], [16, 16], [16, 0]]
    },
    'color-4': {
        name: 'Color 4',
        fillAll: true,
        placeholderColor: 'rgb(61,67,71)',
        border: [[0, 0], [0, 16], [2, 16], [2, 18], [0, 18], [0, 16], [0, 18], [2, 18], [2, 20], [0, 20], [0, 18], [0, 20], [2, 20], [2, 22], [0, 22], [0, 20], [0, 22], [2, 22], [2, 24], [0, 24], [0, 16], [4, 16], [4, 18], [2, 18], [2, 16], [2, 18], [4, 18], [4, 20], [2, 20], [2, 18], [2, 20], [4, 20], [4, 22], [2, 22], [2, 20], [2, 22], [4, 22], [4, 24], [2, 24], [2, 22], [2, 16], [6, 16], [6, 18], [4, 18], [4, 16], [4, 18], [6, 18], [6, 20], [4, 20], [4, 18], [4, 20], [6, 20], [6, 22], [4, 22], [4, 20], [4, 22], [6, 22], [6, 24], [4, 24], [4, 16], [8, 16], [8, 18], [6, 18], [6, 16], [6, 18], [8, 18], [8, 20], [6, 20], [6, 18], [6, 20], [8, 20], [8, 22], [6, 22], [6, 20], [6, 22], [8, 22], [8, 24], [6, 24], [6, 22], [6, 16], [0, 16], [0, 0], [14, 0], [14, 2], [12, 2], [12, 0], [12, 2], [14, 2], [14, 4], [12, 4], [12, 2], [12, 4], [14, 4], [14, 6], [12, 6], [12, 4], [12, 6], [14, 6], [14, 8], [12, 8], [12, 6], [12, 8], [14, 8], [14, 10], [12, 10], [12, 8], [12, 10], [14, 10], [14, 12], [12, 12], [12, 10], [12, 0], [16, 0], [16, 2], [14, 2], [14, 0], [14, 2], [16, 2], [16, 4], [14, 4], [14, 2], [14, 4], [16, 4], [16, 6], [14, 6], [14, 4], [14, 6], [16, 6], [16, 8], [14, 8], [14, 6], [14, 8], [16, 8], [16, 10], [14, 10], [14, 8], [14, 10], [16, 10], [16, 12], [14, 12], [14, 10], [14, 0], [16, 0], [16, 8], [18, 8], [18, 10], [16, 10], [16, 8], [16, 10], [18, 10], [18, 12], [16, 12], [16, 8], [20, 8], [20, 10], [18, 10], [18, 8], [18, 10], [20, 10], [20, 12], [18, 12], [18, 10], [18, 8], [22, 8], [22, 10], [20, 10], [20, 8], [20, 10], [22, 10], [22, 12], [20, 12], [20, 10], [20, 8], [24, 8], [24, 10], [22, 10], [22, 8], [22, 10], [24, 10], [24, 12], [22, 12], [22, 10], [22, 8], [16, 8], [16, 0], [0, 0]]
    }
};

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

module.exports = {
  '000': 'F',
  '010': 'D',
  '011': 'C',
  '012': 'B',
  '013': 'A',
  '020': 'D',
  '030': 'D',
  '031': 'C',
  '032': 'B',
  '040': 'D',
  '100': 'F',
  '110': 'E',
  '111': 'B',
  '112': 'C',
  '113': 'A',
  '120': 'E',
  '130': 'E',
  '131': 'B',
  '132': 'C',
  '140': 'E'
};

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = {
  // Lisboa
  '7d139b52-372d-4f39-93fc-40f3c0a37955': {
    name: 'Lisboa 1'
  },

  '85c5dbbb-0060-4dfb-8f95-78a26b3129bf': {
    name: 'Lisboa 2',
    d: 'M 8 0 L 8 16'
  },

  '1e1fee34-22f7-44c9-b434-6e1d99c5026c': {
    name: 'Lisboa 3',
    d: 'M 8 0 L 8 16 M 0 8 L 16 8'
  },

  '1887c14d-bc09-413a-92d9-8482c366f2bf': {
    name: 'Lisboa 4',
    d: 'M 0 8 L 8 0'
  },

  '3700ff98-fb11-4fb4-9e4a-1bc24f97c543': {
    name: 'Lisboa 5',
    d: 'M 8 16 A 8 8 0 0 1 16 8'
  },

  // Porto
  '36a71a74-22c5-4366-b6e2-b27e3acd02b2': {
    id: '36a71a74-22c5-4366-b6e2-b27e3acd02b2',
    name: 'Porto 1',
    d: ['M 0.16  0   L 0.16  16', 'M 3.04  0   L 3.04  16', 'M 3.36  0   L 3.36  16', 'M 6.24  0   L 6.24  16', 'M 6.56  0   L 6.56  16', 'M 9.44  0   L 9.44  16', 'M 9.76  0   L 9.76  16', 'M 12.64 0   L 12.64 16', 'M 12.96 0   L 12.96 16', 'M 15.84 0   L 15.84 16'].join(' ')
  },

  'f1d8199b-21b2-4042-95ef-b7f0dcbdc06d': {
    name: 'Porto 2',
    d: ['M 0.16  0   L 0.16 16', 'M 3.04  0   L 3.04 16', 'M 3.36  0   L 3.36 16', 'M 6.24  0   L 6.24 16', 'M 6.56  0   L 6.56 16', 'M 9.44  0   L 9.44 16', 'M 9.76  0   L 9.76 16', 'M 12.64 0   L 12.64 16', 'M 1.6   0   L 1.6 16', 'M 4.8   0   L 4.8 16', 'M 8     0   L 8 16', 'M 11.2  0   L 11.2 16', 'M 14.4  0   L 14.4 16', 'M 12.96 0   L 12.96 16', 'M 15.84 0   L 15.84 16'].join(' ')
  },

  'e42dcf38-771f-4088-8002-a88a9c8f6378': {
    name: 'Porto 3',
    d: ['M 0.16  0   L 0.16  16', 'M 15.84 0   L 15.84 16', 'M 3.04  0   L 3.04  16', 'M 3.36  0   L 3.36  16', 'M 6.24  0   L 6.24  16', 'M 6.56  0   L 6.56  16', 'M 9.44  0   L 9.44  16', 'M 9.76  0   L 9.76  16', 'M 12.64 0   L 12.64 16', 'M 12.96 0   L 12.96 16', 'M 2.72  0   L 2.72  16', 'M 5.92  0   L 5.92  16', 'M 9.12  0   L 9.12  16', 'M 12.32 0   L 12.32 16', 'M 15.52 0   L 15.52 16'].join(' ')
  },

  'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9': {
    name: '402 Large',
    bounds: [16, 16],
    // naming: <group><block><variant>
    // group: 0 - clockwise, 1 - anticlockwise
    // block: 0 - center, 1 - NE, 2 - SE, 3 - SW, 4 - NW
    // variant: 0 - 1/4, 1 - 1/2 h, 2 - 1/2 v, 3 - full
    // center block has trailing 0 for consistency
    variants: {
      '000': 'M7.83 11.75l-.07-.05-.06-.05-.07-.04-.06-.05-.07-.05-.06-.05-.06-.05-.07-.05-.06-.05-.06-.05-.07-.05-.06-.05L7 11.1l-.06-.05-.06-.06-.07-.05-.06-.05-.06-.06-.06-.05-.06-.06-.06-.05-.05-.06-.06-.05-.06-.06-.06-.05-.06-.06-.05-.06-.06-.06-.06-.05-.05-.06-.06-.06-.05-.06-.06-.06-.05-.06-.06-.06-.05-.06-.05-.06-.06-.06-.05-.06-.05-.06-.05-.07-.05-.06-.05-.06-.06-.06-.05-.07-.04-.06-.05-.06-.05-.07L5 9l-.05-.07-.05-.06-.04-.07-.05-.07-.05-.06-.04-.07-.05-.06-.04-.07-.05-.07-.04-.07-.05-.06-.04-.07-.04-.07-.04-.07-.05-.07-.04-.07-.04-.07v-.02l.05-.07.05-.06.04-.07.05-.06.05-.07.05-.06.05-.06.05-.07.05-.06.05-.06.05-.07.05-.06L4.9 7l.05-.06.06-.06.05-.07.05-.06.06-.06.05-.06.06-.06.05-.06.06-.05.05-.06.06-.06.05-.06.06-.06.06-.05.06-.06.05-.06.06-.05.06-.06.06-.05.06-.06.06-.05.06-.06.06-.05.06-.05.06-.06.06-.05.06-.05.07-.05.06-.05.06-.05.06-.06.07-.05.06-.04.06-.05.07-.05L7 5l.07-.05.06-.05.07-.04.07-.05.06-.05.07-.04.06-.05.07-.04.07-.05.07-.04.06-.05.07-.04.07-.04.07-.04.07-.05.07-.04.07-.04h.02l.07.05.06.05.07.04.06.05.07.05.06.05.06.05.07.05.06.05.06.05.07.05.06.05.06.05.06.05.06.06.07.05.06.05.06.06.06.05.06.06.06.05.05.06.06.05.06.06.06.05.06.06.05.06.06.06.06.05.05.06.06.06.05.06.06.06.05.06.06.06.05.06.05.06.06.06.05.06.05.06.05.07.05.06.05.06.06.06.05.07.04.06.05.06.05.07L11 7l.05.07.05.06.04.07.05.07.05.06.04.07.05.06.04.07.05.07.04.07.05.06.04.07.04.07.04.07.05.07.04.07.04.07v.02l-.05.07-.05.06-.04.07-.05.06-.05.07-.05.06-.05.06-.05.07-.05.06-.05.06-.05.07-.05.06-.05.06-.05.06-.06.06-.05.07-.05.06-.06.06-.05.06-.06.06-.05.06-.06.05-.05.06-.06.06-.05.06-.06.06-.06.05-.06.06-.05.06-.06.05-.06.06-.06.05-.06.06-.06.05-.06.06-.06.05-.06.05-.06.06-.06.05-.06.05-.07.05-.06.05-.06.05-.06.06-.07.05-.06.04-.06.05-.07.05L9 11l-.07.05-.06.05-.07.04-.07.05-.06.05-.07.04-.06.05-.07.04-.07.05-.07.04-.06.05-.07.04-.07.04-.07.04-.07.05-.07.04-.07.04h-.02',
      '010': 'M2.22 0H16v2.1h-.44l-.44.01-.45.03-.44.04-.44.05-.43.07-.44.07-.43.09-.43.1-.41.1-.42.12-.41.13-.41.14-.4.15-.4.17-.4.17-.37.19-.36.19-.36.2-.35.22-.35.22-.33.24-.33.24-.33.26-.31.26-.3.28-.3.29-.29.3-.27.3-.27.31-.25.32-.13.17-.12.17h-.03l-.04-.09-.05-.08-.04-.08-.04-.08-.04-.08-.04-.09-.05-.08-.04-.08-.04-.09-.03-.08-.04-.08-.04-.09-.04-.08-.04-.08-.03-.09-.04-.08-.04-.09-.03-.08-.04-.09-.03-.08-.04-.09-.03-.09-.03-.08-.03-.09-.04-.08-.03-.1-.03-.08-.03-.08-.03-.1-.03-.08-.03-.09L3 5l-.03-.1-.02-.08-.03-.09-.03-.09-.02-.08-.03-.1-.02-.08-.03-.09-.02-.09-.03-.09-.02-.09-.02-.09-.02-.09-.03-.09-.02-.09-.02-.09-.02-.09-.02-.09-.02-.09-.01-.09-.02-.09-.02-.09-.02-.09-.01-.09-.02-.09-.01-.09-.02-.09-.01-.1-.02-.08-.01-.1-.01-.09-.02-.09v-.09l-.02-.09-.01-.1-.01-.08v-.1l-.02-.09v-.09l-.02-.09v-.1l-.01-.08v-.1l-.01-.09V.92l-.01-.1V.75l-.01-.1V.46l-.01-.1V0',
      '011': 'M15.56 2.1l-.44.01-.45.03-.44.04-.44.05-.43.07-.44.07-.43.09-.43.1-.41.1-.42.12-.41.13-.41.14-.4.15-.8.34-.37.19-.36.19-.36.2-.7.44-.66.48-.33.26-.31.26-.3.28-.3.29-.29.3-.27.3-.27.31-.25.32-.13.17-.12.17h-.03l-.04-.09-.05-.08-.12-.24-.04-.09-.05-.08-.04-.08-.04-.09-.03-.08-.04-.08-.04-.09-.08-.16-.03-.09-.04-.08-.04-.09-.03-.08-.04-.09-.03-.08-.04-.09-.03-.09-.03-.08-.03-.09-.04-.08-.03-.1-.06-.16-.03-.1-.03-.08-.03-.09L3 5l-.03-.1-.02-.08-.06-.18-.02-.08-.03-.1-.02-.08-.03-.09-.02-.09-.03-.09-.06-.27-.03-.09-.1-.45-.01-.09-.06-.27-.01-.09-.02-.09-.01-.09-.02-.09-.01-.1-.02-.08-.01-.1-.01-.09-.02-.09v-.09l-.02-.09-.01-.1-.01-.08v-.1l-.02-.09v-.09l-.02-.09v-.1l-.01-.08v-.1l-.01-.09v-.1l-.01-.1V.75l-.01-.1V.46l-.01-.1V0h27.56v.36l-.01.1v.19l-.01.1v.07l-.01.1v.1l-.01.09v.1l-.01.08v.1l-.02.09v.09l-.02.09v.1l-.01.08-.01.1-.02.09v.09l-.02.09-.01.09-.01.1-.02.08-.01.1-.02.09-.01.09-.02.09-.01.09-.06.27-.01.09-.02.09-.02.09-.02.09-.02.09-.02.09-.03.09-.06.27-.03.09-.02.09-.03.09-.02.08-.03.1-.02.08-.06.18-.02.08L29 5l-.03.07-.03.09-.03.08-.03.1-.06.16-.03.1-.03.08-.04.09-.03.08-.03.09-.04.09-.03.08-.04.09-.03.08-.04.09-.04.08-.03.09-.08.16-.04.09-.04.08-.03.08-.04.09-.04.08-.05.08-.04.09-.12.24-.05.08-.04.09h-.03l-.12-.17-.13-.17-.25-.32-.27-.31-.27-.3-.29-.3-.3-.29-.3-.28-.31-.26-.33-.26-.66-.48-.7-.44-.36-.2-.36-.19-.37-.19-.8-.34-.4-.15-.41-.14-.41-.13-.42-.12-.41-.1-.43-.1-.43-.09-.44-.07-.43-.07-.44-.05-.44-.04-.45-.03-.44-.01h-.88z',
      '012': 'M2.22-.37l.01-.1v-.18l.01-.1v-.08l.01-.1v-.09l.01-.09v-.1l.01-.08v-.1l.02-.09v-.09l.02-.09v-.1l.01-.08.01-.1.02-.09v-.09l.02-.09.01-.09.01-.1.02-.08.01-.1.02-.09.01-.09.02-.09.01-.09.06-.27.01-.09.1-.45.03-.09.06-.27.03-.09.02-.09.03-.09.02-.08.03-.1.02-.08.06-.18.02-.08L3-5l.03-.07.03-.09.03-.08.03-.1.03-.08.06-.18.04-.08.03-.09.03-.08.03-.09.04-.09.03-.08.04-.09.03-.08.04-.09.04-.08.03-.09.08-.16.04-.09.04-.08.03-.08.04-.09.04-.08.05-.08.04-.09.12-.24.05-.08.04-.09h.03l.12.17.13.17.25.32.27.31.27.3.29.3.3.29.3.28.31.26.33.26.66.48.7.44.36.2.36.19.37.19.8.34.4.15.41.14.41.13.42.12.41.1.43.1.43.09.44.07.43.07.44.05.44.04.45.03.44.01H16v4.2h-.44l-.44.01-.45.03-.44.04-.44.05-.43.07-.44.07-.43.09-.43.1-.41.1-.42.12-.41.13-.41.14-.4.15-.8.34-.37.19-.36.19-.36.2-.7.44-.66.48-.33.26-.31.26-.3.28-.3.29-.29.3-.27.3-.27.31-.25.32-.13.17-.12.17h-.03l-.04-.09-.05-.08-.12-.24-.04-.09-.05-.08-.04-.08-.04-.09-.03-.08-.04-.08-.04-.09-.08-.16-.03-.09-.04-.08-.04-.09-.03-.08-.04-.09-.03-.08-.04-.09-.03-.09-.03-.08-.03-.09-.04-.08-.03-.1-.06-.16-.03-.1-.03-.08-.03-.09L3 5l-.03-.1-.02-.08-.06-.18-.02-.08-.03-.1-.02-.08-.03-.09-.02-.09-.03-.09-.06-.27-.03-.09-.1-.45-.01-.09-.06-.27-.01-.09-.02-.09-.01-.09-.02-.09-.01-.1-.02-.08-.01-.1-.01-.09-.02-.09v-.09l-.02-.09-.01-.1-.01-.08v-.1l-.02-.09v-.09l-.02-.09v-.1l-.01-.08v-.1l-.01-.09v-.1l-.01-.1V.75l-.01-.1V.46l-.01-.1v-.73z',
      '013': 'M2.22 0v-.37l.01-.1v-.18l.01-.1v-.08l.01-.1v-.09l.01-.09v-.1l.01-.08v-.1l.02-.09v-.09l.02-.09v-.1l.01-.08.01-.1.02-.09v-.09l.02-.09.01-.09.01-.1.02-.08.01-.1.02-.09.01-.09.02-.09.01-.09.06-.27.01-.09.1-.45.03-.09.06-.27.03-.09.02-.09.03-.09.02-.08.03-.1.02-.08.06-.18.02-.08L3-5l.03-.07.03-.09.03-.08.03-.1.03-.08.06-.18.04-.08.03-.09.03-.08.03-.09.04-.09.03-.08.04-.09.03-.08.04-.09.04-.08.03-.09.08-.16.04-.09.04-.08.03-.08.04-.09.04-.08.05-.08.04-.09.04-.08.08-.16.05-.08.04-.09h.03l.12.17.13.17.25.32.27.31.27.3.29.3.3.29.3.28.31.26.33.26.66.48.7.44.36.2.36.19.37.19.8.34.4.15.41.14.41.13.42.12.41.1.43.1.43.09.44.07.43.07.44.05.44.04.45.03.44.01h.88l.44-.01.45-.03.44-.04.44-.05.43-.07.44-.07.43-.09.43-.1.41-.1.42-.12.41-.13.41-.14.4-.15.8-.34.37-.19.36-.19.36-.2.7-.44.66-.48.33-.26.31-.26.3-.28.3-.29.29-.3.27-.3.27-.31.25-.32.13-.17.12-.17h.03l.04.09.05.08.12.24.04.09.05.08.04.08.04.09.03.08.04.08.04.09.08.16.03.09.04.08.04.09.03.08.04.09.03.08.04.09.03.09.03.08.04.09.03.08.06.18.03.08.03.1.03.08.03.09.03.08.03.1.02.08.06.18.02.08.03.1.02.08.03.09.02.09.03.09.06.27.03.09.1.45.01.09.06.27.01.09.02.09.01.09.02.09.01.1.02.08.01.1.01.09.02.09v.09l.02.09.01.1.01.08v.1l.02.09v.09l.02.09v.1l.01.08v.1l.01.09v.09l.01.1v.08l.01.1v.18l.01.1v.72l-.01.1v.19l-.01.1v.07l-.01.1v.1l-.01.09v.1l-.01.08v.1l-.02.09v.09l-.02.09v.1l-.01.08-.01.1-.02.09v.09l-.02.09-.01.09-.01.1-.02.08-.01.1-.02.09-.01.09-.02.09-.01.09-.06.27-.01.09-.1.45-.03.09-.06.27-.03.09-.02.09-.03.09-.02.08-.03.1-.02.08-.06.18-.02.08L29 5l-.03.07-.03.09-.03.08-.03.1-.06.16-.03.1-.03.08-.04.09-.03.08-.03.09-.04.09-.03.08-.04.09-.03.08-.04.09-.04.08-.03.09-.08.16-.04.09-.04.08-.03.08-.04.09-.04.08-.05.08-.04.09-.12.24-.05.08-.04.09h-.03l-.12-.17-.13-.17-.25-.32-.27-.31-.27-.3-.29-.3-.3-.29-.3-.28-.31-.26-.33-.26-.66-.48-.7-.44-.36-.2-.36-.19-.37-.19-.8-.34-.4-.15-.41-.14-.41-.13-.42-.12-.41-.1-.43-.1-.43-.09-.44-.07-.43-.07-.44-.05-.44-.04-.45-.03-.44-.01h-.88l-.44.01-.45.03-.44.04-.44.05-.43.07-.44.07-.43.09-.43.1-.41.1-.42.12-.41.13-.41.14-.4.15-.8.34-.37.19-.36.19-.36.2-.7.44-.66.48-.33.26-.31.26-.3.28-.3.29-.29.3-.27.3-.27.31-.25.32-.13.17-.12.17h-.03l-.04-.09-.05-.08-.12-.24-.04-.09-.05-.08-.04-.08-.04-.09-.03-.08-.04-.08-.04-.09-.08-.16-.03-.09-.04-.08-.04-.09-.03-.08-.04-.09-.03-.08-.04-.09-.03-.09-.03-.08-.03-.09-.04-.08-.03-.1-.06-.16-.03-.1-.03-.08-.03-.09L3 5l-.03-.1-.02-.08-.06-.18-.02-.08-.03-.1-.02-.08-.03-.09-.02-.09-.03-.09-.06-.27-.03-.09-.1-.45-.01-.09-.06-.27-.01-.09-.02-.09-.01-.09-.02-.09-.01-.1-.02-.08-.01-.1-.01-.09-.02-.09v-.09l-.02-.09-.01-.1-.01-.08v-.1l-.02-.09v-.09l-.02-.09v-.1l-.01-.08v-.1l-.01-.09v-.1l-.01-.1V.75l-.01-.1V.46l-.01-.1V0z',
      '020': 'M16 2.22V16h-2.1v-.44l-.01-.44-.03-.45-.04-.44-.05-.44-.07-.43-.07-.44-.09-.43-.1-.43-.1-.41-.12-.42-.13-.41-.14-.41-.15-.4-.17-.4-.17-.4-.19-.37-.19-.36-.2-.36-.22-.35-.22-.35-.24-.33-.24-.33-.26-.33-.26-.31-.28-.3-.29-.3-.3-.29-.3-.27-.31-.27-.32-.25-.17-.13-.17-.12v-.03l.09-.04.08-.05.08-.04.08-.04.08-.04.09-.04.08-.05.08-.04.09-.04.08-.03.08-.04.09-.04.08-.04.08-.04.09-.03.08-.04.09-.04.08-.03.09-.04.08-.03.09-.04.09-.03.08-.03.09-.03.08-.04.09-.03.09-.03.08-.03.1-.03.08-.03.09-.03L11 3l.1-.03.08-.02.09-.03.09-.03.08-.02.1-.03.08-.02.09-.03.09-.02.09-.03.09-.02.09-.02.09-.02.09-.03.09-.02.09-.02.09-.02.09-.02.09-.02.09-.01.09-.02.09-.02.09-.02.09-.01.09-.02.09-.01.09-.02.1-.01.08-.02.1-.01.09-.01.09-.02h.09l.09-.02.1-.01.08-.01h.1l.09-.02h.09l.09-.02h.1l.08-.01h.1l.09-.01h.09l.1-.01h.08l.1-.01h.18l.1-.01H16',
      '030': 'M13.78 16H0v-2.1h.44l.44-.01.45-.03.44-.04.44-.05.43-.07.44-.07.43-.09.43-.1.41-.1.42-.12.41-.13.41-.14.4-.15.4-.17.4-.17.37-.19.36-.19.36-.2.35-.22.35-.22.33-.24.33-.24.33-.26.31-.26.3-.28.3-.29.29-.3.27-.3.27-.31.25-.32.13-.17.12-.17h.03l.04.09.05.08.04.08.04.08.04.08.04.09.05.08.04.08.04.09.03.08.04.08.04.09.04.08.04.08.03.09.04.08.04.09.03.08.04.09.03.08.04.09.03.09.03.08.04.09.03.08.03.09.03.09.03.08.03.1.03.08.03.09.03.08.03.1.02.08.03.09.03.09.02.08.03.1.02.08.03.09.02.09.03.09.02.09.02.09.02.09.03.09.02.09.02.09.02.09.02.09.02.09.01.09.02.09.02.09.02.09.01.09.02.09.01.09.02.09.01.1.02.08.01.1.01.09.02.09v.09l.02.09.01.1.01.08v.1l.02.09v.09l.02.09v.1l.01.08v.1l.01.09v.09l.01.1v.08l.01.1v.18l.01.1V16',
      '031': 'M-13.78 16v-.37l.01-.1v-.18l.01-.1v-.08l.01-.1v-.09l.01-.09v-.1l.01-.08v-.1l.02-.09v-.09l.02-.09v-.1l.01-.08.01-.1.02-.09v-.09l.02-.09.01-.09.01-.1.02-.08.01-.1.02-.09.01-.09.02-.09.01-.09.02-.09.04-.18.01-.09.02-.09.02-.09.04-.18.02-.09.03-.09.04-.18.02-.09.03-.09.02-.09.03-.09.02-.08.03-.1.02-.08.06-.18.02-.08.03-.1.03-.07.03-.09.03-.08.03-.1.03-.08.03-.09.03-.09.04-.08.03-.09.03-.08.03-.09.04-.09.03-.08.04-.09.03-.08.04-.09.04-.08.03-.09.04-.08.04-.08.04-.09.04-.08.03-.08.04-.09.04-.08.05-.08.04-.09.04-.08.08-.16.05-.08.04-.09h.03l.12.17.13.17.25.32.27.31.27.3.29.3.3.29.3.28.31.26.33.26.66.48.7.44.36.2.36.19.37.19.8.34.4.15.41.14.41.13.42.12.41.1.43.1.43.09.44.07.43.07.44.05.44.04.45.03.44.01h.88l.44-.01.45-.03.44-.04.44-.05.43-.07.44-.07.43-.09.43-.1.41-.1.42-.12.41-.13.41-.14.4-.15.8-.34.37-.19.36-.19.36-.2.7-.44.66-.48.33-.26.31-.26.3-.28.3-.29.29-.3.27-.3.27-.31.25-.32.13-.17.12-.17h.03l.04.09.05.08.12.24.04.09.05.08.04.08.04.09.03.08.04.08.04.09.08.16.03.09.04.08.04.09.03.08.04.09.03.08.04.09.03.09.03.08.04.09.03.08.06.18.03.08.03.1.03.08.03.09.03.08.03.1.02.08.06.18.02.08.03.1.02.08.03.09.02.09.03.09.06.27.03.09.1.45.01.09.06.27.01.09.02.09.01.09.02.09.01.1.02.08.01.1.01.09.02.09v.09l.02.09.01.1.01.08v.1l.02.09v.09l.02.09v.1l.01.08v.1l.01.09v.09l.01.1v.08l.01.1v.18l.01.1V16h-27.56z',
      '032': 'M0 18.1v-4.2h.44l.44-.01.45-.03.44-.04.44-.05.43-.07.44-.07.43-.09.43-.1.41-.1.42-.12.41-.13.41-.14.4-.15.8-.34.37-.19.36-.19.36-.2.7-.44.66-.48.33-.26.31-.26.3-.28.3-.29.29-.3.27-.3.27-.31.25-.32.13-.17.12-.17h.03l.04.09.05.08.12.24.04.09.05.08.04.08.04.09.03.08.04.08.04.09.08.16.03.09.04.08.04.09.03.08.04.09.03.08.04.09.03.09.03.08.04.09.03.08.06.18.03.08.03.1.03.08.03.09.03.08.03.1.02.08.06.18.02.08.03.1.02.08.03.09.02.09.03.09.06.27.03.09.1.45.01.09.06.27.01.09.02.09.01.09.02.09.01.1.02.08.01.1.01.09.02.09v.09l.02.09.01.1.01.08v.1l.02.09v.09l.02.09v.1l.01.08v.1l.01.09v.09l.01.1v.08l.01.1v.18l.01.1v.72l-.01.1v.19l-.01.1v.07l-.01.1v.1l-.01.09v.1l-.01.08v.1l-.02.09v.09l-.02.09v.1l-.01.08-.01.1-.02.09v.09l-.02.09-.01.09-.01.1-.02.08-.01.1-.02.09-.01.09-.02.09-.01.09-.02.09-.02.09-.02.09-.01.09-.02.09-.02.09-.02.09-.02.09-.02.09-.03.09-.02.09-.02.09-.02.09-.03.09-.02.09-.03.09-.02.08-.03.1-.02.08-.06.18-.02.08-.03.1-.03.07-.03.09-.03.08-.03.1-.03.08-.03.08-.03.1-.03.08-.04.09-.03.08-.03.09-.04.09-.03.08-.04.09-.03.08-.04.09-.04.08-.03.09-.04.08-.04.08-.04.09-.04.08-.03.08-.04.09-.04.08-.05.08-.04.09-.04.08-.04.08-.04.08-.05.08-.04.09h-.03l-.12-.17-.13-.17-.25-.32-.27-.31-.27-.3-.29-.3-.3-.29-.3-.28-.31-.26-.33-.26-.66-.48-.7-.44-.36-.2-.36-.19-.37-.19-.8-.34-.4-.15-.41-.14-.41-.13-.42-.12-.41-.1-.43-.1-.43-.09-.44-.07-.43-.07-.44-.05-.44-.04-.45-.03-.44-.01H0z',
      '040': 'M0 13.78V0h2.1v.44l.01.44.03.45.04.44.05.44.07.43.07.44.09.43.1.43.1.41.12.42.13.41.14.41.15.4.17.4.17.4.19.37.19.36.2.36.22.35.22.35.24.33.24.33.26.33.26.31.28.3.29.3.3.29.3.27.31.27.32.25.17.13.17.12v.03l-.09.04-.08.05-.08.04-.08.04-.08.04-.09.04-.08.05-.08.04-.09.04-.08.03-.08.04-.09.04-.08.04-.08.04-.09.03-.08.04-.09.04-.08.03-.09.04-.08.03-.09.04-.09.03-.08.03-.09.04-.08.03-.1.03-.08.03-.08.03-.1.03-.08.03-.09.03L5 13l-.1.03-.08.02-.09.03-.09.03-.08.02-.1.03-.08.02-.09.03-.09.02-.09.03-.09.02-.09.02-.09.02-.09.03-.09.02-.09.02-.09.02-.09.02-.09.02-.09.01-.09.02-.09.02-.09.02-.09.01-.09.02-.09.01-.09.02-.1.01-.08.02-.1.01-.09.01-.09.02h-.09l-.09.02-.1.01-.08.01h-.1l-.09.02h-.09l-.09.02h-.1l-.08.01h-.1l-.09.01h-.1l-.1.01H.75l-.1.01H.46l-.1.01H0',

      '100': 'M8.15 11.75l-.07-.04-.07-.04-.07-.05-.07-.04-.07-.04-.07-.04-.06-.05-.07-.04-.07-.05-.07-.04-.06-.05-.07-.04-.06-.05-.07-.05-.07-.04-.06-.05-.07-.05-.06-.05-.07-.05-.06-.05-.06-.04-.07-.05-.06-.06-.06-.05-.06-.05-.07-.05-.06-.05-.06-.05-.06-.06-.06-.05-.06-.05-.06-.06-.06-.05-.06-.06-.06-.05-.06-.06-.06-.05-.05-.06-.06-.06-.06-.05-.06-.06-.05-.06-.06-.06-.05-.06-.06-.05-.05-.06-.06-.06-.05-.06-.06-.06-.05-.06L5 9.12l-.06-.06L4.9 9l-.05-.06-.05-.06-.05-.07-.05-.06-.05-.06-.05-.07-.05-.06-.05-.06-.05-.07-.05-.06-.04-.07-.05-.06-.05-.07v-.02l.04-.07.04-.07.05-.07.04-.07.04-.07.04-.07.05-.06.04-.07.05-.07.04-.07.05-.06.04-.07.05-.06.05-.07.04-.07.05-.06.05-.07.05-.06.05-.07.05-.06.04-.06.05-.07.06-.06.05-.06.05-.06.05-.07.05-.06.05-.06.06-.06.05-.06.05-.06.06-.06.05-.06.06-.06.05-.06.06-.06.05-.06.06-.05.06-.06.05-.06.06-.06.06-.05.06-.06.06-.05.05-.06.06-.05.06-.06.06-.05.06-.06.06-.05.07-.05.06-.06L7 4.9l.06-.05.06-.05.07-.05.06-.05.06-.05.07-.05.06-.05.06-.05.07-.05.06-.05.07-.04.06-.05.07-.05h.02l.07.04.07.04.07.05.07.04.07.04.07.04.06.05.07.04.07.05.07.04.06.05.07.04.06.05.07.05.07.04.06.05.07.05.06.05.07.05.06.05.06.04.07.05.06.06.06.05.06.05.07.05.06.05.06.05.06.06.06.05.06.05.06.06.06.05.06.06.06.05.06.06.06.05.05.06.06.06.06.05.06.06.05.06.06.06.05.06.06.05.05.06.06.06.05.06.06.06.05.06.05.07.06.06.05.06.05.06.05.06.05.07.05.06.05.06.05.07.05.06.05.06.05.07.05.06.04.07.05.06.05.07v.02l-.04.07-.04.07-.05.07-.04.07-.04.07-.04.07-.05.06-.04.07-.05.07-.04.07-.05.06-.04.07-.05.06-.05.07-.04.07-.05.06-.05.07-.05.06-.05.07-.05.06-.04.06-.05.07-.06.06-.05.06-.05.06-.05.07-.05.06-.05.06-.06.06-.05.06-.05.06-.06.06-.05.06-.06.06-.05.06-.06.06-.05.06-.06.05-.06.06-.05.06-.06.06-.06.05-.06.06-.06.05-.05.06-.06.05-.06.06-.06.05-.06.06-.06.05-.07.05-.06.06-.06.05-.06.05-.06.05-.07.05-.06.05-.06.05-.07.05-.06.05-.06.05-.07.05-.06.05-.07.04-.06.05-.07.05h-.02',
      '110': 'M16 13.78V0h-2.1v.44l-.01.44-.03.45-.04.44-.05.44-.07.43-.07.44-.09.43-.1.43-.1.41-.12.42-.13.41-.14.41-.15.4-.17.4-.17.4-.19.37-.19.36-.2.36-.22.35-.22.35-.24.33-.24.33-.26.33-.26.31-.28.3-.29.3-.3.29-.3.27-.31.27-.32.25-.17.13-.17.12v.03l.09.04.08.05.08.04.08.04.08.04.09.04.08.05.08.04.09.04.08.03.08.04.09.04.08.04.08.04.09.03.08.04.09.04.08.03.09.04.08.03.09.04.09.03.08.03.09.04.08.03.09.03.09.03.08.03.1.03.08.03.09.03.08.03.1.03.08.02.09.03.09.03.08.02.1.03.08.02.09.03.09.02.09.03.09.02.09.02.09.02.09.03.09.02.09.02.09.02.09.02.09.02.09.01.09.02.09.02.09.02.09.01.09.02.09.01.09.02.1.01.08.02.1.01.09.01.09.02h.09l.09.02.1.01.08.01h.1l.09.02h.09l.09.02h.1l.08.01h.1l.09.01h.09l.1.01h.08l.1.01h.18l.1.01H16',
      '111': 'M15.54 13.77h-.18l-.1-.01h-.08l-.1-.01h-.09l-.09-.01h-.1l-.08-.01h-.1l-.09-.02h-.09l-.09-.02h-.1l-.08-.01-.1-.01-.09-.02h-.09l-.09-.02-.09-.01-.1-.01-.08-.02-.1-.01-.09-.02-.09-.01-.09-.02-.09-.01-.27-.06-.09-.01-.45-.1-.09-.03-.27-.06-.09-.03-.09-.02-.09-.03-.08-.02-.1-.03-.08-.02-.18-.06-.08-.02-.1-.03-.08-.03-.09-.03-.08-.03-.1-.03-.08-.03-.18-.06-.08-.03-.09-.04-.08-.03-.09-.03-.09-.04-.08-.03-.09-.04-.08-.03-.09-.04-.08-.04-.09-.03-.16-.08-.09-.04-.08-.04-.08-.03-.09-.04-.08-.04-.08-.05-.09-.04-.24-.12-.08-.05-.09-.04v-.03l.17-.12.17-.13.32-.25.31-.27.3-.27.3-.29.29-.3.28-.3.26-.31.26-.33.48-.66.44-.7.2-.36.19-.36.19-.37.34-.8.15-.4.14-.41.13-.41.12-.42.1-.41.1-.43.09-.43.07-.44.07-.43.05-.44.04-.44.03-.45.01-.44V0h4.2v.44l.01.44.03.45.04.44.05.44.07.43.07.44.09.43.1.43.1.41.12.42.13.41.14.41.15.4.34.8.19.37.19.36.2.36.44.7.48.66.26.33.26.31.28.3.29.3.3.29.3.27.31.27.32.25.17.13.17.12v.03l-.09.04-.08.05-.08.04-.08.04-.08.04-.09.04-.08.05-.08.04-.09.04-.08.03-.08.04-.09.04-.08.04-.08.04-.09.03-.08.04-.09.04-.08.03-.09.04-.08.03-.09.04-.09.03-.08.03-.09.04-.08.03-.1.03-.08.03-.08.03-.1.03-.08.03-.09.03L21 13l-.1.03-.08.02-.18.06-.08.02-.1.03-.08.02-.09.03-.09.02-.09.03-.09.02-.09.02-.09.02-.09.03-.09.02-.09.02-.09.02-.09.02-.09.02-.09.01-.09.02-.09.02-.09.02-.09.01-.09.02-.09.01-.09.02-.1.01-.08.02-.1.01-.09.01-.09.02h-.09l-.09.02-.1.01-.08.01h-.1l-.09.02h-.09l-.09.02h-.1l-.08.01h-.1l-.09.01h-.1l-.1.01h-.07l-.1.01h-.19l-.1.01h-.72l-.1-.01z',
      '112': 'M13.9-.44l-.01-.44-.03-.45-.04-.44-.05-.44-.07-.43-.07-.44-.09-.43-.1-.43-.1-.41-.12-.42-.13-.41-.14-.41-.15-.4-.34-.8-.19-.37-.19-.36-.2-.36-.44-.7-.48-.66-.26-.33-.26-.31-.28-.3-.29-.3-.3-.29-.3-.27-.31-.27-.32-.25-.17-.13-.17-.12v-.03l.09-.04.08-.05.16-.08.08-.04.09-.04.08-.05.08-.04.09-.04.08-.03.08-.04.09-.04.08-.04.08-.04.09-.03.08-.04.09-.04.08-.03.09-.04.08-.03.09-.04.09-.03.08-.03.09-.03.08-.04.09-.03.09-.03.08-.03.1-.03.08-.03.09-.03L11-13l.1-.03.08-.02.18-.06.08-.02.1-.03.08-.02.09-.03.09-.02.09-.03.09-.02.18-.04.09-.03.09-.02.18-.04.09-.02.09-.02.09-.01.18-.04.09-.02.09-.01.09-.02.09-.01.09-.02.1-.01.08-.02.1-.01.09-.01.09-.02h.09l.09-.02.1-.01.08-.01h.1l.09-.02h.09l.09-.02h.1l.08-.01h.1l.09-.01h.09l.1-.01h.08l.1-.01h.18l.1-.01H16v27.56h-.36l-.1-.01h-.18l-.1-.01h-.08l-.1-.01h-.09l-.09-.01h-.1l-.08-.01h-.1l-.09-.02h-.09l-.09-.02h-.1l-.08-.01-.1-.01-.09-.02h-.09l-.09-.02-.09-.01-.1-.01-.08-.02-.1-.01-.09-.02-.09-.01-.09-.02-.09-.01-.27-.06-.09-.01-.45-.1-.09-.03-.27-.06-.09-.03-.09-.02-.09-.03-.08-.02-.1-.03-.08-.02-.18-.06-.08-.02-.1-.03-.08-.03-.09-.03-.08-.03-.1-.03-.08-.03-.18-.06-.08-.03-.09-.04-.08-.03-.09-.03-.09-.04-.08-.03-.09-.04-.08-.03-.09-.04-.08-.04-.09-.03-.16-.08-.09-.04-.08-.04-.08-.03-.09-.04-.08-.04-.08-.05-.09-.04-.24-.12-.08-.05-.09-.04v-.03l.17-.12.17-.13.32-.25.31-.27.3-.27.3-.29.29-.3.28-.3.26-.31.26-.33.48-.66.44-.7.2-.36.19-.36.19-.37.34-.8.15-.4.14-.41.13-.41.12-.42.1-.41.1-.43.09-.43.07-.44.07-.43.05-.44.04-.44.03-.45.01-.44v-.88z',
      '113': 'M13.9 0v-.44l-.01-.44-.03-.45-.04-.44-.05-.44-.07-.43-.07-.44-.09-.43-.1-.43-.1-.41-.12-.42-.13-.41-.14-.41-.15-.4-.34-.8-.19-.37-.19-.36-.2-.36-.44-.7-.48-.66-.26-.33-.26-.31-.28-.3-.29-.3-.3-.29-.3-.27-.31-.27-.32-.25-.17-.13-.17-.12v-.03l.09-.04.08-.05.24-.12.09-.04.08-.05.08-.04.09-.04.08-.03.08-.04.09-.04.16-.08.09-.03.08-.04.09-.04.08-.03.09-.04.08-.03.09-.04.09-.03.08-.03.09-.03.08-.04.18-.06.08-.03.1-.03.08-.03.09-.03L11-13l.1-.03.08-.02.18-.06.08-.02.1-.03.08-.02.09-.03.09-.02.09-.03.27-.06.09-.03.45-.1.09-.01.27-.06.09-.01.09-.02.09-.01.09-.02.1-.01.08-.02.1-.01.09-.01.09-.02h.09l.09-.02.1-.01.08-.01h.1l.09-.02h.09l.09-.02h.1l.08-.01h.1l.09-.01h.09l.1-.01h.08l.1-.01h.18l.1-.01h.73l.1.01h.19l.1.01h.07l.1.01h.1l.09.01h.1l.08.01h.1l.09.02h.09l.09.02h.1l.08.01.1.01.09.02h.09l.09.02.09.01.1.01.08.02.1.01.09.02.09.01.09.02.09.01.27.06.09.01.45.1.09.03.27.06.09.03.09.02.09.03.08.02.1.03.08.02.18.06.08.02.1.03.07.03.09.03.08.03.1.03.16.06.1.03.08.04.09.03.08.03.09.03.09.04.08.03.09.04.08.03.09.04.08.04.09.03.16.08.09.04.08.04.08.03.09.04.08.04.08.05.09.04.24.12.08.05.09.04v.03l-.17.12-.17.13-.32.25-.31.27-.3.27-.3.29-.29.3-.28.3-.26.31-.26.33-.48.66-.44.7-.2.36-.19.36-.19.37-.34.8-.15.4-.14.41-.13.41-.12.42-.1.41-.1.43-.09.43-.07.44-.07.43-.05.44-.04.44-.03.45-.01.44v.88l.01.44.03.45.04.44.05.44.07.43.07.44.09.43.1.43.1.41.12.42.13.41.14.41.15.4.34.8.19.37.19.36.2.36.44.7.48.66.26.33.26.31.28.3.29.3.3.29.3.27.31.27.32.25.17.13.17.12v.03l-.09.04-.08.05-.24.12-.09.04-.08.05-.08.04-.09.04-.08.03-.08.04-.09.04-.16.08-.09.03-.08.04-.09.04-.08.03-.09.04-.08.03-.09.04-.09.03-.08.03-.09.04-.08.03-.1.03-.16.06-.1.03-.08.03-.09.03L21 13l-.1.03-.08.02-.18.06-.08.02-.1.03-.08.02-.09.03-.09.02-.09.03-.27.06-.09.03-.45.1-.09.01-.27.06-.09.01-.09.02-.09.01-.09.02-.1.01-.08.02-.1.01-.09.01-.09.02h-.09l-.09.02-.1.01-.08.01h-.1l-.09.02h-.09l-.09.02h-.1l-.08.01h-.1l-.09.01h-.1l-.1.01h-.07l-.1.01h-.19l-.1.01h-.72l-.1-.01h-.18l-.1-.01h-.08l-.1-.01h-.09l-.09-.01h-.1l-.08-.01h-.1l-.09-.02h-.09l-.09-.02h-.1l-.08-.01-.1-.01-.09-.02h-.09l-.09-.02-.09-.01-.1-.01-.08-.02-.1-.01-.09-.02-.09-.01-.09-.02-.09-.01-.27-.06-.09-.01-.45-.1-.09-.03-.27-.06-.09-.03-.09-.02-.09-.03-.08-.02-.1-.03-.08-.02-.18-.06-.08-.02-.1-.03-.08-.03-.09-.03-.08-.03-.1-.03-.08-.03-.18-.06-.08-.03-.09-.04-.08-.03-.09-.03-.09-.04-.08-.03-.09-.04-.08-.03-.09-.04-.08-.04-.09-.03-.16-.08-.09-.04-.08-.04-.08-.03-.09-.04-.08-.04-.08-.05-.09-.04-.24-.12-.08-.05-.09-.04v-.03l.17-.12.17-.13.32-.25.31-.27.3-.27.3-.29.29-.3.28-.3.26-.31.26-.33.48-.66.44-.7.2-.36.19-.36.19-.37.34-.8.15-.4.14-.41.13-.41.12-.42.1-.41.1-.43.09-.43.07-.44.07-.43.05-.44.04-.44.03-.45.01-.44V0z',
      '120': 'M2.22 16H16v-2.1h-.44l-.44-.01-.45-.03-.44-.04-.44-.05-.43-.07-.44-.07-.43-.09-.43-.1-.41-.1-.42-.12-.41-.13-.41-.14-.4-.15-.4-.17-.4-.17-.37-.19-.36-.19-.36-.2-.35-.22-.35-.22-.33-.24-.33-.24-.33-.26-.31-.26-.3-.28-.3-.29-.29-.3-.27-.3-.27-.31-.25-.32-.13-.17-.12-.17h-.03l-.04.09-.05.08-.04.08-.04.08-.04.08-.04.09-.05.08-.04.08-.04.09-.03.08-.04.08-.04.09-.04.08-.04.08-.03.09-.04.08-.04.09-.03.08-.04.09-.03.08-.04.09-.03.09-.03.08-.03.09-.04.08-.03.09-.03.09-.03.08-.03.1-.03.08-.03.09L3 11l-.03.1-.02.08-.03.09-.03.09-.02.08-.03.1-.02.08-.03.09-.02.09-.03.09-.02.09-.02.09-.02.09-.03.09-.02.09-.02.09-.02.09-.02.09-.02.09-.01.09-.02.09-.02.09-.02.09-.01.09-.02.09-.01.09-.02.09-.01.1-.02.08-.01.1-.01.09-.02.09v.09l-.02.09-.01.1-.01.08v.1l-.02.09v.09l-.02.09v.1l-.01.08v.1l-.01.09v.09l-.01.1v.08l-.01.1v.18l-.01.1V16',
      '130': 'M0 2.22V16h2.1v-.44l.01-.44.03-.45.04-.44.05-.44.07-.43.07-.44.09-.43.1-.43.1-.41.12-.42.13-.41.14-.41.15-.4.17-.4.17-.4.19-.37.19-.36.2-.36.22-.35.22-.35.24-.33.24-.33.26-.33.26-.31.28-.3.29-.3.3-.29.3-.27.31-.27.32-.25.17-.13.17-.12v-.03l-.09-.04-.08-.05-.08-.04-.08-.04-.08-.04-.09-.04-.08-.05-.08-.04-.09-.04-.08-.03-.08-.04-.09-.04-.08-.04-.08-.04-.09-.03-.08-.04-.09-.04-.08-.03-.09-.04-.08-.03-.09-.04-.09-.03-.08-.03-.09-.03-.08-.04-.1-.03-.08-.03-.08-.03-.1-.03-.08-.03-.09-.03L5 3l-.1-.03-.08-.02-.09-.03-.09-.03-.08-.02-.1-.03-.08-.02-.09-.03-.09-.02-.09-.03-.09-.02-.09-.02-.09-.02-.09-.03-.09-.02-.09-.02-.09-.02-.09-.02-.09-.02-.09-.01-.09-.02-.09-.02-.09-.02-.09-.01-.09-.02-.09-.01-.09-.02-.1-.01-.08-.02-.1-.01-.09-.01-.09-.02h-.09l-.09-.02-.1-.01-.08-.01h-.1l-.09-.02h-.09l-.09-.02h-.1l-.08-.01h-.1l-.09-.01H.92l-.1-.01H.75l-.1-.01H.46l-.1-.01H0',
      '131': 'M-2.1 16v-.44l-.01-.44-.03-.45-.04-.44-.05-.44-.07-.43-.07-.44-.09-.43-.1-.43-.1-.41-.12-.42-.13-.41-.14-.41-.15-.4-.34-.8-.19-.37-.19-.36-.2-.36-.44-.7-.48-.66-.26-.33-.26-.31-.28-.3-.29-.3-.3-.29-.3-.27-.31-.27-.32-.25-.17-.13-.17-.12v-.03l.09-.04.08-.05.24-.12.09-.04.08-.05.08-.04.09-.04.08-.03.08-.04.09-.04.16-.08.09-.03.08-.04.09-.04.08-.03.09-.04.08-.03.09-.04.09-.03.08-.03.09-.03.08-.04.18-.06.08-.03.1-.03.08-.03.09-.03L-5 3l.1-.03.08-.02.18-.06.08-.02.1-.03.08-.02.09-.03.09-.02.09-.03.27-.06.09-.03.45-.1.09-.01.27-.06.09-.01.09-.02.09-.01.09-.02.1-.01.08-.02.1-.01.09-.01.09-.02h.09l.09-.02.1-.01.08-.01h.1l.09-.02h.09l.09-.02h.1l.08-.01h.1l.09-.01h.09l.1-.01h.08l.1-.01h.18l.1-.01h.73l.1.01h.19l.1.01h.07l.1.01h.1l.09.01h.1l.08.01h.1l.09.02h.09l.09.02h.1l.08.01.1.01.09.02h.09l.09.02.09.01.1.01.08.02.1.01.09.02.09.01.09.02.09.01.27.06.09.01.45.1.09.03.27.06.09.03.09.02.09.03.08.02.1.03.08.02.18.06.08.02L5 3l.07.03.09.03.08.03.1.03.16.06.1.03.08.04.09.03.08.03.09.03.09.04.08.03.09.04.08.03.09.04.08.04.09.03.16.08.09.04.08.04.08.03.09.04.08.04.08.05.09.04.24.12.08.05.09.04v.03l-.17.12-.17.13-.32.25-.31.27-.3.27-.3.29-.29.3-.28.3-.26.31-.26.33-.48.66-.44.7-.2.36-.19.36-.19.37-.34.8-.15.4-.14.41-.13.41-.12.42-.1.41-.1.43-.09.43-.07.44-.07.43-.05.44-.04.44-.03.45-.01.44V16h-4.2z',
      '132': 'M1.76 29.69h-.1l-.09.02h-.09l-.09.02h-.1l-.08.01h-.1l-.09.01h-.1l-.1.01H.75l-.1.01H.46l-.1.01H0V2.22h.36l.1.01h.19l.1.01h.07l.1.01h.1l.09.01h.1l.08.01h.1l.09.02h.09l.09.02h.1l.08.01.1.01.09.02h.09l.09.02.09.01.1.01.08.02.1.01.09.02.09.01.09.02.09.01.27.06.09.01.45.1.09.03.27.06.09.03.09.02.09.03.08.02.1.03.08.02.18.06.08.02L5 3l.07.03.09.03.08.03.1.03.16.06.1.03.08.04.09.03.08.03.09.03.09.04.08.03.09.04.08.03.09.04.08.04.09.03.16.08.09.04.08.04.08.03.09.04.08.04.08.05.09.04.24.12.08.05.09.04v.03l-.17.12-.17.13-.32.25-.31.27-.3.27-.3.29-.29.3-.28.3-.26.31-.26.33-.48.66-.44.7-.2.36-.19.36-.19.37-.34.8-.15.4-.14.41-.13.41-.12.42-.1.41-.1.43-.09.43-.07.44-.07.43-.05.44-.04.44-.03.45-.01.44v.88l.01.44.03.45.04.44.05.44.07.43.07.44.09.43.1.43.1.41.12.42.13.41.14.41.15.4.34.8.19.37.19.36.2.36.44.7.48.66.26.33.26.31.28.3.29.3.3.29.3.27.31.27.32.25.17.13.17.12v.03l-.09.04-.08.05-.24.12-.09.04-.08.05-.08.04-.09.04-.08.03-.08.04-.09.04-.16.08-.09.03-.08.04-.09.04-.08.03-.09.04-.08.03-.09.04-.09.03-.08.03-.09.04-.08.03-.1.03-.16.06-.1.03-.08.03-.09.03L5 29l-.1.03-.08.02-.18.06-.08.02-.1.03-.08.02-.09.03-.09.02-.09.03-.27.06-.09.03-.09.02-.09.02-.09.02-.09.02-.09.02-.09.01-.27.06-.09.01-.09.02-.09.01-.09.02-.1.01-.08.02-.1.01-.09.01-.09.02h-.09l-.09.02-.1.01-.08.01z',
      '140': 'M13.78 0H0v2.1h.44l.44.01.45.03.44.04.44.05.43.07.44.07.43.09.43.1.41.1.42.12.41.13.41.14.4.15.4.17.4.17.37.19.36.19.36.2.35.22.35.22.33.24.33.24.33.26.31.26.3.28.3.29.29.3.27.3.27.31.25.32.13.17.12.17h.03l.04-.09.05-.08.04-.08.04-.08.04-.08.04-.09.05-.08.04-.08.04-.09.03-.08.04-.08.04-.09.04-.08.04-.08.03-.09.04-.08.04-.09.03-.08.04-.09.03-.08.04-.09.03-.09.03-.08.04-.09.03-.08.03-.1.03-.08.03-.08.03-.1.03-.08.03-.09L13 5l.03-.1.02-.08.03-.09.03-.09.02-.08.03-.1.02-.08.03-.09.02-.09.03-.09.02-.09.02-.09.02-.09.03-.09.02-.09.02-.09.02-.09.02-.09.02-.09.01-.09.02-.09.02-.09.02-.09.01-.09.02-.09.01-.09.02-.09.01-.1.02-.08.01-.1.01-.09.02-.09v-.09l.02-.09.01-.1.01-.08v-.1l.02-.09v-.09l.02-.09v-.1l.01-.08v-.1l.01-.09V.92l.01-.1V.75l.01-.1V.46l.01-.1V0'
    }
  },

  '4a64a548-bcbb-48d6-8c60-86af1371d164': {
    name: '402 Medium',
    bounds: [12, 12],
    variants: {
      '100': 'M6.11 8.81l-.05-.03-.05-.03-.05-.03-.06-.03-.05-.03-.05-.03-.05-.04-.05-.03-.05-.04-.06-.03-.04-.04-.05-.03-.05-.03-.05-.04-.05-.03-.05-.04-.05-.04-.05-.03-.05-.04-.04-.04-.05-.03-.05-.04-.05-.04-.04-.04-.05-.04-.05-.03-.04-.04-.05-.04-.04-.04-.05-.04-.04-.04-.05-.04-.04-.04-.05-.05-.04-.03-.05-.05-.04-.04-.04-.04-.05-.05-.04-.03-.05-.05-.03-.04-.05-.05-.04-.04L4 7.12l-.04-.05-.04-.04-.04-.05-.04-.04-.04-.05-.04-.05-.05-.04-.03-.05-.03-.04-.04-.05-.04-.05-.04-.05-.03-.04-.04-.05-.04-.05-.04-.04-.03-.06-.04-.04-.03-.05-.04-.05-.04-.05V6.1l.03-.05.03-.05.04-.05.03-.06.03-.05.03-.05.04-.05.03-.05.04-.05.03-.05.03-.05.03-.05.04-.05.04-.05.03-.05.04-.05.03-.05.04-.04.04-.06.04-.04.03-.05.03-.05.05-.04.04-.05.03-.04.04-.06.04-.04.04-.05.04-.04.04-.05.04-.04.04-.05.04-.04.04-.05.04-.04.05-.05.03-.04.05-.04.04-.04.04-.05.05-.04.04-.04.05-.05.04-.03.04-.05.04-.04.05-.04.04-.04.05-.04.04-.04.06-.04.04-.04.04-.03.04-.04.05-.04.05-.04.05-.03.04-.04.05-.04.05-.04.04-.03.06-.04.04-.04.05-.03.05-.04.05-.03h.02l.05.03.05.03.05.03.06.03.05.03.05.03.05.04.05.03.05.04.05.03.05.04.05.03.05.03.05.04.05.03.05.04.05.04.04.03.06.04.04.04.05.03.05.04.04.04.05.04.04.04.06.03.04.04.05.04.04.04.05.04.04.04.05.04.04.04.05.05.04.03.05.05.04.04.04.04.04.05.05.03.04.05.04.04.05.05.03.04.05.04.04.05.04.04.04.05.04.04.04.05.04.05.04.04.04.05.04.04.04.05.03.05.04.05.04.04.04.05.03.05.04.04.04.06.04.04.03.05.03.05.04.05v.02l-.03.05-.03.05-.04.05-.03.06-.03.05-.03.05-.03.05-.03.05-.04.05-.03.05-.04.05-.03.05-.04.05-.03.05-.03.05-.04.05-.04.05-.04.04-.03.06-.04.04-.03.05-.04.05-.04.04-.04.05-.04.04-.04.06-.03.04-.04.05-.04.04-.04.05-.04.04-.04.05-.04.04-.05.05-.03.04-.05.05-.04.04-.04.04-.05.04-.03.05-.05.04-.04.04-.05.05-.04.03-.04.05-.05.04-.04.04-.05.04-.04.04-.05.04-.05.04-.04.04-.05.04-.04.04-.05.04-.05.03-.05.04-.04.04-.05.04-.05.03-.04.04-.06.04-.04.04-.05.03-.05.03-.05.04H6.1',
      '110': 'M12 10.33V0h-1.58v.66L10.4 1l-.04.33-.03.33-.05.32-.06.33-.07.32-.07.33-.08.3-.08.32-.1.3-.1.31-.12.3-.13.3-.13.3-.14.28-.14.27-.15.27-.17.26-.16.26-.18.25-.18.25-.2.25-.19.23-.21.22-.22.23-.22.22-.23.2-.23.2-.24.19-.13.1-.12.09v.02l.06.03.06.04.06.03.06.03.06.03.07.03.06.03.06.03.07.03.06.03.06.03.06.03.06.03.06.03.07.02.06.03.07.03.06.02.07.03.06.02.06.03.07.03.06.02.07.03.06.02.07.02.06.03.06.02.08.02.06.02.07.03.06.02.07.02.06.02.07.02.07.02.06.02.07.02.06.02.07.02.07.01.06.03.07.01.07.02.07.01.07.02.06.02.07.01.07.02.07.01.06.02h.07l.07.02.07.02.06.01h.07l.07.02.07.01.06.02h.08l.06.02h.07l.07.01.07.02h.07l.06.01.08.01h.13l.07.02h.07l.07.02H11.18l.06.01h.07l.08.01h.27l.07.02H12',
      '111': 'M11.65 10.33h-.13l-.08-.01h-.2l-.07-.02H10.96l-.06-.02h-.07l-.07-.01h-.07l-.06-.01h-.08l-.07-.02h-.06l-.07-.02h-.07l-.07-.01-.06-.02h-.08l-.07-.02h-.06l-.07-.02-.07-.01-.2-.05h-.07L9.2 10 9.13 10l-.2-.05-.07-.02-.07-.01-.07-.03-.06-.01-.07-.02-.06-.02-.14-.04-.06-.02-.07-.02-.06-.02-.07-.03-.06-.02-.08-.02-.06-.02-.13-.05-.06-.02-.07-.03-.06-.02-.07-.03-.06-.03-.06-.02-.07-.03-.06-.02-.07-.03-.06-.03-.07-.02-.12-.06-.06-.03-.06-.03-.06-.03-.07-.03-.06-.03-.06-.03-.07-.03-.18-.1-.06-.03-.07-.03v-.02l.13-.1.13-.09.24-.19.23-.2.23-.2.22-.22.22-.23.21-.22.2-.23.19-.25.36-.5.33-.52.15-.27.14-.27.14-.28.26-.6.11-.3.1-.3.1-.31.1-.32.07-.3.07-.33.07-.32.05-.33.06-.32.03-.33.03-.33.03-.34V0h3.15v.33l.01.33.02.34.03.33.04.33.05.32.06.33.06.32.08.32.07.31.1.32.1.3.1.31.11.3.25.6.15.28.14.27.15.27.33.52.36.5.2.25.19.23.21.22.22.23.22.22.23.2.23.2.24.19.13.1.13.09v.02l-.07.03-.06.04-.06.03-.06.03-.06.03-.07.03-.06.03-.06.03-.07.03-.06.03-.06.03-.06.03-.06.03-.06.03-.07.02-.06.03-.07.03-.06.02-.07.03-.06.02-.06.03-.07.03-.06.02-.07.03-.06.02-.07.02-.06.03-.06.02-.08.02-.06.02-.07.03-.05.02-.08.02-.06.02-.13.04-.06.02-.08.02-.06.01-.06.03-.07.01-.07.02-.07.02-.06.01-.07.02-.07.02-.07.02-.06.01-.07.02-.07.01-.07.02h-.06l-.07.02-.07.01-.07.02h-.06l-.07.02-.07.01-.07.01-.07.01-.06.02h-.08l-.06.01-.07.02h-.07l-.07.01-.07.01h-.14l-.06.02h-.07l-.07.02H12.83l-.07.01h-.07l-.08.01h-.27l-.07.02h-.54l-.08-.01z',
      '112': 'M10.43-.33l-.01-.33L10.4-1l-.04-.33-.03-.33-.05-.32-.06-.33-.07-.32-.07-.33-.08-.3-.08-.32-.1-.3-.1-.31-.12-.3-.26-.6-.14-.28-.14-.27-.15-.27-.33-.52-.36-.5-.2-.25-.19-.23-.21-.22-.22-.23-.22-.22-.23-.2-.23-.2-.24-.19-.13-.1-.13-.09v-.02l.07-.03.06-.04.12-.06.06-.03.07-.03.06-.03.06-.03.07-.03.06-.03.06-.03.06-.03.06-.03.06-.03.07-.02.06-.03.07-.03.06-.02.07-.03.06-.02.06-.03.07-.03.06-.02.07-.02.06-.03.07-.02.06-.03.06-.02.08-.02.06-.02.07-.03.05-.02.07-.02.06-.02.14-.04.06-.02.07-.02.06-.02.07-.02.07-.01.07-.03.06-.01.14-.03.07-.02.06-.02.14-.03.07-.01.06-.02h.07l.14-.04.06-.01h.07l.07-.02.07-.01.07-.02h.07l.06-.02h.08l.06-.01.07-.02h.07l.07-.01.07-.01h.14l.06-.02h.07l.07-.02H11.17l.07-.01h.06l.08-.01h.27l.07-.02H12v20.67H11.52l-.07-.01H11.24l-.06-.02H10.97l-.07-.02h-.07l-.07-.01h-.07l-.06-.01h-.08l-.06-.02h-.07l-.07-.02h-.07l-.07-.01-.06-.02h-.08l-.06-.02h-.07l-.07-.02-.07-.01-.2-.05h-.07L9.2 10 9.13 10l-.2-.05-.07-.02-.07-.01-.07-.03-.06-.01-.07-.02-.06-.02-.14-.04-.06-.02-.07-.02-.06-.02-.07-.03-.06-.02-.08-.02-.06-.02-.13-.05-.06-.02-.07-.03-.06-.02-.07-.03-.06-.03-.06-.02-.07-.03-.06-.02-.07-.03-.06-.03-.06-.02-.12-.06-.07-.03-.06-.03-.06-.03-.07-.03-.06-.03-.06-.03-.07-.03-.18-.1-.06-.03-.06-.03v-.02l.12-.1.13-.09.24-.19.23-.2.23-.2.22-.22.22-.23.21-.22.2-.23.19-.25.36-.5.33-.52.15-.27.14-.27.15-.28.25-.6.11-.3.1-.3.1-.31.1-.32.07-.3.08-.33.06-.32.06-.33.05-.32.04-.33.03-.33.02-.34v-.99z',
      '113': 'M10.43 0v-.33l-.01-.33L10.4-1l-.04-.33-.03-.33-.05-.32-.06-.33-.07-.32-.07-.33-.08-.3-.08-.32-.1-.3-.1-.31-.12-.3-.26-.6-.14-.28-.14-.27-.15-.27-.33-.52-.36-.5-.2-.25-.19-.23-.21-.22-.22-.23-.22-.22-.23-.2-.23-.2-.24-.19-.13-.1-.13-.09v-.02l.07-.03.06-.04.18-.09.07-.03.06-.03.06-.03.07-.03.06-.03.06-.03.06-.03.12-.06.07-.02.06-.03.07-.03.06-.02.07-.03.06-.02.06-.03.07-.03.06-.02.07-.02.06-.03.13-.05.06-.02.08-.02.06-.02.07-.03.05-.02.07-.02.06-.02.14-.04.06-.02.07-.02.06-.02.07-.02.07-.01.07-.03.2-.04.07-.02.33-.08h.07l.2-.05h.07l.07-.02.07-.01.06-.02h.08l.06-.02h.08l.06-.01.07-.02h.07l.07-.01.07-.01h.14l.06-.02h.07l.07-.02H11.17l.07-.01h.06l.08-.01h.27l.07-.02h.55l.08.01h.14l.07.01H12.77l.06.01h.08l.06.01h.07l.07.02h.07l.07.01h.07l.06.01h.08l.06.02h.07l.07.02h.07l.07.01.06.02h.08l.06.02h.07l.07.02.07.01.2.04.07.01.33.08.07.02.2.04.07.03.07.01.07.02.06.02.07.02.06.02.14.04.06.02.07.02.05.02.07.02.06.03.08.02.12.04.07.03.06.03.07.02.06.02.07.02.06.03.06.03.07.03.06.02.07.03.06.03.07.02.12.06.06.03.06.03.06.02.07.03.06.03.06.04.07.03.18.1.06.03.06.03v.02l-.12.1-.13.09-.24.19-.23.2-.23.2-.22.22-.22.22-.21.23-.2.23-.19.25-.36.5-.33.52-.15.27-.14.27-.15.28-.25.6-.11.3-.1.3-.1.31-.1.32-.07.3-.08.33-.06.32-.06.33-.05.32-.04.33-.03.33-.02.34V.66l.02.34.03.33.04.33.05.32.06.33.06.32.08.32.07.31.1.32.1.3.1.31.11.3.25.6.15.28.14.27.15.27.33.52.36.5.2.25.19.23.21.22.22.23.22.22.23.2.23.2.24.19.13.1.12.09v.02l-.06.03-.06.04-.18.09-.07.03-.06.03-.06.03-.07.03-.06.03-.06.03-.06.03-.12.06-.07.02-.06.03-.07.03-.06.02-.07.03-.06.02-.06.03-.07.03-.06.02-.07.03-.06.02-.07.02-.12.05-.08.02-.06.02-.07.03-.05.02-.07.02-.06.02-.14.04-.06.02-.07.02-.06.02-.07.02-.07.01-.07.03-.2.04-.07.02-.33.08h-.07l-.2.05h-.07l-.07.02-.07.01-.06.02h-.08l-.06.02h-.07l-.07.01-.07.02h-.07l-.06.01-.08.01h-.13l-.07.02h-.07l-.07.02H12.83l-.06.01h-.08l-.07.01h-.27l-.08.02h-.54l-.07-.01h-.14l-.07-.01H11.24l-.06-.01h-.08l-.06-.01h-.07l-.07-.02h-.07l-.07-.01h-.07l-.06-.01h-.08l-.06-.02h-.07l-.07-.02h-.07l-.07-.01-.06-.02h-.08l-.06-.02h-.07l-.07-.02-.07-.01-.2-.04-.07-.01L9.2 10 9.13 10l-.2-.04-.07-.03-.07-.01-.07-.02-.06-.02-.07-.02-.06-.02-.14-.04-.06-.02-.07-.02-.06-.02-.07-.02-.06-.03-.08-.02-.06-.02-.13-.05-.06-.02-.07-.03-.06-.02-.07-.02-.06-.03-.06-.03-.07-.03-.06-.02-.07-.03-.06-.03-.07-.02-.12-.06-.06-.03-.06-.03-.06-.02-.07-.03-.06-.03-.06-.04-.07-.03-.18-.1-.06-.03-.07-.03v-.02l.13-.1.13-.09.24-.19.23-.2.23-.2.22-.22.22-.22.21-.23.2-.23.19-.25.36-.5.33-.52.15-.27.14-.27.14-.28.26-.6.11-.3.1-.3.1-.31.1-.32.07-.3.07-.33.07-.32.05-.33.06-.32.03-.33.03-.33.03-.34V0z',
      '120': 'M1.67 12H12v-1.58h-.66L11 10.4l-.33-.04-.33-.03-.32-.05-.33-.06-.32-.07-.32-.07-.31-.08-.32-.08-.3-.1-.31-.1-.3-.12-.3-.13-.3-.13-.28-.14-.27-.14-.27-.15-.26-.17-.26-.16-.25-.18-.25-.18-.25-.2-.23-.19-.22-.21-.23-.22-.22-.22-.2-.23-.2-.23-.19-.24-.1-.13-.09-.12h-.02l-.03.06-.04.06-.03.06-.03.06-.03.06-.03.07-.03.06-.03.06-.03.07-.03.06-.03.06-.03.06-.03.06-.03.06-.02.07-.03.06-.03.07-.02.06-.03.07-.02.06-.03.06-.03.07-.02.06-.02.07-.03.06-.02.07-.03.06-.02.06-.02.08-.02.06-.03.07-.02.05-.02.07-.02.06-.02.07-.02.07-.02.06-.02.07-.01.06-.03.07-.01.07-.02.07-.02.06-.01.07-.02.07-.02.07-.02.07-.01.06-.02.07-.01.07-.02.07v.06l-.02.07-.01.07-.02.07v.06l-.02.07-.01.07-.01.07-.01.07-.02.06v.08l-.01.06-.02.07v.07l-.01.07-.01.07v.14l-.02.06v.07l-.02.07V11.17l-.01.07v.06l-.01.08v.27l-.01.07V12',
      '130': 'M0 1.67V12h1.58v-.66l.03-.34.03-.33.03-.33.06-.32.05-.33.07-.32.07-.32.08-.31.09-.32.1-.3.1-.31.11-.3.13-.3.13-.3.14-.28.14-.27.15-.27.17-.26.16-.26.18-.25.18-.25.2-.25.19-.23.21-.22.22-.23.22-.22.23-.2.23-.2.24-.19.13-.1.12-.09v-.02l-.06-.03-.06-.04-.06-.03L5.53 3l-.06-.03-.07-.03-.06-.03-.06-.03-.07-.03-.06-.03-.06-.03-.06-.03-.06-.03-.06-.03-.07-.02-.06-.03-.07-.03-.06-.02-.07-.03-.06-.02-.06-.03-.07-.03-.06-.02-.07-.02-.06-.03-.07-.02-.06-.03L4 2.34l-.08-.02-.06-.02-.07-.03-.05-.02-.07-.02-.06-.02-.07-.02-.07-.02-.06-.02-.07-.02-.06-.01-.07-.03-.07-.01-.07-.02-.06-.02-.07-.01L2.88 2l-.07-.02-.06-.02-.07-.01-.07-.02-.07-.01-.06-.02H2.4l-.07-.02-.07-.01-.06-.02h-.07l-.07-.02L2 1.83l-.06-.01-.08-.01-.06-.02h-.07l-.07-.01-.07-.02h-.07l-.06-.01-.08-.01h-.13l-.07-.02H1.1l-.07-.02H.83l-.06-.01H.69l-.07-.01H.35l-.08-.01H0',
      '131': 'M-1.58 12v-.66l-.03-.34-.03-.33-.03-.33-.06-.32-.05-.33-.07-.32-.07-.32-.08-.31-.09-.32-.1-.3-.1-.31-.11-.3-.26-.6-.14-.28-.14-.27-.15-.27-.33-.52-.36-.5-.2-.25-.19-.23-.21-.22-.22-.23-.22-.22-.23-.2-.23-.2-.24-.19-.13-.1-.12-.09v-.02l.06-.03.06-.04.18-.09.07-.03.06-.03.06-.03.07-.03.06-.03.06-.03.06-.03.12-.06.07-.02.06-.03.07-.03.06-.02.07-.03.06-.02.06-.03.07-.03.06-.02.07-.02.06-.03.13-.05.06-.02.08-.02.06-.02.07-.03.05-.02.07-.02.06-.02.14-.04.06-.02.07-.02.06-.01.07-.03.07-.01.07-.02.2-.05.07-.02.33-.08h.07l.2-.05h.07l.07-.02.07-.01.06-.01.08-.01.06-.02h.07l.07-.01.07-.02h.07l.06-.01.08-.01h.13l.07-.02h.07l.07-.02H-.83l.06-.01h.07l.08-.01h.27l.07-.01H.5l.07.01h.2l.07.02H1.04l.07.02h.07l.06.01h.08l.06.01h.07l.07.02h.07l.07.02h.06l.08.01.06.02h.07l.07.02h.07l.07.02.06.01.2.05h.07l.34.08.07.02.2.05.07.02.07.01.06.03.06.01.08.02.06.02.13.04.06.02.08.02.05.02.07.03.06.02.07.02.12.05.08.02.06.03.07.02.06.02.06.03.07.03.06.02.07.03.06.02.07.03.06.03.06.02.12.06.07.03.06.03.06.02.07.03.06.03.06.04.07.03.18.1.06.03.06.03v.02l-.12.1-.13.09-.24.19-.23.2-.23.2-.22.22-.22.22-.21.23-.2.23-.19.25-.36.5-.33.52-.15.27-.14.27-.15.28-.25.6-.11.3-.1.3-.1.31-.1.32-.07.3-.08.33-.06.32-.06.33-.05.32-.04.33-.03.33-.02.34V12h-3.16z',
      '132': 'M1.32 22.27h-.08l-.06.01H1.1l-.07.02H.83l-.06.01H.69l-.07.01H.35l-.08.02H0V1.66h.27l.08.01h.14l.07.01H.77l.06.01h.08l.06.01h.07l.07.02h.07l.07.01h.07l.06.01h.08l.06.02h.07l.07.02h.07l.07.01.06.02h.08l.06.02h.07l.07.02.06.01.2.04.07.01.34.08.07.02.2.04.07.03.07.01.06.02.06.02.08.02.06.02.13.04.06.02.08.02.05.02.07.02.06.03.08.02.12.04.07.03.06.03.07.02.06.02.07.02.06.03.06.03.07.03.06.02.07.03.06.03.06.02.12.06.07.03.06.03.06.02.07.03.06.03.06.04.07.03.18.1.06.03.06.03v.02l-.12.1-.13.09-.24.19-.23.2-.23.2-.22.22-.22.22-.21.23-.2.23-.19.25-.36.5-.33.52-.15.27-.14.27-.15.28-.25.6-.11.3-.1.3-.1.31-.1.32-.07.3-.08.33-.06.32-.06.33-.05.32-.04.33-.03.33-.02.34v1.32l.02.34.03.33.04.33.05.32.06.33.06.32.08.32.07.31.1.32.1.3.1.31.11.3.25.6.15.28.14.27.15.27.33.52.36.5.2.25.19.23.21.22.22.23.22.22.23.2.23.2.24.19.13.1.12.09v.02l-.06.03-.06.04-.18.09-.07.03-.06.04-.06.03-.07.03-.06.02-.06.03-.07.03-.12.06-.06.02-.06.03-.07.03-.06.02-.07.03-.06.03-.06.03-.07.02-.06.02-.07.03-.06.02-.07.03-.12.04-.08.02-.06.03-.07.02-.05.02-.08.02-.06.02-.13.04-.06.02-.08.02-.06.02-.06.02-.07.01-.07.03-.2.04-.07.02-.07.02-.06.01-.07.02-.07.01-.07.02h-.06l-.2.05h-.07l-.07.02-.07.01-.06.02h-.08l-.06.02h-.07l-.07.01-.07.02h-.07l-.06.01-.08.01h-.06z',
      '140': 'M10.33 0H0v1.58h.66l.34.03.33.03.33.03.32.06.33.05.32.07.33.07.3.08.32.09.3.1.31.1.3.11.3.13.3.13.28.14.27.14.27.15.26.17.26.16.25.18.25.18.25.2.23.19.22.21.23.22.22.22.2.23.2.23.19.24.1.13.09.12h.02l.03-.06.04-.06.03-.06.03-.06.03-.06.03-.07.03-.06.03-.06.03-.07.03-.06.03-.06.03-.06.03-.06.03-.06.02-.07.03-.06.03-.07.02-.06.03-.07.02-.06.03-.06.03-.07.02-.06.03-.07.02-.06.02-.07.03-.06.02-.06.02-.08.02-.06.03-.07.02-.05.02-.07.02-.06.02-.07.02-.07.02-.06.02-.07.02-.06.02-.07.01-.07.03-.07.01-.06.02-.07.01-.07.02-.07.02-.06.01-.07.02-.07.01-.07.02-.06V2.4l.02-.07.02-.07.01-.06v-.07l.02-.07.01-.07.02-.06v-.08l.02-.06v-.07l.01-.07.02-.07v-.07l.01-.06.01-.08v-.13l.02-.07V1.1l.02-.07V.83l.01-.06V.69l.01-.07V.35l.02-.08V0',
      '000': 'M5.87 8.81l-.05-.04-.04-.03-.06-.03-.04-.04-.05-.04-.05-.03-.04-.04-.06-.04-.04-.04-.05-.03-.05-.04-.04-.04-.05-.04-.05-.04-.04-.05-.05-.03-.05-.04-.04-.05-.05-.03-.04-.05L4.88 8l-.04-.04-.04-.04-.04-.04-.05-.04-.04-.05-.04-.04-.05-.05-.04-.03-.04-.05-.04-.04-.04-.05-.05-.04-.03-.05-.05-.04-.04-.05-.03-.04-.05-.05-.04-.04-.03-.05-.04-.05-.04-.05-.04-.04-.04-.05-.04-.05-.03-.04-.04-.05-.03-.05-.05-.04-.04-.05-.04-.05-.03-.05-.03-.05-.04-.05-.03-.05-.04-.04-.03-.06-.04-.05-.03-.05-.03-.05-.03-.05-.03-.05-.03-.05-.04-.06-.03-.05-.03-.05v-.02l.04-.05.03-.04.03-.06.04-.04.04-.05.04-.05.03-.04.04-.06.04-.04.04-.05.03-.05.04-.04.05-.05.04-.04.05-.05.04-.05.03-.05.05-.04.04-.05.04-.04.04-.05.04-.03.04-.05.04-.04.04-.05.05-.04.04-.04.05-.05.03-.04.05-.04.04-.04.05-.04.04-.05.05-.03.04-.05.05-.04.04-.03.05-.05.04-.04.05-.03.05-.04.05-.04.04-.04.05-.04.05-.04.04-.03.05-.04.05-.03.04-.05.05-.04.05-.03.05-.03.05-.04.05-.04.05-.03.05-.04.05-.03.05-.03.05-.03.05-.04.05-.03.05-.03.06-.03.05-.04.05-.03.05-.03h.02l.05.04.05.04.05.03.04.03.06.04.04.04.05.04.05.03.04.04.05.04.05.04.05.03.04.04.05.04.04.04.05.04.05.04.04.04.05.04.04.05.05.03.04.05.04.04.05.04.04.04.05.04.03.05.05.04.04.04.04.05.05.04.03.05.05.04.04.05.04.04.04.05.04.04.04.05.04.04.04.05.03.05.04.04.04.05.04.04.04.06.03.04.04.05.04.05.04.05.04.05.03.05.03.05.04.05.04.05.03.05.04.05.03.05.03.05.03.05.04.05.03.05.03.05.03.06.04.05.03.05.03.05v.02l-.04.05-.04.05-.03.05-.03.04-.04.06-.04.04-.04.05-.03.05-.04.04-.04.05-.04.05-.03.05-.04.04-.04.05-.04.04-.04.05-.04.05-.04.04-.04.05-.05.04-.03.05-.05.04-.04.04-.04.05-.04.04-.04.05-.05.03-.04.05-.04.04-.05.04-.04.05-.05.03-.04.05-.05.04-.04.04-.05.04-.04.04-.05.04-.04.04-.05.04-.05.03-.04.04-.05.04-.04.04-.06.04-.04.03-.05.04-.05.04-.05.04-.05.04-.05.04-.05.03-.05.03-.05.04-.05.03-.04.04-.06.03-.05.04-.05.03-.05.03-.05.03-.05.03-.05.03-.06.04-.05.03-.05.03h-.02',
      '010': 'M1.67 0H12v1.58h-.66l-.34.03-.33.03-.33.03-.32.06-.33.05-.32.07-.32.07-.31.08-.32.09-.3.1-.31.1-.3.11-.3.13-.3.13-.28.14-.27.14-.27.15-.26.17-.26.16-.25.18-.25.18-.25.2-.23.19-.22.21-.23.22-.22.22-.2.23-.2.23-.19.24-.1.13-.09.12h-.02l-.03-.06-.04-.06-.03-.06L3 5.53l-.03-.06-.03-.07-.03-.06-.03-.06-.03-.07-.03-.06-.03-.06-.03-.06-.03-.06-.03-.06-.02-.07-.03-.06-.03-.07-.02-.06-.03-.07-.02-.06-.03-.06-.03-.07-.02-.06-.02-.07-.03-.06-.02-.07-.03-.06L2.34 4l-.02-.08-.02-.06-.03-.07-.02-.05-.02-.07-.02-.06-.02-.07-.02-.07-.02-.06-.02-.07-.01-.06-.03-.07-.01-.07-.02-.07-.02-.06-.01-.07L2 2.88l-.02-.07-.02-.06-.01-.07-.02-.07-.01-.07-.02-.06V2.4l-.02-.07-.01-.07-.02-.06v-.07l-.02-.07L1.83 2l-.01-.06-.01-.08-.02-.06v-.07l-.01-.07-.02-.07v-.07l-.01-.06-.01-.08v-.13l-.02-.07V1.1l-.02-.07V.83L1.69.77V.69L1.68.62V.35L1.66.27V0',
      '011': 'M11.67 1.58h-.33l-.34.03-.33.03-.33.03-.32.06-.33.05-.32.07-.32.07-.31.08-.32.09-.3.1-.31.1-.3.11-.6.26-.28.14-.27.14-.27.15-.52.33-.5.36-.25.2-.23.19-.22.21-.23.22-.22.22-.2.23-.2.23-.19.24-.1.13-.09.12h-.02l-.03-.06-.04-.06-.09-.18-.03-.07-.03-.06-.03-.06-.03-.07-.03-.06-.03-.06-.03-.06-.06-.12-.02-.07-.03-.06-.03-.07-.02-.06-.03-.07-.02-.06-.03-.06-.03-.07-.02-.06-.02-.07-.03-.06-.02-.07L2.34 4l-.02-.08-.02-.06-.03-.07-.02-.05-.02-.07-.02-.06-.04-.14-.02-.06-.02-.07-.01-.06-.03-.07-.01-.07-.02-.07-.05-.2-.02-.07-.08-.33V2.4l-.05-.2v-.07l-.02-.07L1.83 2l-.01-.06-.01-.08-.02-.06v-.07l-.01-.07-.02-.07v-.07l-.01-.06-.01-.08v-.13l-.02-.07V1.1l-.02-.07V.83L1.69.77V.69L1.68.62V.35L1.66.27V0h20.66V.49l-.01.07V.77l-.02.06V1.04l-.02.07v.07l-.01.07v.07l-.01.06v.08l-.02.06v.07l-.02.07v.07l-.01.07-.02.06v.08l-.02.06v.07l-.02.07-.01.07-.05.2v.07l-.02.06-.01.07-.02.07-.01.07-.02.06-.02.07-.05.2-.02.07-.01.07-.03.07-.01.06-.02.07-.02.06-.04.14-.02.06-.02.07-.02.05-.03.07-.02.06-.02.08-.05.12-.02.07-.02.06-.03.07-.02.06-.03.07-.03.06-.02.06-.03.07-.02.06-.03.07-.03.06-.02.07-.06.12-.03.06-.03.06-.03.06-.03.07-.03.06-.03.06-.03.07-.1.18-.03.06-.03.07h-.02l-.1-.13-.09-.13-.19-.24-.2-.23-.2-.23-.22-.22-.23-.22-.22-.21-.23-.2-.25-.19-.5-.36-.52-.33-.27-.15-.27-.14-.28-.14-.6-.26-.3-.11-.3-.1-.31-.1-.32-.1-.3-.07-.33-.07-.32-.07-.33-.05-.32-.06-.33-.03L13 1.6l-.34-.03h-.99z',
      '012': 'M1.67-.28V-.49l.01-.07V-.77l.02-.06V-1.04l.02-.07v-.07l.01-.06v-.08l.01-.06v-.07l.02-.07v-.07l.02-.07v-.06l.01-.08.02-.06v-.07L1.84-2v-.07l.02-.07.01-.06.04-.2.01-.07.08-.34.02-.07.05-.2.02-.07.01-.07.03-.06.01-.06.02-.08.02-.06.04-.13.02-.06.02-.08.02-.05.03-.07.02-.06.02-.07.02-.06.05-.14.03-.06.02-.07.02-.06.03-.06.03-.07.02-.06.03-.07.02-.06.03-.07.03-.06.02-.06.06-.12.03-.07.03-.06.03-.06.03-.07.03-.06.03-.06.03-.07.1-.18.03-.06.03-.06h.02l.1.12.09.13.19.24.2.23.2.23.22.22.23.22.22.21.23.2.25.19.5.36.52.33.27.15.27.14.28.15.6.25.3.11.3.1.31.1.32.1.3.07.33.08.32.06.33.06.32.05.33.04.33.03.34.02H12v3.16h-.66l-.34.03-.33.03-.33.03-.32.06-.33.05-.32.07-.32.07-.31.08-.32.09-.3.1-.31.1-.3.11-.6.26-.28.14-.27.14-.27.15-.52.33-.5.36-.25.2-.23.19-.22.21-.23.22-.22.22-.2.23-.2.23-.19.24-.1.13-.09.13h-.02l-.03-.07-.04-.06-.09-.18-.03-.07-.03-.06-.03-.06-.03-.07-.03-.06-.03-.06-.03-.06-.06-.12-.02-.07-.03-.06-.03-.07-.02-.06-.03-.07-.02-.06-.03-.06-.03-.07-.02-.06-.02-.07-.03-.06-.02-.07L2.34 4l-.02-.08-.02-.06-.03-.07-.02-.05-.02-.07-.02-.06-.04-.14-.02-.06-.02-.07-.01-.06-.03-.07-.01-.07-.02-.07-.05-.2-.02-.07-.08-.33V2.4l-.05-.2v-.07l-.02-.07L1.83 2l-.01-.06-.01-.08-.02-.06v-.07l-.01-.07-.02-.07v-.07l-.01-.06-.01-.08v-.13l-.02-.07V1.1l-.02-.07V.83L1.69.77V.69L1.68.62V.35L1.66.27v-.55z',
      '013': 'M1.67 0V-.49l.01-.07V-.77l.02-.06V-1.04l.02-.07v-.07l.01-.06v-.08l.01-.06v-.07l.02-.07v-.07l.02-.07v-.06l.01-.08.02-.06v-.07L1.84-2v-.07l.02-.07.01-.06.04-.2.01-.07.08-.34.02-.07.05-.2.02-.07.01-.07.03-.06.01-.06.02-.08.02-.06.04-.13.02-.06.02-.08.02-.05.03-.07.02-.06.02-.07.02-.06.05-.14.03-.06.02-.07.02-.06.03-.06.03-.07.02-.06.03-.07.02-.06.03-.07.03-.06.02-.06.06-.12.03-.07.03-.06.03-.06.03-.07.03-.06.03-.06.03-.07.03-.06.06-.12.04-.06.03-.06h.02l.1.12.09.13.19.24.2.23.2.23.22.22.23.22.22.21.23.2.25.19.5.36.52.33.27.15.27.14.28.15.6.25.3.11.3.1.31.1.32.1.3.07.33.08.32.06.33.06.32.05.33.04.33.03.34.02h1.32L13-1.6l.33-.03.33-.04.32-.05.33-.06.32-.06.32-.08.31-.07.32-.1.3-.1.31-.1.3-.11.6-.25.28-.15.27-.14.27-.15.52-.33.5-.36.25-.2.23-.19.22-.21.23-.22.22-.22.2-.23.2-.23.19-.24.1-.13.09-.12h.02l.03.06.04.06.09.18.03.07.04.06.03.06.03.07.02.06.03.06.03.07.06.12.02.06.03.06.03.07.02.06.03.07.03.06.03.07.02.06.02.06.03.07.02.06.05.14.02.06.02.07.03.06.02.07.02.06.02.07.02.06.04.14.02.06.02.07.02.06.02.07.01.07.03.07.04.2.02.07.08.33v.07l.05.2v.07l.02.07.01.07.02.06v.08l.02.06v.07l.01.07.02.07v.07l.01.06.01.08v.13l.02.07v.07l.02.06V-.83l.01.07v.07l.01.07v.27l.02.08v.54l-.01.07V.5l-.01.07v.2l-.01.07v.08l-.01.06v.07l-.02.07v.07l-.01.06v.08l-.01.06v.07l-.02.07v.07l-.02.07v.06l-.01.08-.02.06v.07l-.02.07v.07l-.02.07-.01.06-.04.2-.01.07-.08.34-.02.07-.04.2-.03.07-.01.07-.02.06-.02.06-.02.08-.02.06-.04.13-.02.06-.02.08-.02.05-.02.07-.03.06-.02.08-.04.12-.03.07-.02.06-.03.07-.02.06-.02.07-.03.06-.03.06-.03.07-.02.06-.03.07-.03.06-.02.06-.06.12-.03.07-.03.06-.02.06-.03.07-.03.06-.04.06-.03.07-.1.18-.03.06-.03.06h-.02l-.1-.12-.09-.13-.19-.24-.2-.23-.2-.23-.22-.22-.22-.22-.23-.21-.23-.2-.25-.19-.5-.36-.52-.33-.27-.15-.27-.14-.28-.15-.6-.25-.3-.11-.3-.1-.31-.1-.32-.1-.3-.07-.33-.08-.32-.06-.33-.06-.32-.05-.33-.04L13 1.6l-.34-.02h-1.32L11 1.6l-.33.03-.33.04-.32.05-.33.06-.32.06-.32.08-.31.07-.32.1-.3.1-.31.1-.3.11-.6.25-.28.15-.27.14-.27.15-.52.33-.5.36-.25.2-.23.19-.22.21-.23.22-.22.22-.2.23-.2.23-.19.24-.1.13-.09.12h-.02l-.03-.06-.04-.06-.09-.18-.03-.07-.03-.06-.03-.06-.03-.07-.03-.06-.03-.06-.03-.07-.06-.12-.02-.06-.03-.06-.03-.07-.02-.06-.03-.07-.02-.06-.03-.06-.03-.07-.02-.06-.02-.07-.03-.06-.02-.07L2.34 4l-.02-.08-.02-.06-.03-.07-.02-.05-.02-.08-.02-.06-.04-.13-.02-.06-.02-.08-.01-.06-.03-.06-.01-.07-.02-.07-.05-.2-.02-.07-.08-.34v-.06l-.05-.2v-.07l-.02-.07L1.83 2l-.01-.07-.01-.07-.02-.06v-.08l-.01-.06-.02-.07v-.07l-.01-.06-.01-.08v-.13l-.02-.07V1.1l-.02-.07V.83L1.69.77V.69L1.68.62V.34L1.66.27V0z',
      '020': 'M12 1.67V12h-1.58v-.66L10.4 11l-.04-.33-.03-.33-.05-.32-.06-.33-.07-.32-.07-.32-.08-.31-.08-.32-.1-.3-.1-.31-.12-.3-.13-.3-.13-.3-.14-.28-.14-.27-.15-.27-.17-.26-.16-.26-.18-.25-.18-.25-.2-.25-.19-.23-.21-.22-.22-.23-.22-.22-.23-.2-.23-.2-.24-.19-.13-.1-.12-.09v-.02l.06-.03.06-.04.06-.03.06-.03.06-.03.07-.03.06-.03.06-.03.07-.03.06-.03.06-.03.06-.03.06-.03.06-.03.07-.02.06-.03.07-.03.06-.02.07-.03.06-.02.06-.03.07-.03.06-.02.07-.02.06-.03.07-.02.06-.03.06-.02.08-.02.06-.02.07-.03.05-.02.07-.02.06-.02.07-.02.07-.02.06-.02.07-.02.06-.01.07-.03.07-.01.07-.02.06-.02.07-.01.07-.02.07-.02.07-.02.06-.01.07-.02.07-.01.07-.02h.06l.07-.02.07-.01.07-.02h.06l.07-.02.07-.01.07-.01.07-.01.06-.02h.08l.06-.01.07-.02h.07l.07-.01.07-.01h.14l.06-.02h.07l.07-.02H11.17l.07-.01h.06l.08-.01h.27l.07-.01H12',
      '030': 'M10.33 12H0v-1.58h.66L1 10.4l.33-.04.33-.03.32-.05.33-.06.32-.07.33-.07.3-.08.32-.08.3-.1.31-.1.3-.12.3-.13.3-.13.28-.14.27-.14.27-.15.26-.17.26-.16.25-.18.25-.18.25-.2.23-.19.22-.21.23-.22.22-.22.2-.23.2-.23.19-.24.1-.13.09-.12h.02l.03.06.04.06.03.06.03.06.03.06.03.07.03.06.03.06.03.07.03.06.03.06.03.06.03.06.03.06.02.07.03.06.03.07.02.06.03.07.02.06.03.06.03.07.02.06.03.07.02.06.02.07.03.06.02.06.02.08.02.06.03.07.02.06.02.07.02.06.02.07.02.07.02.06.02.07.02.06.02.07.01.07.03.06.01.07.02.07.01.07.02.07.02.06.01.07.02.07.01.07.02.06v.07l.02.07.02.07.01.06v.07l.02.07.01.07.02.06v.08l.02.06v.07l.01.07.02.07v.07l.01.06.01.08v.13l.02.07v.07l.02.07V11.18l.01.06v.07l.01.08v.27l.02.07V12',
      '031': 'M-10.33 12V11.51l.01-.07v-.2l.02-.07V10.96l.02-.07v-.07l.01-.07v-.07l.01-.06v-.08l.02-.06v-.07l.02-.07v-.07l.01-.07.02-.06v-.08l.02-.06v-.07l.02-.07.01-.07.02-.06.03-.14v-.07l.02-.06.01-.07.03-.14.02-.06.02-.07.03-.14.02-.06.02-.07.01-.07.03-.07.01-.06.02-.07.02-.06.04-.14.02-.06.02-.07.02-.05.03-.07.02-.06.02-.08.02-.06.03-.06.02-.07.03-.06.02-.07.02-.06.03-.07.03-.06.02-.06.03-.07.02-.06.03-.07.03-.06.02-.07.03-.06.03-.06.03-.06.03-.06.03-.06.03-.07.03-.06.03-.06.03-.07.03-.06.06-.12.04-.06.03-.07h.02l.1.13.09.13.19.24.2.23.2.23.22.22.23.22.22.21.23.2.25.19.5.36.52.33.27.15.27.14.28.14.6.26.3.11.3.1.31.1.32.1.3.07.33.07.32.07.33.05.32.06.33.03.33.03.34.03H.66l.34-.03.33-.03.33-.03.32-.06.33-.05.32-.07.33-.07.3-.08.32-.09.3-.1.31-.1.3-.11.6-.26.28-.14.27-.14.27-.15.53-.33.49-.36.25-.2.23-.19.23-.21.22-.22.22-.22.2-.23.2-.23.19-.24.1-.13.09-.13h.02l.03.07.04.06.09.18.03.07.04.06.03.06.03.07.02.06.03.06.03.06.06.12.02.07.03.06.03.07.02.06.03.07.03.06.03.06.02.07.02.06.03.07.02.06.05.13.02.06.02.08.03.06.02.07.02.06.02.07.02.06.04.14.02.06.02.07.02.06.02.07.01.07.03.06.04.2.02.07.08.34v.07l.05.2v.07l.02.07.01.06.02.07v.08l.02.06v.07l.01.07.02.07v.06l.01.07.01.08v.13l.02.07v.07l.02.06V11.19l.01.06v.07l.01.08v.27l.02.07V12h-20.67z',
      '032': 'M0 13.58v-3.15h.33l.33-.01.34-.02.33-.04.33-.03.32-.05.33-.06.32-.07.33-.07.3-.08.32-.08.3-.1.31-.1.3-.12.6-.26.28-.14.27-.14.27-.15.52-.33.5-.36.25-.2.23-.19.22-.21.23-.22.22-.22.2-.23.2-.23.19-.24.1-.13.09-.13h.02l.03.07.04.06.09.18.03.07.03.06.03.06.03.07.03.06.03.06.03.06.06.12.02.07.03.06.03.07.02.06.03.07.02.06.03.06.03.07.02.06.03.07.02.06.05.13.02.06.02.08.02.06.03.07.02.06.02.07.02.06.04.14.02.06.02.07.02.06.02.07.01.07.03.06.04.2.02.07.08.34v.07l.05.2v.07l.02.07.01.07.02.06v.08l.02.06v.07l.01.07.02.07v.07l.01.06.01.08v.13l.02.07v.07l.02.07V11.18l.01.06v.07l.01.08v.27l.02.07v.54l-.01.08v.14l-.01.07V12.77l-.01.06v.08l-.01.06v.07l-.02.07v.07l-.01.07v.07l-.01.06v.08l-.02.06v.07l-.02.07v.07l-.01.07-.02.06v.08l-.02.06v.07l-.02.07-.01.07-.01.06-.02.07-.01.07-.01.07-.02.06-.01.07-.02.07-.01.07-.02.06-.02.07-.01.07-.02.07-.01.06-.03.07-.01.07-.03.07-.01.06-.02.07-.02.06-.04.14-.02.06-.02.07-.02.05-.03.07-.02.06-.02.08-.02.06-.03.06-.02.07-.02.06-.03.07-.02.06-.03.07-.03.06-.02.06-.03.07-.02.06-.03.07-.03.06-.02.07-.03.06-.03.06-.03.06-.03.06-.03.06-.03.07-.03.06-.03.06-.03.07-.03.06-.03.06-.03.06-.04.06-.03.06h-.02l-.1-.12-.09-.13-.19-.24-.2-.23-.2-.23-.22-.22-.23-.22-.22-.21-.23-.2-.25-.19-.5-.36-.52-.33-.27-.15-.27-.14-.28-.15-.6-.25-.3-.11-.3-.1-.31-.1-.32-.1-.3-.07-.33-.08-.32-.06-.33-.06-.32-.05-.33-.04L1 13.6l-.34-.02H0z',
      '040': 'M0 10.33V0h1.58v.66l.03.34.03.33.03.33.06.32.05.33.07.32.07.33.08.3.09.32.1.3.1.31.11.3.13.3.13.3.14.28.14.27.15.27.17.26.16.26.18.25.18.25.2.25.19.23.21.22.22.23.22.22.23.2.23.2.24.19.13.1.12.09v.02l-.06.03-.06.04-.06.03-.06.03-.06.03-.07.03-.06.03-.06.03-.07.03-.06.03-.06.03-.06.03-.06.03-.06.03-.07.02-.06.03-.07.03-.06.02-.07.03-.06.02-.06.03-.07.03-.06.02-.07.03-.06.02-.07.02-.06.03-.06.02-.08.02-.06.02-.07.03-.05.02-.07.02-.06.02-.07.02-.07.02-.06.02-.07.02-.06.02-.07.02-.07.01-.07.03-.06.01-.07.02-.07.01-.07.02-.06.02-.07.01-.07.02-.07.01-.06.02H2.4l-.07.02-.07.02-.06.01h-.07l-.07.02-.07.01-.06.02h-.08l-.06.02h-.07l-.07.01-.07.02h-.07l-.06.01-.08.01h-.13l-.07.02H1.1l-.07.02H.83l-.06.01H.69l-.07.01H.35l-.08.02H0'
    }
  },

  '3eadae5c-c35d-4f74-a516-a9e0795ac76f': {
    name: '402 Small',
    bounds: [8, 8],
    variants: {
      '100': 'M4.08 5.88l-.04-.02L4 5.84l-.03-.03-.04-.02-.03-.02-.04-.02-.03-.02-.03-.02-.04-.03-.03-.02-.03-.02-.04-.02-.03-.03-.03-.02-.04-.02-.03-.03-.03-.02-.03-.03-.04-.02-.03-.03-.03-.02-.03-.03-.03-.03-.03-.02-.03-.03-.04-.02-.03-.03-.03-.02-.02-.03-.03-.03-.03-.02-.03-.03L3 5.08l-.03-.03-.03-.02L2.92 5l-.03-.03-.03-.03-.03-.03-.03-.02-.03-.03-.02-.03-.03-.03-.03-.03-.03-.03-.02-.03-.03-.03-.03-.03-.03-.03-.02-.03-.03-.03-.03-.03-.02-.03-.03-.03-.02-.03-.02-.04-.03-.03-.02-.03-.03-.03-.02-.03-.03-.03-.02-.04-.03-.03-.02-.03-.02-.03-.03-.04h0l.02-.04.02-.04.03-.03.02-.04.02-.03.02-.04.02-.03.02-.03.03-.04.02-.03.02-.03.02-.04.03-.03.02-.03.02-.04.03-.03.02-.03.03-.03.02-.04.03-.03.02-.03.02-.03.03-.03.03-.03.02-.03.03-.04.02-.03.03-.03.02-.03.03-.03.02-.03.03-.03.03-.03.03-.03.02-.03.03-.03.03-.03.03-.02.03-.03.02-.03.03-.03.03-.03.03-.03.03-.02.03-.03.03-.02.03-.03.03-.03.03-.03.03-.02.03-.03.03-.03.03-.02.03-.03.03-.02.03-.02.03-.03.03-.02.04-.03.03-.02.03-.03.03-.02.03-.03.04-.02.03-.02.03-.03h.01l.04.02.03.02.04.03.03.02.04.02.04.02.03.02.03.02.04.03.03.02.03.02.04.02.03.03.03.02.04.02.03.03.03.02.03.03.04.02.03.03.03.02.03.02.03.03.03.03.03.02.04.03.03.02.03.03.03.02.03.03.03.02.03.03.03.03.03.03.03.02.03.03.03.03.02.03.03.03.03.02.03.03.03.03.03.03.02.03.03.03.03.03.03.03.02.03.03.03.03.03.02.03.03.03.03.03.02.03.03.03.02.04.03.03.02.03.03.03.02.03.03.03.02.04.03.03.02.03.02.03.03.04v.01l-.02.03-.02.04-.03.03-.02.04-.02.03-.02.04-.02.03-.02.03-.03.04-.02.03-.02.03-.02.04-.03.03-.02.03-.02.04-.03.03-.02.03-.03.03-.02.04-.03.03-.02.03-.02.03-.03.03-.03.03-.02.03-.03.04-.02.03-.03.03-.03.03-.02.03-.03.03-.03.03-.02.03-.03.03-.03.03-.03.03-.02.03-.03.03-.03.03-.03.03-.03.03-.03.02-.03.03-.03.03-.02.03-.03.02-.03.03-.03.03-.03.03-.03.02-.04.03-.03.03-.03.02-.03.03-.03.02-.03.03-.03.02-.03.03-.04.02-.03.03-.03.02-.03.03-.03.02-.04.02-.03.03-.03.02h-.01',
      '110': 'M8 6.89V0H6.95v.44l-.02.23-.02.21-.02.23-.04.21-.03.22-.05.21-.05.22-.05.2-.06.22-.06.2-.07.2-.08.2-.09.2-.08.2-.1.19-.09.18-.1.18-.11.18-.11.17-.12.17-.12.16-.13.17-.13.15-.14.15-.14.15-.15.15-.15.13-.16.14-.16.12-.09.07-.08.06v.01l.04.02.04.03.04.02.05.02.04.02.04.01.04.03.04.02.04.02.05.01.04.02.04.02.04.02.04.02.04.02.05.02.04.02.04.01.04.02.04.02.05.02.04.01.04.02.05.02.04.01.04.02.05.01.04.02.05.01.04.02.04.01.04.02.05.01.04.01.05.02.04.01.04.01.05.02.04.01.05.01.04.01.05.02.04.01.05.01.04.01.05.01.04.01.05.01.04.01.05.01.04.01.05.01.04.01.05.01.04.01h.05l.04.01.05.01.04.01h.05l.04.01.05.01h.05l.04.01H7l.04.01.05.01h.09l.05.01h.04l.05.01h.05l.04.01h.14l.05.01h.18l.05.01H8',
      '111': 'M7.77 6.88H7.5l-.05-.01h-.14l-.04-.01h-.05l-.04-.01h-.05l-.04-.01h-.05l-.05-.01h-.04l-.05-.01-.04-.01H6.8l-.04-.01-.05-.01-.05-.01h-.04l-.05-.01-.04-.01-.14-.03h-.04l-.23-.05-.04-.02-.14-.03-.04-.01-.05-.01-.04-.02-.04-.01-.05-.01-.04-.01-.1-.03-.03-.01-.05-.02-.04-.01-.05-.02-.04-.01-.05-.02-.04-.01-.09-.03-.04-.02-.04-.02-.04-.01-.05-.02-.04-.02-.04-.01-.05-.02-.04-.02-.04-.02-.04-.02-.05-.01-.08-.04-.04-.02-.04-.02-.04-.02-.05-.02-.04-.02-.04-.02-.04-.02-.12-.06-.04-.03-.05-.02v-.01l.09-.06.08-.07.16-.12.16-.14.15-.13.15-.15.14-.15.14-.15.13-.15.13-.17.24-.33.22-.35.1-.18.1-.18.09-.18.17-.4.08-.2.07-.21.06-.2.06-.21.05-.21.05-.21.05-.22.03-.22.04-.21.02-.22.02-.22.02-.23V0h2.1v.44l.02.23.02.21.03.23.03.21.04.22.04.21.05.22.05.2.06.22.07.2.07.2.07.2.17.4.1.19.09.18.1.18.22.35.24.33.13.17.13.15.14.15.15.15.15.15.15.13.15.14.16.12.09.07.08.06v.01l-.04.02-.04.03-.04.02-.04.02-.04.02-.05.01-.04.03-.04.02-.04.02-.04.01-.04.02-.05.02-.04.02-.04.02-.04.02-.04.02-.05.02-.04.01-.04.02-.04.02-.05.02-.04.01-.04.02-.05.02-.04.01-.05.02-.04.01-.04.02-.05.01-.04.02-.04.01-.04.02-.05.01-.04.01-.09.03-.04.01-.05.02-.04.01-.04.01-.05.01-.04.02-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01h-.04l-.05.01-.04.01-.05.01h-.05l-.04.01-.05.01h-.04l-.05.01h-.04l-.05.01-.05.01h-.09l-.04.01h-.05l-.04.01h-.05l-.04.01H8.46l-.05.01h-.18l-.05.01h-.41z',
      '112': 'M6.95-.22v-.22l-.02-.23-.02-.21-.02-.23-.04-.21-.03-.22-.05-.21-.05-.22-.05-.2-.06-.22-.06-.2-.07-.2L6.4-3l-.17-.4-.1-.19-.09-.18-.1-.18-.22-.35-.24-.33-.13-.17-.13-.15-.14-.15-.14-.15-.15-.15-.15-.13-.16-.14-.16-.12-.08-.07-.09-.06v-.01l.05-.02.04-.03.08-.04.04-.02.04-.02.04-.02.04-.02.05-.02.04-.01.04-.02.04-.02.04-.02.04-.02.05-.02.04-.02.04-.02.04-.01.05-.02.04-.02.04-.02.05-.01.04-.02.04-.01.04-.02.05-.02.04-.01.04-.02.05-.01.04-.02.05-.01.03-.02.05-.01.04-.01.09-.03.04-.01.05-.02.04-.01.04-.01.05-.01.04-.02.05-.01.09-.02.04-.01.05-.01.09-.02.04-.01.05-.01.04-.01.1-.02.04-.01h.04l.05-.01.04-.01.05-.01h.05l.04-.01.05-.01h.04l.05-.01h.04l.05-.01.05-.01h.09l.04-.01h.05l.04-.01h.05l.04-.01h.14l.05-.01h.19l.04-.01H8V6.89H7.68l-.05-.01H7.5l-.05-.01h-.14l-.04-.01h-.05l-.04-.01h-.05l-.04-.01h-.05l-.05-.01h-.04l-.05-.01-.04-.01H6.8l-.04-.01-.05-.01-.05-.01h-.04l-.05-.01-.04-.01-.14-.03h-.04l-.23-.05-.04-.02-.14-.03-.04-.01-.05-.01-.04-.02-.04-.01-.05-.01-.04-.01-.1-.03-.03-.01-.05-.02-.04-.01-.05-.02-.04-.01-.05-.02-.04-.01-.09-.03-.04-.02-.04-.02-.04-.01-.05-.02-.04-.02-.04-.01-.05-.02-.04-.02-.04-.02-.04-.02-.05-.01-.08-.04-.04-.02-.04-.02-.04-.02-.05-.02-.04-.02-.04-.02-.04-.02-.12-.06-.04-.03-.05-.02v-.01l.09-.06.08-.07.16-.12.16-.14.15-.13.15-.15.14-.15.14-.15.13-.15.13-.17.24-.33.22-.35.1-.18.1-.18.09-.18.17-.4.08-.2.07-.21.06-.2.06-.21.05-.21.05-.21.05-.22.03-.22.04-.21.02-.22.02-.22.02-.23v-.66z',
      '113': 'M6.95 0v-.44l-.02-.23-.02-.21-.02-.23-.04-.21-.03-.22-.05-.21-.05-.22-.05-.2-.06-.22-.06-.2-.07-.2L6.4-3l-.17-.4-.1-.19-.09-.18-.1-.18-.22-.35-.24-.33-.13-.17-.13-.15-.14-.15-.14-.15-.15-.15-.15-.13-.16-.14-.16-.12-.08-.07-.09-.06v-.01l.05-.02.04-.03.12-.06.04-.02.04-.02.04-.02.05-.02.04-.01.04-.02.04-.02.08-.04.05-.02.04-.02.04-.02.04-.01.05-.02.04-.02.04-.02.05-.01.04-.02.04-.01.04-.02.09-.03.04-.02.05-.01.04-.02.05-.01.03-.02.05-.01.04-.01.09-.03.04-.01.05-.02.04-.01.04-.01.05-.01.04-.02.14-.03.04-.01.23-.05.04-.01.14-.03h.04l.05-.01.04-.01.05-.01h.05l.04-.01.05-.01h.04l.05-.01h.04l.05-.01.05-.01h.09l.04-.01h.05l.04-.01h.05l.04-.01h.14l.05-.01h.19l.04-.01h.52l.04.01h.14l.04.01h.14l.05.02h.14l.04.01h.05l.04.02h.09l.05.01h.05l.04.02h.05l.05.01h.04l.04.02h.05l.14.03h.04l.23.06.04.01.14.03.04.02h.04l.05.02.04.01.05.02h.04l.09.03.04.02.05.01.03.01.05.02.04.01.05.02.08.03.05.01.04.02.04.02.04.01.05.02.04.02.04.01.05.02.04.02.04.02.04.02.05.01.08.04.04.02.04.02.04.02.05.02.04.02.04.02.04.02.12.06.04.03.05.02v.01l-.09.06-.08.07-.16.12-.16.14-.15.13-.15.15-.14.15-.14.15-.13.15-.13.17-.24.33-.22.35-.1.18-.1.18-.09.18-.17.4-.08.2-.07.21-.06.2-.06.21-.05.21-.05.21-.05.22-.03.22-.04.21-.02.22-.02.22-.02.23v.88l.02.22.02.22.02.22.04.22.03.22.05.21.05.22.05.2.06.21.06.21.07.2.08.2.17.4.1.19.09.18.1.18.22.35.24.33.13.16.13.16.14.15.14.15.15.14.15.14.16.13.16.13.08.06.09.06v.02l-.05.02-.04.02-.12.06-.04.02-.04.03-.04.02-.05.02-.04.01-.04.02-.04.02-.08.04-.05.02-.04.02-.04.02-.04.01-.05.02-.04.02-.04.02-.05.01-.04.02-.04.02-.04.01-.05.02-.08.03-.05.01-.04.02-.05.01-.03.02-.05.01-.04.01-.09.03-.04.01-.05.02-.04.01-.04.01-.05.01-.04.02-.14.03-.04.01-.23.05-.04.01-.14.03h-.04l-.05.01-.04.01-.05.01h-.05l-.04.01-.05.01h-.04l-.05.01h-.04l-.05.01-.05.01h-.09l-.04.01h-.05l-.04.01h-.05l-.04.01H8.46l-.05.01h-.18l-.05.01h-.5l-.05-.01h-.14l-.04-.01h-.14l-.05-.02h-.14l-.04-.01h-.05L7 6.81H6.9l-.05-.01H6.8l-.04-.02h-.05l-.04-.01h-.04l-.05-.02h-.04l-.14-.03h-.04l-.23-.06-.04-.01-.14-.03-.04-.02h-.05l-.04-.02-.04-.01-.05-.02h-.04l-.1-.03-.03-.02-.05-.01-.04-.01-.05-.02-.04-.01-.05-.02-.04-.01-.09-.03-.04-.02-.04-.02-.04-.01-.05-.02-.04-.02-.04-.01-.05-.02-.04-.02-.04-.02-.04-.02-.05-.01-.08-.04-.04-.02-.04-.02-.04-.02-.05-.02-.04-.02-.04-.02-.04-.02-.12-.06-.04-.03-.05-.02v-.01l.09-.06.08-.07.16-.12.16-.14.15-.13.15-.15.14-.15.14-.15.13-.15.13-.17.24-.33.22-.35.1-.18.1-.18.09-.18.17-.4.08-.2.07-.21.06-.2.06-.21.05-.21.05-.21.05-.22.03-.22.04-.21.02-.22.02-.22.02-.23V0z',
      '120': 'M1.11 8H8V6.95h-.44l-.22-.02-.22-.02-.22-.02-.22-.04-.22-.03-.21-.05-.22-.05-.2-.05-.21-.06-.21-.06-.2-.07L5 6.4l-.2-.09-.2-.08-.19-.1-.18-.09-.18-.1-.17-.11-.18-.11-.16-.12-.17-.12-.16-.13-.16-.13-.15-.14-.15-.14-.14-.15-.14-.15-.13-.16-.13-.16-.06-.09-.06-.08h-.02l-.02.04-.02.04-.02.04-.02.05-.02.04-.02.04-.03.04-.02.04-.02.04-.01.05-.02.04-.02.04-.02.04-.02.04-.02.04-.02.05-.02.04-.01.04-.02.04-.02.04-.02.05-.01.04-.02.04-.01.05-.02.04-.02.04-.01.05-.02.04-.01.05-.02.04-.01.04-.02.04-.01.05-.01.04-.02.04-.01.05-.01.04-.02.05-.01.04-.01.04-.01.05-.02.04-.01.05-.01.04-.01.05-.01.04-.01.05-.01.04-.01.05-.01.04-.01.05-.01.04-.01.05-.01.04-.01.05v.04l-.01.05-.01.04-.01.05v.05l-.01.04-.01.05v.04l-.01.05v.04l-.01.05-.01.05v.09l-.01.04v.05l-.01.04v.05l-.01.04v.14l-.01.05v.19l-.01.04V8',
      '130': 'M0 1.11V8h1.05v-.44l.02-.22.02-.22.02-.22.04-.22.03-.22.05-.21.05-.22.05-.2.06-.21.06-.21.07-.2.08-.2.08-.2.09-.2.1-.19.09-.18.1-.18.11-.17.11-.18.12-.16.12-.17.13-.16.13-.16.14-.15.14-.15.15-.14.15-.14.16-.13.16-.13.08-.06.09-.06v-.02l-.05-.02-.04-.02-.04-.02L3.68 2l-.04-.02-.04-.02-.04-.03-.04-.02-.05-.02-.04-.01-.04-.02-.04-.02-.04-.02-.04-.02-.05-.02-.04-.02-.04-.02-.04-.01-.05-.02-.04-.02-.04-.02-.05-.01-.04-.02-.04-.01-.04-.02-.05-.02-.04-.01-.04-.02-.05-.01-.04-.02-.05-.01-.03-.02-.05-.01-.04-.01-.04-.02-.05-.01-.04-.01-.05-.02-.04-.01-.04-.01-.05-.01-.04-.02L2 1.36l-.04-.01-.05-.01-.04-.01-.05-.01-.04-.01-.05-.01-.04-.01-.05-.01-.04-.01-.05-.01-.04-.01-.05-.01h-.04l-.05-.01-.04-.01-.05-.01h-.05L1.2 1.2l-.05-.01h-.04l-.05-.01h-.04l-.05-.01-.05-.01H.83l-.04-.01H.74L.7 1.14H.65L.6 1.13H.46l-.05-.01H.23L.18 1.1H0',
      '131': 'M-1.05 8v-.44l-.02-.22-.02-.22-.02-.22-.04-.22-.03-.22-.05-.21-.05-.22-.05-.2-.06-.21-.06-.21-.07-.2-.08-.2-.17-.4-.1-.19-.09-.18-.1-.18-.22-.35-.24-.33-.13-.16-.13-.16-.14-.15-.14-.15-.15-.14-.15-.14-.16-.13-.16-.13-.08-.06-.09-.06v-.02l.05-.02.04-.02.12-.06.04-.02.04-.03.04-.02.05-.02.04-.01.04-.02.04-.02.08-.04.05-.02.04-.02.04-.02.04-.01.05-.02.04-.02.04-.02.05-.01.04-.02.04-.01.04-.02.09-.03.04-.02.05-.01.04-.02.05-.01.03-.02.05-.01.04-.01.09-.03.04-.01.05-.02.04-.01.04-.01.05-.01.04-.02.14-.03.04-.01.23-.05.04-.01.14-.03h.04l.05-.01.04-.01.05-.01h.05l.04-.01.05-.01h.04l.05-.01h.04l.05-.01.05-.01h.09l.04-.01h.05l.04-.01h.05l.04-.01h.14l.05-.01h.19l.04-.01h.52l.04.01h.14l.04.01H.7l.05.02h.14l.04.01h.05l.04.02h.09l.05.01h.05l.04.02h.05l.04.01h.05l.04.02h.05l.13.03h.05l.22.06.05.01.13.03.05.02h.04l.05.02.04.01.05.02h.04l.09.04h.04l.05.02.04.01.04.02.04.01.05.02.08.03.05.01.04.02.04.02.04.01.05.02.04.02.04.01.05.02.04.02.04.02.04.02.05.01.08.04.04.02.04.02.04.02.05.02.04.02.04.02.04.02.12.06.04.03.05.02v.01l-.09.06-.08.07-.16.12-.16.14-.15.13-.15.15-.14.15-.14.15-.13.15-.13.17-.24.33-.22.35-.1.18-.1.18-.09.18-.17.4-.07.2-.07.21-.07.2-.06.21-.05.21-.05.21-.04.22-.04.22-.03.21-.03.22-.02.22-.01.23-.01.22V8h-2.1z',
      '132': 'M.88 14.85H.74l-.05.02H.46l-.05.01H.23l-.05.01H0V1.11H.33l.04.01h.14l.04.01H.7l.05.01h.05l.04.01h.05l.04.01h.05l.05.01h.04l.05.01.04.01h.05l.04.01.05.01.05.01h.04l.05.01.04.01.14.03h.04l.23.05.04.02.14.03.04.01.04.01.05.02.04.01.05.01.04.01.09.03.04.01.05.02.04.01.04.02.04.01.05.02.08.03.05.01.04.02.04.02.04.01.05.02.04.02.04.01.05.02.04.02.04.02.04.02.05.01.08.04.04.02.04.02.04.02.05.02.04.02.04.02.04.02.12.06.04.03.05.02v.01l-.09.06-.08.07-.16.12-.16.14-.15.13-.15.15-.14.15-.14.15-.13.15-.13.17-.24.33-.22.35-.1.18-.1.18-.09.18-.17.4-.07.2-.07.21-.07.2-.06.21-.05.21-.05.21-.04.22-.04.22-.03.21-.03.22-.02.22-.01.23-.01.22v.66l.02.22.02.22.03.22.03.22.04.22.04.21.05.22.05.2.06.21.07.21.07.2.07.2.17.4.1.19.09.18.1.18.22.35.24.33.13.16.13.16.14.15.15.15.15.14.15.14.15.13.16.13.09.06.08.06v.02l-.04.02-.04.02-.12.06-.05.02-.04.03-.04.02-.04.02-.04.01-.04.02-.05.02-.08.04-.04.02-.04.02-.05.02-.04.01-.04.02-.04.02-.05.02-.04.01-.04.02-.05.02-.04.01-.05.02-.08.03-.05.01-.04.02-.04.01-.04.02-.05.01-.04.02-.09.03h-.04l-.05.02-.04.01-.04.01-.05.02-.04.01-.14.03-.04.01-.05.02h-.04l-.05.02H1.7l-.05.01-.04.01-.14.03h-.04l-.05.02h-.04l-.05.01h-.05l-.04.02h-.09l-.05.02H.97l-.05.01H.88z',
      '140': 'M6.89 0H0v1.05h.44l.23.02.21.02.23.02.21.04.22.03.21.05.22.05.2.05.22.06.2.06.2.07.2.08.2.08.2.09.19.1.18.09.18.1.18.11.17.11.17.12.16.12.17.13.15.13.15.14.15.14.15.15.13.15.14.16.12.16.07.08.06.09h.01l.02-.05.03-.04.02-.04.02-.04.02-.04.01-.04.03-.04.02-.04.02-.05.01-.04.02-.04.02-.04.02-.04.02-.04.02-.05.02-.04.02-.04.01-.04.02-.05.02-.04.02-.04.01-.05.02-.04.02-.04.01-.04.02-.05.01-.04.02-.04.01-.05.02-.04.01-.05.02-.03.01-.05.01-.04.02-.04.01-.05.01-.04.02-.05.01-.04.01-.04.01-.05.02-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05v-.04l.01-.05.01-.04.01-.05v-.05l.01-.04.01-.05v-.04l.01-.05v-.04l.01-.05.01-.05V.83l.01-.04V.74L6.86.7V.65L6.87.6V.46l.01-.05V.23L6.9.18V0',
      '000': 'M3.92 5.88l-.04-.03-.03-.03-.04-.02-.03-.02-.03-.03-.03-.02-.03-.03-.03-.02-.03-.03-.03-.02-.04-.03-.03-.02-.03-.03-.03-.03-.03-.03-.03-.02-.03-.03-.03-.03-.03-.02-.03-.03-.03-.03-.03-.03-.03-.02-.03-.03-.03-.03-.03-.03-.02-.03-.03-.03-.03-.02L3 5.08l-.03-.03-.02-.03-.03-.03-.03-.03-.03-.03-.02-.03-.03-.03-.03-.03-.02-.03-.03-.03-.02-.04-.03-.03-.02-.03-.03-.03-.03-.03-.02-.03-.02-.03-.03-.04-.03-.02-.03-.04-.02-.03-.02-.03-.03-.04-.02-.03-.02-.03-.02-.03-.02-.04-.03-.03-.02-.04-.02-.03-.02-.03-.02-.04-.02-.03-.03-.04-.02-.03-.02-.04h0l.03-.04.02-.03.02-.04.03-.03.02-.03.03-.03.02-.03.03-.04.02-.03.03-.03.02-.03.02-.03.04-.03.03-.03.03-.03.02-.03.03-.03.02-.03.03-.03.03-.03.02-.03.03-.03.03-.03.03-.03.02-.03.03-.03.03-.02.03-.03.03-.03.03-.03.03-.03.03-.02.03-.03.03-.03.03-.03.03-.02.03-.03.03-.03.03-.02.03-.03.03-.02.03-.03.03-.02.03-.03.04-.03.03-.02.03-.02.03-.03.03-.03.04-.03.03-.02.03-.02.04-.03.03-.02.03-.02.03-.02.04-.02.03-.03.04-.02.03-.02.03-.02.04-.02.03-.02.04-.03.03-.02.04-.02h0l.04.03.03.02.04.02.03.03.03.02.03.03.03.02.04.03.03.02.03.03.03.02.03.02.03.03.03.02.03.03.04.03.03.02.03.03.03.03.03.03.03.02.02.03.03.03.03.03.03.02.03.03.03.03.03.03.03.03.02.03.03.03.03.03.03.03.02.03.03.03.03.03.02.03.03.03.03.03.02.03.03.03.02.03.03.03.03.03.02.04.02.03.03.03.02.03.03.04.03.04.02.03.02.03.03.04.02.03.02.03.03.03.02.04.02.03.02.04.03.03.02.03.02.04.02.03.02.04.02.03.02.04h0l-.03.04-.02.03-.02.04-.03.03-.02.03-.03.03-.02.03-.03.04-.02.03-.03.03-.02.03-.03.03-.02.03-.03.03-.03.03-.02.04-.03.03-.03.03-.02.03-.03.03-.03.03-.03.02-.02.03-.03.03-.03.03-.03.03-.03.03-.03.03-.02.03-.03.02-.03.03-.03.03-.03.03-.03.02-.03.03-.03.03-.03.02-.03.03-.03.03-.03.02-.04.03-.03.02-.03.03-.03.03-.03.02-.03.02-.03.03-.04.02-.03.03-.04.03-.03.02-.03.02-.04.03-.03.02-.03.02-.03.03-.04.02-.03.02-.04.02-.03.03-.03.02-.04.02-.03.02-.04.02-.03.02-.04.02h0',
      '010': 'M1.11 0H8v1.05h-.44l-.22.02-.22.02-.22.02-.22.04-.22.03-.21.05-.22.05-.2.05-.21.06-.21.06-.2.07-.2.08-.2.08-.2.09-.19.1-.18.09-.18.1-.17.11-.18.11-.16.12-.17.12-.16.13-.16.13-.15.14-.15.14-.14.15-.14.15-.13.16-.13.16-.06.08-.06.09h-.02l-.02-.05-.02-.04-.02-.04L2 3.68l-.02-.04-.02-.04-.03-.04-.02-.04-.02-.05-.01-.04-.02-.04-.02-.04-.02-.04-.02-.04-.02-.05-.02-.04-.02-.04-.01-.04-.02-.05-.02-.04-.02-.04-.01-.05-.02-.04-.01-.04-.02-.04-.02-.05-.01-.04-.02-.04-.01-.05-.02-.04-.01-.05-.02-.03-.01-.05-.01-.04-.02-.04-.01-.05-.01-.04-.02-.05-.01-.04-.01-.04-.01-.05-.02-.04L1.36 2l-.01-.04-.01-.05-.01-.04-.01-.05-.01-.04-.01-.05-.01-.04-.01-.05-.01-.04-.01-.05-.01-.04-.01-.05v-.04l-.01-.05-.01-.04-.01-.05v-.05L1.2 1.2l-.01-.05v-.04l-.01-.05v-.04L1.17.97 1.16.92V.83L1.15.79V.74L1.14.7V.65L1.13.6V.46L1.12.41V.23L1.1.18V0',
      '011': 'M7.78 1.05h-.22l-.22.02-.22.02-.22.02-.22.04-.22.03-.21.05-.22.05-.2.05-.21.06-.21.06-.2.07-.2.08-.4.17-.19.1-.18.09-.18.1-.35.22-.33.24-.16.13-.16.13-.15.14-.15.14-.14.15-.14.15-.13.16-.13.16-.06.08-.06.09h-.02l-.02-.05-.02-.04-.06-.12-.02-.04-.03-.04-.02-.04-.02-.05-.01-.04-.02-.04-.02-.04-.04-.08-.02-.05-.02-.04-.02-.04-.01-.04-.02-.05-.02-.04-.02-.04-.01-.05-.02-.04-.01-.04-.02-.04-.02-.05-.03-.08-.01-.05-.02-.04-.01-.05-.02-.03-.01-.05-.01-.04-.03-.09-.01-.04-.02-.05-.01-.04-.01-.04-.01-.05-.02-.04-.03-.14-.01-.04-.05-.23-.01-.04-.03-.14v-.04l-.01-.05-.01-.04-.01-.05v-.05L1.2 1.2l-.01-.05v-.04l-.01-.05v-.04L1.17.97 1.16.92V.83L1.15.79V.74L1.14.7V.65L1.13.6V.46L1.12.41V.23L1.1.18V0h13.78V.33l-.01.04v.14l-.01.04V.7l-.02.05v.14l-.01.04v.05l-.02.05v.09l-.01.04v.05l-.02.04v.05l-.01.05v.04l-.02.05v.04l-.03.14v.04l-.02.04v.05l-.02.04v.05l-.02.04-.01.05-.03.13-.02.05v.04l-.02.05-.01.04-.02.05v.04l-.04.09v.04l-.02.05-.01.04-.02.04-.02.04-.01.05-.03.08-.02.05-.01.04-.02.04-.02.04-.01.05-.02.04-.02.04-.02.05-.01.04-.02.04-.02.04-.02.05-.04.08-.02.04-.02.04-.01.04-.02.05-.02.04-.03.04-.02.04-.06.12-.02.04-.02.05h-.02l-.06-.09-.06-.08-.13-.16-.13-.16-.14-.15-.14-.15-.15-.14-.15-.14-.16-.13-.16-.13-.33-.24-.35-.22-.18-.1-.18-.1-.18-.09-.4-.17-.2-.07-.21-.07-.2-.07-.22-.06-.2-.05-.22-.05-.21-.04-.22-.04-.22-.03-.22-.03-.22-.02-.22-.01-.22-.01h-.44z',
      '012': 'M1.11-.18v-.14l.01-.05v-.14l.01-.04V-.7l.01-.05v-.05l.01-.04v-.05l.01-.04v-.05l.01-.05v-.04l.01-.05.01-.04v-.05l.01-.04.01-.05.01-.05v-.04l.01-.05.01-.04.03-.14v-.04l.05-.23.02-.04.03-.14.01-.04.01-.04.02-.05.01-.04.01-.05.01-.04.03-.09.01-.04.02-.05.01-.04.02-.04.01-.04.02-.05.01-.04.03-.09.02-.04.02-.04.01-.04.02-.05.02-.04.01-.04.02-.05.02-.04.02-.04.02-.04.01-.05.04-.08.02-.04.02-.04.02-.04.02-.05.02-.04.02-.04.02-.04.06-.12.03-.04.02-.05h.01l.06.09.07.08.12.16.14.16.13.15.15.15.15.14.15.14.15.13.17.13.33.24.35.22.18.1.18.1.18.09.4.17.2.07.21.07.2.07.21.06.21.05.21.05.22.04.22.04.21.03.22.03.22.02.23.01.22.01H8v2.1h-.44l-.22.02-.22.02-.22.02-.22.04-.22.03-.21.05-.22.05-.2.05-.21.06-.21.06-.2.07-.2.08-.4.17-.19.1-.18.09-.18.1-.35.22-.33.24-.16.13-.16.13-.15.14-.15.14-.14.15-.14.15-.13.16-.13.16-.06.08-.06.09h-.02l-.02-.05-.02-.04-.06-.12-.02-.04-.03-.04-.02-.04-.02-.05-.01-.04-.02-.04-.02-.04-.04-.08-.02-.05-.02-.04-.02-.04-.01-.04-.02-.05-.02-.04-.02-.04-.01-.05-.02-.04-.01-.04-.02-.04-.02-.05-.03-.08-.01-.05-.02-.04-.01-.05-.02-.03-.01-.05-.01-.04-.03-.09-.01-.04-.02-.05-.01-.04-.01-.04-.01-.05-.02-.04-.03-.14-.01-.04-.05-.23-.01-.04-.03-.14v-.04l-.01-.05-.01-.04-.01-.05v-.05L1.2 1.2l-.01-.05v-.04l-.01-.05v-.04L1.17.97 1.16.92V.83L1.15.79V.74L1.14.7V.65L1.13.6V.46L1.12.41V.23L1.1.18v-.36z',
      '013': 'M1.11 0v-.32l.01-.05v-.14l.01-.04V-.7l.01-.05v-.05l.01-.04v-.05l.01-.04v-.05l.01-.05v-.04l.01-.05.01-.04v-.05l.01-.04.01-.05.01-.05v-.04l.01-.05.01-.04.03-.14v-.04l.05-.23.02-.04.03-.14.01-.04.01-.04.02-.05.01-.04.01-.05.01-.04.03-.09.01-.04.02-.05.01-.04.02-.04.01-.04.02-.05.01-.04.03-.09.02-.04.02-.04.01-.04.02-.05.02-.04.01-.04.02-.05.02-.04.02-.04.02-.04.01-.05.04-.08.02-.04.02-.04.02-.04.02-.05.02-.04.02-.04.02-.04.02-.04.04-.08.03-.04.02-.05h.01l.06.09.07.08.12.16.14.16.13.15.15.15.15.14.15.14.15.13.17.13.33.24.35.22.18.1.18.1.18.09.4.17.2.07.21.07.2.07.21.06.21.05.21.05.22.04.22.04.21.03.22.03.22.02.23.01.22.01h.66l.22-.02.22-.02.22-.03.22-.03.22-.04.21-.04.22-.05.2-.05.21-.06.21-.07.2-.07.2-.07.4-.17.19-.1.18-.09.18-.1.35-.22.33-.24.16-.13.16-.13.15-.14.15-.15.14-.15.14-.15.13-.15.13-.16.06-.09.06-.08h.02l.02.04.02.04.06.12.02.05.03.04.02.04.02.04.01.04.02.04.02.05.04.08.02.04.02.04.02.05.01.04.02.04.02.04.02.05.01.04.02.04.02.05.01.04.03.09.02.04.01.05.02.04.01.04.02.04.01.05.01.04.03.1.01.03.02.05.01.04.01.05.01.04.02.05.03.13.01.05.05.22.01.05.03.13v.05l.02.04v.05l.01.04v.05l.02.04v.1l.02.04v.09l.01.05v.09l.02.05v.14l.01.04v.14l.01.05v.18l.01.05v.51l-.01.04v.14l-.01.04V.7l-.01.05v.04l-.01.05v.05l-.01.04v.05l-.01.04v.05l-.01.04-.01.05v.05l-.01.04-.01.05-.01.04v.05l-.01.04-.01.05-.03.13v.05l-.06.22-.01.05-.03.13-.02.05v.04l-.02.05-.01.04-.02.05v.04l-.04.09v.04l-.02.05-.01.04-.02.04-.02.04-.01.05-.03.08-.02.05-.01.04-.02.04-.02.04-.01.05-.02.04-.02.04-.02.05-.01.04-.02.04-.02.04-.02.05-.04.08-.02.04-.02.04-.01.04-.02.05-.02.04-.03.04-.02.04-.06.12-.02.04-.02.05h-.02l-.06-.09-.06-.08-.13-.16-.13-.16-.14-.15-.14-.15-.15-.14-.15-.14-.16-.13-.16-.13-.33-.24-.35-.22-.18-.1-.18-.1-.18-.09-.4-.17-.2-.07-.21-.07-.2-.07-.22-.06-.2-.05-.22-.05-.21-.04-.22-.04-.22-.03-.22-.03-.22-.02-.22-.01-.22-.01h-.66l-.23.02-.22.02-.22.03-.21.03-.22.04-.22.04-.21.05-.2.05-.22.06-.2.07-.2.07-.2.07-.4.17-.19.1-.18.09-.18.1-.35.22-.33.24-.17.13-.15.13-.15.14-.15.15-.15.15-.13.15-.14.15-.12.16-.07.09-.06.08h-.01l-.02-.04-.03-.04-.06-.12-.02-.05-.02-.04-.02-.04-.02-.04-.02-.04-.02-.04-.02-.05-.04-.08-.01-.04-.02-.04-.02-.05-.02-.04-.02-.04-.01-.04-.02-.05-.02-.04-.01-.04-.02-.05-.02-.04-.01-.05-.03-.08-.02-.05-.01-.04-.02-.04-.01-.04-.01-.05-.01-.04-.03-.09-.01-.04-.02-.05-.01-.04-.01-.04-.01-.05-.02-.04-.03-.14-.01-.04-.05-.23-.01-.04-.03-.14v-.04l-.01-.05-.01-.04-.01-.05v-.05L1.2 1.2l-.01-.05v-.04l-.01-.05v-.04L1.17.97 1.16.92V.83L1.15.79V.74L1.14.7V.65L1.13.6V.46L1.12.41V.23L1.1.18V0z',
      '020': 'M8 1.11V8H6.95v-.44l-.02-.22-.02-.22-.02-.22-.04-.22-.03-.22-.05-.21-.05-.22-.05-.2-.06-.21-.06-.21-.07-.2L6.4 5l-.09-.2-.08-.2-.1-.19-.09-.18-.1-.18-.11-.17-.11-.18-.12-.16-.12-.17-.13-.16-.13-.16-.14-.15-.14-.15-.15-.14-.15-.14-.16-.13-.16-.13-.09-.06-.08-.06v-.02l.04-.02.04-.02.04-.02.05-.02.04-.02.04-.02.04-.03.04-.02.04-.02.05-.01.04-.02.04-.02.04-.02.04-.02.04-.02.05-.02.04-.02.04-.01.04-.02.04-.02.05-.02.04-.01.04-.02.05-.01.04-.02.04-.02.05-.01.04-.02.05-.01.04-.02.04-.01.04-.02.05-.01.04-.01.04-.02.05-.01.04-.01.05-.02.04-.01.04-.01.05-.01.04-.02.05-.01.04-.01.05-.01.04-.01.05-.01.04-.01.05-.01.04-.01.05-.01.04-.01.05-.01.04-.01.05-.01h.04l.05-.01.04-.01.05-.01h.05l.04-.01.05-.01h.04l.05-.01h.04l.05-.01.05-.01h.09l.04-.01h.05l.04-.01h.05l.04-.01h.14l.05-.01h.19l.04-.01H8',
      '030': 'M6.89 8H0V6.95h.44l.23-.02.21-.02.23-.02.21-.04.22-.03.21-.05.22-.05.2-.05.22-.06.2-.06.2-.07.2-.08.2-.09.2-.08.19-.1.18-.09.18-.1.18-.11.17-.11.17-.12.16-.12.17-.13.15-.13.15-.14.15-.14.15-.15.13-.15.14-.16.12-.16.07-.09.06-.08h.01l.02.04.03.04.02.04.02.05.02.04.01.04.03.04.02.04.02.04.01.05.02.04.02.04.02.04.02.04.02.04.02.05.02.04.01.04.02.04.02.04.02.05.01.04.02.04.02.05.01.04.02.04.01.05.02.04.01.05.02.04.01.04.02.04.01.05.01.04.02.05.01.04.01.04.02.05.01.04.01.05.01.04.02.05.01.04.01.05.01.04.01.05.01.04.01.05.01.04.01.05.01.04.01.05.01.04.01.05.01.04v.05l.01.04.01.05.01.04v.05l.01.04.01.05v.05l.01.04V7l.01.04.01.05v.09l.01.05v.04l.01.05v.05l.01.04v.14l.01.05v.18l.01.05V8',
      '031': 'M-6.89 8V7.67l.01-.04v-.14l.01-.04V7.3l.01-.05v-.04l.01-.05v-.05l.01-.04v-.05l.01-.04v-.05l.01-.04.01-.05V6.8l.01-.04.01-.05.01-.04v-.05l.01-.04.01-.05.01-.04.02-.1v-.04l.01-.04.01-.05.02-.09.01-.04.02-.05.02-.09.01-.04.01-.05.01-.04.02-.05.01-.04.01-.05.01-.04.03-.09.01-.04.02-.05.01-.03.02-.05.01-.04.02-.05.01-.04.02-.04.01-.05.02-.04.02-.04.01-.04.02-.05.02-.04.01-.04.02-.05.02-.04.02-.04.02-.04.01-.05.02-.04.02-.04.02-.04.02-.04.02-.04.02-.05.02-.04.02-.04.02-.04.02-.04.04-.08.03-.04.02-.05h.01l.06.09.07.08.12.16.14.16.13.15.15.15.15.14.15.14.15.13.17.13.33.24.35.22.18.1.18.1.18.09.4.17.2.08.21.07.2.06.21.06.21.05.21.05.22.05.22.03.21.04.22.02.22.02.23.02h.88l.22-.02.22-.02.22-.02.22-.04.22-.03.21-.05.22-.05.2-.05.21-.06.21-.06.2-.07.2-.08.4-.17.19-.1.18-.09.18-.1.35-.22.33-.24.16-.13.16-.13.15-.14.15-.14.14-.15.14-.15.13-.16.13-.16.06-.08.06-.09h.02l.02.05.02.04.06.12.02.04.03.04.02.04.02.05.01.04.02.04.02.04.04.08.02.05.02.04.02.04.01.04.02.05.02.04.02.04.01.05.02.04.02.04.01.04.03.09.02.04.01.05.02.04.01.05.02.04.01.05.01.04.03.09.01.04.02.05.01.04.01.04.01.05.02.04.03.14.01.04.05.23.01.04.03.14v.04l.01.05.01.04.01.05v.05l.01.04.01.05v.04l.01.05v.04l.01.05.01.05v.09l.01.04v.05l.01.04v.05l.01.04v.14l.01.05v.18l.01.05V8H-6.89z',
      '032': 'M0 9.05v-2.1h.44l.23-.02.21-.02.23-.02.21-.04.22-.03.21-.05.22-.05.2-.05.22-.06.2-.06.2-.07.2-.08.4-.17.19-.1.18-.09.18-.1.35-.22.33-.24.17-.13.15-.13.15-.14.15-.14.15-.15.13-.15.14-.16.12-.16.07-.08.06-.09h.01l.02.05.03.04.06.12.02.04.02.04.02.04.02.05.01.04.02.04.02.04.04.08.02.05.02.04.02.04.01.04.02.05.02.04.02.04.01.05.02.04.02.04.01.04.03.09.02.04.01.05.02.04.01.05.02.04.01.05.01.04.03.09.01.04.02.05.01.04.01.04.01.05.02.04.03.14.01.04.05.23.01.04.03.14v.04l.01.04.01.05.01.04v.05l.01.04.01.05v.05l.01.04V7l.01.04.01.05v.09l.01.05v.04l.01.05v.05l.01.04v.14l.01.05v.18l.01.05v.51l-.01.04v.14l-.01.05v.14l-.02.04v.14l-.01.04v.05l-.02.05v.09l-.01.04v.05l-.02.04v.05l-.01.05v.04l-.02.05v.04l-.01.05-.01.04-.01.05v.04l-.02.05v.04l-.02.05v.04l-.02.05-.01.04-.01.05-.01.04-.01.05-.02.04v.05l-.02.04-.01.04-.02.05v.04l-.04.09v.04l-.02.05-.02.04-.01.04-.02.04-.01.05-.02.04-.01.04-.02.05-.01.04-.02.04-.02.04-.01.05-.02.04-.01.04-.02.05-.02.04-.02.04-.02.04-.01.05-.02.04-.02.04-.02.04-.02.04-.02.04-.02.05-.02.04-.02.04-.02.04-.02.04-.02.04-.02.04-.03.04-.02.05h-.01l-.06-.09-.07-.08-.12-.16-.14-.16-.13-.15-.15-.15-.15-.14-.15-.14-.15-.13-.17-.13-.33-.24-.35-.22-.18-.1-.18-.1-.18-.09L3 9.6l-.2-.08-.21-.07-.2-.06-.21-.06-.21-.05-.21-.05-.22-.05-.22-.03-.21-.04-.22-.02-.22-.02-.23-.02H0z',
      '040': 'M0 6.89V0h1.05v.44l.02.23.02.21.02.23.04.21.03.22.05.21.05.22.05.2.06.22.06.2.07.2.08.2.08.2.09.2.1.19.09.18.1.18.11.18.11.17.12.17.12.16.13.17.13.15.14.15.14.15.15.15.15.13.16.14.16.12.08.07.09.06v.01l-.05.02-.04.03-.04.02-.04.02-.04.02-.04.01-.04.03-.04.02-.05.02-.04.01-.04.02-.04.02-.04.02-.04.02-.05.02-.04.02-.04.02-.04.01-.05.02-.04.02-.04.02-.05.01-.04.02-.04.02-.04.01-.05.02-.04.01-.04.02-.05.01-.04.02-.05.01-.03.02-.05.01-.04.01-.04.02-.05.01-.04.01-.05.02-.04.01-.04.01-.05.01-.04.02-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01-.04.01-.05.01h-.04l-.05.01-.04.01-.05.01h-.05l-.04.01-.05.01h-.04l-.05.01h-.04l-.05.01-.05.01H.83l-.04.01H.74l-.04.01H.65l-.04.01H.46l-.05.01H.23l-.05.01H0'
    }
  }
};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

var lisboa1 = '7d139b52-372d-4f39-93fc-40f3c0a37955';
var lisboa2 = '85c5dbbb-0060-4dfb-8f95-78a26b3129bf';
var lisboa3 = '1e1fee34-22f7-44c9-b434-6e1d99c5026c';
var lisboa4 = '1887c14d-bc09-413a-92d9-8482c366f2bf';
var lisboa5 = '3700ff98-fb11-4fb4-9e4a-1bc24f97c543';

var porto1 = '36a71a74-22c5-4366-b6e2-b27e3acd02b2';
var porto2 = 'f1d8199b-21b2-4042-95ef-b7f0dcbdc06d';
var porto3 = 'e42dcf38-771f-4088-8002-a88a9c8f6378';

var SP_BLOCKS = __webpack_require__(36);

var getBlockName = function getBlockName(id) {
  return SP_BLOCKS[id].name || '';
};

module.exports = {
  '23d97e24-99c2-4520-b1c8-09e182fdf9d0': {
    name: 'Lisboa 1-001',
    module: [[{ id: lisboa1, name: getBlockName(lisboa1) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  '29ad7b4d-25cd-44bb-9e06-d3fcc3eed182': {
    name: 'Lisboa 2-001',
    module: [[{ id: lisboa2, name: getBlockName(lisboa2) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  '03cecbb5-aafe-4c7e-ba6a-f7c331a24eea': {
    name: 'Lisboa 2-002',
    module: [[{ id: lisboa2, name: getBlockName(lisboa2), r: 90 }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  '332eb4b9-c33c-4aaa-967d-58bae5309545': {
    name: 'Lisboa 3-001',
    module: [[{ id: lisboa3, name: getBlockName(lisboa3) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  'd0acfa61-0063-4424-8df2-da4f98254fb8': {
    name: 'Lisboa 4-001',
    module: [[{ id: lisboa4, name: getBlockName(lisboa4) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  '3fbad118-6526-40db-864a-38807f4a7390': {
    name: 'Lisboa 4-002',
    module: [[180, 270, 180, 270, 180, 270], [180, 0, 90, 0, 90, 270], [0, 180, 0, 90, 270, 90], [270, 90, 270, 180, 0, 180], [90, 270, 180, 270, 180, 0], [90, 0, 90, 0, 90, 0]].map(function (row) {
      return row.map(function (r) {
        return { id: lisboa4, name: getBlockName(lisboa4), r: r };
      });
    }),
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  '244c939e-eed5-428c-846f-9e4737ce53c3': {
    name: 'Lisboa 5-001',
    module: [[{ id: lisboa5, name: getBlockName(lisboa5) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  '48cc25cb-55f7-47f3-9fef-ddc5a450d85d': {
    name: 'Lisboa 5-002',
    module: [[{ id: lisboa5, name: getBlockName(lisboa5) }, { id: lisboa5, name: getBlockName(lisboa5), r: 180 }], [{ id: lisboa5, name: getBlockName(lisboa5), r: 180 }, { id: lisboa5, name: getBlockName(lisboa5) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  'c7004e30-d53a-42dc-b64f-7676f788b818': {
    name: 'Lisboa All-001',
    module: [[{ id: lisboa5, name: getBlockName(lisboa5), r: 90 }, { id: lisboa1, name: getBlockName(lisboa1) }, { id: lisboa5, name: getBlockName(lisboa5) }, { id: lisboa5, name: getBlockName(lisboa5), r: 90 }, { id: lisboa1, name: getBlockName(lisboa1) }, { id: lisboa5, name: getBlockName(lisboa5) }], [{ id: lisboa2, name: getBlockName(lisboa2) }, { id: lisboa1, name: getBlockName(lisboa1) }, { id: lisboa2, name: getBlockName(lisboa2) }, { id: lisboa2, name: getBlockName(lisboa2) }, { id: lisboa1, name: getBlockName(lisboa1) }, { id: lisboa2, name: getBlockName(lisboa2) }], [{ id: lisboa5, name: getBlockName(lisboa5), r: 270 }, { id: lisboa5, name: getBlockName(lisboa5), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2) }, { id: lisboa5, name: getBlockName(lisboa5), r: 270 }, { id: lisboa5, name: getBlockName(lisboa5), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2) }], [{ id: lisboa1, name: getBlockName(lisboa1) }, { id: lisboa2, name: getBlockName(lisboa2) }, { id: lisboa2, name: getBlockName(lisboa2) }, { id: lisboa5, name: getBlockName(lisboa5) }, { id: lisboa3, name: getBlockName(lisboa3) }, { id: lisboa5, name: getBlockName(lisboa5), r: 180 }], [{ id: lisboa5, name: getBlockName(lisboa5) }, { id: lisboa3, name: getBlockName(lisboa3) }, { id: lisboa5, name: getBlockName(lisboa5), r: 180 }, { id: lisboa5, name: getBlockName(lisboa5), r: 270 }, { id: lisboa5, name: getBlockName(lisboa5), r: 180 }, { id: lisboa1, name: getBlockName(lisboa1) }], [{ id: lisboa5, name: getBlockName(lisboa5), r: 270 }, { id: lisboa5, name: getBlockName(lisboa5), r: 180 }, { id: lisboa1, name: getBlockName(lisboa1) }, { id: lisboa1, name: getBlockName(lisboa1) }, { id: lisboa1, name: getBlockName(lisboa1) }, { id: lisboa1, name: getBlockName(lisboa1) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  '93beb7dd-edeb-4447-a264-ade07b1b2746': {
    name: 'Lisboa All-002',
    module: [[{ id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }], [{ id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }], [{ id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }], [{ id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }], [{ id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }], [{ id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }], [{ id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }], [{ id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa4, name: getBlockName(lisboa4), r: 180 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }], [{ id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa4, name: getBlockName(lisboa4), r: 0 }, { id: lisboa4, name: getBlockName(lisboa4), r: 90 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa3, name: getBlockName(lisboa3), r: 0 }, { id: lisboa2, name: getBlockName(lisboa2), r: 90 }, { id: lisboa4, name: getBlockName(lisboa4), r: 270 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }, { id: lisboa1, name: getBlockName(lisboa1), r: 0 }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5]
  },

  // Porto

  '97210965-f0e7-4142-bc58-c0eef97f07b8': {
    name: 'Porto 1-001',
    module: [[{ id: porto1, name: getBlockName(porto1) }]],
    customBlocks: [porto1, lisboa1]
  },

  'fc41f36d-beb7-4920-a650-c2b13beb6bd2': {
    name: 'Porto 1-002',
    module: [[{ id: porto1, name: getBlockName(porto1), r: 90 }]],
    customBlocks: [porto1, lisboa1]
  },

  '515c1b94-da9d-466b-b354-571968374992': {
    name: 'Porto 1-003',
    module: [[{ id: porto1, name: getBlockName(porto1), r: 90 }, { id: porto1, name: getBlockName(porto1), r: 0 }], [{ id: porto1, name: getBlockName(porto1), r: 0 }, { id: porto1, name: getBlockName(porto1), r: 90 }]],
    customBlocks: [porto1, lisboa1]
  },

  '2ee4d11e-c94e-49dd-93b3-2f2fb6b3ebca': {
    name: 'Porto 2-001',
    module: [[{ id: porto2, name: getBlockName(porto2) }]],
    customBlocks: [porto2, lisboa1]
  },

  'd3fb820a-cc5d-40ad-9efd-78c524c9b7b3': {
    name: 'Porto 2-002',
    module: [[{ id: porto2, name: getBlockName(porto2), r: 90 }]],
    customBlocks: [porto2, lisboa1]
  },

  'b2eb9482-17b3-4dae-80a1-85a58de9012a': {
    name: 'Porto 2-003',
    module: [[{ id: porto2, name: getBlockName(porto2), r: 90 }, { id: porto2, name: getBlockName(porto2), r: 0 }], [{ id: porto2, name: getBlockName(porto2), r: 0 }, { id: porto2, name: getBlockName(porto2), r: 90 }]],
    customBlocks: [porto2, lisboa1]
  },

  '81bb8afa-9574-45aa-b9be-2f42ccfa3ee8': {
    name: 'Porto 3-001',
    module: [[{ id: porto3, name: getBlockName(porto3) }]],
    customBlocks: [porto3, lisboa1]
  },

  '274bee68-74bd-4776-804e-566b99927346': {
    name: 'Porto 3-002',
    module: [[{ id: porto3, name: getBlockName(porto3), r: 90 }]],
    customBlocks: [lisboa3, porto1]
  },

  '1d12c8b3-1016-4340-b439-70b640f1e367': {
    name: 'Porto 3-003',
    module: [[{ id: porto3, name: getBlockName(porto3), r: 90 }, { id: porto3, name: getBlockName(porto3), r: 270 }]],
    customBlocks: [porto3, lisboa1]
  },

  '2f096dee-b4c7-4e1e-94fa-a43531ce71e5': {
    name: 'Porto 3-004',
    module: [[{ id: porto3, name: getBlockName(porto3) }, { id: porto3, name: getBlockName(porto3), r: 180 }]],
    customBlocks: [porto3, lisboa1]
  },

  '12c38751-6815-43ff-8421-75b9c5eed2eb': {
    name: 'Porto 3-005',
    module: [[{ id: porto3, name: getBlockName(porto3), r: 90 }, { id: porto3, name: getBlockName(porto3), r: 0 }], [{ id: porto3, name: getBlockName(porto3), r: 0 }, { id: porto3, name: getBlockName(porto3), r: 90 }]],
    customBlocks: [porto3, lisboa1]
  }

  // 'aff5ea63-34c8-40f0-8c65-a510460ba076': {
  //   name: 'Design 402 Large',
  //   fullBlocksOnly: true,
  //   dimensions: { i: `W 2'-8" x H 2'-8"`, m: 'W 81.2 cm x H 81.2 cm' },
  //   blocks: [
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //   ],
  //   origin: [0.5, 0.5],
  //   repeat: [[16, 0], [0, 16]],
  //   align: [[16, 0, -8], [16, 0, -8]],
  // },

  // '281d02c2-e7e5-4252-9e7b-2068a366fc01': {
  //   name: 'Design 402 Medium',
  //   fullBlocksOnly: true,
  //   dimensions: { i: `W 2'-0" x H 2'-0"`, m: 'W 61 cm x H 61 cm' },
  //   blocks: [
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //   ],
  //   origin: [0.5, 0.5],
  //   repeat: [[12, 0], [0, 12]],
  //   align: [[12, 0, -6], [12, 0, -6]],
  // },

  // 'cd9ca5e5-ed19-4729-812c-8182ab8fc5c7': {
  //   name: 'Design 402 Small',
  //   fullBlocksOnly: true,
  //   dimensions: { i: `W 1'-4" x H 1'-4" `, m: 'W 40 cm x H 40 cm' },
  //   blocks: [
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //   ],
  //   origin: [0.5, 0.5],
  //   repeat: [[8, 0], [0, 8]],
  //   align: [[8, 0, -4], [8, 0, -4]],
  // },
};

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(57)(false);
// imports


// module
exports.push([module.i, ".pattern-gallery svg{width:300px;height:200px}.pattern-gallery polygon{stroke:#333;stroke-width:.15}.pattern-gallery path,.pattern-gallery rect{fill:none;stroke:#333;stroke-width:.15}.link:hover{.caption-container{background-color:rgba(69,117,143,.8)}}", ""]);

// exports


/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(57)(false);
// imports


// module
exports.push([module.i, ".pattern-gallery[data-v-1d68c87e]{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:-7px -10px}.pattern-gallery>[data-v-1d68c87e]{margin:7px 10px}.link[data-v-1d68c87e]{display:block;color:inherit;text-decoration:inherit}.preview[data-v-1d68c87e]{position:relative;display:block;width:300px;height:200px;background:#f7f7f7}.caption-container[data-v-1d68c87e]{position:absolute;top:0;left:0;display:-ms-flexbox;display:flex;width:100%;height:100%;-ms-flex-align:center;align-items:center}.caption[data-v-1d68c87e]{width:100%;text-align:center;font-size:20px;color:#fff;visibility:hidden}.link:focus .preview[data-v-1d68c87e],.link:hover .preview[data-v-1d68c87e]{background:#45758f}.link:focus .caption[data-v-1d68c87e],.link:hover .caption[data-v-1d68c87e]{visibility:visible}", ""]);

// exports


/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(57)(false);
// imports


// module
exports.push([module.i, ".dimension-input[data-v-367a2fe0]{display:-ms-flexbox;display:flex;width:100%}.dimension-input>[data-v-367a2fe0]{-ms-flex:1 1 auto;flex:1 1 auto}.dimension-input.imperial>[data-v-367a2fe0]:first-child{border-right:none}.input-right-border[data-v-367a2fe0]{height:45px;border-right:2px solid #aeaeae}", ""]);

// exports


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(221);
exports = module.exports = __webpack_require__(57)(false);
// imports


// module
exports.push([module.i, ".editor[data-v-4ac45b82]{display:-ms-flexbox;display:flex;margin:0 -20px 30px;min-height:650px}.editor>[data-v-4ac45b82]{margin:0 20px}.main[data-v-4ac45b82]{-ms-flex:1 0 300px;flex:1 0 300px}.sidebar[data-v-4ac45b82]{-ms-flex:0 0 170px;flex:0 0 170px}label[data-v-4ac45b82]{display:block}.label-switch[data-v-4ac45b82]{display:-ms-flexbox;display:flex}.min-height-message[data-v-4ac45b82]{font-size:.75rem;color:#999;line-height:1.2}.unit-switch[data-v-4ac45b82]{display:block;border:none;margin:0 0 0 auto;padding:0 .2em;font-size:.75rem;cursor:pointer}.select[data-v-4ac45b82]{padding-left:1em;-moz-appearance:none;-webkit-appearance:none;background:url(" + escape(__webpack_require__(540)) + ") no-repeat right .7em center}.button[data-v-4ac45b82],.select[data-v-4ac45b82]{display:block;width:100%;border:2px solid #aeaeae;height:45px}.form-group[data-v-4ac45b82]{margin-bottom:15px}.button-group[data-v-4ac45b82]{display:-ms-flexbox;display:flex;padding-left:2px}.button-group>[data-v-4ac45b82]{-ms-flex:1 1 auto;flex:1 1 auto;margin-left:-2px}.colors[data-v-4ac45b82]{-ms-flex:0 0 170px;flex:0 0 170px}.colors-container[data-v-4ac45b82]{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-line-pack:start;align-content:flex-start}.color-circle[data-v-4ac45b82]{-ms-flex:0 0 auto;flex:0 0 auto;width:30px;height:30px;border:2px solid #fff;border-radius:30px;margin:2px;cursor:pointer}.color-circle.active[data-v-4ac45b82]{border:2px solid #999}.apply-color-container[data-v-4ac45b82],.color-circle-container[data-v-4ac45b82],.need-help-container[data-v-4ac45b82]{position:relative}.tooltip[data-v-4ac45b82]{position:absolute;bottom:100%;left:50%;margin-left:-100px;margin-bottom:7px;width:200px;visibility:hidden;pointer-events:none;text-align:center}:focus+.tooltip[data-v-4ac45b82],:hover>.tooltip[data-v-4ac45b82]{visibility:visible}.tooltip-content[data-v-4ac45b82]{border-radius:.3em;padding:.5em .7em;background:#999;color:#fff}.tooltip-content[data-v-4ac45b82]:after{content:\"\";position:absolute;top:100%;left:50%;margin-left:-5px;border:5px solid transparent;border-top-color:#999}.tooltip.apply-color[data-v-4ac45b82],.tooltip.how-to[data-v-4ac45b82]{background:#999;left:auto;right:0;width:440px;margin:0;text-align:left}.tooltip.apply-color .tooltip-content[data-v-4ac45b82],.tooltip.how-to .tooltip-content[data-v-4ac45b82]{display:block}.tooltip.apply-color .tooltip-content[data-v-4ac45b82]:after,.tooltip.how-to .tooltip-content[data-v-4ac45b82]:after{left:70%}.tooltip.apply-color .tooltip-content ol[data-v-4ac45b82],.tooltip.how-to .tooltip-content ol[data-v-4ac45b82]{margin:.5rem 1.5rem;padding:0}.customize .customize-button[data-v-4ac45b82]{position:relative}.customize button[data-v-4ac45b82]{display:block;width:60px;height:60px;border:1px solid #333;margin:0 auto 10px;padding:0}.customize button.active[data-v-4ac45b82]{border:3px solid #333}.customize svg[data-v-4ac45b82]{display:block;width:100%;height:100%}.customize rect[data-v-4ac45b82]{fill:none;stroke:#333;stroke-width:.6}.customize path[data-v-4ac45b82]{fill:none;stroke:#333;stroke-width:.4}.customize .rotate-button[data-v-4ac45b82]{background-size:30px 30px;background:url(" + escape(__webpack_require__(544)) + ") no-repeat 50%}.help-note[data-v-4ac45b82]{line-height:1.2;margin-top:10px;font-size:.85rem;font-style:italic;max-width:760px}.download-pdf[data-v-4ac45b82],.save-or-share[data-v-4ac45b82]{margin-top:30px}.gallery[data-v-4ac45b82]{margin:45px 0;border-top:2px dotted #929496}.ghost-block[data-v-4ac45b82]{position:absolute;width:50px;height:50px;border:1px solid #333;background:#fff;pointer-events:none}.ghost-block svg[data-v-4ac45b82]{display:block;width:100%;height:100%}.ghost-block path[data-v-4ac45b82]{fill:none;stroke:#333;stroke-width:.4}", ""]);

// exports


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(57)(false);
// imports


// module
exports.push([module.i, ".unit-input[data-v-5f8ee07a]{position:relative;height:45px;border:2px solid #aeaeae}.input[data-v-5f8ee07a]{display:block}.addon[data-v-5f8ee07a],.input[data-v-5f8ee07a]{width:100%;height:100%;border:0;padding:0 0 0 1em;line-height:41px}.addon[data-v-5f8ee07a]{position:absolute;overflow:hidden;pointer-events:none}.hidden[data-v-5f8ee07a]{visibility:hidden}", ""]);

// exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(221);
exports = module.exports = __webpack_require__(57)(false);
// imports


// module
exports.push([module.i, ".email-input[data-v-9ee1e386]{position:relative;width:300px}.input[data-v-9ee1e386]{display:block;width:100%;height:45px;border:2px solid #aeaeae;padding:0 60px 0 1em;line-height:41px}.button-submit[data-v-9ee1e386]{position:absolute;top:0;right:0;width:90px;height:45px;border:none;//:url(" + escape(__webpack_require__(539)) + ") no-repeat center center;background:#929496;color:#fff;font-size:12px;text-transform:uppercase}.button[data-v-9ee1e386]{display:block;width:270px;border:2px solid #aeaeae;height:45px}", ""]);

// exports


/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(57)(false);
// imports


// module
exports.push([module.i, ".design-svg[data-v-cb5cdc42]{display:block;max-height:500px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.design-block[data-v-cb5cdc42]{stroke:#333;stroke-width:.15}.design-block path.sp-path[data-v-cb5cdc42]{stroke:#333;stroke-width:.3}.active-color .design-block[data-v-cb5cdc42],.active-custom-block .design-block[data-v-cb5cdc42],.active-rotate .design-block[data-v-cb5cdc42]{cursor:pointer}.design-border[data-v-cb5cdc42]{fill:none;stroke:#333;stroke-width:.3;pointer-events:none}", ""]);

// exports


/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/chevron-right.406db43d.png";

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/drop.14376882.png";

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/logo-ff.1112f440.png";

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/spin-logo.08a6939e.png";

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/into-icon.02f5dc91.svg";

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/rotate.74512595.svg";

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)
__webpack_require__(535)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(567),
  /* scopeId */
  "data-v-367a2fe0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(577)
__webpack_require__(576)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  "data-v-1d68c87e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(570),
  /* scopeId */
  "data-v-5f8ee07a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(568),
  /* scopeId */
  "data-v-4ac45b82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(571),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(536)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  "data-v-328e629d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  null,
  /* template */
  __webpack_require__(565),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  null,
  /* template */
  __webpack_require__(564),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  null,
  /* template */
  __webpack_require__(569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(538)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(573),
  /* scopeId */
  "data-v-b0137c32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 561:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "id": "app"
    }
  }, [(_vm.brand === 'filzfelt') ? _c('header-filzfelt') : _vm._e(), _vm._v(" "), (_vm.brand === 'spinneybeck') ? _c('header-spinneybeck') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.brand === 'filzfelt') ? _c('footer-filzfelt') : _vm._e(), _vm._v(" "), (_vm.brand === 'spinneybeck') ? _c('footer-spinneybeck') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pattern-gallery"
  }, [_vm._l((_vm.patterns), function(p) {
    return [_c('router-link', {
      staticClass: "link",
      attrs: {
        "to": _vm.getPatternLink(p)
      }
    }, [_c('div', {
      staticClass: "preview"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(p.preview)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption-container"
    }, [_c('div', {
      staticClass: "caption alt-font"
    }, [_vm._v(_vm._s(p.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "alt-font"
    }, [_vm._v(_vm._s(p.name))])])]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "alt-font",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadPdf($event)
      }
    }
  }, [_vm._v("↓ Download PDF")])
},staticRenderFns: []}

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "l-footer"
  }, [_c('div', {
    staticClass: "l-footer__primary"
  }, [_c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/contact-us"
    }
  }, [_vm._v("Customer Service")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/contact-us"
    }
  }, [_vm._v("Sales Representatives")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/contact-us"
    }
  }, [_vm._v("Showrooms")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Downloads")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#About-Leather"
    }
  }, [_vm._v("About Leather")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Environmental"
    }
  }, [_vm._v("Environmental")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Catalogs"
    }
  }, [_vm._v("Catalogs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Product-Cut-Sheets"
    }
  }, [_vm._v("Product Cut Sheets")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Installation"
    }
  }, [_vm._v("Installation")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Maintenance"
    }
  }, [_vm._v("Maintenance")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Product")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/upholstery-leather/categories/"
    }
  }, [_vm._v("Upholstery Leather")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/architectural-products/"
    }
  }, [_vm._v("Architectural Products")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-us"
    }
  }, [_vm._v("About Us")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-leather"
    }
  }, [_vm._v("About Leather")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-cork"
    }
  }, [_vm._v("About Cork")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-how-leather-is-made"
    }
  }, [_vm._v("How Leather is Made")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-glossary"
    }
  }, [_vm._v("Glossary")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-Environmental"
    }
  }, [_vm._v("Environmental")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-Custom"
    }
  }, [_vm._v("About Custom")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/Collaborators"
    }
  }, [_vm._v("Collaborators")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/news"
    }
  }, [_vm._v("News")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/Press"
    }
  }, [_vm._v("Press")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Policies")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/faq"
    }
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/selling-policy"
    }
  }, [_vm._v("Selling Policy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/terms-of-use"
    }
  }, [_vm._v("Terms Of Use")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-footer__secondary"
  }, [_c('form', {
    staticClass: "mailing-list-form validate",
    attrs: {
      "action": "https://filzfelt.us6.list-manage.com/subscribe/post?u=b7c765aef80b20793da90832f&id=0a5d45439f",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('input', {
    staticClass: "input-text mailing-list-form__input required email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "Enter your email address..."
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mailing-list-form__submit button",
    attrs: {
      "type": "submit",
      "value": "Sign Up",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "social-links"
  }, [_c('h2', {
    staticClass: "social-links__heading"
  }, [_vm._v("Follow Us")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--facebook",
    attrs: {
      "href": "https://www.facebook.com/spinneybeck",
      "target": "_blank"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--instagram",
    attrs: {
      "href": "https://instagram.com/spinneybeck",
      "target": "_blank"
    }
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--vimeo",
    attrs: {
      "href": "https://vimeo.com/spinneybeck",
      "target": "_blank"
    }
  }, [_vm._v("Vimeo")])]), _vm._v(" "), _c('div', {
    staticClass: "social-links"
  }, [_c('h2', {
    staticClass: "social-links__heading"
  }, [_vm._v("LOOKING FOR FELT?")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "//www.spinneybeck.com/images/pages/footer/ff-logo.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-info"
  }, [_c('div', {
    staticClass: "vcard"
  }, [_c('div', {
    staticClass: "tel"
  }, [_vm._v("800.482.7777")]), _vm._v(" "), _c('div', {
    staticClass: "tel"
  }, [_vm._v("+1.716.446.2380")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sales@spinneybeck.com"
    }
  }, [_vm._v("sales@spinneybeck.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "contact-info__copyright"
  }, [_vm._v("©2017 Spinneybeck. All Rights Reserved.")])])])
}]}

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "l-footer"
  }, [_c('div', {
    staticClass: "l-footer__primary"
  }, [_c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/contact-us"
    }
  }, [_vm._v("Customer Service")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/contact-us"
    }
  }, [_vm._v("Sales Representatives")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/contact-us"
    }
  }, [_vm._v("Showrooms")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Downloads")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Color-Guide"
    }
  }, [_vm._v("Color Guide")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Price-Lists"
    }
  }, [_vm._v("Price Lists")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Catalogs"
    }
  }, [_vm._v("Catalogs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Product-Cut-Sheets"
    }
  }, [_vm._v("Product Cut Sheets")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Environmental"
    }
  }, [_vm._v("Environmental")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Installation-Assembly"
    }
  }, [_vm._v("Installation + Assembly")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Maintenance-Cleaning"
    }
  }, [_vm._v("Maintenance + Cleaning")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Product")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/by-the-yard"
    }
  }, [_vm._v("By the Yard")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/acoustic"
    }
  }, [_vm._v("Acoustic")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/drapery"
    }
  }, [_vm._v("Drapery")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/floor-coverings"
    }
  }, [_vm._v("Floor Coverings")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/hanging-panels"
    }
  }, [_vm._v("Hanging Panels")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/modular"
    }
  }, [_vm._v("Modular")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/shop/product/hanging-panel-track-system"
    }
  }, [_vm._v("Track System")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/wall-panels"
    }
  }, [_vm._v("Wall Panels")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Custom")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/about-custom"
    }
  }, [_vm._v("About Custom")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/custom"
    }
  }, [_vm._v("Custom Cut Design Felt")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/shop/product/custom-floor-coverings"
    }
  }, [_vm._v("Floor Coverings")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/shop/product/custom-hanging-panels"
    }
  }, [_vm._v("Hanging Panels")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Policies")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/faq"
    }
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/selling-policy"
    }
  }, [_vm._v("Selling Policy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/terms-of-use"
    }
  }, [_vm._v("Terms Of Use")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-footer__secondary"
  }, [_c('form', {
    staticClass: "mailing-list-form validate",
    attrs: {
      "action": "https://filzfelt.us6.list-manage.com/subscribe/post?u=b7c765aef80b20793da90832f&id=1f09615de6",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('input', {
    staticClass: "input-text mailing-list-form__input required email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "Enter your email address..."
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mailing-list-form__submit button",
    attrs: {
      "type": "submit",
      "value": "Sign Up",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "social-links"
  }, [_c('h2', {
    staticClass: "social-links__heading"
  }, [_vm._v("Follow Us")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--facebook",
    attrs: {
      "href": "https://www.facebook.com/filzfelt",
      "target": "_blank"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--instagram",
    attrs: {
      "href": "https://instagram.com/filzfelt/",
      "target": "_blank"
    }
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--vimeo",
    attrs: {
      "href": "https://vimeo.com/filzfelt",
      "target": "_blank"
    }
  }, [_vm._v("Vimeo")])]), _vm._v(" "), _c('div', {
    staticClass: "social-links"
  }, [_c('h2', {
    staticClass: "social-links__heading"
  }, [_vm._v("LOOKING FOR LEATHER?")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "//www.filzfelt.com/images/pages/footer/spinneybeck.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-info"
  }, [_c('div', {
    staticClass: "vcard"
  }, [_c('div', {
    staticClass: "tel"
  }, [_vm._v("800.482.7777")]), _vm._v(" "), _c('div', {
    staticClass: "tel"
  }, [_vm._v("+1.716.446.2380")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info@filzfelt.com"
    }
  }, [_vm._v("info@filzfelt.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "contact-info__copyright"
  }, [_vm._v("©2017 FilzFelt. All Rights Reserved.")])])])
}]}

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "viewer"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', [_c('router-link', {
    staticClass: "alt-font",
    attrs: {
      "to": _vm.galleryLink
    }
  }, [_vm._v("‹ Pattern Gallery")])], 1), _vm._v(" "), _c('design-view', {
    attrs: {
      "design": _vm.design,
      "readonly": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "download-pdf"
  }, [_c('download-pdf', {
    attrs: {
      "test": "testing"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "save-or-share"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Save or Share Design")]), _vm._v(" "), _c('save-form')], 1)], 1), _vm._v(" "), (_vm.usedColors.length && _vm.colorsUsedAndPlaceholders.length === 0 && _vm.brand === 'filzfelt') ? _c('div', {
    staticClass: "used-colors"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Colors")]), _vm._v(" "), _vm._l((_vm.usedColors), function(ref) {
    var key = ref[0];
    var count = ref[1];
    var ref_2 = ref[2];
    var name = ref_2.name;
    var value = ref_2.value;
    var idx = ref_2.idx;

    return _c('div', {
      key: key,
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "color-circle",
      style: (("background: " + value))
    }), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(count > 1 ? (count + " tiles in ") : (count + " tile in ")) + " " + _vm._s(idx) + " " + _vm._s(name))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.colorsUsedAndPlaceholders.length && _vm.brand === 'filzfelt') ? _c('div', {
    staticClass: "used-colors"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Colors")]), _vm._v(" "), _vm._l((_vm.colorsUsedAndPlaceholders), function(ref) {
    var name = ref.name;
    var usedColor = ref.usedColor;
    var placeholderColor = ref.placeholderColor;

    return _c('div', {
      key: name,
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "color-circle",
      style: (("background: " + (usedColor ? usedColor.value : placeholderColor) + "; " + (usedColor || placeholderColor === 'rgb(255, 255, 255)' ? 'border: 1px solid #000;' : '')))
    }), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(name) + " - " + _vm._s(usedColor ? usedColor.idx : '') + " " + _vm._s(usedColor ? usedColor.name : 'TBD') + "\n        ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isSp402 && _vm.usedBlocks && _vm.brand === 'spinneybeck') ? _c('div', {
    staticClass: "used-colors"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Pattern Breakdown")]), _vm._v(" "), _vm._l((_vm.sp402Breakdown), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v("(" + _vm._s(item.count) + ") " + _vm._s(item.tile))])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isSp402 && _vm.usedBlocks && _vm.brand === 'spinneybeck') ? _c('div', {
    staticClass: "used-colors"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Pattern Breakdown")]), _vm._v(" "), _vm._l((_vm.usedBlocks), function(count, name) {
    return _c('div', {
      key: name,
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(count > 1 ? (count + " tiles in ") : (count + " tile in ")) + " " + _vm._s(name))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "specs"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Wall Dimensions")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("W " + _vm._s(_vm.width) + " x H " + _vm._s(_vm.height))])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Pattern")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.patternName))])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Tile Counts")]), _vm._v(" "), (_vm.coloredTilesCount) ? [(_vm.metric) ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n            W " + _vm._s(_vm.convertInchesToCm(_vm.coloredTilesDimensions.width)) + " cm x H " + _vm._s(_vm.convertInchesToCm(_vm.coloredTilesDimensions.height)) + " cm\n          ")]) : _c('div', {
    staticClass: "value"
  }, [_vm._v("W " + _vm._s(_vm.inchesToFeetString(_vm.coloredTilesDimensions.width)) + " x H " + _vm._s(_vm.inchesToFeetString(_vm.coloredTilesDimensions.height)))]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.coloredTilesCount) + " tiles")])] : [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalTilesCount) + " total tiles")])]], 2), _vm._v(" "), (_vm.tileDimensions) ? [_c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Tile Dimensions")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.tileDimensions))])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('router-link', {
    staticClass: "alt-font return-back",
    attrs: {
      "to": "edit"
    }
  }, [_vm._v("Back to Editor")])], 1)], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dimension-input",
    class: !_vm.metric && 'imperial'
  }, [(!_vm.metric) ? [_c('unit-input', {
    attrs: {
      "placeholder": "Feet",
      "mark": "'"
    },
    model: {
      value: (_vm.feet),
      callback: function($$v) {
        _vm.feet = $$v
      },
      expression: "feet"
    }
  }), _vm._v(" "), (_vm.showInches) ? [_c('unit-input', {
    attrs: {
      "placeholder": "Inches",
      "mark": "\""
    },
    model: {
      value: (_vm.inches),
      callback: function($$v) {
        _vm.inches = $$v
      },
      expression: "inches"
    }
  })] : _vm._e(), _vm._v(" "), (!_vm.showInches) ? [_c('span', {
    staticClass: "input-right-border"
  })] : _vm._e()] : (_vm.metric) ? [_c('unit-input', {
    attrs: {
      "placeholder": "Cm",
      "mark": "cm"
    },
    model: {
      value: (_vm.centimeters),
      callback: function($$v) {
        _vm.centimeters = $$v
      },
      expression: "centimeters"
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "editor",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', [_c('router-link', {
    staticClass: "alt-font",
    attrs: {
      "to": _vm.galleryLink
    }
  }, [_vm._v("‹ Pattern Gallery")])], 1), _vm._v(" "), _c('design-view', {
    attrs: {
      "design": _vm.design
    },
    on: {
      "block-click": _vm.onBlockClick,
      "block-drop": _vm.onBlockDrop,
      "block-drag": _vm.onBlockDrag
    }
  }), _vm._v(" "), (_vm.showHelpNote) ? _c('div', {
    staticClass: "help-note"
  }, [_vm._v(_vm._s(_vm.helpNote))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "download-pdf"
  }, [_c('download-pdf')], 1), _vm._v(" "), _c('div', {
    staticClass: "save-or-share"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Save or Share Design")]), _vm._v(" "), _c('save-form')], 1)], 1), _vm._v(" "), (_vm.brand === 'filzfelt') ? _c('div', {
    staticClass: "colors"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "colors-container"
  }, _vm._l((Object.entries(_vm.colors)), function(ref) {
    var key = ref[0];
    var c = ref[1];

    return _c('div', {
      staticClass: "color-circle-container"
    }, [_c('button', {
      staticClass: "color-circle",
      class: _vm.activeColor === key && 'active',
      style: (("background: " + (c.value))),
      on: {
        "click": function($event) {
          _vm.setActiveColor(key)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip alt-font"
    }, [_c('span', {
      staticClass: "tooltip-content"
    }, [_vm._v(_vm._s(c.idx) + " " + _vm._s(c.name))])])])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.isSp402 && _vm.brand === 'spinneybeck') ? _c('div', {
    staticClass: "customize"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Customize")]), _vm._v(" "), _vm._l((_vm.customBlocks), function(cb) {
    return _c('div', {
      staticClass: "customize-button"
    }, [_c('button', {
      directives: [{
        name: "draggable",
        rawName: "v-draggable"
      }],
      class: _vm.activeCustomBlock === cb.id && 'active',
      attrs: {
        "data-drag": _vm.getCustomBlockData(cb)
      },
      on: {
        "click": function($event) {
          _vm.setActiveCustomBlock(cb)
        },
        "drag-start": function($event) {
          _vm.grabCustomBlock(cb)
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 16 16"
      }
    }, [_c('path', {
      attrs: {
        "d": cb.d
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "tooltip alt-font"
    }, [_c('span', {
      staticClass: "tooltip-content"
    }, [_vm._v(_vm._s(cb.name))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "customize-button"
  }, [_c('button', {
    staticClass: "rotate-button",
    class: _vm.activeRotate && 'active',
    on: {
      "click": function($event) {
        _vm.setActiveRotate()
      }
    }
  }), _vm._v(" "), _vm._m(0)])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "label-switch"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Width")]), _vm._v(" "), (_vm.showMetric) ? [_c('button', {
    staticClass: "unit-switch",
    on: {
      "click": _vm.switchUnits
    }
  }, [_vm._v("Switch to " + _vm._s(_vm.metric ? 'Imperial' : 'Metric'))])] : _vm._e()], 2), _vm._v(" "), _c('dimension-input', {
    attrs: {
      "id": ((this._uid) + "-input-width"),
      "value": _vm.design.width,
      "showInches": _vm.showInches
    },
    on: {
      "input": _vm.setWidth
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Height")]), _vm._v(" "), _c('dimension-input', {
    attrs: {
      "value": _vm.design.height,
      "showInches": _vm.showInches
    },
    on: {
      "input": _vm.setHeight
    }
  }), _vm._v(" "), (_vm.showPatternRepeatHeight) ? [_c('p', {
    staticClass: "min-height-message"
  }, [_vm._v("Pattern has a repeat of " + _vm._s(_vm.patternRepeatHeight) + ".")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Pattern")]), _vm._v(" "), _c('select', {
    staticClass: "select",
    domProps: {
      "value": _vm.design.pattern
    },
    on: {
      "change": function($event) {
        _vm.setPattern($event.target.value)
      }
    }
  }, _vm._l((_vm.patterns), function(p) {
    return _c('option', {
      domProps: {
        "value": p.id
      }
    }, [_vm._v(_vm._s(p.name))])
  }))]), _vm._v(" "), (_vm.brand === 'filzfelt') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.clearColorForAll()
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), (_vm.showFill) ? [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeColor && _vm.setColorForAll(_vm.activeColor)
      }
    }
  }, [_vm._v("Fill")])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('router-link', {
    staticClass: "alt-font",
    attrs: {
      "to": "view"
    }
  }, [_vm._v("View Specs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "need-help-container"
  }, [_c('a', {
    staticClass: "alt-font",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Need Help?")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip how-to"
  }, [_c('div', {
    staticClass: "tooltip-content alt-font"
  }, [_c('ol', _vm._l((_vm.howToText), function(step) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(step)
      }
    })
  }))])])])])])]), _vm._v(" "), (_vm.ghostBlock) ? _c('div', {
    staticClass: "ghost-block",
    style: (("top: " + (_vm.cursorY - 25) + "px; left: " + (_vm.cursorX - 25) + "px"))
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.ghostBlock.d,
      "transform": ("rotate(" + (_vm.ghostBlock.r || 0) + " 8 8)")
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tooltip alt-font"
  }, [_c('span', {
    staticClass: "tooltip-content"
  }, [_vm._v("Rotate")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply-color-container"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Apply Color")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip apply-color alt-font"
  }, [_c('span', {
    staticClass: "tooltip-content"
  }, [_vm._v("Select ‘Single’ to add color to individual tiles or ‘All’ to add one color\n              to entire wall. To switch color of a tile, selection ‘Single’, click on another color, and then click on\n              that tile.\n            ")])])])
}]}

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    staticClass: "l-header"
  }, [_c('a', {
    staticClass: "ff-logo",
    attrs: {
      "href": "http://www.filzfelt.com"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "filzfelt",
      "src": __webpack_require__(541),
      "width": "179",
      "height": "44"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--portfolio is-first",
    attrs: {
      "href": "https://www.filzfelt.com/portfolio/categories/"
    }
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--products",
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--design-tool",
    attrs: {
      "href": "http://dt.filzfelt.com/"
    }
  }, [_vm._v("Design Tool")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--about",
    attrs: {
      "href": "https://www.filzfelt.com/about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--shop",
    attrs: {
      "href": "https://www.filzfelt.com/shop/categories/"
    }
  }, [_vm._v("Shop")]), _vm._v(" "), _c('form', {
    staticClass: "site-search-form",
    attrs: {
      "method": "post",
      "action": "https://www.filzfelt.com/index.php"
    }
  }, [_c('div', {
    staticClass: "hiddenFields"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "ACT",
      "value": "4"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "RES",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "meta",
      "value": "cUhAUc7Z0E6+4Wq3A5LDgE6tzuuGAEkpJY+ZNQQ/nDj0ElAryylRoBAtY27hWM4/zgJWQLtiMUav6nHWOHCp4SRfsb5rAZktzylT/jZOE+HYA7PifK/s4q+brfPzL7A4Q+PIrsdXN0ClMlKLk/bQQmT7oYbFu/VVzBxnoS4OtidHPEryxzjuXAGF/jPR4Rym3IvZpESdJHUUxwHz90rdUscu1YjbHpu+tDEzNkyq8/bfFzc7Ev2IHEmpXi4bv7eXHrKhGhvPjkE6wGoqXl4wkmiXjqVMmdLnoholaoIW7hFI4JPWMxGwuWSzpT+Cnu9+8U9F6b+PGmhjmqhkrIX2vPRi9L1nynq1gHPv3pisLXR2bgCUO/1b9tPlyowFNyxc4cckE9xsQtPXXJypiBNz36e6fBZJf/2wWR4LaRZn3QdIRYLqVYRMWmrD8YZR7O4Z5apKEIh/waFLUDfToHSvsyg7maS+upb2mJZpSGUZl9c9WfHQU7T9LTTzXG9VMJgL"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "site_id",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "csrf_token",
      "value": "1c09d6803e7d32e7b86d01c6b88698079e8ef5c4"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "input-text site-search-form__input",
    attrs: {
      "name": "keywords",
      "id": "keywords",
      "type": "text",
      "placeholder": "Search…"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "site-search-form__submit",
    attrs: {
      "type": "submit"
    }
  })])])])
}]}

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-input"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayValue),
      expression: "displayValue"
    }],
    staticClass: "addon"
  }, [_c('span', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.displayValue))]), _vm._v(" "), _c('span', {
    staticClass: "unit-mark"
  }, [_vm._v(_vm._s(_vm.mark))])]), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.displayValue
    },
    on: {
      "input": _vm.onInput,
      "change": _vm.onChange
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_c('pattern-gallery', {
    staticClass: "gallery"
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(543),
      "width": "72",
      "height": "75"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "alt-font"
  }, [_vm._v("Design Tool")]), _vm._v(" "), _c('p', [_vm._v("\n        Welcome to " + _vm._s(_vm.brand) + "'s Design Tool. This handy tool allows you to build and customize your wall installation.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        To start, simply click on one of the templates to the left to begin designing.\n        Once in the tool, set the installation size, arrange colors, then save or email your work.\n        Have a change of heart? Return to this screen by clicking on ‘pattern gallery’ to select a new template.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        And if you need help at any time, click ‘contact us’ at the right of your screen.\n      ")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [(!_vm.authorized) ? _c('div', {
    staticClass: "email-input"
  }, [(_vm.isNewDesign) ? _c('input', {
    staticClass: "input",
    attrs: {
      "type": "email",
      "required": "",
      "placeholder": "Enter your email address..."
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": _vm.setEmail
    }
  }) : _c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter secret..."
    },
    domProps: {
      "value": _vm.secret
    },
    on: {
      "input": _vm.setSecret
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n      Save changes\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.saveSuccess) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.saveSuccess) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.saveError) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.saveError) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "c-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "c-nav"
  }, _vm._l((_vm.navItems), function(navItem) {
    return _c('a', {
      key: navItem.text,
      class: _vm.getClasses(navItem.active),
      attrs: {
        "href": navItem.url
      }
    }, [_vm._v(_vm._s(navItem.text))])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-logo",
    attrs: {
      "href": "http://www.spinneybeck.com"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Spinneybeck",
      "src": __webpack_require__(542),
      "width": "285",
      "height": "50"
    }
  })])
}]}

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "design-svg",
    attrs: {
      "preserveAspectRatio": "xMinYMin meet",
      "viewBox": ("0 0 " + (_vm.design.width) + " " + (_vm.design.height))
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": (_vm._uid + "-clip-path")
    }
  }, [_c('rect', {
    attrs: {
      "width": _vm.design.width,
      "height": _vm.design.height
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": ("url(#" + _vm._uid + "-clip-path)")
    }
  }, [(_vm.scalePattern) ? _vm._l((_vm.scalePattern), function(layer) {
    return _c('g', _vm._l((layer), function(block) {
      return _c('g', {
        key: block.key,
        staticClass: "design-block",
        attrs: {
          "data-key": block.key
        },
        on: {
          "click": function($event) {
            _vm.$emit('block-click', {
              key: block.key,
              block: block
            })
          }
        }
      }, [_c('path', {
        attrs: {
          "transform": _vm.getBlockTransform(block),
          "d": block.path,
          "fill": _vm.getBlockFill(block)
        }
      })])
    }))
  }) : (_vm.sp402Pattern) ? _vm._l((_vm.sp402Pattern), function(block) {
    return _c('g', {
      key: block.key,
      staticClass: "design-block",
      attrs: {
        "data-key": block.key
      },
      on: {
        "click": function($event) {
          _vm.$emit('block-click', {
            key: block.key,
            block: block
          })
        }
      }
    }, [_c('path', {
      attrs: {
        "transform": _vm.getBlockTransform(block),
        "d": block.path,
        "fill": "#f5f5f5"
      }
    })])
  }) : _vm._l((Object.entries(_vm.design.data)), function(ref) {
    var key = ref[0];
    var block = ref[1];

    return _c('g', {
      key: key,
      staticClass: "design-block",
      on: {
        "click": function($event) {
          _vm.$emit('block-click', {
            key: key,
            block: block
          })
        }
      }
    }, [(_vm.brand === 'filzfelt' && block.points) ? _c('polygon', {
      attrs: {
        "points": _vm.getBlockPoints(block),
        "fill": _vm.getBlockFill(block)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.brand === 'filzfelt' && !block.points && !_vm.scaleBlockInUse) ? _c('path', {
      attrs: {
        "transform": _vm.getBlockTransform(block),
        "d": _vm.getFFBlockPath(block),
        "fill": _vm.getBlockFill(block)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.brand === 'spinneybeck') ? _c('g', {
      directives: [{
        name: "draggable",
        rawName: "v-draggable",
        value: (!_vm.readonly),
        expression: "!readonly"
      }],
      attrs: {
        "transform": ("translate(" + (block.x) + " " + (block.y) + ")"),
        "data-drag": _vm.getBlockDropData(block)
      },
      on: {
        "drag-start": function($event) {
          _vm.blockDrag(key, $event)
        },
        "drag-end": function($event) {
          _vm.blockDrop(key, $event)
        }
      }
    }, [_c('polygon', {
      attrs: {
        "points": "0,0 16,0 16,16 0,16",
        "fill": "#eacfa2"
      }
    }), _vm._v(" "), (_vm.getBlockPath(block)) ? _c('path', {
      staticClass: "sp-path",
      attrs: {
        "d": _vm.getBlockPath(block),
        "transform": ("rotate(" + (block.r || 0) + " 8 8)"),
        "fill": "none"
      }
    }) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('rect', {
    staticClass: "design-border",
    attrs: {
      "width": _vm.design.width,
      "height": _vm.design.height
    }
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(527);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(58)("0892847e", content, true);

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(528);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(58)("7233c7d8", content, true);

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(529);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(58)("7ffb6e26", content, true);

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(530);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(58)("8e33510e", content, true);

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(531);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(58)("3e16ec06", content, true);

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(58)("31f16301", content, true);

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(533);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(58)("7a5e3aa5", content, true);

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(226);


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

var tw = 2;
var waffle = __webpack_require__(265);
var plainWeave = __webpack_require__(263);
var checker = __webpack_require__(260);
var gingham = __webpack_require__(261);
var twill = __webpack_require__(264);
var mosaikCustom = __webpack_require__(262);

module.exports = {
  'e0b7ad2c-dd75-421f-zv19-9dde30a2157d': {
    name: 'Tac-Tile Module A',
    border: [[0, 0], [12, 0], [12, 9], [0, 9], [0, 0], [15.8125, 0], [15.8125, 9], [12, 9], [12, 0], [19.625, 0], [19.625, 9], [15.8125, 9], [15.8125, 0], [24, 0], [24, 9], [19.625, 9], [19.625, 0]]
  },
  'e0b7ad2c-dd75-421f-zv29-9dde30a2157d': {
    name: 'Tac-Tile Module D',
    border: [[0, 0], [12, 0], [12, 9], [0, 9]]
  },
  'e0b7ad2c-dd75-421f-zb19-9dde30a2157d': {
    name: 'Tac-Tile Module B',
    border: [[0, 0], [12, 0], [12, 6], [0, 6], [0, 0], [15.8125, 0], [15.8125, 6], [12, 6], [12, 0], [19.625, 0], [19.625, 6], [15.8125, 6], [15.8125, 0], [24, 0], [24, 6], [19.625, 6], [19.625, 0]]
  },
  'e0b7ad2c-dd75-421f-zb29-9dde30a2157d': {
    name: 'Tac-Tile Module E',
    border: [[0, 0], [12, 0], [12, 6], [0, 6]]
  },

  'e0b7ad2c-dd75-421f-zc29-9dde30a2157d': {
    name: 'Tac-Tile Module F',
    border: [[0, 0], [12, 0], [12, 3], [0, 3]]
  },
  'e0b7ad2c-dd75-421f-zc39-9dde30a2157d': {
    name: 'Tac-Tile Module C',
    border: [[0, 0], [12, 0], [12, 3], [0, 3], [0, 0], [15.8125, 0], [15.8125, 3], [12, 3], [12, 0], [19.625, 0], [19.625, 3], [15.8125, 3], [15.8125, 0], [24, 0], [24, 3], [19.625, 3], [19.625, 0]]
  },
  'e0b7ad2c-dd75-421f-a639-9dde30a2157d': {
    name: 'AK 10 Block Triangle 90',
    border: [[0, 0], [12, 12], [0, 12]]
  },

  '840ad52b-d579-4233-ba31-ca81de9f34c6': {
    name: 'AK 10 Block Triangle 60',
    border: [[6.875, 0], [13.75, 12], [0, 12]]
  },

  'c8ff74cd-20a5-46c3-856c-325a910bdb27': {
    name: 'AK 10 Block Hex',
    border: [[3.375, 0], [10.375, 0], [13.75, 6], [10.375, 12], [3.375, 12], [0, 6]]
  },

  '4e2bec82-17b4-426a-91a3-465110a9f053': {
    name: 'AK 10 Block Square',
    border: [[0, 0], [12, 0], [12, 12], [0, 12]]
  },

  '43f6902a-d03c-4d36-af81-f38d2e2405c9': {
    name: 'AK 10 Block Rectangle A',
    border: [[0, 0], [24, 0], [24, 8], [0, 8]]
  },

  '347dca8d-682a-4782-8974-f86eb4f54265': {
    name: 'AK 10 Block Rectangle B',
    border: [[0, 0], [12, 0], [12, 8], [0, 8]]
  },

  'a82c43f6-a855-40c7-82c3-c25f2db5e5ba': {
    name: 'AK 10 Block Diamond',
    border: [[6.875, 0], [13.75, 12], [6.875, 24], [0, 12]]
  },

  '6fa2d74f-655b-414b-b282-422b21e544b2': {
    name: 'ARO Block 1',
    border: [[6.349, 1.09], [7.608, 1.09], [13.3275, 11], [12.698, 12.09], [1.259, 12.09], [0.6295, 11]]
  },

  'e8a69811-3dfb-4db2-b9c5-e7f22891ee9b': {
    name: 'ARO Block 2',
    border: [[5.343, 2.63], [8.383, 2.63], [12.206, 9.25], [10.686, 11.88], [3.04, 11.88], [1.52, 9.25]]
  },

  '700039ec-4130-4d93-9212-39c57640f8df': {
    name: 'ARO Block 3',
    border: [[2, 0], [8.5, 1], [18.75, 0], [16.75, 3.5], [16.75, 8], [10.25, 7], [0, 8], [2, 4.5]]
  },

  '0da46e9a-8c97-4977-9712-57870c8f1f94': {
    name: 'ARO Block 4.1',
    border: [[1.5, 0], [21.75, 0], [20.25, 7.75], [0, 7.75]]
  },

  '982a1c91-0a01-4630-b8fd-886b29fabb21': {
    name: 'ARO Block 4.2',
    border: [[1.5, 0], [16, 0], [14.5, 7.75], [0, 7.75]]
  },

  '679b38fa-ad4d-4382-b53c-80ab3ba70c0d': {
    name: 'Bottle Block',
    bounds: [9.2, 12.05],
    path: 'M0,10.6c2.8,1.9,6.4,1.9,9.2,0c-1.9-2.8-1.9-6.4,0-9.2C6.4-0.5,2.8-0.5,0,1.4C1.9,4.2,1.9,7.8,0,10.6z'
  },

  '6e1bccce-613a-43ce-9d87-7324b33b6cfa': {
    name: 'Fish Block',
    bounds: [12, 6.427],
    path: 'M5.4,6.2c0.8,0.3,1.8,0.3,2.6,0l0.2-0.1c0.6-0.3,1.6-1,2.2-1.4c0.1-0.1,0.3-0.2,0.4-0.2h0C10.9,4.3,11,4.1,11.2,4c0.2-0.2,0.4-0.3,0.7-0.4C11.9,3.5,12,3.4,12,3.2c0-0.1-0.1-0.3-0.2-0.4c-0.2-0.1-0.5-0.3-0.7-0.4c-0.1-0.1-0.3-0.3-0.4-0.5h0c-0.1-0.1-0.3-0.1-0.4-0.2C9.7,1.3,8.8,0.6,8.2,0.3L8,0.2c-0.8-0.3-1.8-0.3-2.6,0C5.3,0.3,5.1,0.4,5,0.4C4.3,0.9,3.4,1.6,2.8,1.9L2.6,1.9C1.8,2.3,0.8,2.3,0,1.9c0.1,0.2,0.2,0.3,0.3,0.5C0.5,2.6,0.8,2.7,1,2.8c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1-0.1,0.3-0.2,0.4C0.8,3.7,0.6,3.8,0.4,4C0.2,4.1,0.1,4.3,0,4.5c0.8-0.3,1.8-0.3,2.6,0l0.2,0.1C3.4,4.8,4.3,5.6,5,6C5.1,6.1,5.3,6.2,5.4,6.2'
  },

  '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9': {
    name: 'Goblet Block',
    bounds: [5.625, 12],
    path: 'M4.7,12c1.3-1.8,1.3-4.2,0-6c-1.4-1.8-1.4-4.2,0-6H1.1c1.4,1.8,1.4,4.2,0,6s-1.4,4.2,0,6H4.7z'
  },

  '036da44e-0a01-4c91-a15d-2e25a63e916c': {
    name: 'Hourglass Block',
    bounds: [12, 12],
    path: 'M7.6,5.5l4.2-5C12,0.4,12.1,0.2,12.1,0H0c0,0.2,0.1,0.3,0.2,0.5l4.3,5c0.3,0.3,0.3,0.7,0,1l-4.3,5C0.1,11.6,0,11.8,0,12h12.1c0-0.2-0.1-0.3-0.2-0.5l-4.3-5C7.4,6.2,7.4,5.8,7.6,5.5z'
  },

  'deea6070-c7cd-4509-8467-5292853e611b': {
    name: 'Spindle Block',
    bounds: [7, 12],
    path: 'M2.9,0h1.2c0,0.6,0.2,1.2,0.5,1.8c0.2,0.5,0.6,0.9,1,1.2s0.7,0.7,1,1.2C6.8,4.8,7,5.4,7,6S6.8,7.2,6.5,7.8C6.3,8.3,5.9,8.7,5.5,9s-0.8,0.7-1,1.2c-0.2,0.6-0.4,1.2-0.4,1.8H2.9c0-0.6-0.2-1.2-0.4-1.8C2.2,9.7,1.9,9.3,1.4,9C1,8.7,0.7,8.3,0.4,7.8C0.2,7.2,0,6.6,0,6s0.2-1.2,0.4-1.8C0.7,3.7,1,3.3,1.4,3s0.8-0.7,1-1.2C2.7,1.2,2.9,0.6,2.9,0z'
  },

  'd69f96d6-5561-4199-bf23-1c8ccbb29558': {
    name: 'Vase Block',
    bounds: [7.87, 12],
    path: 'M1,0h5.8c-1.4,1.8-1.4,4.2,0,6s1.4,4.2,0,6H1c-1.4-1.8-1.4-4.2,0-6S2.4,1.8,1,0z'
  },

  '994f1c2b-3548-42dd-b792-e5c5e9e42e1d': {
    name: 'Chevron Block A',
    border: [[0, 0], [12, 12], [12, 18], [0, 6]]
  },

  'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b': {
    name: 'Chevron Block B',
    border: [[0, 12], [12, 0], [12, 6], [0, 18]]
  },

  '0d5ebc31-8892-4471-a6d6-bb13ee6a932d': {
    name: 'Dart Block',
    border: [[0, 5], [5, 0], [10, 5], [10, 15], [5, 10], [0, 15]]
  },

  '854ce8f3-c736-4998-9b35-8d874c0bd420': {
    name: 'Picket Block',
    border: [[0, 5.0718], [2.9282, 0], [5.8564, 5.0718], [5.8564, 10.9282], [2.9282, 16], [0, 10.9282]]
  },

  'c85a3088-adef-4e09-87a4-ad827ce8ea61': {
    name: 'Plus Block',
    border: [[0, 4], [4, 4], [4, 0], [8, 0], [8, 4], [12, 4], [12, 8], [8, 8], [8, 12], [4, 12], [4, 8], [0, 8]]
  },

  '717fae39-bca4-4637-8e18-b203024ff3f2': {
    name: 'Scale Small Block',
    bounds: [2.7601, 2.8543, -2.7601, -2.8543],
    variants: {
      // key is a bit-mask where each bit signifies if corresponding corner is being overlapped
      // corners order is clockwise: top-left, top-right, bottom-right, bottom-left
      '0000': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,1.7696 L0,-1.7696',
      '0001': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.443,2.3367 L-1.443,0.9751 L-2.7601,1.4927 Z M0,-1.7696 L0,1.7696',
      '0010': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,1.4927 L1.443,0.9751 L1.443,2.3367 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '0011': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,1.4927 L1.443,0.9751 L1.443,2.3367 L0,1.7696 L-1.443,2.3367 L-1.443,0.9751 L-2.7601,1.4927 Z M0,-1.7696 L0,1.7696',
      '0100': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.443,-2.3367 L1.443,-0.9751 L2.7601,-1.4927 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696L0,1.7696',
      '0101': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2919 L0,-1.7694 L1.443,-2.3364 L1.443,-0.9748 L2.7601,-1.4925 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.443,2.3364 L-1.443,0.9748 L-2.7601,1.4925 Z M0,-1.7696 L0,1.7696',
      '0110': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.443,-2.3367 L1.443,-0.9751 L2.7601,-1.4927 L2.7601,1.4927 L1.443,0.9751 L1.443,2.3367 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '0111': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2919 L0,-1.7696 L1.443,-2.3364 L1.443,-0.9748 L2.7601,-1.4925 L2.7601,1.4925 L1.443,0.9748 L1.443,2.3364 L0,1.7696 L-1.443,2.3364 L-1.443,0.9748 L-2.7601,1.4925 Z M0,-1.7696 L0,1.7696',
      '1000': 'M-2.7601,-1.4927 L-1.443,-0.9751 L-1.443,-2.3367 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '1001': 'M-2.7601,-1.4927 L-1.443,-0.9751 L-1.443,-2.3367 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.443,2.3367 L-1.443,0.9751 L-2.7601,1.4927 Z M0,-1.7696 L0,1.7696',
      '1010': 'M-2.7601,-1.4925 L-1.443,-0.9748 L-1.443,-2.3364 L0,-1.7694 L1.3296,-2.2919 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,1.4925 L1.443,0.9748 L1.443,2.3364 L0,1.7696 L-1.3296,2.2919 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '1011': 'M-2.7601,-1.4925 L-1.443,-0.9748 L-1.443,-2.3364 L0,-1.7694 L1.3296,-2.2919 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,1.4925 L1.443,0.9748 L1.443,2.3364 L0,1.7694 L-1.443,2.3364 L-1.443,0.9748 L-2.7601,1.4925 Z M0,-1.7696 L0,1.7694',
      '1100': 'M-2.7601,-1.4927 L-1.443,-0.9751 L-1.443,-2.3367 L0,-1.7696 L1.443,-2.3367 L1.443,-0.9751 L2.7601,-1.4927 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '1101': 'M-2.7601,-1.4925 L-1.443,-0.9748 L-1.443,-2.3364 L0,-1.7694 L1.443,-2.3364 L1.443,-0.9748 L2.7601,-1.4925 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.443,2.3364 L-1.443,0.9748 L-2.7601,1.4925 Z M0,-1.7694 L0,1.7696',
      '1110': 'M-2.7601,-1.4925 L-1.443,-0.9748 L-1.443,-2.3364 L0,-1.7694 L1.443,-2.3364 L1.443,-0.9748 L2.7601,-1.4925 L2.7601,1.4925 L1.443,0.9748 L1.443,2.3364 L0,1.7696 L-1.3296,2.2919 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '1111': 'M-2.7601,-1.4925 L-1.4430,-0.9748 L-1.4430,-2.3364 L0.0000,-1.7694 L1.4430,-2.3364 L1.4430,-0.9748 L2.7601,-1.4925 L2.7601,1.4925 L1.4430,0.9748 L1.4430,2.3364 L0.0000,1.7694 L-1.4430,2.3364 L-1.4430,0.9748 L-2.7601,1.4925 Z M0,1.7694 L0,-1.7694'
    }
  },

  'c52c3cb4-390b-4cac-9ff3-f601c7439369': {
    name: 'Scale Large Block',
    bounds: [5.5625, 5.7085, -5.5625, -5.7085],
    variants: {
      // see Scale Small Block
      '0000': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '0001': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '0010': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '0011': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '0100': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '0101': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '0110': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '0111': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '1000': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '1001': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '1010': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '1011': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '1100': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '1101': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '1110': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '1111': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433'
    }
  },

  '1342419c-78c8-11ee-b962-0242ac120002': twill['color-1'],
  '7657f05e-78c5-11ee-b962-0242ac120002': twill['color-2'],
  'b8701284-7751-11ee-b962-0242ac120002': twill['color-3'],
  '44ff1abc-7750-11ee-b962-0242ac120002': twill['color-4'],

  'fe8f7de4-99d5-11ee-b9d1-0242ac120002': gingham['color-1'],
  'fe8f7f38-99d5-11ee-b9d1-0242ac120002': gingham['color-2'],
  'fe8f8258-99d5-11ee-b9d1-0242ac120002': gingham['color-3'],

  '5bfd32ea-99ff-11ee-b9d1-0242ac120002': checker['color-1'],
  'a70a230e-99e8-11ee-b9d1-0242ac120002': checker['color-2'],
  'a70a220a-99e8-11ee-b9d1-0242ac120002': checker['color-3'],
  'a70a20f2-99e8-11ee-b9d1-0242ac120002': checker['color-4'],
  'a70a1dfa-99e8-11ee-b9d1-0242ac120002': checker['color-5'],
  'a70a1bac-99e8-11ee-b9d1-0242ac120002': checker['color-6'],

  '5bfd37a4-99ff-11ee-b9d1-0242ac120002': waffle['color-1'],
  '5bfd38c6-99ff-11ee-b9d1-0242ac120002': waffle['color-2'],
  '5bfd39de-99ff-11ee-b9d1-0242ac120002': waffle['color-3'],
  'a2be56a6-9aa3-11ee-b9d1-0242ac120002': waffle['color-4'],

  'a2be5e08-9aa3-11ee-b9d1-0242ac120002': plainWeave['color-1'],
  'a2be5f3e-9aa3-11ee-b9d1-0242ac120002': plainWeave['color-2'],
  '0874ca76-9ac6-11ee-b9d1-0242ac120002': plainWeave['color-3'],
  '0874cd1e-9ac6-11ee-b9d1-0242ac120002': plainWeave['color-4'],
  '0874d1ce-9ac6-11ee-b9d1-0242ac120002': plainWeave['color-5'],
  '0874d304-9ac6-11ee-b9d1-0242ac120002': plainWeave['color-6'],
  'a2be59bc-9aa3-11ee-b9d1-0242ac120002': plainWeave['color-7'],

  'ff70ca03-ff13-47f4-b05c-af6abf506500': mosaikCustom['color-1'],
  'ff70ca03-ff13-47f4-b05c-af6abf506501': mosaikCustom['color-2'],
  'ff70ca03-ff13-47f4-b05c-af6abf506502': mosaikCustom['color-3'],
  'ff70ca03-ff13-47f4-b05c-af6abf506503': mosaikCustom['color-4'],
  'ff70ca03-ff13-47f4-b05c-af6abf506504': mosaikCustom['color-5'],
  'ff70ca03-ff13-47f4-b05c-af6abf506505': mosaikCustom['color-6'],
  'ff70ca03-ff13-47f4-b05c-af6abf506506': mosaikCustom['color-7'],
  'ff70ca03-ff13-47f4-b05c-af6abf506507': mosaikCustom['color-8'],
  'ff70ca03-ff13-47f4-b05c-af6abf506508': mosaikCustom['color-9'],
  'ff70ca03-ff13-47f4-b05c-af6abf506509': mosaikCustom['color-10'],
  'ff70ca03-ff13-47f4-b05c-af6abf506510': mosaikCustom['color-11'],
  'ff70ca03-ff13-47f4-b05c-af6abf506511': mosaikCustom['color-12'],
  'ff70ca03-ff13-47f4-b05c-af6abf506512': mosaikCustom['color-13'],
  'ff70ca03-ff13-47f4-b05c-af6abf506513': mosaikCustom['color-14'],
  'ff70ca03-ff13-47f4-b05c-af6abf506514': mosaikCustom['color-15'],
  'ff70ca03-ff13-47f4-b05c-af6abf506515': mosaikCustom['color-16'],
  'ff70ca03-ff13-47f4-b05c-af6abf506516': mosaikCustom['color-17'],
  'ff70ca03-ff13-47f4-b05c-af6abf506517': mosaikCustom['color-18'],
  'ff70ca03-ff13-47f4-b05c-af6abf506518': mosaikCustom['color-19'],
  'ff70ca03-ff13-47f4-b05c-af6abf506519': mosaikCustom['color-20'],
  'ff70ca03-ff13-47f4-b05c-af6abf506520': mosaikCustom['color-21'],
  'ff70ca03-ff13-47f4-b05c-af6abf506521': mosaikCustom['color-22'],
  'ff70ca03-ff13-47f4-b05c-af6abf506522': mosaikCustom['color-23'],
  'ff70ca03-ff13-47f4-b05c-af6abf506523': mosaikCustom['color-24'],
  'ff70ca03-ff13-47f4-b05c-af6abf506524': mosaikCustom['color-25'],
  'ff70ca03-ff13-47f4-b05c-af6abf506525': mosaikCustom['color-26'],
  'ff70ca03-ff13-47f4-b05c-af6abf506526': mosaikCustom['color-27'],
  'ff70ca03-ff13-47f4-b05c-af6abf506527': mosaikCustom['color-28'],
  'ff70ca03-ff13-47f4-b05c-af6abf506528': mosaikCustom['color-29'],
  'ff70ca03-ff13-47f4-b05c-af6abf506529': mosaikCustom['color-30'],
  'ff70ca03-ff13-47f4-b05c-af6abf506530': mosaikCustom['color-31'],
  'ff70ca03-ff13-47f4-b05c-af6abf506531': mosaikCustom['color-32'],
  'ff70ca03-ff13-47f4-b05c-af6abf506532': mosaikCustom['color-33'],
  'ff70ca03-ff13-47f4-b05c-af6abf506533': mosaikCustom['color-34'],
  'ff70ca03-ff13-47f4-b05c-af6abf506534': mosaikCustom['color-35'],
  'ff70ca03-ff13-47f4-b05c-af6abf506535': mosaikCustom['color-36']
};

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

module.exports = {
  'db9ee9dv-4c99-4463-z8d0-4df1a56b3d49': {
    name: 'Tac-Tile',
    blocks: [
    // col1
    // B
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 0,
      y: 0,
      r: [0, 6, 6]
    },
    // C
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 24,
      y: 0,
      r: [0, 6, 6]
    },
    // C*
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 0,
      y: 0,
      r: [180, 24, 3]
    },
    // B
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 48,
      y: 0,
      r: [0, 6, 6]
    },

    // col2

    // E
    {
      id: 'e0b7ad2c-dd75-421f-zb29-9dde30a2157d',
      x: 0,
      y: 6,
      r: [0, 6, 6]
    },
    // F
    {
      id: 'e0b7ad2c-dd75-421f-zc29-9dde30a2157d',
      x: 0,
      y: 12,
      r: [0, 6, 6]
    },
    // A
    {
      id: 'e0b7ad2c-dd75-421f-zv19-9dde30a2157d',
      x: 12,
      y: 6,
      r: [0, 6, 6]
    },
    // C*
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 0,
      y: 9,
      r: [180, 30, 0]
    },
    // B
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 36,
      y: 9,
      r: [0, 6, 6]
    },
    // D
    {
      id: 'e0b7ad2c-dd75-421f-zv29-9dde30a2157d',
      x: 60,
      y: 6,
      r: [0, 6, 6]
    },

    // col3
    // B*
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 12,
      y: 9,
      r: [180, 6, 6]
    },
    // B
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 24,
      y: 15,
      r: [0, 6, 6]
    },
    // C*
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 60,
      y: 9,
      r: [180, 6, 6]
    },
    // C
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 48,
      y: 15,
      r: [0, 6, 6]
    },

    // col4
    // D
    {
      id: 'e0b7ad2c-dd75-421f-zv29-9dde30a2157d',
      x: 0,
      y: 21,
      r: [0, 6, 6]
    },
    // C
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 12,
      y: 21,
      r: [0, 6, 6]
    },
    // B*
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 0,
      y: 30,
      r: [180, 18, 0]
    },
    // B
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 36,
      y: 21,
      r: [0, 6, 6]
    },
    // C*
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 0,
      y: 30,
      r: [180, 30, 0]
    },
    // F
    {
      id: 'e0b7ad2c-dd75-421f-zc29-9dde30a2157d',
      x: 60,
      y: 21,
      r: [0, 6, 6]
    },
    // E
    {
      id: 'e0b7ad2c-dd75-421f-zb29-9dde30a2157d',
      x: 60,
      y: 24,
      r: [0, 6, 6]
    },

    // col5
    // B*
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 12,
      y: 24,
      r: [180, 6, 6]
    },
    // B*
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 36,
      y: 24,
      r: [180, 6, 6]
    },
    // C*
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 60,
      y: 21,
      r: [180, 6, 6]
    },
    // C
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 48,
      y: 33,
      r: [0, 6, 6]
    },

    // col6
    // F
    {
      id: 'e0b7ad2c-dd75-421f-zc29-9dde30a2157d',
      x: 0,
      y: 36,
      r: [0, 6, 6]
    },
    // E
    {
      id: 'e0b7ad2c-dd75-421f-zb29-9dde30a2157d',
      x: 0,
      y: 39,
      r: [0, 6, 6]
    },
    // A*
    {
      id: 'e0b7ad2c-dd75-421f-zv19-9dde30a2157d',
      x: 24,
      y: 33,
      r: [180, 6, 6]
    },
    // C
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 36,
      y: 36,
      r: [0, 6, 6]
    },
    // B*
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 48,
      y: 33,
      r: [180, 6, 6]
    },
    // D
    {
      id: 'e0b7ad2c-dd75-421f-zv29-9dde30a2157d',
      x: 60,
      y: 36,
      r: [0, 6, 6]
    },

    // col7
    // B*
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 12,
      y: 39,
      r: [180, 6, 6]
    },
    // C*
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 36,
      y: 36,
      r: [180, 6, 6]
    },
    // C
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 24,
      y: 48,
      r: [0, 6, 6]
    },
    // B
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 48,
      y: 45,
      r: [0, 6, 6]
    },

    // col8
    // D
    {
      id: 'e0b7ad2c-dd75-421f-zv29-9dde30a2157d',
      x: 0,
      y: 51,
      r: [0, 6, 6]
    },
    // C*
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 24,
      y: 42,
      r: [180, 6, 6]
    },
    // B
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 12,
      y: 54,
      r: [0, 6, 6]
    },
    // A
    {
      id: 'e0b7ad2c-dd75-421f-zv19-9dde30a2157d',
      x: 36,
      y: 51,
      r: [0, 6, 6]
    },
    // F
    {
      id: 'e0b7ad2c-dd75-421f-zc29-9dde30a2157d',
      x: 60,
      y: 51,
      r: [0, 6, 6]
    },
    // E
    {
      id: 'e0b7ad2c-dd75-421f-zb29-9dde30a2157d',
      x: 60,
      y: 54,
      r: [0, 6, 6]
    },

    // col9
    // B*
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 12,
      y: 54,
      r: [180, 6, 6]
    },
    // C
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 24,
      y: 60,
      r: [0, 6, 6]
    },
    // C*
    {
      id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
      x: 36,
      y: 54,
      r: [180, 6, 6]
    },
    // B*
    {
      id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
      x: 60,
      y: 54,
      r: [180, 6, 6]
    }],
    repeat: [[0, 66], [72, 0]],
    changeViewport: [1]
    //  origin: [0, 1],
    // align: [
    //   [12, -6, 0, 0]
    // ],

  },
  'db9ee9da-4c99-4463-a8d0-4df1a56b3d49': {
    name: 'Square-001',
    blocks: [{ id: '4e2bec82-17b4-426a-91a3-465110a9f053' }],
    repeat: [[12, 0], [0, 12]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '6a5207be-6f0f-4312-928e-75b4bb3993f9': {
    name: 'Square-002',
    blocks: [{ id: '4e2bec82-17b4-426a-91a3-465110a9f053' }],
    repeat: [[12, 0], [6, 12]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '3e6890ba-20ef-4634-9d67-f2d5c9e6573c': {
    name: 'Rectangle-001',
    blocks: [{ id: '43f6902a-d03c-4d36-af81-f38d2e2405c9' }],
    repeat: [[24, 0], [0, 8]],
    origin: [0.5, 0],
    align: [[24, -12, -24, 0]]
  },

  '85663125-89d4-4c2e-ac20-6b08d9c458c9': {
    name: 'Rectangle-002',
    blocks: [{ id: '43f6902a-d03c-4d36-af81-f38d2e2405c9' }],
    repeat: [[24, 0], [12, 8]],
    origin: [0.5, 0],
    align: [[24, -12, -24, 0]]
  },

  '797adb6d-e545-4cd3-9421-b5953580b70b': {
    name: 'Rectangle-003',
    blocks: [{ id: '347dca8d-682a-4782-8974-f86eb4f54265' }],
    repeat: [[12, 0], [0, 8]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '518c8c2f-f362-4e0c-81d7-c2e971f37838': {
    name: 'Rectangle-004',
    blocks: [{ id: '347dca8d-682a-4782-8974-f86eb4f54265' }],
    repeat: [[12, 0], [6, 8]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  'b82401a7-1657-4c1a-b998-dfdf5d35cc87': {
    name: 'Rectangle-008',
    blocks: [{
      id: '347dca8d-682a-4782-8974-f86eb4f54265',
      x: -2,
      y: 2,
      r: [90, 6, 4]
    }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 8, r: [90, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 8, r: [270, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 20, r: [90, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 20, r: [270, 6, 6] }, {
      id: '43f6902a-d03c-4d36-af81-f38d2e2405c9',
      x: 24,
      y: 8,
      r: [90, 12, 4]
    }, { id: '4e2bec82-17b4-426a-91a3-465110a9f053', x: 40 }, {
      id: '347dca8d-682a-4782-8974-f86eb4f54265',
      x: 50,
      y: 2,
      r: [90, 6, 4]
    }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 60 }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 60, r: [180, 6, 6] }, { id: '4e2bec82-17b4-426a-91a3-465110a9f053', y: 12 }, {
      id: '43f6902a-d03c-4d36-af81-f38d2e2405c9',
      x: 4,
      y: 20,
      r: [90, 12, 4]
    }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 20,
      y: 12,
      r: [90, 6, 6]
    }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 20,
      y: 12,
      r: [270, 6, 6]
    }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 40,
      y: 12,
      r: [90, 6, 6]
    }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 40,
      y: 12,
      r: [270, 6, 6]
    }, {
      id: '347dca8d-682a-4782-8974-f86eb4f54265',
      x: 50,
      y: 14,
      r: [90, 6, 4]
    }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 60,
      y: 12,
      r: [90, 6, 6]
    }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 60,
      y: 12,
      r: [270, 6, 6]
    }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', y: 24, r: [90, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', y: 24, r: [270, 6, 6] }, {
      id: '347dca8d-682a-4782-8974-f86eb4f54265',
      x: 18,
      y: 26,
      r: [90, 6, 4]
    }, {
      id: '347dca8d-682a-4782-8974-f86eb4f54265',
      x: 26,
      y: 26,
      r: [90, 6, 4]
    }, { id: '4e2bec82-17b4-426a-91a3-465110a9f053', x: 36, y: 24 }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 48,
      y: 24,
      r: [90, 6, 6]
    }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 48,
      y: 24,
      r: [270, 6, 6]
    }, { id: '4e2bec82-17b4-426a-91a3-465110a9f053', x: 60, y: 24 }, {
      id: '347dca8d-682a-4782-8974-f86eb4f54265',
      x: -2,
      y: 38,
      r: [90, 6, 4]
    }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 8, y: 36 }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 8,
      y: 36,
      r: [180, 6, 6]
    }, {
      id: '347dca8d-682a-4782-8974-f86eb4f54265',
      x: 18,
      y: 38,
      r: [90, 6, 4]
    }, {
      id: '347dca8d-682a-4782-8974-f86eb4f54265',
      x: 26,
      y: 38,
      r: [90, 6, 4]
    }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 36, y: 36 }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 36,
      y: 36,
      r: [180, 6, 6]
    }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 48,
      y: 36,
      r: [90, 6, 6]
    }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 48,
      y: 36,
      r: [270, 6, 6]
    }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 60, y: 36 }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 60,
      y: 36,
      r: [180, 6, 6]
    }],
    repeat: [[72, 0], [0, 48]],
    origin: [0.5, 0]
  },

  '1de33837-dcd9-4343-afa0-dd8bf784d526': {
    name: 'Triangle 60-001',
    blocks: [{ id: '840ad52b-d579-4233-ba31-ca81de9f34c6' }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 6.875,
      r: [180, 6.875, 6]
    }],
    repeat: [[13.75, 0], [0, 12]],
    origin: [0.5, 0]
  },

  'b77bce77-af3c-49a2-94b3-a3b667fa60df': {
    name: 'Triangle 60-002',
    blocks: [{ id: '840ad52b-d579-4233-ba31-ca81de9f34c6' }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 6.875,
      r: [180, 6.875, 6]
    }],
    repeat: [[13.75, 0], [6.875, 12]],
    origin: [0.5, 0]
  },

  '20cb340b-5ee8-41a0-b8a9-ab8c5f0c001a': {
    name: 'Triangle 90-001',
    blocks: [{ id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d' }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', r: [180, 6, 6] }],
    repeat: [[12, 0], [0, 12]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '0bf4f536-32d8-4fb1-a6f8-3e2a59ef90a8': {
    name: 'Triangle 90-002',
    blocks: [{ id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', r: [90, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', r: [270, 6, 6] }],
    repeat: [[12, 0], [0, 12]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '253b803f-93ce-4f6b-a58b-3d87c678a55b': {
    name: 'Triangle 90-003',
    blocks: [{ id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d' }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', r: [180, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 12, r: [90, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 12, r: [270, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', y: 12, r: [90, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', y: 12, r: [270, 6, 6] }, { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 12, y: 12 }, {
      id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
      x: 12,
      y: 12,
      r: [180, 6, 6]
    }],
    repeat: [[24, 0], [0, 24]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '96640d3b-311c-49c2-b06e-37d2b79d0d65': {
    name: 'Diamond-001',
    blocks: [{ id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba' }],
    repeat: [[13.75, 0], [6.875, 12]],
    origin: [0.5, 0],
    align: [[13.75, -6.875, -13.75, 0]]
  },

  'a78e4911-e6b1-4cc9-a9e8-e969671a1bd9': {
    name: 'Diamond-002',
    blocks: [{ id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba' }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', r: [59.9, 6.875, 0] }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', r: [-59.9, 6.875, 24] }],
    repeat: [[20.705, 12], [0, 24]],
    origin: [0.5, 0]
  },

  'deb17540-1c21-450e-adde-b09fc709b4b3': {
    name: 'Diamond-003',
    blocks: [{
      id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba',
      x: -6.875,
      y: -12,
      r: [90, 6.875, 12]
    }, {
      id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba',
      x: -12.875,
      y: -1.69,
      r: [149.9, 6.875, 12]
    }, {
      id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba',
      x: -0.875,
      y: -1.69,
      r: [-149.9, 6.875, 12]
    }],
    repeat: [[24, 0], [12, 20.7]],
    origin: [0.5, 0]
  },

  '7ada7f48-254f-4fae-af61-6739bc3dccf6': {
    name: 'Diamond-004',
    blocks: [
    // row 1
    {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 6.875,
      r: [180, 6.875, 6]
    }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 20.625,
      r: [180, 6.875, 6]
    }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 34.375,
      r: [180, 6.875, 6]
    }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 48.125,
      r: [180, 6.875, 6]
    }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 61.875,
      r: [180, 6.875, 6]
    }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 75.625,
      r: [180, 6.875, 6]
    }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 89.375,
      r: [180, 6.875, 6]
    }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 103.125,
      r: [180, 6.875, 6]
    }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 116.875,
      r: [180, 6.875, 6]
    },

    // row 2
    { id: '840ad52b-d579-4233-ba31-ca81de9f34c6' }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', y: 12, r: [180, 6.875, 6] }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 13.75 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 27.5 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 27.5,
      y: 12,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 41.25 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 41.25,
      y: 12,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 55 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 55,
      y: 12,
      r: [180, 6.875, 6]
    }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 68.75 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 82.5 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 82.5,
      y: 12,
      r: [180, 6.875, 6]
    }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 96.25 }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 110 },

    // row 3
    { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 6.875, y: 12 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 6.875,
      y: 24,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 20.625, y: 12 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 20.625,
      y: 24,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 34.375, y: 12 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 34.375,
      y: 24,
      r: [180, 6.875, 6]
    }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 48.125, y: 12 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 61.875, y: 12 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 61.875,
      y: 24,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 75.625, y: 12 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 75.625,
      y: 24,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 89.375, y: 12 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 89.375,
      y: 24,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 103.125, y: 12 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 103.125,
      y: 24,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 116.875, y: 12 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 116.875,
      y: 24,
      r: [180, 6.875, 6]
    },

    // row 4
    { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', y: 24 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 13.75, y: 24 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 13.75,
      y: 36,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 27.5, y: 24 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 27.5,
      y: 36,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 41.25, y: 24 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 41.25,
      y: 36,
      r: [180, 6.875, 6]
    }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 55, y: 24 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 68.75, y: 24 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 68.75,
      y: 36,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 82.5, y: 24 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 82.5,
      y: 36,
      r: [180, 6.875, 6]
    }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 96.25, y: 24 }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 110, y: 24 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 110, y: 24 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 110,
      y: 36,
      r: [180, 6.875, 6]
    },

    // row 5
    { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 6.875, y: 36 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 6.875,
      y: 48,
      r: [180, 6.875, 6]
    }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 20.625, y: 36 }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 34.375, y: 36 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 48.125, y: 36 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 48.125,
      y: 48,
      r: [180, 6.875, 6]
    }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 61.875, y: 36 }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 75.625, y: 36 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 89.375, y: 36 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 89.375,
      y: 48,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 103.125, y: 36 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 103.125,
      y: 48,
      r: [180, 6.875, 6]
    }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 116.875, y: 36 },

    // row 6
    { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', y: 48 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', y: 60, r: [180, 6.875, 6] }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 13.75, y: 48 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 27.5, y: 48 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 27.5,
      y: 60,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 41.25, y: 48 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 41.25,
      y: 60,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 55, y: 48 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 55,
      y: 60,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 68.75, y: 48 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 68.75,
      y: 60,
      r: [180, 6.875, 6]
    }, { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 82.5, y: 48 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 96.25, y: 48 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 96.25,
      y: 60,
      r: [180, 6.875, 6]
    }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 110, y: 48 }, {
      id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
      x: 110,
      y: 60,
      r: [180, 6.875, 6]
    },

    // row 7
    { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 6.875, y: 60 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 20.625, y: 60 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 34.375, y: 60 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 48.125, y: 60 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 61.875, y: 60 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 75.625, y: 60 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 89.375, y: 60 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 103.125, y: 60 }, { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 116.875, y: 60 }],
    repeat: [[123.75, 0], [0, 72]],
    origin: [0.5, 0]
  },

  '844a3bc5-f148-41c7-a0c0-6dc3cc8523f7': {
    name: 'Hex-001',
    blocks: [{ id: 'c8ff74cd-20a5-46c3-856c-325a910bdb27' }],
    repeat: [[10.375, 6], [0, 12]],
    origin: [0.5, 0]
  },

  'c66207c3-850a-4e68-864e-d0b766f92235': {
    name: 'ARO 1-001',
    dimensions: { i: 'W 1\'-0 3/4" x H 11"', m: 'W 32 cm x H 28 cm' },
    blocks: [{ id: '6fa2d74f-655b-414b-b282-422b21e544b2' }, {
      id: '6fa2d74f-655b-414b-b282-422b21e544b2',
      x: 6.9785,
      r: [180, 6.9785, 6.045]
    }],
    repeat: [[13.957, 0], [6.9785, 12.09]],
    origin: [0.5, 0]
  },

  'e6d8fc9e-91c3-43bb-9151-9c3cbbd5b7f5': {
    name: 'ARO 2-001',
    dimensions: { i: 'W 10 3/4\u201D x H 9 1/4\u201D', m: 'W 27.4 cm x H 23.7 cm' },
    blocks: [{ id: 'e8a69811-3dfb-4db2-b9c5-e7f22891ee9b' }, {
      id: 'e8a69811-3dfb-4db2-b9c5-e7f22891ee9b',
      x: 6.86295,
      r: [180, 6.86295, 5.941355]
    }],
    repeat: [[13.7259, 0], [6.9785, 11.88271]],
    origin: [0.5, 0],
    preview: {
      width: 70.5,
      height: 47
    }
  },

  '8a2e7abe-f73b-496a-a55c-795a6939d025': {
    name: 'ARO 3-001',
    dimensions: { i: 'W 1\u2019-6\u201D 3/4\u201D x H 8\u201D', m: 'W 45.7 cm x H 20.3 cm' },
    blocks: [{ id: '700039ec-4130-4d93-9212-39c57640f8df', y: -4.5 }],
    repeat: [[16.75, 0], [8.25, 7]],
    origin: [0.5, 0]
  },

  '18f8377e-4196-477c-9ae6-95639f53bf54': {
    name: 'ARO 4-001',
    dimensions: { i: 'W 1\u2019-9 3/4\u201D x H 7 3/4\u201D', m: 'W 55.2 cm x H 19.7 cm' },
    blocks: [{ id: '0da46e9a-8c97-4977-9712-57870c8f1f94' }],
    repeat: [[20.25, 0], [-1.5, 7.75]],
    origin: [0.5, 0],
    preview: {
      width: 69,
      height: 46
    }
  },

  '6057b2f8-fed0-4a0f-b379-cbc80d05ff85': {
    name: 'ARO 4-002',
    dimensions: { i: 'W 1\u2019-4\u201D x H 7 3/4\u201D', m: 'W 40.4 cm x H 19.7 cm' },
    blocks: [{ id: '982a1c91-0a01-4630-b8fd-886b29fabb21' }],
    repeat: [[14.5, 0], [-1.5, 7.75]],
    origin: [0.5, 0],
    preview: {
      width: 69,
      height: 46
    }
  },

  '6dba90ab-3c65-4f8d-8c1a-ff384af4d265': {
    name: 'ARO 4-003',
    blocks: [{ id: '982a1c91-0a01-4630-b8fd-886b29fabb21' }, { id: '0da46e9a-8c97-4977-9712-57870c8f1f94', x: 14.5 }, { id: '0da46e9a-8c97-4977-9712-57870c8f1f94', x: -1.5, y: 7.75 }, { id: '982a1c91-0a01-4630-b8fd-886b29fabb21', x: 18.75, y: 7.75 }],
    repeat: [[34.75, 0], [-3, 15.5]],
    origin: [0.5, 0],
    preview: {
      width: 69,
      height: 46
    }
  },

  '6ebdd50f-4760-4a5d-a746-4da9d1147d18': {
    name: 'Bottle-001',
    blocks: [{ id: '679b38fa-ad4d-4382-b53c-80ab3ba70c0d' }, {
      id: '679b38fa-ad4d-4382-b53c-80ab3ba70c0d',
      x: 1.42,
      y: 1.42,
      r: [90, 0, 0]
    }],
    repeat: [[9.2 * 2, 0], [9.2, 9.2]],
    origin: [0.5, 0],
    align: [[9.2, -4.6, -4.6, 0]]
  },

  'da8a8310-7e8b-4875-b172-d8f6c0e1515c': {
    name: 'Fish-001',
    blocks: [{ id: '6e1bccce-613a-43ce-9d87-7324b33b6cfa' }],
    origin: [0.5, 0],
    repeat: [[10.82, 0], [5.385, 4.254]],
    align: [[12, -1.18, -1.18, 0]]
  },

  '776b4083-b29f-49b6-bfaf-0ac81f21ea4a': {
    name: 'Fish-002',
    blocks: [{ id: '6e1bccce-613a-43ce-9d87-7324b33b6cfa', r: [-90, 0, 0], y: 12 }],
    origin: [0.5, 0],
    repeat: [[4.254, 5.385], [0, 10.82]],
    align: [[6.427, -6.427 / 2, -6.427 / 2, 0]]
  },

  'd090aed0-4eec-445f-b7d0-d242ff84e5e4': {
    name: 'Fish-003',
    blocks: [{
      id: '6e1bccce-613a-43ce-9d87-7324b33b6cfa',
      r: [-180, 0, 0],
      x: 12,
      y: 6.427
    }],
    origin: [0.5, 0],
    repeat: [[10.82, 0], [5.385, 4.254]],
    align: [[12, -1.18, -1.18, 0]]
  },

  'f37c6ad0-6b61-4197-bba6-49a001f7fe1f': {
    name: 'Fish-004',
    blocks: [{ id: '6e1bccce-613a-43ce-9d87-7324b33b6cfa', r: [90, 0, 0], x: 6.427 }],
    origin: [0.5, 0],
    repeat: [[4.254, 5.385], [0, 10.82]],
    align: [[6.427, -6.427 / 2, -6.427 / 2, 0]]
  },

  'fb68821e-a705-49da-82a7-4821a27f4bcc': {
    name: 'Goblet-001',
    blocks: [{ id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9' }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: 5.625 + 3.612,
      y: 12
    }],
    origin: [0.5, 0],
    repeat: [[5.625 + 3.612 - 2.25, 0], [0, 12]],
    align: [[5.625 + 3.612, -(5.625 + 3.612) / 2, -(5.625 + 3.612) / 2, 0]]
  },

  'ba95ba12-eb89-45cc-a81a-c0b16ce466b2': {
    name: 'Goblet-002',
    blocks: [{ id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9' }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: 5.625 + 3.612,
      y: 12
    }],
    origin: [0.5, 0],
    repeat: [[5.625 + 3.612 - 2.25, 0], [3.54, 12]],
    align: [[5.625 + 3.612, -(5.625 + 3.612) / 2, -(5.625 + 3.612) / 2, 0]]
  },

  '8e9bdb36-b588-462d-aecd-d1f6769cba64': {
    name: 'Goblet-003',
    blocks: [{ id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9' }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: 5.625 + 3.612,
      y: 12
    },
    // second row
    { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: -3.54 + 0.75, y: 12 }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: -3.54 + 0.75 + 5.625 + 3.612,
      y: 24
    }],
    origin: [0.5, 0],
    repeat: [[5.625 + 3.612 - 2.25, 0], [0, 24]],
    align: [[5.625 + 3.612, -(5.625 + 3.612) / 2, -(5.625 + 3.612) / 2, 0]]
  },

  '89824802-8bc2-4081-ae5c-c23c35513078': {
    name: 'Goblet-004',
    blocks: [{
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [90, 0, 0],
      x: 12,
      y: -5.625 / 2
    }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [-90, 0, 0],
      y: 5.625 / 2 + 3.612
    }],
    origin: [0.5, 0],
    repeat: [[12, 0], [0, 5.625 + 3.612 - 2.25]],
    align: [[12, -6, -12, 0]]
  },

  'bca9a8ac-2f63-4a89-8754-cd8238b8a3e2': {
    name: 'Goblet-005',
    origin: [0.5, 0],
    blocks: [{
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: 5.685,
      y: 12
    }, { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 3.575, y: 0 }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: 12.935,
      y: 12
    }, { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 10.825, y: 0 }, {
      id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
      r: [180, 0, 0],
      x: 22.375,
      y: 12
    }, { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: 20.375, y: 0 }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: 31.935,
      y: 12
    }, { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 29.825, y: 0 }, {
      id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
      r: [180, 0, 0],
      x: 41.375,
      y: 12
    }, { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: 39.375, y: 0 }, { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: 0, y: 12 }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: 11.56,
      y: 24
    }, { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 9.45, y: 12 }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: 18.81,
      y: 24
    }, { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 16.7, y: 12 }, {
      id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
      r: [180, 0, 0],
      x: 28.25,
      y: 24
    }, { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: 26.25, y: 12 }, {
      id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
      r: [180, 0, 0],
      x: 37.81,
      y: 24
    }, { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 35.7, y: 12 }, {
      id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
      r: [180, 0, 0],
      x: 47.25,
      y: 24
    }],
    repeat: [[45.25, 0], [0, 24]],
    align: [[1, -1, -1, 0]]
  },

  'e75bce1f-439c-4a74-8bb9-f22a49997f9d': {
    name: 'Hourglass-001',
    blocks: [{ id: '036da44e-0a01-4c91-a15d-2e25a63e916c', x: -6, y: -6 }],
    origin: [0.5, 0],
    repeat: [[7.435, 6], [0, 12]]
  },

  '7b151173-0151-4366-bd68-fcc61977fda7': {
    name: 'Hourglass-002',
    blocks: [{
      id: '036da44e-0a01-4c91-a15d-2e25a63e916c',
      r: [-90, 0, 0],
      x: -6,
      y: 6
    }],
    origin: [0.5, 0],
    repeat: [[12, 0], [6, 7.435]]
  },

  'a862e78a-ba55-4943-96a7-6bf6b8d76e1e': {
    name: 'Spindle-001',
    blocks: [{ id: 'deea6070-c7cd-4509-8467-5292853e611b', x: -3.5, y: -6 }],
    origin: [0.5, 0],
    repeat: [[4.1, 6], [0, 12]]
  },

  '0d4450cd-f869-43ae-a8ff-cbda10040b81': {
    name: 'Spindle-002',
    blocks: [{
      id: 'deea6070-c7cd-4509-8467-5292853e611b',
      r: [-90, 0, 0],
      x: -6,
      y: 3.5
    }],
    origin: [0.5, 0],
    repeat: [[12, 0], [6, 4.1]]
  },

  '30c72f7c-7680-4560-8223-fad2965d0e5a': {
    name: 'Vase-001',
    blocks: [{ id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: -1.02 }, {
      id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
      r: [180, 0, 0],
      x: 1.02,
      y: 12
    }],
    origin: [0.5, 0],
    repeat: [[11.6, 0], [0, 12]]
  },

  'd1df5ebe-ab3d-4912-b124-e60f65f719b9': {
    name: 'Vase-002',
    blocks: [{ id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: -1.02 }, {
      id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
      r: [180, 0, 0],
      x: 1.02,
      y: 12
    }],
    origin: [0.5, 0],
    repeat: [[11.6, 0], [5.8, 12]]
  },

  '96cc0040-b9a0-4c84-ae3c-4f519791a0e6': {
    name: 'Vase-003',
    blocks: [{ id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: -1.02 }, {
      id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
      r: [180, 0, 0],
      x: 1.02,
      y: 12
    },
    // second row
    {
      id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
      x: 5.8 - 1.02 - 1.8,
      y: 12
    }, {
      id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
      r: [180, 0, 0],
      x: 5.8 + 1.02 - 1.8,
      y: 24
    }],
    origin: [0.5, 0],
    repeat: [[11.6, 0], [0, 24]]
  },

  '403560ac-4a5a-4219-b7cf-01e0114d4eae': {
    name: 'Chevron-001',
    blocks: [{ id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d' }, { id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b', x: 12 }],
    origin: [0.5, 0],
    repeat: [[24, 0], [0, 6]],
    align: [[24, -12, 0, 0]]
  },

  'cd3f3c70-eb93-4c9a-bf78-4f1f530204ee': {
    name: 'Chevron-002',
    blocks: [{ id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b' }, { id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d', x: 12 }],
    origin: [0.5, 0],
    repeat: [[24, 0], [0, 6]],
    align: [[24, -12, 0, 0]]
  },

  '715d6e16-20e7-4b97-8a69-c0227e922751': {
    name: 'Chevron-003',
    blocks: [{ id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b', r: [90, 12, 0], y: 12 }, {
      id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d',
      r: [90, 0, 0],
      x: 12,
      y: 12
    }],
    origin: [0.5, 0],
    repeat: [[6, 0], [0, 24]],
    align: [[1, -6, -6, 0]]
  },

  'f3cdd2a4-da8a-447e-9687-dad9ec6b7809': {
    name: 'Chevron-004',
    blocks: [{ id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d', r: [90, 12, 0], y: 12 }, {
      id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b',
      r: [90, 0, 0],
      x: 12,
      y: 12
    }],
    origin: [0.5, 0],
    repeat: [[6, 0], [0, 24]],
    align: [[1, -6, -6, 0]]
  },

  '8e7f6f31-43ce-4713-a65d-24e98b5b3d9a': {
    name: 'Chevron-005',
    blocks: [{ id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b' }],
    origin: [0.5, 0],
    repeat: [[12, 0], [0, 6]],
    align: [[12, -6, 0, 0]]
  },

  'b6ee4df2-57bc-4499-9bcb-8c885e53efb1': {
    name: 'Chevron-006',
    blocks: [{ id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d' }],
    origin: [0.5, 0],
    repeat: [[12, 0], [0, 6]],
    align: [[12, -6, 0, 0]]
  },

  '2130a6b2-2284-4100-bd3b-8ec9f34627a2': {
    name: 'Chevron-007',
    blocks: [{ id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d', r: [90, 0, 0], x: 12 }],
    origin: [0.5, 0],
    repeat: [[6, 0], [0, 12]],
    align: [[1, -6, -6, 0]]
  },

  '61870097-d969-4970-9892-17744dbd74b7': {
    name: 'Chevron-008',
    blocks: [{ id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b', r: [90, 0, 0], x: 12 }],
    origin: [0.5, 0],
    repeat: [[6, 0], [0, 12]],
    align: [[1, -6, -6, 0]]
  },

  'b05cd8de-8e0a-4a93-b497-cd576c58fb21': {
    name: 'Dart-001',
    blocks: [{ id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d' }],
    origin: [0.5, 0],
    repeat: [[10, 0], [0, 10]],
    align: [[10, -5, 0, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  'bb1c7900-cc21-40bb-8933-1c5bac5246f2': {
    name: 'Dart-002',
    blocks: [{
      id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
      r: [180, 0, 0],
      x: 10,
      y: 15
    }],
    origin: [0.5, 0],
    repeat: [[10, 0], [0, 10]],
    align: [[10, -5, 0, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  '312d2987-67b5-419b-81a4-42d087aad947': {
    name: 'Dart-003',
    blocks: [{ id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d', r: [90, 0, 0], x: 12.5 }],
    origin: [0.5, 0],
    repeat: [[10, 0], [0, 10]],
    preview: {
      width: 75,
      height: 50
    }
  },

  '9430fb63-4bac-41d2-afc0-faedbc9f4ec4': {
    name: 'Dart-004',
    blocks: [{
      id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
      r: [-90, 0, 0],
      x: -12.5,
      y: 10
    }],
    origin: [0.5, 0],
    repeat: [[10, 0], [0, 10]],
    preview: {
      width: 75,
      height: 50
    }
  },

  'a23001a8-128f-49ea-bdcd-25fc2b7317cd': {
    name: 'Dart-005',
    blocks: [{ id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d' }, {
      id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
      r: [180, 0, 0],
      x: 20,
      y: 15
    }],
    origin: [0.5, 0],
    repeat: [[20, 0], [0, 10]],
    align: [[20, -10, 0, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  'fd3cd5cc-ed24-4aa7-9a9e-2a82248b5747': {
    name: 'Dart-006',
    blocks: [{ id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d' }, {
      id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
      r: [180, 0, 0],
      x: 20,
      y: 15
    }, {
      id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
      r: [180, 0, 0],
      x: 30,
      y: 15
    }],
    origin: [0.5, 0],
    repeat: [[30, 0], [0, 10]],
    align: [[20, -10, 0, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  'ddd07a1e-8116-42b5-bd9e-79fd7853726f': {
    name: 'Dart-007',
    blocks: [{ id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d', r: [-45, 5, 0], x: -5 }],
    origin: [0.5, 0],
    repeat: [[Math.sqrt(50), Math.sqrt(50)], [-Math.sqrt(50), Math.sqrt(50)]],
    preview: {
      width: 78,
      height: 52
    }
  },

  '97abd38a-eb6c-491d-86f7-c4bd66a851b4': {
    name: 'Dart-008',
    blocks: [{ id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d', r: [45, 5, 0], x: -5 }],
    origin: [0.5, 0],
    repeat: [[Math.sqrt(50), Math.sqrt(50)], [-Math.sqrt(50), Math.sqrt(50)]],
    preview: {
      width: 78,
      height: 52
    }
  },

  '5649feec-e25b-4a8f-a515-8a62b580c6aa': {
    name: 'Picket-001',
    blocks: [{ id: '854ce8f3-c736-4998-9b35-8d874c0bd420' }],
    origin: [0.5, 0],
    repeat: [[5.8564, 0], [2.9282, 10.9282]],
    preview: {
      width: 75,
      height: 50
    }
  },

  '7e01dd9f-bd6c-4216-aff0-db7c442c6d74': {
    name: 'Picket-002',
    blocks: [{ id: '854ce8f3-c736-4998-9b35-8d874c0bd420', r: [90, 0, 0], x: 8 }],
    origin: [0.5, 0],
    repeat: [[10.9282, 2.9282], [0, 5.8564]]
  },

  'f88cac62-245c-47c0-b1e0-45af730fe08a': {
    name: 'Picket-003',
    blocks: [{ id: '854ce8f3-c736-4998-9b35-8d874c0bd420', r: [15, 2.9282, 0] }, {
      id: '854ce8f3-c736-4998-9b35-8d874c0bd420',
      r: [-15, 2.9282, 0],
      x: 1.53,
      y: 5.58
    }],
    origin: [0.5, 0],
    repeat: [[11.37, 0], [0, 11.2]],
    align: [[1, -3.75, -3.75, 0]]
  },

  '40ad5a09-92c6-4324-84d0-c037f8ccdd29': {
    name: 'Picket-004',
    blocks: [{ id: '854ce8f3-c736-4998-9b35-8d874c0bd420', r: [255, 2.9282, 0] }, {
      id: '854ce8f3-c736-4998-9b35-8d874c0bd420',
      r: [-255, 2.9282, 0],
      x: 9.76,
      y: 5.64
    }],
    origin: [0.5, 0],
    repeat: [[11.37, 0], [0, 11.2]],
    align: [[1, -3.75, -3.75, 0], [1, 2.4, 2.4, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  '0fe9c5b8-db53-473c-b1f9-3e65351c4198': {
    name: 'Plus-001',
    blocks: [{ id: 'c85a3088-adef-4e09-87a4-ad827ce8ea61', x: -10 }],
    origin: [0.5, 0],
    repeat: [[8, -4], [4, 8]]
  },

  '6938f1f4-f01f-4fa1-9f95-7baaa5f068aa': {
    name: 'Plus-002',
    blocks: [{ id: 'c85a3088-adef-4e09-87a4-ad827ce8ea61', x: -2 }],
    origin: [0.5, 0],
    repeat: [[8, 4], [-4, 8]]
  },

  'f63506bd-8e58-4e57-856c-02713cd7b319': {
    name: 'Plus-003',
    blocks: [{ id: 'c85a3088-adef-4e09-87a4-ad827ce8ea61', r: [45, 4, 0], x: -4 }],
    origin: [0.5, 0],
    repeat: [[1.5 * Math.sqrt(32), -16 / Math.sqrt(32)], [16 / Math.sqrt(32), 1.5 * Math.sqrt(32)]]
  },

  '3f92d800-eac3-4761-ad57-113513a77659': {
    name: 'Plus-004',
    blocks: [{ id: 'c85a3088-adef-4e09-87a4-ad827ce8ea61', r: [45, 4, 0], x: 2 }],
    origin: [0.5, 0],
    repeat: [[1.5 * Math.sqrt(32), 16 / Math.sqrt(32)], [-16 / Math.sqrt(32), 1.5 * Math.sqrt(32)]]
  },

  'be3ee6b5-32fc-43ca-aa1d-d9a6919cfc70': {
    name: 'Scale Small',
    dimensions: {
      i: 'W 5 1/2\u201D x H 5 11/16\u201D',
      m: 'W 14 cm x H 14.5 cm',
      w: 14,
      h: 14.5
    },
    fullBlocksOnly: true,
    blocks: [{ id: '717fae39-bca4-4637-8e18-b203024ff3f2' }, { id: '717fae39-bca4-4637-8e18-b203024ff3f2', x: 2.875, y: 3.3125 }],
    origin: [0.5, 0.5],
    repeat: [[5.75, 0], [0, 6.625]]
  },

  'ce3a0a56-e73f-4f8c-bc6c-3c98453ce58f': {
    name: 'Scale Large',
    dimensions: {
      i: 'W 11 1/8\u201D x H 11 7/16\u201D',
      m: 'W 28.3 cm x H 29 cm',
      w: 28.3,
      h: 29
    },
    fullBlocksOnly: true,
    blocks: [{ id: 'c52c3cb4-390b-4cac-9ff3-f601c7439369' }, { id: 'c52c3cb4-390b-4cac-9ff3-f601c7439369', x: 5.75, y: 6.5 }],
    origin: [0.5, 0.5],
    repeat: [[11.4375, 0], [0, 13]]
  },

  'd45ca39c-774f-11ee-b962-0242ac120002': {
    name: 'Twill',
    // blocks: [{ id: '44ff1abc-7750-11ee-b962-0242ac120002'}, ],
    dimensions: {
      i: 'W 12" x H 12"',
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5
    },
    blocks: [{ id: '1342419c-78c8-11ee-b962-0242ac120002' }, { id: '7657f05e-78c5-11ee-b962-0242ac120002' }, { id: 'b8701284-7751-11ee-b962-0242ac120002', x: 2 }, { id: '44ff1abc-7750-11ee-b962-0242ac120002' }],
    origin: [0, 0],
    repeat: [[24, 0], [0, 24]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true
  },
  'fe8f7952-99d5-11ee-b9d1-0242ac120002': {
    name: 'Gingham',
    dimensions: {
      i: 'W 12" x H 12"',
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5
    },
    blocks: [{ id: 'fe8f7de4-99d5-11ee-b9d1-0242ac120002' }, { id: 'fe8f7f38-99d5-11ee-b9d1-0242ac120002' }, { id: 'fe8f8258-99d5-11ee-b9d1-0242ac120002' }],
    origin: [0, 0],
    repeat: [[12, 0], [0, 12]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true
  },
  'fe8f8384-99d5-11ee-b9d1-0242ac120002': {
    name: 'Checker',
    dimensions: {
      i: 'W 12" x H 12"',
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5
    },
    blocks: [{ id: '5bfd32ea-99ff-11ee-b9d1-0242ac120002' }, { id: 'a70a230e-99e8-11ee-b9d1-0242ac120002' }, { id: 'a70a220a-99e8-11ee-b9d1-0242ac120002' }, { id: 'a70a20f2-99e8-11ee-b9d1-0242ac120002' }, { id: 'a70a1dfa-99e8-11ee-b9d1-0242ac120002' }, { id: 'a70a1bac-99e8-11ee-b9d1-0242ac120002' }],
    origin: [0, 0],
    repeat: [[12, 0], [0, 96]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    wallHeight: 108,
    calcTileCountWithDimensions: true,
    showColorsByName: true,
    patternRepeatHeight: 108
  },
  '5bfd3664-99ff-11ee-b9d1-0242ac120002': {
    name: 'Waffle',
    dimensions: {
      i: 'W 12" x H 12"',
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5
    },
    blocks: [{ id: '5bfd37a4-99ff-11ee-b9d1-0242ac120002' }, { id: '5bfd38c6-99ff-11ee-b9d1-0242ac120002' }, { id: '5bfd39de-99ff-11ee-b9d1-0242ac120002' }, { id: 'a2be56a6-9aa3-11ee-b9d1-0242ac120002' }],
    origin: [0, 0],
    repeat: [[24, 0], [0, 24]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true
  },
  'a2be58a4-9aa3-11ee-b9d1-0242ac120002': {
    name: 'Weave',
    dimensions: {
      i: 'W 12" x H 12"',
      m: 'W 91.5 cm x H 91.5 cm',
      w: 91.5,
      h: 91.5
    },
    blocks: [{ id: 'a2be5e08-9aa3-11ee-b9d1-0242ac120002' }, { id: 'a2be5f3e-9aa3-11ee-b9d1-0242ac120002' }, { id: '0874ca76-9ac6-11ee-b9d1-0242ac120002' }, { id: '0874cd1e-9ac6-11ee-b9d1-0242ac120002' }, { id: '0874d1ce-9ac6-11ee-b9d1-0242ac120002' }, { id: '0874d304-9ac6-11ee-b9d1-0242ac120002' }, { id: 'a2be59bc-9aa3-11ee-b9d1-0242ac120002' }],
    origin: [0, 0],
    repeat: [[36, 0], [0, 36]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true
  },
  'a72e6515-aa20-42db-b4fc-20a76e9d1d6e': {
    name: 'Mosaik',
    dimensions: {
      i: 'W 12" x H 12"',
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5
    },
    blocks: [{ id: 'ff70ca03-ff13-47f4-b05c-af6abf506500' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506501' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506502' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506503' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506504' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506505' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506506' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506507' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506508' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506509' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506510' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506511' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506512' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506513' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506514' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506515' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506516' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506517' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506518' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506519' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506520' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506521' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506522' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506523' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506524' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506525' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506526' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506527' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506528' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506529' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506530' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506531' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506532' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506533' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506534' }, { id: 'ff70ca03-ff13-47f4-b05c-af6abf506535' }],
    origin: [0, 0],
    repeat: [[12, 0], [0, 12]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true,
    customHelpNote: 'Mosaik\'s design tool is set up for repeating 12" square tiles (six 2" tiles wide and high). Start building a pattern in the upper right-hand corner and the pattern will repeat automatically.'
  }
};

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_number_epsilon__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__universal_filzfelt_blocks__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__universal_filzfelt_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__universal_filzfelt_blocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__universal_filzfelt_patterns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__universal_filzfelt_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__universal_filzfelt_patterns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__universal_spinneybeck_blocks__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__universal_spinneybeck_blocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__universal_spinneybeck_blocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__universal_spinneybeck_patterns__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__universal_spinneybeck_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__universal_spinneybeck_patterns__);






var _marked = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.mark(lines);






/* harmony default export */ __webpack_exports__["a"] = (function (id, width, height, old) {
  var pattern = __WEBPACK_IMPORTED_MODULE_6__universal_filzfelt_patterns___default.a[id] || __WEBPACK_IMPORTED_MODULE_8__universal_spinneybeck_patterns___default.a[id];

  var ox = 0;
  var oy = 0;
  if ('origin' in pattern) {
    ox = pattern.origin[0] * width;
    oy = pattern.origin[1] * height;
  }
  if ('align' in pattern) {
    if (pattern.align[0]) ox += alignment(pattern.align[0], width);
    if (pattern.align[1]) oy += alignment(pattern.align[1], height);
  }
  if ('changeViewport' in pattern) {
    oy += height - 66;
  }

  var _pattern$repeat = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(pattern.repeat, 2),
      _pattern$repeat$ = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_pattern$repeat[0], 2),
      ix = _pattern$repeat$[0],
      iy = _pattern$repeat$[1],
      _pattern$repeat$2 = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_pattern$repeat[1], 2),
      jx = _pattern$repeat$2[0],
      jy = _pattern$repeat$2[1];

  var result = {};
  var queue = new __WEBPACK_IMPORTED_MODULE_3__home_stagingdt_public_html_node_modules_babel_runtime_core_js_set___default.a();
  queue.add('0,0');

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(queue), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      var _key$split$map = key.split(',').map(function (n) {
        return Number(n);
      }),
          _key$split$map2 = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_key$split$map, 2),
          i = _key$split$map2[0],
          j = _key$split$map2[1];

      var ex = ox + i * ix + j * jx;
      var ey = oy + i * iy + j * jy;

      var stop = true;

      var _loop = function _loop(b, _i) {
        var blockKey = key + ',' + _i;
        var color = old && old[blockKey] && old[blockKey].color;
        var x = ex + (b.x || 0);
        var y = ey + (b.y || 0);
        var r = b.r;

        var full = function full(block) {
          result[blockKey] = block;
        };

        var partial = function partial(block) {
          block.partial = true;
          result[blockKey] = block;
        };

        var BLOCK = __WEBPACK_IMPORTED_MODULE_5__universal_filzfelt_blocks___default.a[b.id] || __WEBPACK_IMPORTED_MODULE_7__universal_spinneybeck_blocks___default.a[b.id];

        // blocks defined by border points
        if (BLOCK.border) {
          var points = transform(BLOCK.border, x, y, r);
          var block = { id: b.id, points: points, color: color };
          if (isFullyInside(points, width, height)) {
            full(block);
            stop = false;
          } else if (isPartiallyInside(points, width, height)) {
            if (!pattern.fullBlocksOnly) {
              partial(block);
            }
            stop = false;
          }
          return 'continue';
        }

        // blocks defined by bounding size
        if (BLOCK.bounds) {
          var _BLOCK$bounds = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(BLOCK.bounds, 4),
              w = _BLOCK$bounds[0],
              h = _BLOCK$bounds[1],
              _BLOCK$bounds$ = _BLOCK$bounds[2],
              _ox = _BLOCK$bounds$ === undefined ? 0 : _BLOCK$bounds$,
              _BLOCK$bounds$2 = _BLOCK$bounds[3],
              _oy = _BLOCK$bounds$2 === undefined ? 0 : _BLOCK$bounds$2;

          var box = transform([[_ox, _oy], [w, _oy], [w, h], [_ox, h]], x, y, r);
          var _block = { id: b.id, x: x, y: y, r: r, color: color };
          if (isFullyInside(box, width, height)) {
            full(_block);
            stop = false;
          } else if (isPartiallyInside(box, width, height)) {
            if (!pattern.fullBlocksOnly) {
              partial(_block);
            }
            stop = false;
          }
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(pattern.blocks.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref = _step2.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var _i = _ref2[0];
          var b = _ref2[1];

          var _ret = _loop(b, _i);

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (!stop) {
        queue.add(i - 1 + ',' + j).add(i + ',' + (j - 1)).add(i + 1 + ',' + j).add(i + ',' + (j + 1));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
});

var alignment = function alignment() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
      _ref4 = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref3, 4),
      span = _ref4[0],
      odd = _ref4[1],
      even = _ref4[2],
      _ref4$ = _ref4[3],
      rest = _ref4$ === undefined ? 0 : _ref4$;

  var base = arguments[1];

  var n = base / span | 0;
  var r = base / span % 1;
  return (!n || n % 2 ? odd : even) + rest * r * span / 2;
};

var transform = function transform(points, x, y, r) {
  points = points.map(function (_ref5) {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
        px = _ref6[0],
        py = _ref6[1];

    return [x + px, y + py];
  });
  if (r == null) {
    return points;
  }

  var _r = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(r, 3),
      a = _r[0],
      cx = _r[1],
      cy = _r[2];

  cx += x;
  cy += y;
  a *= Math.PI / 180;
  return points.map(function (_ref7) {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
        px = _ref8[0],
        py = _ref8[1];

    return [cx + Math.cos(a) * (px - cx) - Math.sin(a) * (py - cy), cy + Math.sin(a) * (px - cx) + Math.cos(a) * (py - cy)];
  });
};

var isFullyInside = function isFullyInside(points, w, h) {
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(points), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _ref9 = _step3.value;

      var _ref10 = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref9, 2);

      var _x2 = _ref10[0];
      var _y = _ref10[1];

      if (_x2 < 0 || _y < 0 || _x2 > w || _y > h) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return true;
};

var isPartiallyInside = function isPartiallyInside(points, w, h) {
  var boxPoints = [[0, 0], [w, 0], [w, h], [0, h]];
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(lines(points)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var line1 = _step4.value;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2__home_stagingdt_public_html_node_modules_babel_runtime_core_js_get_iterator___default()(lines(boxPoints)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var line2 = _step5.value;

          if (intersects(line1, line2)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return false;
};

var ccw = function ccw(a, b, c) {
  return (c[1] - a[1]) * (b[0] - a[0]) > (b[1] - a[1]) * (c[0] - a[0]);
};

var floatEq = function floatEq(a, b) {
  return Math.abs(a - b) < __WEBPACK_IMPORTED_MODULE_1__home_stagingdt_public_html_node_modules_babel_runtime_core_js_number_epsilon___default.a;
};

var pointEq = function pointEq(a, b) {
  return floatEq(a[0], b[0]) && floatEq(a[1], b[1]);
};

var adjoining = function adjoining(a, b, c, d) {
  return pointEq(a, c) || pointEq(a, d) || pointEq(b, c) || pointEq(b, d);
};

var intersects = function intersects(_ref11, _ref12) {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
      a = _ref14[0],
      b = _ref14[1];

  var _ref13 = __WEBPACK_IMPORTED_MODULE_4__home_stagingdt_public_html_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref12, 2),
      c = _ref13[0],
      d = _ref13[1];

  // if lines form an angle, don't consider them intersecting
  return !adjoining(a, b, c, d) && ccw(a, c, d) !== ccw(b, c, d) && ccw(a, b, c) !== ccw(a, b, d);
};

function lines(points) {
  var i;
  return __WEBPACK_IMPORTED_MODULE_0__home_stagingdt_public_html_node_modules_babel_runtime_regenerator___default.a.wrap(function lines$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          i = 0;

        case 1:
          if (!(i < points.length - 1)) {
            _context.next = 7;
            break;
          }

          _context.next = 4;
          return [points[i], points[i + 1]];

        case 4:
          ++i;
          _context.next = 1;
          break;

        case 7:
          _context.next = 9;
          return [points[points.length - 1], points[0]];

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

module.exports = {
  '1': { idx: '487', name: 'Pfirsich', value: 'rgb(246, 164, 126)' },
  '2': { idx: '023', name: 'Koralle', value: 'rgb(247, 181, 153)' },
  '3': { idx: '945', name: 'Drachenfrucht', value: 'rgb(159, 24, 71)' },
  '4': { idx: '221', name: 'Himbeere', value: 'rgb(139, 27, 65)' },
  '5': { idx: '136', name: 'Weinrot', value: 'rgb(79, 34, 41)' },
  '6': { idx: '209', name: 'Bordeaux', value: 'rgb(84, 34, 47)' },
  '7': { idx: '102', name: 'Kirsche', value: 'rgb(105, 28, 29)' },
  '8': { idx: '201', name: 'Rot', value: 'rgb(120, 29, 31)' },
  '9': { idx: '125', name: 'Tomate', value: 'rgb(160, 32, 25)' },
  '10': { idx: '179', name: 'Hellrot', value: 'rgb(189, 31, 27)' },
  '11': { idx: '180', name: 'Terracotta', value: 'rgb(155, 58, 48)' },
  '12': { idx: '173', name: 'Mango', value: 'rgb(187, 58, 49)' },
  '13': { idx: '105', name: 'Rost', value: 'rgb(161, 61, 16)' },
  '14': { idx: '573', name: 'Kupfer', value: 'rgb(162, 96, 52)' },
  '15': { idx: '116', name: 'Orange', value: 'rgb(197, 110, 0)' },
  '16': { idx: '495', name: 'Abricot', value: 'rgb(243, 127, 0)' },
  '17': { idx: '124', name: 'Gelb', value: 'rgb(255, 180, 0)' },
  '18': { idx: '131', name: 'Honig', value: 'rgb(243, 184, 83)' },
  '19': { idx: '509', name: 'Kamel', value: 'rgb(223, 163, 39)' },
  '20': { idx: '550', name: 'Ocker', value: 'rgb(182, 135, 1)' },
  '21': { idx: '274', name: 'Senf', value: 'rgb(195, 159, 0)' },
  '22': { idx: '108', name: 'Zitrone', value: 'rgb(255, 229, 35)' },
  '23': { idx: '403', name: 'Mais', value: 'rgb(255, 239, 130)' },
  '24': { idx: '535', name: 'Sesam', value: 'rgb(231, 225, 170)' },
  '25': { idx: '203', name: 'Vanille', value: 'rgb(221, 214, 135)' },
  '26': { idx: '027', name: 'Kartause', value: 'rgb(206, 201, 101)' },
  '27': { idx: '384', name: 'Lind', value: 'rgb(151, 161, 68)' },
  '28': { idx: '713', name: 'Kiwi', value: 'rgb(155, 172, 78)' },
  '29': { idx: '377', name: 'Maigrün', value: 'rgb(117, 168, 46)' },
  '30': { idx: '732', name: 'Farn', value: 'rgb(82, 101, 32)' },
  '31': { idx: '378', name: 'Oliv', value: 'rgb(75, 100, 33)' },
  '32': { idx: '260', name: 'Sprießen', value: 'rgb(165, 201, 158)' },
  '34': { idx: '343', name: 'D’Grün', value: 'rgb(23, 54, 31)' },
  '35': { idx: '435', name: 'Smaragd', value: 'rgb(44, 89, 71)' },
  '36': { idx: '625', name: 'Pinie', value: 'rgb(59, 124, 114)' },
  '37': { idx: '248', name: 'Jade', value: 'rgb(101, 180, 145)' },
  '38': { idx: '472', name: 'Minze', value: 'rgb(95, 178, 163)' },
  '39': { idx: '575', name: 'Salbei', value: 'rgb(165, 207, 189)' },
  '40': { idx: '483', name: 'Adria', value: 'rgb(95, 140, 152)' },
  '41': { idx: '548', name: 'Türkis', value: 'rgb(10, 148, 157)' },
  '42': { idx: '312', name: 'Lagune', value: 'rgb(51, 144, 153)' },
  '43': { idx: '345', name: 'Pazifik', value: 'rgb(0, 101, 106)' },
  '44': { idx: '308', name: 'Petrol', value: 'rgb(0, 93, 127)' },
  '45': { idx: '698', name: 'Dunst', value: 'rgb(64, 115, 145)' },
  '46': { idx: '405', name: 'Stahl', value: 'rgb(70, 115, 140)' },
  '47': { idx: '215', name: 'Meer', value: 'rgb(42, 86, 100)' },
  '48': { idx: '540', name: 'Ozean', value: 'rgb(5, 66, 103)' },
  '49': { idx: '533', name: 'Indigo', value: 'rgb(39, 60, 85)' },
  '50': { idx: '282', name: 'D’Blau', value: 'rgb(20, 38, 71)' },
  '51': { idx: '111', name: 'Traube', value: 'rgb(23, 62, 101)' },
  '52': { idx: '626', name: 'Azur', value: 'rgb(0, 52, 113)' },
  '53': { idx: '647', name: 'Kobalt', value: 'rgb(6, 73, 114)' },
  '54': { idx: '686', name: 'Enzian', value: 'rgb(13, 98, 153)' },
  '55': { idx: '272', name: 'Royal', value: 'rgb(19, 71, 167)' },
  '56': { idx: '286', name: 'H’Blau', value: 'rgb(17, 100, 192)' },
  '57': { idx: '995', name: 'Wasser', value: 'rgb(67, 175, 232)' },
  '58': { idx: '458', name: 'Bewölkt', value: 'rgb(125, 209, 230)' },
  '59': { idx: '284', name: 'Himmel', value: 'rgb(107, 176, 233)' },
  '60': { idx: '613', name: 'Gletscher', value: 'rgb(126, 169, 195)' },
  '61': { idx: '551', name: 'Eis', value: 'rgb(180, 226, 242)' },
  '62': { idx: '113', name: 'Immergrün', value: 'rgb(155, 185, 232)' },
  '63': { idx: '099', name: 'Lila', value: 'rgb(150, 158, 215)' },
  '64': { idx: '667', name: 'Amethyst', value: 'rgb(103, 98, 144)' },
  '65': { idx: '242', name: 'Pink', value: 'rgb(131, 27, 108)' },
  '66': { idx: '640', name: 'Granat', value: 'rgb(128, 51, 79)' },
  '67': { idx: '634', name: 'Erröten', value: 'rgb(205, 131, 171)' },
  '68': { idx: '671', name: 'Pfingstrose', value: 'rgb(231, 171, 195)' },
  '69': { idx: '255', name: 'Flieder', value: 'rgb(97, 48, 113)' },
  '70': { idx: '269', name: 'Violett', value: 'rgb(57, 45, 122)' },
  '71': { idx: '437', name: 'Aubergine', value: 'rgb(49, 32, 50)' },
  '72': { idx: '250', name: 'Trüffelbraun', value: 'rgb(47, 44, 40)' },
  '73': { idx: '220', name: 'Rehbraun', value: 'rgb(81, 72, 60)' },
  '74': { idx: '411', name: 'Alpaka', value: 'rgb(76, 73, 70)' },
  '75': { idx: '190', name: 'Natur-meliert', value: 'rgb(95, 93, 86)' },
  '76': { idx: '200', name: 'Natur', value: 'rgb(106, 99, 93)' },
  '77': { idx: '331', name: 'Sahara', value: 'rgb(169, 159, 127)' },
  '78': { idx: '311', name: 'Mandel', value: 'rgb(213, 185, 149)' },
  '79': { idx: '467', name: 'Sand', value: 'rgb(195, 177, 138)' },
  '80': { idx: '481', name: 'Sandstein', value: 'rgb(221, 204, 179)' },
  '81': { idx: '100', name: 'Wollweiß', value: 'rgb(255, 255, 236)' },
  '82': { idx: '110', name: 'Rohweiß', value: 'rgb(249, 238, 196)' },
  '83': { idx: '160', name: 'Beige', value: 'rgb(195, 189, 167)' },
  '84': { idx: '529', name: 'Champagner', value: 'rgb(196, 191, 171)' },
  '85': { idx: '150', name: 'Weiß', value: 'rgb(209, 211, 200)' },
  '86': { idx: '428', name: 'Silber', value: 'rgb(208, 221, 221)' },
  '87': { idx: '427', name: 'Stein', value: 'rgb(194, 200, 195)' },
  '88': { idx: '021', name: 'Beton', value: 'rgb(199, 208, 214)' },
  '89': { idx: '170', name: 'Asche', value: 'rgb(149, 156, 154)' },
  '90': { idx: '423', name: 'Hellgrau', value: 'rgb(140, 151, 151)' },
  '91': { idx: '408', name: 'Taupe', value: 'rgb(135, 134, 125)' },
  '92': { idx: '175', name: 'Graphit', value: 'rgb(78, 87, 90)' },
  '93': { idx: '425', name: 'Taubengrau', value: 'rgb(88, 102, 101)' },
  '94': { idx: '446', name: 'Kohle', value: 'rgb(39, 60, 63)' },
  '95': { idx: '300', name: 'Anthrazit', value: 'rgb(44, 52, 53)' },
  '96': { idx: '426', name: 'Schwarz', value: 'rgb(27, 33, 30)' }
};

/***/ })

},[586]);


// WEBPACK FOOTER //
// client.afc83d8d.js